
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("actEI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("c0sDW")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $c0sDW = parcelRequire("c0sDW");

});
parcelRegister("c0sDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2823b878282b5cc3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dpXKE = parcelRequire("dpXKE");

var $0cdA8 = parcelRequire("0cdA8");

var $heNSb = parcelRequire("heNSb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8N2W1 = parcelRequire("8N2W1");

var $huvdb = parcelRequire("huvdb");

var $gx9jR = parcelRequire("gx9jR");

var $kzQ9s = parcelRequire("kzQ9s");

var $fO5rB = parcelRequire("fO5rB");

var $5p2pw = parcelRequire("5p2pw");

var $bhwgQ = parcelRequire("bhwgQ");

var $7BhMl = parcelRequire("7BhMl");

var $3iYii = parcelRequire("3iYii");

var $onPBs = parcelRequire("onPBs");

var $6M8Uw = parcelRequire("6M8Uw");

var $gd0Sp = parcelRequire("gd0Sp");

var $9BQAQ = parcelRequire("9BQAQ");

var $VFdsG = parcelRequire("VFdsG");
const $2823b878282b5cc3$var$DeploymentsPage = ({ useProjectDetails: useProjectDetails, useViewDeploymentsExperienceFail: useViewDeploymentsExperienceFail, useTenantContext: useTenantContext })=>{
    const project = useProjectDetails();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onViewDeploymentsExperienceFail = useViewDeploymentsExperienceFail();
    const onViewDeploymentsTimelineExperienceFail = (0, $gx9jR.useViewDeploymentsTimelineExperienceFail)();
    const tenantContext = useTenantContext();
    const hasSoftwareLicense = (0, $7BhMl.checkLicense)(tenantContext, 'software');
    let hasDeployments;
    let deploymentsPreconditionData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huvdb.ViewDeploymentsExperienceStart), {
        experienceId: project.key
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, hasSoftwareLicense ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "pageContent",
        packageName: "jiraSpaAppsSoftwareDeployments",
        teamName: "fusion-solaris",
        extraEventData: {
            isSimplifiedProject: project.isSimplified ?? false
        },
        onError: (location, error)=>{
            onViewDeploymentsExperienceFail(location, error, {
                isNetworkError: (0, $VFdsG.isNetworkError)(error),
                hasDeployments: hasDeployments
            });
            if (deploymentsPreconditionData != null && (0, $8N2W1.getPrecondition)(deploymentsPreconditionData) === 'ALL_SATISFIED') // If the preconditions are satisfied, then we attempted to render the timeline
            onViewDeploymentsTimelineExperienceFail(location, error);
        },
        attributes: (error)=>({
                isNetworkError: (0, $VFdsG.isNetworkError)(error),
                isSimplifiedProject: project.isSimplified ?? false,
                hasDeployments: hasDeployments
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: tenantContext.baseUrl,
        projectKey: project.key,
        projectName: project.name ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $onPBs.PreconditionCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gx9jR.ViewDeploymentsTimelineExperienceStart), {
        experienceId: project.key
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzQ9s.default), {
        projectKey: project.key
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $9BQAQ.default).title)
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5p2pw.AsyncNoSoftwareLicense), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huvdb.ViewDeploymentsExpectedErrorExperienceSuccessTracker), null))));
};
$2823b878282b5cc3$var$DeploymentsPage.defaultProps = {
    useProjectDetails: (0, $3iYii.useProjectDetails),
    useViewDeploymentsExperienceFail: (0, $huvdb.useViewDeploymentsExperienceFail),
    useTenantContext: (0, $gd0Sp.useTenantContext)
};
var $2823b878282b5cc3$export$2e2bcd8739ae039 = $2823b878282b5cc3$var$DeploymentsPage;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("8N2W1", function(module, exports) {

$parcel$export(module.exports, "getPrecondition", () => $b337f3decc95152f$export$aedf916d06abd507);
$parcel$export(module.exports, "PreconditionCheck", () => $b337f3decc95152f$export$ef543003424a5eae);

var $eqwtX = parcelRequire("eqwtX");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $cFSju = parcelRequire("cFSju");

var $huvdb = parcelRequire("huvdb");

var $gx9jR = parcelRequire("gx9jR");

var $5cM2U = parcelRequire("5cM2U");

var $5MsOK = parcelRequire("5MsOK");

var $4D4hF = parcelRequire("4D4hF");
const $b337f3decc95152f$export$aedf916d06abd507 = (data)=>{
    if (!data.isFeatureEnabled) return 'NOT_AVAILABLE';
    if (!data.hasViewDevToolsPermission) return 'NOT_AVAILABLE';
    if (!data.hasIssuesWithDeployments) return 'DEPLOYMENTS_EMPTY_STATE';
    return 'ALL_SATISFIED';
};
const $b337f3decc95152f$export$a1ffe530301da264 = ({ children: children, preconditionResult: preconditionResult })=>{
    const precondition = $b337f3decc95152f$export$aedf916d06abd507(preconditionResult);
    switch(precondition){
        case 'ALL_SATISFIED':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
        case 'DEPLOYMENTS_EMPTY_STATE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFSju.AsyncDeploymentsEmptyState), null);
        case 'NOT_AVAILABLE':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MsOK.NotAvailablePage), null);
    }
};
const $b337f3decc95152f$export$ef543003424a5eae = ({ children: children, queryReference: queryReference })=>{
    const project = (0, $5cM2U.useProjectDetails)();
    const onViewDeploymentsExperienceFail = (0, $huvdb.useViewDeploymentsExperienceFail)();
    const onViewDeploymentsTimelineExperienceFail = (0, $gx9jR.useViewDeploymentsTimelineExperienceFail)();
    const { jira: { deploymentsFeaturePreconditionByProjectKey: deploymentsFeaturePreconditionByProjectKey } } = (0, $iWLL0.usePreloadedQuery)((0, $eqwtX.default), queryReference);
    let page;
    switch(deploymentsFeaturePreconditionByProjectKey){
        case 'ALL_SATISFIED':
            page = children;
            break;
        case 'DEPLOYMENTS_EMPTY_STATE':
            page = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFSju.AsyncDeploymentsEmptyState), null);
            break;
        case 'NOT_AVAILABLE':
        default:
            page = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MsOK.NotAvailablePage), null);
    }
    return(// this error boundary is placed here to check whether the project has deployments
    // originally this was done in spa-apps but that is no longer possible because we
    // need to access the precondition after usePreloadedQuery receives its query ref
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "pageContent",
        packageName: "jiraSoftwareDeploymentsPrecondition",
        teamName: "fusion-solaris",
        extraEventData: {
            isSimplifiedProject: project.isSimplified ?? false
        },
        onError: (location, error)=>{
            onViewDeploymentsExperienceFail(location, error, {
                isNetworkError: (0, $4D4hF.isNetworkError)(error),
                hasDeployments: deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED'
            });
            if (deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED') // If the preconditions are satisfied, then we attempted to render the timeline
            onViewDeploymentsTimelineExperienceFail(location, error);
        },
        attributes: (error)=>({
                isNetworkError: (0, $4D4hF.isNetworkError)(error),
                isSimplifiedProject: project.isSimplified ?? false,
                hasDeployments: deploymentsFeaturePreconditionByProjectKey === 'ALL_SATISFIED'
            })
    }, page));
};

});
parcelRegister("cFSju", function(module, exports) {

$parcel$export(module.exports, "AsyncDeploymentsEmptyState", () => $2234b54b3b7e25db$export$b0994e4fa65a6470);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2234b54b3b7e25db$var$DeploymentsEmptyState = (0, $7rh0R.lazy)(()=>(parcelRequire("eTrxB")), {
    moduleId: "./src/packages/software/deployments/empty-state/src/ui/index.tsx"
});
const $2234b54b3b7e25db$export$b0994e4fa65a6470 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "deployments-empty-state",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2234b54b3b7e25db$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2234b54b3b7e25db$var$DeploymentsEmptyState, null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2234b54b3b7e25db$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eTrxB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cl8Ni")
]).then(()=>parcelRequire('dXKdC'));

});


parcelRegister("huvdb", function(module, exports) {

$parcel$export(module.exports, "ViewDeploymentsExperienceStart", () => $6929034728d11f38$export$70c80ec46f5fec9b);
$parcel$export(module.exports, "useViewDeploymentsExperienceFail", () => $6929034728d11f38$export$56eb6263ae515925);
$parcel$export(module.exports, "ViewDeploymentsExpectedErrorExperienceSuccessTracker", () => $6929034728d11f38$export$33bf42243b766ccd);
$parcel$export(module.exports, "ViewDeploymentsExperienceSuccessTracker", () => $6929034728d11f38$export$72dd7cb2f95061cf);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $gEpgE = parcelRequire("gEpgE");

var $ab6rA = parcelRequire("ab6rA");

var $OwuLI = parcelRequire("OwuLI");

var $lnbOK = parcelRequire("lnbOK");
const $6929034728d11f38$var$viewDeploymentsExperienceName = 'viewDeployments';
const $6929034728d11f38$export$70c80ec46f5fec9b = ({ experienceId: experienceId })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: $6929034728d11f38$var$viewDeploymentsExperienceName,
        analyticsSource: "deployments",
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $6929034728d11f38$export$56eb6263ae515925 = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $6929034728d11f38$var$viewDeploymentsExperienceName,
        attributes: {
            hasDeployments: true
        }
    });
const $6929034728d11f38$export$33bf42243b766ccd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $6929034728d11f38$var$viewDeploymentsExperienceName,
        attributes: {
            hasDeployments: true
        }
    });
const $6929034728d11f38$export$30f065c157611e00 = (coreDataServiceResult)=>coreDataServiceResult.loadingState === (0, $gEpgE.LoadingStateOptions).READY; // Once loadingState becomes READY, we return true. All other cases are false
const $6929034728d11f38$export$72dd7cb2f95061cf = ()=>{
    const { serviceResult: coreDataServiceResult } = (0, $OwuLI.useCoreData)();
    const attributes = (0, $lnbOK.useProjectAnalyticsAttributes)('DeploymentsExperienceSuccess');
    if (attributes === null) return null;
    return $6929034728d11f38$export$30f065c157611e00(coreDataServiceResult) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $6929034728d11f38$var$viewDeploymentsExperienceName,
        attributes: {
            ...attributes,
            hasDeployments: Number(coreDataServiceResult.data?.allDeployments.length) > 0
        }
    }) : null;
};

});
parcelRegister("gEpgE", function(module, exports) {

$parcel$export(module.exports, "LoadingStateOptions", () => $19edf50da5e9cd0a$export$cb202ac26b54d8c6);
const $19edf50da5e9cd0a$export$cb202ac26b54d8c6 = {
    LOADING_INITIAL: 'LOADING_INITIAL',
    LOADING_SET_VARIABLES: 'LOADING_SET_VARIABLES',
    LOADING_NEXT_PAGE: 'LOADING_NEXT_PAGE',
    READY: 'READY',
    HAS_ERROR: 'HAS_ERROR',
    UNMAPPED: 'UNMAPPED'
};

});

parcelRegister("OwuLI", function(module, exports) {

$parcel$export(module.exports, "CoreDataFilterProvider", () => $cdd13196d2e0aa18$export$f783b29311209b0b);
$parcel$export(module.exports, "useCoreDataFilter", () => $cdd13196d2e0aa18$export$21745039f12a8096);
$parcel$export(module.exports, "useCoreData", () => $cdd13196d2e0aa18$export$4b88cf5a05e76c52);
$parcel$export(module.exports, "useCoreDataLimits", () => $cdd13196d2e0aa18$export$94e1304cd1d3b30e);
$parcel$export(module.exports, "useIssues", () => $cdd13196d2e0aa18$export$fdf0b908e72b6bef);
$parcel$export(module.exports, "useIssue", () => $cdd13196d2e0aa18$export$9fd86fb6b3622569);
$parcel$export(module.exports, "useAllDeployments", () => $cdd13196d2e0aa18$export$c46e448f10613cda);
$parcel$export(module.exports, "useIssueDeployments", () => $cdd13196d2e0aa18$export$68a33f119c7853b3);
$parcel$export(module.exports, "useIsCoreLoadingByFilterChange", () => $cdd13196d2e0aa18$export$20554bd8282807ab);
$parcel$export(module.exports, "useIsLoadingNextPage", () => $cdd13196d2e0aa18$export$934d73666a71cec9);
$parcel$export(module.exports, "fetchCoreData", () => $cdd13196d2e0aa18$export$fbda6896135285a6);
$parcel$export(module.exports, "CoreDataServiceProvider", () => $cdd13196d2e0aa18$export$7b6e94572246f648);
$parcel$export(module.exports, "useEarliestVisibleDeploymentDate", () => $cdd13196d2e0aa18$export$6d519f324ee09296);

var $iR0Zs = parcelRequire("iR0Zs");

var $c9IsI = parcelRequire("c9IsI");

var $jnwwa = parcelRequire("jnwwa");

var $94kJz = parcelRequire("94kJz");

var $j2Hz1 = parcelRequire("j2Hz1");

var $eUqFw = parcelRequire("eUqFw");

var $aYAw7 = parcelRequire("aYAw7");

var $fcWBJ = parcelRequire("fcWBJ");

var $3aUuh = parcelRequire("3aUuh");

var $1EkP8 = parcelRequire("1EkP8");

var $MdoH4 = parcelRequire("MdoH4");

var $lyOYo = parcelRequire("lyOYo");

var $9sv5e = parcelRequire("9sv5e");

var $iWLL0 = parcelRequire("iWLL0");

var $eI5EY = parcelRequire("eI5EY");

var $lPQPn = parcelRequire("lPQPn");

var $huI7r = parcelRequire("huI7r");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $gEpgE = parcelRequire("gEpgE");

var $dWLk9 = parcelRequire("dWLk9");

var $psMOt = parcelRequire("psMOt");

var $yevjV = parcelRequire("yevjV");

var $itCm6 = parcelRequire("itCm6");

var $2LmzR = parcelRequire("2LmzR");

var $lnbOK = parcelRequire("lnbOK");

var $ePfmq = parcelRequire("ePfmq");

var $2fW3U = parcelRequire("2fW3U");

var $3iyQa = parcelRequire("3iyQa");

var $2cKta = parcelRequire("2cKta");

var $kuiLT = parcelRequire("kuiLT");

var $dD35P = parcelRequire("dD35P");

var $asHsD = parcelRequire("asHsD");
// @ts-expect-error - TS7031 - Binding element 'summary' implicitly has an 'any' type. | TS7031 - Binding element 'color' implicitly has an 'any' type.
const $cdd13196d2e0aa18$var$transformEpic = ({ summary: summary, color: color })=>{
    if (summary == null) throw Error('Invalid issue epic');
    return {
        summary: summary,
        color: (0, $lPQPn.asColor)(color === undefined ? null : color)
    };
};
const $cdd13196d2e0aa18$var$transformIssueSearch = ({ node: node })=>{
    if (node == null) throw Error('Invalid Issue Data');
    const { fieldsByIdOrAlias: fields, id: issueId, key: issueKey } = node;
    if (issueId == null || issueKey == null || fields == null) throw Error('Invalid Issue Data');
    const issueTypeId = fields.find((field)=>field?.fieldId === 'issuetype')?.issueType?.id ?? null;
    if (issueTypeId == null) throw Error('Invalid Issue Data');
    const projectId = '100001'; // TODO
    const summary = fields.find((field)=>field?.fieldId === 'summary')?.text ?? '';
    const assigneeUserValue = fields.find((field)=>field?.fieldId === 'assignee')?.user ?? null;
    let assignee = null;
    if (assigneeUserValue) {
        const { accountId: accountId, name: name, picture: picture } = assigneeUserValue;
        if (accountId != null && name != null) assignee = {
            id: (0, $6vrw7.toAccountId)(accountId),
            displayName: name,
            avatarUrl: picture != null ? picture : undefined
        };
    }
    const parent = fields.find((field)=>field?.fieldId === 'parent') ?? null;
    const epicSummary = parent?.parentIssue?.fieldsByIdOrAlias?.find((field)=>field?.fieldId === 'summary')?.text ?? null;
    const epicColor = parent?.parentIssue?.issueColorField?.color?.colorKey;
    const epic = parent?.parentIssue == null ? null : $cdd13196d2e0aa18$var$transformEpic({
        summary: epicSummary,
        color: epicColor
    });
    return {
        id: (0, $6vrw7.toIssueId)((0, $itCm6.getResourceId)(issueId)),
        key: (0, $6vrw7.toIssueKey)(issueKey),
        typeId: (0, $6vrw7.toIssueTypeId)((0, $itCm6.getResourceId)(issueTypeId)),
        projectId: (0, $6vrw7.toProjectId)(projectId),
        summary: summary,
        assignee: assignee,
        epic: epic
    };
};
// @ts-expect-error - TS7006 - Parameter 'edge' implicitly has an 'any' type.
const $cdd13196d2e0aa18$var$transformIssue = (edge)=>{
    const issueId = edge?.node?.id;
    const issueKey = edge?.node?.issueKey;
    const issueTypeId = edge?.node?.issueTypeId;
    const projectId = '100001'; // TODO
    const summary = edge?.node?.summary ?? '';
    const epic = edge?.node?.epic ?? null;
    const assigneeUserValue = edge?.node?.assignee ?? null;
    let assignee = null;
    if (assigneeUserValue) {
        const { accountId: accountId, name: name, picture: picture } = assigneeUserValue;
        if (accountId != null && name != null) assignee = {
            id: (0, $6vrw7.toAccountId)(accountId),
            displayName: name,
            avatarUrl: picture != null ? picture : undefined
        };
    }
    if (issueId == null || issueKey == null || issueTypeId == null || projectId == null) throw Error('Invalid Issue Data');
    return {
        id: (0, $6vrw7.toIssueId)((0, $itCm6.getResourceId)(issueId)),
        key: (0, $6vrw7.toIssueKey)(issueKey),
        typeId: (0, $6vrw7.toIssueTypeId)((0, $itCm6.getResourceId)(issueTypeId)),
        projectId: (0, $6vrw7.toProjectId)(projectId),
        summary: summary,
        assignee: assignee,
        epic: epic == null ? null : $cdd13196d2e0aa18$var$transformEpic(epic)
    };
};
const $cdd13196d2e0aa18$export$f79382ad55cc4ebf = (data, error)=>{
    const loadingState = (0, $gEpgE.LoadingStateOptions).READY;
    if (data?.jira?.issueSearchStable?.edges == null) return {
        loadingState: (0, $gEpgE.LoadingStateOptions).HAS_ERROR,
        error: error || Error('Critical data missing from "mainIssueQuery" response. Check Apollo Studio for details.')
    };
    try {
        return {
            loadingState: loadingState,
            data: {
                issues: data.jira.issueSearchStable.edges.filter(Boolean).map($cdd13196d2e0aa18$var$transformIssueSearch),
                pageInfo: {
                    nextPageCursor: null
                }
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (issueTransformError) {
        return {
            loadingState: (0, $gEpgE.LoadingStateOptions).HAS_ERROR,
            error: issueTransformError
        };
    }
};
const $cdd13196d2e0aa18$export$4129385c65073703 = (data, error)=>{
    const loadingState = (0, $gEpgE.LoadingStateOptions).READY;
    if (data?.jiraReleases?.issues?.edges == null) return {
        loadingState: (0, $gEpgE.LoadingStateOptions).HAS_ERROR,
        error: error || Error('Critical data missing from "mainIssueQuery" response. Check Apollo Studio for details.')
    };
    const nextPageCursor = data.jiraReleases.issues.pageInfo.hasNextPage === true ? data.jiraReleases.issues.edges[data.jiraReleases.issues.edges.length - 1]?.cursor ?? null : null;
    try {
        return {
            loadingState: loadingState,
            data: {
                issues: data.jiraReleases.issues.edges.map($cdd13196d2e0aa18$var$transformIssue),
                pageInfo: {
                    nextPageCursor: nextPageCursor
                }
            }
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (issueTransformError) {
        return {
            loadingState: (0, $gEpgE.LoadingStateOptions).HAS_ERROR,
            error: issueTransformError
        };
    }
};
const $cdd13196d2e0aa18$export$886c8fd3526d766e = /*#__PURE__*/ (0, $eUqFw.createContext)();
const $cdd13196d2e0aa18$export$a2f772351fd8cd8f = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $cdd13196d2e0aa18$export$f783b29311209b0b = ({ filter: filter, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cdd13196d2e0aa18$export$a2f772351fd8cd8f.Provider, {
        value: filter
    }, children);
const $cdd13196d2e0aa18$export$21745039f12a8096 = ()=>(0, $eUqFw.useContext)($cdd13196d2e0aa18$export$a2f772351fd8cd8f);
const $cdd13196d2e0aa18$var$useCoreDataContext = ()=>{
    const result = (0, $eUqFw.useContext)($cdd13196d2e0aa18$export$886c8fd3526d766e);
    if (result === undefined) throw new Error('Missing core data service provider');
    return result;
};
const $cdd13196d2e0aa18$export$4b88cf5a05e76c52 = ()=>$cdd13196d2e0aa18$var$useCoreDataContext();
const $cdd13196d2e0aa18$export$94e1304cd1d3b30e = ()=>{
    const a = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    const { hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit, hasReachedMaxIssuesLimit: hasReachedMaxIssuesLimit } = a;
    return {
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit,
        hasReachedMaxIssuesLimit: hasReachedMaxIssuesLimit
    };
};
const $cdd13196d2e0aa18$export$fdf0b908e72b6bef = ()=>{
    const result = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return {
        ...result.serviceResult,
        data: result.serviceResult.data?.issues ?? [],
        hasReachedMaxIssuesLimit: result.hasReachedMaxIssuesLimit,
        getNextIssuePage: result.getNextIssuePage
    };
};
const $cdd13196d2e0aa18$export$9fd86fb6b3622569 = (issueId)=>{
    const result = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return result.serviceResult.data?.issuesByIssueId[issueId] ?? undefined;
};
const $cdd13196d2e0aa18$export$c46e448f10613cda = ()=>{
    const result = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return {
        ...result.serviceResult,
        data: result.serviceResult.data?.allDeployments ?? []
    };
};
const $cdd13196d2e0aa18$export$68a33f119c7853b3 = (issueId)=>{
    const result = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return {
        ...result.serviceResult,
        data: result.serviceResult.data?.deploymentsByIssueId[issueId] ?? []
    };
};
const $cdd13196d2e0aa18$export$20554bd8282807ab = ()=>{
    const result = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return result.serviceResult.loadingState === (0, $gEpgE.LoadingStateOptions).LOADING_SET_VARIABLES;
};
const $cdd13196d2e0aa18$export$934d73666a71cec9 = ()=>{
    const result = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return result.serviceResult.loadingState === (0, $gEpgE.LoadingStateOptions).LOADING_NEXT_PAGE;
};
const { HAS_ERROR: $cdd13196d2e0aa18$var$HAS_ERROR } = (0, $gEpgE.LoadingStateOptions);
const $cdd13196d2e0aa18$var$fetchIssuesAGSQuery = async (jqlSearch, environment, cloudId)=>{
    let data;
    let error;
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        data = await (0, $iWLL0.fetchQuery)(environment, (0, $j2Hz1.default), {
            first: (0, $ePfmq.ISSUE_PAGE_SIZE),
            cloudId: cloudId,
            jqlSearch: jqlSearch
        }, {
            fetchPolicy: 'store-or-network'
        }).toPromise();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        error = e;
    }
    return {
        data: data,
        error: error
    };
};
const $cdd13196d2e0aa18$export$89cf1798ec1ca82b = async (environment, numIssuePagesToFetch, issueIds, cloudId, projectId)=>{
    let issues = [];
    let currentIssuePage = 0;
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.issuesAGSFetched).start();
    // We will fetch ISSUE_PAGE_SIZE issues at a time by building a JQL string
    // to search for issue ids
    const issueIdPagesToFetch = (0, (/*@__PURE__*/$parcel$interopDefault($aYAw7)))(issueIds, (0, $ePfmq.ISSUE_PAGE_SIZE));
    do {
        const jqlSearch = `project = ${projectId} AND id IN (${issueIdPagesToFetch[currentIssuePage].join(',')})`;
        // eslint-disable-next-line no-await-in-loop
        const { data: data, error: error } = await $cdd13196d2e0aa18$var$fetchIssuesAGSQuery(jqlSearch, environment, cloudId);
        const issuePageResponse = $cdd13196d2e0aa18$export$f79382ad55cc4ebf(data, error);
        if (issuePageResponse.error || issuePageResponse.data == null) throw new Error(`issuePageResponse has no data, we should never get here. error: ${issuePageResponse.error ?? 'unknown'}`);
        issues = issues.concat(issuePageResponse.data.issues);
        currentIssuePage += 1;
    }while (currentIssuePage < issueIdPagesToFetch.length && currentIssuePage < numIssuePagesToFetch);
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.issuesAGSFetched).stop({
        customData: {
            ...(0, $asHsD.collectorFromNumIssues)({
                numIssues: issues.length,
                issuePageSize: (0, $ePfmq.ISSUE_PAGE_SIZE),
                deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
            }),
            relay: true
        }
    });
    return {
        issues: issues,
        hasNextPage: currentIssuePage < issueIdPagesToFetch.length
    };
};
const $cdd13196d2e0aa18$export$db8cc4a4a990b3a2 = async (environment, filter, totalIssuePageNum, cloudId)=>{
    let issues = [];
    let issueAfterCursor = null;
    let totalIssuePageCount = 0;
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.issuesFetched).start();
    do {
        let data;
        let error;
        try {
            // eslint-disable-next-line no-await-in-loop
            data = await (0, $iWLL0.fetchQuery)(environment, (0, $94kJz.default), {
                ...(0, $dD35P.getIssueQueryVariables)(filter, cloudId, issueAfterCursor)
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            error = e;
        }
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'mainIssueQuery$data | undefined'.
        const issuePageResponse = $cdd13196d2e0aa18$export$4129385c65073703(data, error);
        if (issuePageResponse.error) throw issuePageResponse.error;
        if (issuePageResponse.data == null) throw new Error('issuePageResponse has no data, we should never get here');
        const { issues: curPageIssues } = issuePageResponse.data;
        issues = issues.concat(curPageIssues);
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'mainIssueQuery$data | undefined'.
        issueAfterCursor = (0, $dD35P.getNextIssuePageCursor)(data);
        totalIssuePageCount += 1;
    }while (totalIssuePageCount < totalIssuePageNum && issueAfterCursor !== null);
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.issuesFetched).stop({
        customData: {
            ...(0, $asHsD.collectorFromNumIssues)({
                numIssues: issues.length,
                issuePageSize: (0, $ePfmq.ISSUE_PAGE_SIZE),
                deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
            }),
            relay: true
        }
    });
    return {
        issues: issues,
        hasNextPage: issueAfterCursor !== null
    };
};
const $cdd13196d2e0aa18$var$transformDeploymentState = (state)=>{
    switch(state){
        case 'PENDING':
            return (0, $yevjV.DeploymentStateOptions).PENDING;
        case 'IN_PROGRESS':
            return (0, $yevjV.DeploymentStateOptions).IN_PROGRESS;
        case 'SUCCESSFUL':
            return (0, $yevjV.DeploymentStateOptions).SUCCESSFUL;
        case 'CANCELLED':
            return (0, $yevjV.DeploymentStateOptions).CANCELLED;
        case 'FAILED':
            return (0, $yevjV.DeploymentStateOptions).FAILED;
        case 'ROLLED_BACK':
            return (0, $yevjV.DeploymentStateOptions).ROLLED_BACK;
        case 'UNKNOWN':
            return (0, $yevjV.DeploymentStateOptions).UNKNOWN;
        default:
            return (0, $yevjV.DeploymentStateOptions).UNKNOWN;
    }
};
const $cdd13196d2e0aa18$var$transformPipeline = (pipeline)=>{
    const { displayName: displayName, url: url } = pipeline;
    if (displayName == null || url == null) throw new Error('pipeline not found');
    return {
        id: 'pipelineId',
        displayName: // TODO remove once we stop supporting two core-data services
        displayName,
        url: url
    };
};
const $cdd13196d2e0aa18$var$transformEnvironment = (environment)=>{
    const { displayName: displayName, category: category } = environment;
    if (displayName == null) throw new Error('environment not found');
    return {
        id: 'environmentId',
        // TODO remove once we stop supporting two core-data services
        type: category == null ? (0, $yevjV.DeploymentEnvironmentTypeOptions).UNMAPPED : (0, $dD35P.transformEnvironmentType)(category),
        displayName: displayName
    };
};
const $cdd13196d2e0aa18$var$transformDeployment = ({ id: // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
id, issueIds: // @ts-expect-error - TS7031 - Binding element 'issueIds' implicitly has an 'any' type.
issueIds, deploymentSequenceNumber: // @ts-expect-error - TS7031 - Binding element 'deploymentSequenceNumber' implicitly has an 'any' type.
deploymentSequenceNumber, updateSequenceNumber: // @ts-expect-error - TS7031 - Binding element 'updateSequenceNumber' implicitly has an 'any' type.
updateSequenceNumber, displayName: // @ts-expect-error - TS7031 - Binding element 'displayName' implicitly has an 'any' type.
displayName, url: // @ts-expect-error - TS7031 - Binding element 'url' implicitly has an 'any' type.
url, description: // @ts-expect-error - TS7031 - Binding element 'description' implicitly has an 'any' type.
description, lastUpdated: // @ts-expect-error - TS7031 - Binding element 'lastUpdated' implicitly has an 'any' type.
lastUpdated, state: // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type.
state, pipeline: // @ts-expect-error - TS7031 - Binding element 'pipeline' implicitly has an 'any' type.
pipeline, environment: // @ts-expect-error - TS7031 - Binding element 'environment' implicitly has an 'any' type.
environment })=>{
    if (issueIds == null || deploymentSequenceNumber == null || updateSequenceNumber == null || displayName == null || url == null || description == null || lastUpdated == null || state == null || pipeline == null || environment == null) throw Error('Invalid deployment');
    return {
        id: id,
        // @ts-expect-error - TS7006 - Parameter 'issueId' implicitly has an 'any' type.
        issueIds: issueIds.map((issueId)=>(0, $6vrw7.toIssueId)((0, $itCm6.getResourceId)(issueId))),
        deploymentSequenceNumber: deploymentSequenceNumber,
        updateSequenceNumber: updateSequenceNumber,
        displayName: displayName,
        url: url,
        description: description,
        lastUpdated: new Date(lastUpdated),
        state: $cdd13196d2e0aa18$var$transformDeploymentState(state),
        pipeline: $cdd13196d2e0aa18$var$transformPipeline(pipeline),
        environment: $cdd13196d2e0aa18$var$transformEnvironment(environment)
    };
};
const $cdd13196d2e0aa18$var$groupByDeploymentSequenceNumber = (deployments)=>Object.values((0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(deployments, (deployment)=>`${deployment.deploymentSequenceNumber}_${deployment.pipeline.url}_${deployment.environment.type}_${deployment.environment.displayName}`));
const $cdd13196d2e0aa18$var$getByMostRecentUpdateSequenceNumber = (deployments)=>// @ts-expect-error - TS2322 - Type 'Deployment | undefined' is not assignable to type 'Deployment'.
    (0, (/*@__PURE__*/$parcel$interopDefault($1EkP8)))(deployments, (deployment)=>deployment.updateSequenceNumber);
const $cdd13196d2e0aa18$export$a7aa5a5f9c6dfb6f = (deployments)=>$cdd13196d2e0aa18$var$groupByDeploymentSequenceNumber(deployments).map($cdd13196d2e0aa18$var$getByMostRecentUpdateSequenceNumber);
const $cdd13196d2e0aa18$export$958d9308eef1b87d = (data, error)=>{
    if (data?.graphStore?.projectAssociatedDeployment?.edges == null) return {
        loadingState: (0, $gEpgE.LoadingStateOptions).HAS_ERROR,
        error: error || Error('Data missing error.')
    };
    const { edges: edges } = data.graphStore.projectAssociatedDeployment;
    const deployments = edges.flatMap((edge)=>edge?.node ? [
            $cdd13196d2e0aa18$var$transformDeployment(edge.node)
        ] : []);
    return {
        loadingState: (0, $gEpgE.LoadingStateOptions).READY,
        data: deployments
    };
};
const $cdd13196d2e0aa18$export$eb2424d16c0e4416 = (data, error)=>{
    const loadingState = (0, $gEpgE.LoadingStateOptions).READY;
    if (data?.jiraReleases?.deployments?.edges == null) return {
        loadingState: loadingState,
        error: error || Error('Critical data missing from "mainDeploymentsQuery" response. Check Apollo Studio for details.')
    };
    const { edges: edges } = data.jiraReleases.deployments;
    const deployments = edges.flatMap((edge)=>edge?.node ? [
            $cdd13196d2e0aa18$var$transformDeployment(edge.node)
        ] : []);
    const filteredDeployments = $cdd13196d2e0aa18$export$a7aa5a5f9c6dfb6f(deployments);
    return {
        loadingState: (0, $gEpgE.LoadingStateOptions).READY,
        data: filteredDeployments
    };
};
const $cdd13196d2e0aa18$export$6474cc3702da1237 = (data, error)=>{
    const loadingState = (0, $gEpgE.LoadingStateOptions).READY;
    if (data?.graphStore?.issueAssociatedDeploymentBatch?.nodes == null) return {
        loadingState: loadingState,
        error: error || Error('Critical data missing from "mainDeploymentsQuery" response. Check Apollo Studio for details.')
    };
    const { nodes: nodes } = data.graphStore.issueAssociatedDeploymentBatch;
    const deployments = nodes.flatMap((node)=>node?.to?.data ? [
            $cdd13196d2e0aa18$var$transformDeployment(node.to.data)
        ] : []);
    const filteredDeployments = $cdd13196d2e0aa18$export$a7aa5a5f9c6dfb6f(deployments);
    return {
        loadingState: (0, $gEpgE.LoadingStateOptions).READY,
        data: filteredDeployments
    };
};
const $cdd13196d2e0aa18$var$fetchAssociatedDeploymentsQuery = async (environment, projectId, cloudId, timeWindow, after)=>{
    let data;
    let error;
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        data = await (0, $iWLL0.fetchQuery)(environment, (0, $jnwwa.default), {
            projectId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }),
            timeBefore: timeWindow.before.getTime(),
            timeAfter: timeWindow.after.getTime(),
            first: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE),
            after: after
        }, // TODO: I don't think this fetch policy is working as expected? I'm seeing the same deployments query
        // hit the network multiple times :|
        {
            fetchPolicy: 'store-or-network'
        }).toPromise();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        error = e;
    }
    return {
        data: data,
        error: error
    };
};
const $cdd13196d2e0aa18$export$969f1da435e9dcbb = async (environment, projectId, cloudId, totalIssuePageNum, filter)=>{
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentsAGSFetched).start();
    let allIssueIds = [];
    let allDeployments = [];
    let deploymentsAfterCursor = null;
    let hasNextPage = false;
    let hasReachedMaxDeploymentsLimit = false;
    const numIssuesToFetch = totalIssuePageNum * (0, $ePfmq.ISSUE_PAGE_SIZE);
    do {
        // eslint-disable-next-line no-await-in-loop
        const { data: data, error: error } = await $cdd13196d2e0aa18$var$fetchAssociatedDeploymentsQuery(environment, projectId, cloudId, filter.timeWindow, deploymentsAfterCursor);
        const { loadingState: loadingState, data: deployments, error: fetchError } = $cdd13196d2e0aa18$export$958d9308eef1b87d(data, error);
        if (loadingState === $cdd13196d2e0aa18$var$HAS_ERROR || deployments == null) throw new Error(`Fetching deployment failed when fetching deployments. Detail: ${fetchError?.message ?? 'unknown'}`);
        const issueIds = deployments.flatMap((deployment)=>deployment.issueIds);
        allDeployments = allDeployments.concat(deployments);
        allIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))(allIssueIds.concat(issueIds));
        deploymentsAfterCursor = (0, $dD35P.getNextDeploymentAGSPageCursor)(data);
        hasNextPage = data?.graphStore?.projectAssociatedDeployment?.pageInfo.hasNextPage ?? false;
        if (allDeployments.length >= (0, $ePfmq.MAXIMUM_FETCHABLE_DEPLOYMENTS) && hasNextPage) hasReachedMaxDeploymentsLimit = true;
    /**
     * Keep trying to fetch deployments until we have either
     *
     * - At least (ISSUE_PAGE_SIZE * pageNumber) unique issues associated with deployments OR
     * - We have run out of deployments OR
     * - We have reached the max deployments limit
     */ }while (allIssueIds.length < numIssuesToFetch && deploymentsAfterCursor != null && !hasReachedMaxDeploymentsLimit);
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentsAGSFetched).stop();
    return {
        deployments: allDeployments,
        issueIds: allIssueIds,
        hasNextPage: hasNextPage,
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit
    };
};
const $cdd13196d2e0aa18$export$6f144cd006bec80 = async (environment, filter, cloudId)=>{
    const { issueIds: issueIds } = filter;
    let deployments = [];
    let deploymentAfterCursor = null;
    let hasReachedMaxDeploymentsLimit = false;
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentsFetched).start();
    // Data depot has limit for the number of issues. We have to cut by issue pages.
    for(let i = 0; i < issueIds.length; i += (0, $ePfmq.MAXIMUM_ISSUES_PER_DEPLOYMENT_REQUEST)){
        let deploymentsPageNumber = 0;
        do {
            deploymentsPageNumber += 1;
            const lastIndex = i + (0, $ePfmq.ISSUE_PAGE_SIZE) > issueIds.length ? issueIds.length : i + (0, $ePfmq.ISSUE_PAGE_SIZE);
            const partialIssueAris = issueIds.slice(i, lastIndex);
            if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentPageFetched).start();
            const variables = (0, $dD35P.getDeploymentQueryVariables)({
                ...filter,
                issueIds: partialIssueAris
            }, cloudId, deploymentAfterCursor);
            let data;
            let error;
            try {
                // eslint-disable-next-line no-await-in-loop
                data = await (0, $iWLL0.fetchQuery)(environment, (0, $c9IsI.default), {
                    ...variables
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                error = e;
            }
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'mainDeploymentsQuery$data | undefined'.
            const deploymentsPageResponse = $cdd13196d2e0aa18$export$eb2424d16c0e4416(data, error);
            if (deploymentsPageResponse.loadingState === $cdd13196d2e0aa18$var$HAS_ERROR || deploymentsPageResponse.data == null) throw new Error(`Fetching deployment failed when fetching from ${i} to ${lastIndex}. Detail: ${deploymentsPageResponse?.error?.message ?? 'unknown'}`);
            const fetchedDeployments = deploymentsPageResponse.data;
            if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentPageFetched).stop({
                customData: {
                    ...(0, $asHsD.collectorFromNumIssuesDeployments)({
                        numIssues: partialIssueAris.length,
                        numDeployments: fetchedDeployments.length,
                        issuePageSize: (0, $ePfmq.ISSUE_PAGE_SIZE),
                        deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
                    }),
                    relay: true
                }
            });
            deployments = deployments.concat(fetchedDeployments);
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'mainDeploymentsQuery$data | undefined'.
            deploymentAfterCursor = (0, $dD35P.getNextDeploymentPageCursor)(data);
            const hasNextPage = !!deploymentAfterCursor;
            if (deploymentsPageNumber === (0, $ePfmq.MAXIMUM_DEPLOYMENT_PAGES_TO_FETCH_PER_ISSUE_PAGE) && hasNextPage) hasReachedMaxDeploymentsLimit = true;
        }while (!(deploymentAfterCursor == null || hasReachedMaxDeploymentsLimit));
    }
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentsFetched).stop({
        customData: {
            ...(0, $asHsD.collectorFromNumIssuesDeployments)({
                numIssues: issueIds.length,
                numDeployments: deployments.length,
                issuePageSize: (0, $ePfmq.ISSUE_PAGE_SIZE),
                deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
            }),
            relay: true
        }
    });
    return {
        deployments: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(deployments, (deployment)=>deployment.id),
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit
    };
};
const $cdd13196d2e0aa18$var$toDeploymentFilter = ({ environments: environments, timeWindow: timeWindow }, issues)=>({
        issueIds: issues.map((issue)=>issue.id),
        environments: environments,
        timeWindow: timeWindow
    });
const $cdd13196d2e0aa18$var$toIssueFilter = ({ text: text, assignees: assignees, environments: environments, timeWindow: timeWindow, epicIds: epicIds, issueTypeIds: issueTypeIds, fixVersions: fixVersions, showIssuesWithoutDeployments: showIssuesWithoutDeployments }, projectId)=>({
        projectId: projectId,
        epicIds: epicIds,
        issueTypeIds: issueTypeIds,
        text: text,
        assignees: assignees,
        environments: environments,
        fixVersions: fixVersions,
        timeWindow: timeWindow,
        showIssuesWithoutDeployments: showIssuesWithoutDeployments
    });
const $cdd13196d2e0aa18$export$fbda6896135285a6 = async (environment, filter, totalIssuePageNum, projectId, cloudId)=>{
    if ((0, $eI5EY.fg)('solaris_deployments_timeline_migration_to_ags')) {
        if ((0, $2cKta.isFilterSuitableForAGSQuery)(filter)) return $cdd13196d2e0aa18$export$e0e9873a396d6523(environment, filter, totalIssuePageNum, projectId, cloudId);
        return $cdd13196d2e0aa18$export$5b18d792546bf216(environment, filter, totalIssuePageNum, projectId, cloudId);
    }
    if ((0, $2cKta.isFilterSuitableForAGSQuery)(filter)) return $cdd13196d2e0aa18$export$e0e9873a396d6523(environment, filter, totalIssuePageNum, projectId, cloudId);
    return $cdd13196d2e0aa18$export$208a87a7fa413e70(environment, filter, totalIssuePageNum, projectId, cloudId);
};
const $cdd13196d2e0aa18$export$e0e9873a396d6523 = async (environment, filter, totalIssuePageNum, projectId, cloudId)=>{
    const fetchDeploymentsResult = await $cdd13196d2e0aa18$export$969f1da435e9dcbb(environment, projectId, cloudId, totalIssuePageNum, filter);
    if (fetchDeploymentsResult === null) return null;
    if (fetchDeploymentsResult.issueIds.length === 0) // If there are no issues returned by the deployment query, there is nothing to display so
    // we can return an empty result here.
    return {
        coreData: {
            allDeployments: [],
            deploymentsByIssueId: {},
            issuesByIssueId: {},
            issues: []
        },
        hasNextIssuePage: false,
        hasReachedMaxDeploymentsLimit: false
    };
    const fetchIssuesResult = await $cdd13196d2e0aa18$export$89cf1798ec1ca82b(environment, totalIssuePageNum, fetchDeploymentsResult.issueIds, cloudId, projectId);
    if (fetchIssuesResult === null) return null;
    const { issues: issues } = fetchIssuesResult;
    const { deployments: deployments } = fetchDeploymentsResult;
    const sortedDeployments = (0, $2LmzR.getOrderedDeploymentsByTime)(deployments);
    const deploymentsByIssueId = (0, $dD35P.groupDeploymentsByIssueId)(sortedDeployments);
    const issuesByIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issues, 'id');
    const issuesOrderedNoDeploymentsLast = (0, $kuiLT.sortIssueByLatestDeploymentsAndLocateEmptyDeploymentsLast)(issues, deploymentsByIssueId);
    return {
        coreData: {
            allDeployments: sortedDeployments,
            deploymentsByIssueId: deploymentsByIssueId,
            issuesByIssueId: issuesByIssueId,
            issues: issuesOrderedNoDeploymentsLast
        },
        /**
     * We can try to fetch a new page when we scroll down if we either:
     *
     * - have more deployments we can fetch (fetchDeploymentsResult.hasNextPage) OR
     * - there are more issueIds that haven't been fetched yet (fetchIssuesResult.hasNextPage)
     */ hasNextIssuePage: fetchDeploymentsResult.hasNextPage || fetchIssuesResult.hasNextPage,
        hasReachedMaxDeploymentsLimit: fetchDeploymentsResult.hasReachedMaxDeploymentsLimit
    };
};
const $cdd13196d2e0aa18$export$208a87a7fa413e70 = async (environment, filter, totalIssuePageNum, projectId, cloudId)=>{
    const issueFilter = $cdd13196d2e0aa18$var$toIssueFilter(filter, projectId);
    const fetchIssuesResult = await $cdd13196d2e0aa18$export$db8cc4a4a990b3a2(environment, issueFilter, totalIssuePageNum, cloudId);
    if (fetchIssuesResult === null) return null;
    const { issues: issues, hasNextPage: hasNextIssuePage } = fetchIssuesResult;
    const deploymentFilter = $cdd13196d2e0aa18$var$toDeploymentFilter(filter, issues);
    const fetchDeploymentsResult = await $cdd13196d2e0aa18$export$6f144cd006bec80(environment, deploymentFilter, cloudId);
    if (fetchDeploymentsResult === null) return null;
    const { deployments: deployments, hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit } = fetchDeploymentsResult;
    const sortedDeployments = (0, $2LmzR.getOrderedDeploymentsByTime)(deployments);
    const deploymentsByIssueId = (0, $dD35P.groupDeploymentsByIssueId)(sortedDeployments);
    const issuesByIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issues, 'id');
    const issuesOrderedNoDeploymentsLast = (0, $kuiLT.sortIssueByLatestDeploymentsAndLocateEmptyDeploymentsLast)(issues, deploymentsByIssueId);
    return {
        coreData: {
            allDeployments: sortedDeployments,
            deploymentsByIssueId: deploymentsByIssueId,
            issuesByIssueId: issuesByIssueId,
            issues: issuesOrderedNoDeploymentsLast
        },
        hasNextIssuePage: hasNextIssuePage,
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit
    };
};
const $cdd13196d2e0aa18$var$canFetchIssuePage = (numIssuePages)=>(0, $ePfmq.ISSUE_PAGE_SIZE) * numIssuePages <= (0, $ePfmq.MAXIMUM_FETCHABLE_ISSUES);
const $cdd13196d2e0aa18$var$hasMaximumFetchableIssuesReached = (numIssuePages)=>(0, $ePfmq.ISSUE_PAGE_SIZE) * numIssuePages >= (0, $ePfmq.MAXIMUM_FETCHABLE_ISSUES);
const $cdd13196d2e0aa18$var$constructResult = (coreData, loadingState, error, numIssuePages, fetchMore, hasNextIssuePage, hasReachedMaxDeploymentsLimit)=>{
    const getNextIssuePage = hasNextIssuePage && $cdd13196d2e0aa18$var$canFetchIssuePage(numIssuePages + 1) ? fetchMore : null;
    const hasReachedMaxIssuesLimit = $cdd13196d2e0aa18$var$hasMaximumFetchableIssuesReached(numIssuePages) && hasNextIssuePage;
    return {
        serviceResult: {
            error: error ?? undefined,
            loadingState: loadingState,
            data: coreData ?? undefined
        },
        getNextIssuePage: getNextIssuePage,
        hasReachedMaxIssuesLimit: hasReachedMaxIssuesLimit,
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit
    };
};
const $cdd13196d2e0aa18$export$7b6e94572246f648 = ({ children: children })=>{
    const filter = $cdd13196d2e0aa18$export$21745039f12a8096();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // RLSS-501: Move project ID into `Filter` type
    const projectId = (0, $lnbOK.useProjectId)();
    const [{ coreData: coreData, error: error, loadingState: loadingState, numIssuePages: numIssuePages, hasNextIssuePage: hasNextIssuePage, hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit }, dispatch] = (0, $eUqFw.useReducer)((0, $3iyQa.coreDataReducer), (0, $3iyQa.initialState));
    (0, $eUqFw.useEffect)(()=>{
        let wasCancelled = false;
        const fetchPaginationChunk = async ()=>{
            if (filter === null || projectId === null) return;
            try {
                // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
                dispatch({
                    type: 'fetchTriggered'
                });
                if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.issuesAndDeploymentsFetched).start();
                const fetchCoreDataResult = await $cdd13196d2e0aa18$export$fbda6896135285a6(environment, filter, numIssuePages, projectId, cloudId);
                if (fetchCoreDataResult === null || wasCancelled) return;
                const isFetchingViaAGS = filter && (0, $2cKta.isFilterSuitableForAGSQuery)(filter);
                if ((0, $asHsD.isInitialLoad)()) {
                    (0, $psMOt.issuesAndDeploymentsFetched).stop({
                        customData: {
                            ...(0, $asHsD.collectorFromCoreData)({
                                coreData: fetchCoreDataResult.coreData,
                                issuePageSize: (0, $2cKta.isFilterSuitableForAGSQuery)(filter) ? (0, $ePfmq.ISSUE_PAGE_SIZE) : (0, $ePfmq.ISSUE_PAGE_SIZE),
                                deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
                            }),
                            relay: true,
                            isFetchingViaAGS: isFetchingViaAGS
                        }
                    });
                    (0, $asHsD.setInitialLoadFinished)();
                }
                try {
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'queried deploymentsTimelineData', {
                        hasIssuesWithoutDeployments: Object.keys(fetchCoreDataResult.coreData.deploymentsByIssueId).length !== fetchCoreDataResult.coreData.issues.length,
                        showIssuesWithoutDeployments: filter.showIssuesWithoutDeployments,
                        hasFiltersApplied: (0, $2fW3U.isFilterApplied)(filter)
                    });
                } catch (e) {
                // Don't do anything
                }
                // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
                dispatch({
                    type: 'fetchSuccess',
                    payload: fetchCoreDataResult
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                if (wasCancelled) return;
                // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
                dispatch({
                    type: 'fetchFailed',
                    payload: e
                });
            }
        };
        fetchPaginationChunk();
        return ()=>{
            wasCancelled = true;
        };
    }, [
        filter,
        numIssuePages,
        cloudId,
        environment,
        projectId,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
            type: 'filterChanged'
        });
    }, [
        filter
    ]);
    const fetchMore = ()=>{
        // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        dispatch({
            type: 'fetchMore'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cdd13196d2e0aa18$export$886c8fd3526d766e.Provider, {
        value: $cdd13196d2e0aa18$var$constructResult(coreData, loadingState, error, numIssuePages, fetchMore, hasNextIssuePage, hasReachedMaxDeploymentsLimit)
    }, children);
};
const $cdd13196d2e0aa18$export$6d519f324ee09296 = ()=>{
    const { serviceResult: serviceResult } = $cdd13196d2e0aa18$export$4b88cf5a05e76c52();
    return $cdd13196d2e0aa18$export$ea2fd562b935f4a9(serviceResult);
};
const $cdd13196d2e0aa18$export$ea2fd562b935f4a9 = (serviceResult)=>{
    const issues = serviceResult.data?.issues ?? [];
    const deploymentsByIssueId = serviceResult.data?.deploymentsByIssueId ?? {};
    // Note: the "issues without deployments" setting means it's possible for
    // `deploymentsByIssueId[issue.id]` to yield no result.
    const issueDeploymentDates = issues.flatMap((issue)=>deploymentsByIssueId[issue.id] ?? []).map((deployment)=>deployment.lastUpdated);
    return issueDeploymentDates.length === 0 ? null : (0, $9sv5e.default)(issueDeploymentDates);
};
const $cdd13196d2e0aa18$export$5b18d792546bf216 = async (environment, filter, totalIssuePageNum, projectId, cloudId)=>{
    const issueFilter = $cdd13196d2e0aa18$var$toIssueFilter(filter, projectId);
    const fetchIssuesResult = await $cdd13196d2e0aa18$export$db8cc4a4a990b3a2(environment, issueFilter, totalIssuePageNum, cloudId);
    if (fetchIssuesResult === null) return null;
    const { issues: issues, hasNextPage: hasNextIssuePage } = fetchIssuesResult;
    const deploymentFilter = $cdd13196d2e0aa18$var$toDeploymentFilter(filter, issues);
    const fetchDeploymentsResult = await $cdd13196d2e0aa18$export$9cc114b99aa2d5b6(environment, deploymentFilter, cloudId);
    if (fetchDeploymentsResult === null) return null;
    const { deployments: deployments, hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit } = fetchDeploymentsResult;
    const sortedDeployments = (0, $2LmzR.getOrderedDeploymentsByTime)(deployments);
    const deploymentsByIssueId = (0, $dD35P.groupDeploymentsByIssueId)(sortedDeployments);
    const issuesByIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issues, 'id');
    const issuesOrderedNoDeploymentsLast = (0, $kuiLT.sortIssueByLatestDeploymentsAndLocateEmptyDeploymentsLast)(issues, deploymentsByIssueId);
    return {
        coreData: {
            allDeployments: sortedDeployments,
            deploymentsByIssueId: deploymentsByIssueId,
            issuesByIssueId: issuesByIssueId,
            issues: issuesOrderedNoDeploymentsLast
        },
        hasNextIssuePage: hasNextIssuePage,
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit
    };
};
const $cdd13196d2e0aa18$export$92341bd4ef4b5d89 = (deployments, environmentDisplayNames)=>{
    return deployments.filter((deployment)=>environmentDisplayNames.some((environmentDisplayName)=>deployment.environment.displayName.toLowerCase().includes(environmentDisplayName.toLowerCase())));
};
const $cdd13196d2e0aa18$export$9cc114b99aa2d5b6 = async (environment, filter, cloudId)=>{
    const { issueIds: issueIds } = filter;
    let deployments = [];
    let deploymentAfterCursor = null;
    let hasReachedMaxDeploymentsLimit = false;
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentsFetched).start();
    // Data depot has limit for the number of issues. We have to cut by issue pages.
    for(let i = 0; i < issueIds.length; i += (0, $ePfmq.MAXIMUM_ISSUES_PER_DEPLOYMENT_REQUEST)){
        let deploymentsPageNumber = 0;
        do {
            deploymentsPageNumber += 1;
            const lastIndex = i + (0, $ePfmq.ISSUE_PAGE_SIZE) > issueIds.length ? issueIds.length : i + (0, $ePfmq.ISSUE_PAGE_SIZE);
            const partialIssueAris = issueIds.slice(i, lastIndex);
            if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentPageFetched).start();
            const variables = (0, $dD35P.getAGSDeploymentQueryVariables)({
                ...filter,
                issueIds: partialIssueAris
            }, cloudId, deploymentAfterCursor);
            let data;
            let error;
            try {
                // eslint-disable-next-line no-await-in-loop
                data = await (0, $iWLL0.fetchQuery)(environment, (0, $iR0Zs.default), {
                    ...variables
                }, {
                    fetchPolicy: 'store-or-network'
                }).toPromise();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                error = e;
            }
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'mainAGSQuery$data | undefined'.
            const deploymentsPageResponse = $cdd13196d2e0aa18$export$6474cc3702da1237(data, error);
            if (deploymentsPageResponse.loadingState === $cdd13196d2e0aa18$var$HAS_ERROR || deploymentsPageResponse.data == null) throw new Error(`Fetching deployment failed when fetching from ${i} to ${lastIndex}. Detail: ${deploymentsPageResponse?.error?.message ?? 'unknown'}`);
            const fetchedDeploymentsResult = deploymentsPageResponse.data;
            // This is to filter the deployments based on environment display names if any environment display name filters are applied
            const filteredFetchedDeploymentsResult = filter.environments.names.length ? $cdd13196d2e0aa18$export$92341bd4ef4b5d89(fetchedDeploymentsResult, filter.environments.names) : fetchedDeploymentsResult;
            if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentPageFetched).stop({
                customData: {
                    ...(0, $asHsD.collectorFromNumIssuesDeployments)({
                        numIssues: partialIssueAris.length,
                        numDeployments: filteredFetchedDeploymentsResult.length,
                        issuePageSize: (0, $ePfmq.ISSUE_PAGE_SIZE),
                        deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
                    }),
                    relay: true
                }
            });
            deployments = deployments.concat(filteredFetchedDeploymentsResult);
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'mainDeploymentsQuery$data | undefined'.
            deploymentAfterCursor = (0, $dD35P.getNextDeploymentPageCursor)(data);
            const hasNextPage = !!deploymentAfterCursor;
            if (deploymentsPageNumber === (0, $ePfmq.MAXIMUM_DEPLOYMENT_PAGES_TO_FETCH_PER_ISSUE_PAGE) && hasNextPage) hasReachedMaxDeploymentsLimit = true;
        }while (!(deploymentAfterCursor == null || hasReachedMaxDeploymentsLimit));
    }
    if ((0, $asHsD.isInitialLoad)()) (0, $psMOt.deploymentsFetched).stop({
        customData: {
            ...(0, $asHsD.collectorFromNumIssuesDeployments)({
                numIssues: issueIds.length,
                numDeployments: deployments.length,
                issuePageSize: (0, $ePfmq.ISSUE_PAGE_SIZE),
                deploymentsPageSize: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE)
            }),
            relay: true
        }
    });
    return {
        deployments: (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(deployments, (deployment)=>deployment.id),
        hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit
    };
};

});
parcelRegister("iR0Zs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d181ef33e25dac0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40aa72ed85e3e50fc1a0fe08722f58e8>>
 * @relayHash 60019fa0669d2577e66db7174eca690f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 985815c6878b5a76357e62468de040fe8b13d5af56eabc395c16c1fe98c89025
const $3d181ef33e25dac0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ids"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "ids",
            "variableName": "ids"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "url"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "issueIds"
            },
            {
                "kind": "ScalarField",
                "name": "deploymentSequenceNumber"
            },
            {
                "kind": "ScalarField",
                "name": "updateSequenceNumber"
            },
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "description"
            },
            {
                "kind": "ScalarField",
                "name": "state"
            },
            {
                "kind": "ScalarField",
                "name": "lastUpdated"
            },
            {
                "concreteType": "DeploymentPipeline",
                "kind": "LinkedField",
                "name": "pipeline",
                "plural": false,
                "selections": [
                    v8 /*: any*/ ,
                    v7 /*: any*/ 
                ]
            },
            {
                "concreteType": "DevOpsEnvironment",
                "kind": "LinkedField",
                "name": "environment",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v7 /*: any*/ 
                ]
            }
        ],
        "type": "DeploymentSummary"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainAGSQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "GraphStoreBatchIssueAssociatedDeploymentConnection",
                            "kind": "LinkedField",
                            "name": "issueAssociatedDeploymentBatch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreBatchIssueAssociatedDeploymentNode",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreBatchIssueAssociatedDeploymentEndNode",
                                            "kind": "LinkedField",
                                            "name": "to",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "data",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainAGSQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "GraphStoreBatchIssueAssociatedDeploymentConnection",
                            "kind": "LinkedField",
                            "name": "issueAssociatedDeploymentBatch",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreBatchIssueAssociatedDeploymentNode",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreBatchIssueAssociatedDeploymentEndNode",
                                            "kind": "LinkedField",
                                            "name": "to",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "data",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                },
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "985815c6878b5a76357e62468de040fe8b13d5af56eabc395c16c1fe98c89025",
            "metadata": {},
            "name": "mainAGSQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3d181ef33e25dac0$var$node.hash = "eb58f0abc520577293fef6e52f27e962";
var $3d181ef33e25dac0$export$2e2bcd8739ae039 = $3d181ef33e25dac0$var$node;

});

parcelRegister("c9IsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85a97961db23272$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e67c3776a1f0cb9a230249ce9807b077>>
 * @relayHash 5bca99fd4d034350fb6444fd0005b5bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 01a79c2e48f39df6dd06b0b3839ffec2f865d8fc3e907a9fac8206ff06467038
const $c85a97961db23272$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = [
        {
            "concreteType": "JiraReleases",
            "kind": "LinkedField",
            "name": "jiraReleases",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "filter"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "JiraReleasesDeploymentSummaryConnection",
                    "kind": "LinkedField",
                    "name": "deployments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraReleasesDeploymentSummaryEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                },
                                {
                                    "concreteType": "DeploymentSummary",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "issueIds"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "deploymentSequenceNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "updateSequenceNumber"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "state"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastUpdated"
                                        },
                                        {
                                            "concreteType": "DeploymentPipeline",
                                            "kind": "LinkedField",
                                            "name": "pipeline",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "DevOpsEnvironment",
                                            "kind": "LinkedField",
                                            "name": "environment",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainDeploymentsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainDeploymentsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "01a79c2e48f39df6dd06b0b3839ffec2f865d8fc3e907a9fac8206ff06467038",
            "metadata": {},
            "name": "mainDeploymentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c85a97961db23272$var$node.hash = "0e91b6bc7d847a5a5fcb18b033c10caa";
var $c85a97961db23272$export$2e2bcd8739ae039 = $c85a97961db23272$var$node;

});

parcelRegister("jnwwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $810d9ef94c3beaee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b3a6398ac642f6a02d14c60ca877ba81>>
 * @relayHash 76542aee6e4003d20e65765e2c0abbf7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15f73cad5301305479bcbdc47643d8fae8b955d056a05d5b7cf09d43e958c635
const $810d9ef94c3beaee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeAfter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeBefore"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "items": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "greaterThanOrEqual",
                                            "variableName": "timeAfter"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "to_deploymentLastUpdated"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "and.0"
                        },
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "lessThan",
                                            "variableName": "timeBefore"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "to_deploymentLastUpdated"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "and.1"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "and"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "projectId"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": {
                "to_deploymentLastUpdated": {
                    "direction": "DESC",
                    "priority": 1
                }
            }
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "url"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "projectId",
                        "variableName": "projectId"
                    }
                ],
                "kind": "ScalarField",
                "name": "issueIds"
            },
            {
                "kind": "ScalarField",
                "name": "deploymentSequenceNumber"
            },
            {
                "kind": "ScalarField",
                "name": "updateSequenceNumber"
            },
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "description"
            },
            {
                "kind": "ScalarField",
                "name": "state"
            },
            {
                "kind": "ScalarField",
                "name": "lastUpdated"
            },
            {
                "concreteType": "DeploymentPipeline",
                "kind": "LinkedField",
                "name": "pipeline",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    v8 /*: any*/ 
                ]
            },
            {
                "concreteType": "DevOpsEnvironment",
                "kind": "LinkedField",
                "name": "environment",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "category"
                    },
                    v8 /*: any*/ 
                ]
            }
        ],
        "type": "DeploymentSummary"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainDeploymentsAGSQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentConnection",
                            "kind": "LinkedField",
                            "name": "projectAssociatedDeployment",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainDeploymentsAGSQuery",
            "selections": [
                {
                    "concreteType": "GraphStore",
                    "kind": "LinkedField",
                    "name": "graphStore",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentConnection",
                            "kind": "LinkedField",
                            "name": "projectAssociatedDeployment",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "15f73cad5301305479bcbdc47643d8fae8b955d056a05d5b7cf09d43e958c635",
            "metadata": {},
            "name": "mainDeploymentsAGSQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$810d9ef94c3beaee$var$node.hash = "ac55f8e19c154dac8550b1937dc29436";
var $810d9ef94c3beaee$export$2e2bcd8739ae039 = $810d9ef94c3beaee$var$node;

});

parcelRegister("94kJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1127a888036e867$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c159a7004b274dfe10b4131b0c521874>>
 * @relayHash d910e14528b778edccdf3346d4dd1cd7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c5898b87be2785cd1fa98b9e26166f97cc871384be79e78648ac0054ab83525
const $e1127a888036e867$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueKey"
    }, v8 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v13 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v14 = {
        "concreteType": "JiraReleasesEpic",
        "kind": "LinkedField",
        "name": "epic",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "color"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainIssueQuery",
            "selections": [
                {
                    "concreteType": "JiraReleases",
                    "kind": "LinkedField",
                    "name": "jiraReleases",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraReleasesIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraReleasesIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "JiraReleasesIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainIssueQuery",
            "selections": [
                {
                    "concreteType": "JiraReleases",
                    "kind": "LinkedField",
                    "name": "jiraReleases",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraReleasesIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraReleasesIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "JiraReleasesIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8c5898b87be2785cd1fa98b9e26166f97cc871384be79e78648ac0054ab83525",
            "metadata": {},
            "name": "mainIssueQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e1127a888036e867$var$node.hash = "d92a25ffb880dc1e08efe08905c98d12";
var $e1127a888036e867$export$2e2bcd8739ae039 = $e1127a888036e867$var$node;

});

parcelRegister("j2Hz1", function(module, exports) {

$parcel$export(module.exports, "default", () => $85eaed6e51aa6fd0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea49052951f377c360715ea6a4cc7bdf>>
 * @relayHash 08356da0dcdf728974572b8fd470cb17
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22391a6351810c59f5b7faf4f4b111fb3fbe055924c265a793c30d9a80107090
const $85eaed6e51aa6fd0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jqlSearch"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "jql",
                    "variableName": "jqlSearch"
                }
            ],
            "kind": "ObjectValue",
            "name": "issueSearchInput"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "idsOrAliases",
            "value": [
                "issuetype",
                "assignee",
                "parent",
                "summary"
            ]
        },
        {
            "kind": "Literal",
            "name": "ignoreMissingFields",
            "value": true
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v4 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v14 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v15 = [
        {
            "kind": "Literal",
            "name": "idsOrAliases",
            "value": [
                "summary"
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainIssueAGSQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraColorField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueColorField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": v15 /*: any*/ ,
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsByIdOrAlias",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\"])"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraParentIssueField"
                                                        }
                                                    ],
                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"assignee\",\"parent\",\"summary\"],ignoreMissingFields:true)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainIssueAGSQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v4 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraColorField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueColorField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraColor",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "color",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v14 /*: any*/ ,
                                                                                        v4 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v4 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": v15 /*: any*/ ,
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsByIdOrAlias",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v4 /*: any*/ 
                                                                            ],
                                                                            "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\"])"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraParentIssueField"
                                                        },
                                                        v4 /*: any*/ 
                                                    ],
                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"issuetype\",\"assignee\",\"parent\",\"summary\"],ignoreMissingFields:true)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "22391a6351810c59f5b7faf4f4b111fb3fbe055924c265a793c30d9a80107090",
            "metadata": {},
            "name": "mainIssueAGSQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$85eaed6e51aa6fd0$var$node.hash = "b88c5eb28196cc550fa42480e3096026";
var $85eaed6e51aa6fd0$export$2e2bcd8739ae039 = $85eaed6e51aa6fd0$var$node;

});

parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("1EkP8", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $bOiiU = parcelRequire("bOiiU");

var $7qARj = parcelRequire("7qARj");
/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ function $1339ae07b141cc7d$var$maxBy(array, iteratee) {
    return array && array.length ? $77fbL(array, $7qARj(iteratee, 2), $bOiiU) : undefined;
}
module.exports = $1339ae07b141cc7d$var$maxBy;

});
parcelRegister("77fbL", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $52e4f805c3622ecd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8aco7(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $52e4f805c3622ecd$var$baseExtremum;

});

parcelRegister("bOiiU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $899290031a4184bf$var$baseGt(value, other) {
    return value > other;
}
module.exports = $899290031a4184bf$var$baseGt;

});


parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");


var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $73a5c9d720aa66e1$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
    [(0, $73a5c9d720aa66e1$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
    [(0, $73a5c9d720aa66e1$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
    [(0, $73a5c9d720aa66e1$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
    [(0, $73a5c9d720aa66e1$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
    [(0, $73a5c9d720aa66e1$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
    [(0, $73a5c9d720aa66e1$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
    [(0, $73a5c9d720aa66e1$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
    [(0, $73a5c9d720aa66e1$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
    [(0, $73a5c9d720aa66e1$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
    [(0, $73a5c9d720aa66e1$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
    [(0, $73a5c9d720aa66e1$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
    [(0, $73a5c9d720aa66e1$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    [(0, $73a5c9d720aa66e1$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $73a5c9d720aa66e1$exports).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $73a5c9d720aa66e1$exports).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $73a5c9d720aa66e1$exports).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $73a5c9d720aa66e1$exports).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $73a5c9d720aa66e1$exports).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $73a5c9d720aa66e1$exports).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $73a5c9d720aa66e1$exports).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $73a5c9d720aa66e1$exports).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $73a5c9d720aa66e1$exports).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $73a5c9d720aa66e1$exports).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $73a5c9d720aa66e1$exports).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $73a5c9d720aa66e1$exports).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $73a5c9d720aa66e1$exports).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $73a5c9d720aa66e1$exports).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $73a5c9d720aa66e1$exports).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $73a5c9d720aa66e1$exports).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $73a5c9d720aa66e1$exports).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $73a5c9d720aa66e1$exports).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $73a5c9d720aa66e1$exports).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $73a5c9d720aa66e1$exports).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $73a5c9d720aa66e1$exports).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R200})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $73a5c9d720aa66e1$exports).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $73a5c9d720aa66e1$exports).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $73a5c9d720aa66e1$exports).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N300})`,
        text: `var(--ds-text-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $73a5c9d720aa66e1$exports).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$exports).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("psMOt", function(module, exports) {

$parcel$export(module.exports, "issuesAndDeploymentsFetched", () => $07e669d08d412225$export$1478177fec34cdef);
$parcel$export(module.exports, "issuesFetched", () => $07e669d08d412225$export$ae5025a8b1ef933b);
$parcel$export(module.exports, "issuesAGSFetched", () => $07e669d08d412225$export$2b91c42df46d6b8b);
$parcel$export(module.exports, "deploymentsFetched", () => $07e669d08d412225$export$17d1f15b843fa371);
$parcel$export(module.exports, "deploymentsAGSFetched", () => $07e669d08d412225$export$d2cf2e1c4c7972dd);
$parcel$export(module.exports, "deploymentPageFetched", () => $07e669d08d412225$export$9c26e37797e02f7a);

var $lNfG4 = parcelRequire("lNfG4");
const $07e669d08d412225$export$1478177fec34cdef = (0, $lNfG4.metrics).custom({
    key: 'software.deployments.issues-and-deployments',
    slo: {
        threshold: 7000
    }
});
const $07e669d08d412225$export$ae5025a8b1ef933b = (0, $lNfG4.metrics).custom({
    key: 'software.deployments.issues',
    slo: {
        threshold: 6000
    }
});
const $07e669d08d412225$export$2b91c42df46d6b8b = (0, $lNfG4.metrics).custom({
    key: 'software.deployments.issues-ags',
    slo: {
        threshold: 6000
    }
});
const $07e669d08d412225$export$17d1f15b843fa371 = (0, $lNfG4.metrics).custom({
    key: 'software.deployments.deployments',
    slo: {
        threshold: 6000
    }
});
const $07e669d08d412225$export$d2cf2e1c4c7972dd = (0, $lNfG4.metrics).custom({
    key: 'software.deployments.deployments-ags',
    slo: {
        threshold: 6000
    }
});
const $07e669d08d412225$export$9c26e37797e02f7a = (0, $lNfG4.metrics).custom({
    key: 'software.deployments.deployment-page',
    slo: {
        threshold: 6000
    }
});

});

parcelRegister("yevjV", function(module, exports) {

$parcel$export(module.exports, "DeploymentEnvironmentTypeOptions", () => $2051521358adadb6$export$1f6aff51f6b6bc0f);
$parcel$export(module.exports, "DeploymentStateOptions", () => $2051521358adadb6$export$a761da6c19e008f6);
/**
 * Deployment
 */ const $2051521358adadb6$var$PRODUCTION = 'PRODUCTION';
const $2051521358adadb6$var$STAGING = 'STAGING';
const $2051521358adadb6$var$TESTING = 'TESTING';
const $2051521358adadb6$var$DEVELOPMENT = 'DEVELOPMENT';
const $2051521358adadb6$var$UNMAPPED = 'UNMAPPED';
const $2051521358adadb6$export$1f6aff51f6b6bc0f = {
    PRODUCTION: $2051521358adadb6$var$PRODUCTION,
    STAGING: $2051521358adadb6$var$STAGING,
    TESTING: $2051521358adadb6$var$TESTING,
    DEVELOPMENT: $2051521358adadb6$var$DEVELOPMENT,
    UNMAPPED: $2051521358adadb6$var$UNMAPPED
};
const $2051521358adadb6$var$PENDING = 'PENDING';
const $2051521358adadb6$var$IN_PROGRESS = 'IN_PROGRESS';
const $2051521358adadb6$var$SUCCESSFUL = 'SUCCESSFUL';
const $2051521358adadb6$var$CANCELLED = 'CANCELLED';
const $2051521358adadb6$var$FAILED = 'FAILED';
const $2051521358adadb6$var$ROLLED_BACK = 'ROLLED_BACK';
const $2051521358adadb6$var$UNKNOWN = 'UNKNOWN';
const $2051521358adadb6$export$a761da6c19e008f6 = {
    PENDING: $2051521358adadb6$var$PENDING,
    IN_PROGRESS: $2051521358adadb6$var$IN_PROGRESS,
    SUCCESSFUL: $2051521358adadb6$var$SUCCESSFUL,
    CANCELLED: $2051521358adadb6$var$CANCELLED,
    FAILED: $2051521358adadb6$var$FAILED,
    ROLLED_BACK: $2051521358adadb6$var$ROLLED_BACK,
    UNKNOWN: $2051521358adadb6$var$UNKNOWN
};

});

parcelRegister("itCm6", function(module, exports) {

$parcel$export(module.exports, "getResourceId", () => $396a85f8de5f1222$export$8aa413923a6a0c63);

var $huI7r = parcelRequire("huI7r");
const $396a85f8de5f1222$export$8aa413923a6a0c63 = (ariLikeString)=>{
    const ari = (0, $huI7r.toAri)(ariLikeString);
    if (ari === undefined) throw Error('Invalid ARI');
    return (0, $huI7r.getAriConfig)(ari).resourceId;
};

});

parcelRegister("2LmzR", function(module, exports) {

$parcel$export(module.exports, "getEnvironmentId", () => $77fddeb8adfbcb0c$export$e383d492f3f341ca);
$parcel$export(module.exports, "getMostMeaningfulDeployment", () => $77fddeb8adfbcb0c$export$cd3d3758a084e0b8);
$parcel$export(module.exports, "getColorForDeploymentState", () => $77fddeb8adfbcb0c$export$65af5b68f98ed71);
$parcel$export(module.exports, "getGroupedDeployments", () => $77fddeb8adfbcb0c$export$2cba1bbd39d32352);
$parcel$export(module.exports, "areDeploymentsEqual", () => $77fddeb8adfbcb0c$export$721ab7378db06440);
$parcel$export(module.exports, "getOrderedDeploymentsByTime", () => $77fddeb8adfbcb0c$export$4b5b568b5e3d7123);

var $fcWBJ = parcelRequire("fcWBJ");

var $3G3gn = parcelRequire("3G3gn");

var $h0vyZ = parcelRequire("h0vyZ");


var $5GPm9 = parcelRequire("5GPm9");

var $yevjV = parcelRequire("yevjV");
const $77fddeb8adfbcb0c$var$priorityList = [
    {
        state: (0, $yevjV.DeploymentStateOptions).FAILED
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).IN_PROGRESS
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).PENDING
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).ROLLED_BACK
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).SUCCESSFUL,
        prodOnly: true
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).SUCCESSFUL,
        nonProdOnly: true
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).UNKNOWN
    },
    {
        state: (0, $yevjV.DeploymentStateOptions).CANCELLED
    }
];
// @ts-expect-error - TS7006 - Parameter 'deployment' implicitly has an 'any' type.
const $77fddeb8adfbcb0c$var$findPriorityNumber = (deployment)=>$77fddeb8adfbcb0c$var$priorityList.findIndex((priority)=>{
        if (priority.prodOnly && deployment.environment.type !== (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION) return false;
        if (priority.nonProdOnly && deployment.environment.type === (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION) return false;
        return deployment.state === priority.state;
    });
const $77fddeb8adfbcb0c$export$e383d492f3f341ca = (environment)=>`${environment.type}:${environment.displayName}`;
const $77fddeb8adfbcb0c$export$cd3d3758a084e0b8 = (timeSortedDeployments)=>{
    if (timeSortedDeployments.length === 1) return timeSortedDeployments[0];
    const deploysByEnvironment = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(timeSortedDeployments, (deployment)=>$77fddeb8adfbcb0c$export$e383d492f3f341ca(deployment.environment)));
    const mostRecentDeploymentsPerEnvironment = deploysByEnvironment.map((deploys)=>deploys[0]);
    const prioritySortedDeployments = (0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(mostRecentDeploymentsPerEnvironment, (deployment)=>$77fddeb8adfbcb0c$var$findPriorityNumber(deployment));
    return prioritySortedDeployments[0];
};
const $77fddeb8adfbcb0c$export$65af5b68f98ed71 = (deploymentState)=>{
    const state = {
        type: deploymentState
    };
    switch(state.type){
        case (0, $yevjV.DeploymentStateOptions).PENDING:
            return `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B300})`;
        case (0, $yevjV.DeploymentStateOptions).IN_PROGRESS:
            return `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B300})`;
        case (0, $yevjV.DeploymentStateOptions).SUCCESSFUL:
            return `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
        case (0, $yevjV.DeploymentStateOptions).CANCELLED:
            return `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`;
        case (0, $yevjV.DeploymentStateOptions).FAILED:
            return `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
        case (0, $yevjV.DeploymentStateOptions).ROLLED_BACK:
            return `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y400})`;
        case (0, $yevjV.DeploymentStateOptions).UNKNOWN:
            return `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
        default:
            throw Error('Unhandled deployment state');
    }
};
const $77fddeb8adfbcb0c$export$2cba1bbd39d32352 = (deployments, getPositionFromDate, mode)=>{
    const daysToDeployments = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(deployments, (deployment)=>{
        const roundingDuration = (0, $5GPm9.getRoundingDuration)(mode);
        return (0, $5GPm9.roundToMultiple)((0, $h0vyZ.default)(deployment.lastUpdated, 'utc').valueOf(), roundingDuration);
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const grouped = Object.values(daysToDeployments);
    return grouped.map((deploymentsOnDay)=>({
            deployments: deploymentsOnDay,
            ...getPositionFromDate(deploymentsOnDay[0].lastUpdated)
        }));
};
const $77fddeb8adfbcb0c$export$721ab7378db06440 = (sortedDeps1, sortedDeps2)=>{
    if (sortedDeps1.length !== sortedDeps2.length) return false;
    return sortedDeps1.every((deployment, index)=>deployment.id === sortedDeps2[index].id);
};
const $77fddeb8adfbcb0c$export$4b5b568b5e3d7123 = (deployments)=>[
        ...deployments
    ].sort((d1, d2)=>d2.lastUpdated.getTime() - d1.lastUpdated.getTime());

});
parcelRegister("5GPm9", function(module, exports) {

$parcel$export(module.exports, "getTimelineWidth", () => $035eb0c77fe81a2f$export$87113eddf3515c00);
$parcel$export(module.exports, "getRoundingDuration", () => $035eb0c77fe81a2f$export$c3d26571de1aa45c);
$parcel$export(module.exports, "roundToMultiple", () => $035eb0c77fe81a2f$export$6abe75030bbc425c);
$parcel$export(module.exports, "getPositionFromDateFn", () => $035eb0c77fe81a2f$export$8f9bb442d2c6d0b5);

var $6wqPF = parcelRequire("6wqPF");
var $1XsGP = parcelRequire("1XsGP");
var $3jYzf = parcelRequire("3jYzf");

var $h0vyZ = parcelRequire("h0vyZ");

var $5iWql = parcelRequire("5iWql");

var $gsGpO = parcelRequire("gsGpO");

var $36Dty = parcelRequire("36Dty");

var $94TFJ = parcelRequire("94TFJ");
const { DAYS: $035eb0c77fe81a2f$var$DAYS, WEEKS: $035eb0c77fe81a2f$var$WEEKS, MONTHS: $035eb0c77fe81a2f$var$MONTHS, QUARTERS: $035eb0c77fe81a2f$var$QUARTERS } = (0, $gsGpO.TimelineModeOptions);
// Size in pixels a column should ideally represent for any timeline mode
const $035eb0c77fe81a2f$var$WEEKS_COLUMN_WIDTH = 255;
// Size in pixels a single value should be for hours (36px for each hour)
const $035eb0c77fe81a2f$var$DAYS_COLUMN_WIDTH = 432;
const $035eb0c77fe81a2f$export$893f7447303d5bc0 = {
    [$035eb0c77fe81a2f$var$DAYS]: $035eb0c77fe81a2f$var$DAYS_COLUMN_WIDTH / (0, $1XsGP.default)({
        days: 1
    }),
    [$035eb0c77fe81a2f$var$WEEKS]: $035eb0c77fe81a2f$var$WEEKS_COLUMN_WIDTH / (0, $1XsGP.default)({
        days: 7
    }),
    [$035eb0c77fe81a2f$var$MONTHS]: $035eb0c77fe81a2f$var$WEEKS_COLUMN_WIDTH / (0, $1XsGP.default)({
        days: 30
    }),
    [$035eb0c77fe81a2f$var$QUARTERS]: $035eb0c77fe81a2f$var$WEEKS_COLUMN_WIDTH / (0, $1XsGP.default)({
        days: 91
    })
};
const $035eb0c77fe81a2f$export$87113eddf3515c00 = (0, $5iWql.default)((timelineMode, duration)=>(0, $36Dty.getTotalMilliseconds)(duration) * $035eb0c77fe81a2f$export$893f7447303d5bc0[timelineMode]);
const $035eb0c77fe81a2f$var$roundTwoDecimals = (n)=>Math.round(n * 100) / 100;
const $035eb0c77fe81a2f$export$c37640da124effef = (decimal)=>$035eb0c77fe81a2f$var$roundTwoDecimals(decimal * 100);
const $035eb0c77fe81a2f$export$c3d26571de1aa45c = (0, $5iWql.default)((timelineMode)=>{
    if (timelineMode === $035eb0c77fe81a2f$var$DAYS) return (0, $1XsGP.default)({
        hours: (0, $94TFJ.DAY_VIEW_COLUMN_HOUR_INTERVAL)
    });
    if (timelineMode === $035eb0c77fe81a2f$var$WEEKS) return (0, $1XsGP.default)({
        days: 1
    });
    throw Error('cannot find rounding duration');
});
const $035eb0c77fe81a2f$export$6abe75030bbc425c = (num, multiple)=>Math.floor(num / multiple) * multiple;
const $035eb0c77fe81a2f$export$8f9bb442d2c6d0b5 = (0, $5iWql.default)((startDate, endDate, timelineMode)=>{
    const start = (0, $h0vyZ.default)((0, $3jYzf.default)(new Date(startDate)), 'utc').valueOf();
    const end = (0, $h0vyZ.default)((0, $3jYzf.default)((0, $6wqPF.default)(new Date(endDate), 1)), 'utc').valueOf();
    const roundingDuration = $035eb0c77fe81a2f$export$c3d26571de1aa45c(timelineMode); // either 1 day or X hours in milliseconds
    const duration = end - start;
    return (date)=>{
        const target = $035eb0c77fe81a2f$export$6abe75030bbc425c((0, $h0vyZ.default)(date, 'utc').valueOf(), roundingDuration);
        return {
            left: $035eb0c77fe81a2f$export$c37640da124effef((target - start) / duration),
            right: $035eb0c77fe81a2f$export$c37640da124effef((end - (target + roundingDuration)) / duration)
        };
    };
});

});
parcelRegister("gsGpO", function(module, exports) {

$parcel$export(module.exports, "TimelineModeOptions", () => $53da99b0a7d8614d$export$c0847becb3a089f);
const $53da99b0a7d8614d$export$c0847becb3a089f = {
    DAYS: 'DAYS',
    WEEKS: 'WEEKS',
    MONTHS: 'MONTHS',
    QUARTERS: 'QUARTERS'
};

});

parcelRegister("36Dty", function(module, exports) {

$parcel$export(module.exports, "getDatePercentage", () => $4884f96ba4e7aea6$export$a938183963d87f2c);
$parcel$export(module.exports, "getPositionForTimestamp", () => $4884f96ba4e7aea6$export$eae015a6ab747653);
$parcel$export(module.exports, "getTotalMilliseconds", () => $4884f96ba4e7aea6$export$63b7265fc5ebc679);

var $h0vyZ = parcelRequire("h0vyZ");
const $4884f96ba4e7aea6$export$a938183963d87f2c = (targetDate, from, to)=>{
    // convert to UTC to measure dates because UTC doesn't have to deal with
    // daylight savings times. Our timeline renders all hours, including
    // dead hours at daylight savings time.
    const targetDateUTC = (0, $h0vyZ.default)(new Date(targetDate), 'utc').valueOf();
    const fromUTC = (0, $h0vyZ.default)(new Date(from), 'utc').valueOf();
    const toUTC = (0, $h0vyZ.default)(new Date(to), 'utc').valueOf();
    const total = toUTC - fromUTC;
    return (targetDateUTC - fromUTC) / total;
};
const $4884f96ba4e7aea6$export$eae015a6ab747653 = (timestamp, timelineDuration)=>$4884f96ba4e7aea6$export$a938183963d87f2c(timestamp, timelineDuration.startDate, timelineDuration.endDate);
const $4884f96ba4e7aea6$export$63b7265fc5ebc679 = ({ startDate: startDate, endDate: endDate })=>(0, $h0vyZ.default)(endDate, 'utc').valueOf() - (0, $h0vyZ.default)(startDate, 'utc').valueOf();

});

parcelRegister("94TFJ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEVEL", () => $f7d9347e6adbf210$export$480df663967f228c);
$parcel$export(module.exports, "RESIZE_DEBOUNCE_MS", () => $f7d9347e6adbf210$export$747901c4619ea19c);
$parcel$export(module.exports, "TABLE_HEADER_HEIGHT_PX", () => $f7d9347e6adbf210$export$761baed1fe05cc33);
$parcel$export(module.exports, "DAY_VIEW_COLUMN_HOUR_INTERVAL", () => $f7d9347e6adbf210$export$d30be57c88741d7d);

const $f7d9347e6adbf210$export$480df663967f228c = 1;
const $f7d9347e6adbf210$export$747901c4619ea19c = 250;
const $f7d9347e6adbf210$export$761baed1fe05cc33 = `${(0, $d736b332644d7251$export$cdb7fd9d999c7168)}px`;
const $f7d9347e6adbf210$export$7392d057167c7cc7 = '50px';
const $f7d9347e6adbf210$export$729e677ca5ac2f4f = 36;
const $f7d9347e6adbf210$export$d30be57c88741d7d = 2;

});
const $d736b332644d7251$export$f898a7479a35465b = 44;
const $d736b332644d7251$export$58590494eb7f9f92 = 320;
const $d736b332644d7251$export$bb47e7a2358e2727 = 32;
const $d736b332644d7251$export$cdb7fd9d999c7168 = 56;




parcelRegister("lnbOK", function(module, exports) {

$parcel$export(module.exports, "ProjectKeyContext", () => $00025c3c78aeb9cf$export$3b1b303ecfb6e4b5);
$parcel$export(module.exports, "useProjectContextServiceQueryResult", () => $00025c3c78aeb9cf$export$eecbca8d093722d5);
$parcel$export(module.exports, "useProjectKey", () => $00025c3c78aeb9cf$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectId", () => $00025c3c78aeb9cf$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProject", () => $00025c3c78aeb9cf$export$51b1383ef8844a7);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $00025c3c78aeb9cf$export$b6a91b2d78273787);
$parcel$export(module.exports, "useIssueTypesLookup", () => $00025c3c78aeb9cf$export$99bb7429acff5866);

var $eUqFw = parcelRequire("eUqFw");

var $3aUuh = parcelRequire("3aUuh");

var $iZuDo = parcelRequire("iZuDo");

var $ixwgj = parcelRequire("ixwgj");

var $6vrw7 = parcelRequire("6vrw7");

var $32Xmj = parcelRequire("32Xmj");

var $lB25E = parcelRequire("lB25E");

var $jXtkF = parcelRequire("jXtkF");

var $eP95f = parcelRequire("eP95f");

var $4FouR = parcelRequire("4FouR");
const $00025c3c78aeb9cf$export$3b1b303ecfb6e4b5 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $00025c3c78aeb9cf$export$eecbca8d093722d5 = ()=>(0, $32Xmj.resourceResultToServiceQueryResult)((0, $lB25E.useResource)((0, $ixwgj.projectContextResource)));
const $00025c3c78aeb9cf$export$f87be37f8e8be65 = ()=>{
    const projectKey = (0, $eUqFw.useContext)($00025c3c78aeb9cf$export$3b1b303ecfb6e4b5);
    if (projectKey === null) throw new Error('projectKey not found in context');
    return projectKey;
};
const $00025c3c78aeb9cf$export$16d1475ed6c26568 = ()=>{
    const { data: data } = $00025c3c78aeb9cf$export$eecbca8d093722d5();
    return data === undefined ? null : (0, $6vrw7.toProjectId)(`${data.projectId}`);
};
const $00025c3c78aeb9cf$export$51b1383ef8844a7 = ()=>{
    const projectContextResult = $00025c3c78aeb9cf$export$eecbca8d093722d5();
    const projectKey = (0, $eUqFw.useContext)($00025c3c78aeb9cf$export$3b1b303ecfb6e4b5);
    if (projectKey === null) throw new Error('projectKey not found in context');
    const giraClient = (0, $jXtkF.useGiraClient)();
    const queryResult = (0, $iZuDo.useQuery)((0, $eP95f.PROJECT_QUERY), {
        variables: {
            projectKey: projectKey
        },
        client: giraClient
    });
    return (0, $eUqFw.useMemo)(()=>(0, $4FouR.transformQueryResult)(queryResult, projectContextResult), [
        projectContextResult,
        queryResult
    ]);
};
const $00025c3c78aeb9cf$export$b6a91b2d78273787 = (eventName)=>{
    const { loading: loading, error: error, data: data } = $00025c3c78aeb9cf$export$eecbca8d093722d5();
    if (error) throw new Error(`Loading project failed while attempting to fire ${eventName} event. Details: ${error.message}`);
    if (loading || data == null) return null;
    return {
        isSimplified: data.simplified,
        isProjectAdmin: data.isProjectAdmin ?? false,
        projectId: (0, $6vrw7.toProjectId)(`${data.projectId}`)
    };
};
const $00025c3c78aeb9cf$export$99bb7429acff5866 = ()=>{
    const project = $00025c3c78aeb9cf$export$51b1383ef8844a7();
    return (0, $eUqFw.useMemo)(()=>{
        if (!project.data) throw new Error('project data is undefined but is required for useIssueTypesLookup');
        return (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(project.data.issueTypes, 'id');
    }, [
        project.data
    ]);
};

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("32Xmj", function(module, exports) {

$parcel$export(module.exports, "resourceResultToServiceQueryResult", () => $91dde00f09f6d095$export$1048cc6e0b2e7d7c);
const $91dde00f09f6d095$export$1d0379f6dbf5e124 = (result, transform)=>result.data === undefined ? {
        ...result,
        data: undefined
    } : {
        ...result,
        data: transform(result.data)
    };
const $91dde00f09f6d095$export$1048cc6e0b2e7d7c = ({ data: data, loading: loading, error: error })=>({
        data: data === null ? undefined : data,
        loading: loading,
        error: error === null ? undefined : error
    });

});

parcelRegister("jXtkF", function(module, exports) {

$parcel$export(module.exports, "useGiraClient", () => $5dd740b6794f0f74$export$5490b18010539e4e);
/* eslint-disable react-hooks/rules-of-hooks */ 
var $iZuDo = parcelRequire("iZuDo");

var $7T0RP = parcelRequire("7T0RP");

var $yuXsW = parcelRequire("yuXsW");

var $2Wgbz = parcelRequire("2Wgbz");

var $gd0Sp = parcelRequire("gd0Sp");
const $5dd740b6794f0f74$export$4cea60a165c59df0 = (baseUrl)=>(0, $yuXsW.getClient)(baseUrl, (0, $7T0RP.default));
const $5dd740b6794f0f74$export$fb8deecf3418b248 = (baseUrl)=>(0, $yuXsW.getClient)(baseUrl, (0, $2Wgbz.default));
/**
 * WARNING: Do not enable this in production code! It's a dirty hack that lets us mock
 * Apollo responses in our examples. Apollo's `MockedProvider` only works if a client
 * is not explicitly passed into `useQuery`/`useMutation` calls. We have to explicitly
 * pass clients in because we use more than one of them.
 */ let $5dd740b6794f0f74$var$shouldUseDefaultClient = false;
const $5dd740b6794f0f74$export$6d0c2afcf3fc664d = ()=>{
    $5dd740b6794f0f74$var$shouldUseDefaultClient = true;
};
const $5dd740b6794f0f74$var$useClient = (clientConfig)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return $5dd740b6794f0f74$var$shouldUseDefaultClient ? (0, $iZuDo.useApolloClient)() : (0, $yuXsW.getClient)(tenantContext.baseUrl, clientConfig);
};
const $5dd740b6794f0f74$export$5490b18010539e4e = ()=>$5dd740b6794f0f74$var$useClient((0, $7T0RP.default));
const $5dd740b6794f0f74$export$c16567b229440504 = ()=>$5dd740b6794f0f74$var$useClient((0, $2Wgbz.default));

});
parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $bvQX6.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bvQX6.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bvQX6.Observable).of({
                data: {}
            });
            return new (0, $bvQX6.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fYqUr = parcelRequire("fYqUr");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fYqUr.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});

parcelRegister("2Wgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e169a67ca28ac2$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $8Y3VE = parcelRequire("8Y3VE");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $5zSUY = parcelRequire("5zSUY");

var $eeJ3R = parcelRequire("eeJ3R");

var $aXA7t = parcelRequire("aXA7t");

var $277yk = parcelRequire("277yk");



const $a3e169a67ca28ac2$var$retryLink = new (0, $kcwGc.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $eeJ3R.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $a3e169a67ca28ac2$var$errorLink = (0, $aqG9W.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'errorType'
            ], null);
            return (0, $eeJ3R.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $eeJ3R.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
            'statusCode'
        ], null);
        (0, $eeJ3R.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $a3e169a67ca28ac2$var$fragmentMatcher = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($277yk))
});
const $a3e169a67ca28ac2$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $a3e169a67ca28ac2$var$fragmentMatcher
};
const $a3e169a67ca28ac2$var$cache = new (0, $2vRh6.InMemoryCache)($a3e169a67ca28ac2$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3e169a67ca28ac2$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $a3e169a67ca28ac2$var$xsrfLink = ()=>(0, $8Y3VE.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $5zSUY.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $a3e169a67ca28ac2$var$clientCreator = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: 'SWAG',
        link: (0, $bvQX6.ApolloLink).from([
            $a3e169a67ca28ac2$var$retryLink,
            $a3e169a67ca28ac2$var$xsrfLink(),
            $a3e169a67ca28ac2$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($a3e169a67ca28ac2$var$cache),
            new (0, $35Kb7.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $a3e169a67ca28ac2$var$customFetch
            })
        ]),
        cache: $a3e169a67ca28ac2$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a3e169a67ca28ac2$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $a3e169a67ca28ac2$var$clientCreator
};

});
parcelRegister("8Y3VE", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $6876f98359b8915e$export$2f04de43fe27971a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $6876f98359b8915e$export$2f04de43fe27971a(setter) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        var request = (0, $fKE23.__rest)(operation, []);
        return new (0, $bvQX6.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("eeJ3R", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $ff92a92e5b2be045$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $ff92a92e5b2be045$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $ff92a92e5b2be045$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $ff92a92e5b2be045$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $ff92a92e5b2be045$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $ff92a92e5b2be045$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $ff92a92e5b2be045$export$3e50530825dee9d1);

var $gUUjF = parcelRequire("gUUjF");
const $ff92a92e5b2be045$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $gUUjF.default).safeErrorWithoutCustomerData(type, m, params);
};
const $ff92a92e5b2be045$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $ff92a92e5b2be045$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$ff92a92e5b2be045$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $ff92a92e5b2be045$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $ff92a92e5b2be045$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $ff92a92e5b2be045$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $ff92a92e5b2be045$export$25d52be9f4671e9e = (error, queryName)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $ff92a92e5b2be045$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});

parcelRegister("277yk", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});



parcelRegister("eP95f", function(module, exports) {

$parcel$export(module.exports, "PROJECT_QUERY", () => $8206be6424d8851b$export$4d41378da3f70f0f);

var $9ypom = parcelRequire("9ypom");
const $8206be6424d8851b$export$4d41378da3f70f0f = (0, $9ypom.default)`
    query jira_deploymentsPage_getProject_Query($projectKey: String!) {
        project(projectKey: $projectKey) {
            id
            projectId
            key
            name
            simplified
            issueTypes {
                id
                name
                iconUrl
            }
        }
    }
`;

});

parcelRegister("4FouR", function(module, exports) {

$parcel$export(module.exports, "transformQueryResult", () => $81eff08347742367$export$f8067c2b38255fb2);

var $6vrw7 = parcelRequire("6vrw7");
const $81eff08347742367$var$transformIssueType = (issueType)=>({
        id: (0, $6vrw7.toIssueTypeId)(issueType.id),
        name: issueType.name,
        iconUrl: issueType.iconUrl != null ? issueType.iconUrl : ''
    });
const $81eff08347742367$var$transformProject = (project, projectContext)=>{
    const { issueTypes: issueTypes } = project;
    if (issueTypes == null || issueTypes.length === 0) return Error('Issue types not found');
    return {
        id: (0, $6vrw7.toProjectId)(project.projectId),
        key: (0, $6vrw7.toProjectKey)(project.key),
        name: project.name,
        isSimplified: project.simplified,
        isProjectAdmin: projectContext.isProjectAdmin ?? false,
        issueTypes: issueTypes.map($81eff08347742367$var$transformIssueType)
    };
};
const $81eff08347742367$export$f8067c2b38255fb2 = ({ loading: giraLoading, error: giraError, data: giraData }, { loading: projectContextLoading, error: projectContextError, data: projectContextData })=>{
    if (giraLoading || projectContextLoading) return {
        loading: true
    };
    if (giraError || projectContextError) return {
        error: giraError || projectContextError,
        loading: false
    };
    if (giraData == null || giraData.project == null || projectContextData == null) return {
        loading: false,
        error: Error('Project not found')
    };
    const transformationResult = $81eff08347742367$var$transformProject(giraData.project, projectContextData);
    return transformationResult instanceof Error ? {
        error: transformationResult,
        loading: false
    } : {
        data: transformationResult,
        loading: false
    };
};

});


parcelRegister("ePfmq", function(module, exports) {

$parcel$export(module.exports, "DEPLOYMENTS_PAGE_SIZE", () => $f69500d5681a4688$export$f64e28e5029458f6);
$parcel$export(module.exports, "ISSUE_PAGE_SIZE", () => $f69500d5681a4688$export$6ca87ede5ed2e0c7);
$parcel$export(module.exports, "MAXIMUM_DEPLOYMENT_PAGES_TO_FETCH_PER_ISSUE_PAGE", () => $f69500d5681a4688$export$bdadc2a32c3b8538);
$parcel$export(module.exports, "MAXIMUM_FETCHABLE_DEPLOYMENTS", () => $f69500d5681a4688$export$ac74ebe642136ed0);
$parcel$export(module.exports, "MAXIMUM_FETCHABLE_ISSUES", () => $f69500d5681a4688$export$ec5988dfc1c15c70);
$parcel$export(module.exports, "MAXIMUM_ISSUES_PER_DEPLOYMENT_REQUEST", () => $f69500d5681a4688$export$284a104b74a1013d);
// Note: when this was set to 500, we were occasionally bumping into AGG's default 5MB response size limit
const $f69500d5681a4688$export$f64e28e5029458f6 = 300;
const $f69500d5681a4688$export$6ca87ede5ed2e0c7 = 40;
const $f69500d5681a4688$export$c083d90cb6b5063b = 4000;
const $f69500d5681a4688$export$bdadc2a32c3b8538 = Math.ceil($f69500d5681a4688$export$c083d90cb6b5063b / $f69500d5681a4688$export$f64e28e5029458f6);
const $f69500d5681a4688$export$ac74ebe642136ed0 = 10000;
const $f69500d5681a4688$export$ec5988dfc1c15c70 = 1000;
const $f69500d5681a4688$export$284a104b74a1013d = 40;

});

parcelRegister("2fW3U", function(module, exports) {

$parcel$export(module.exports, "isFilterApplied", () => $d5978b72c7bb4afe$export$980aed36f19060a5);
const $d5978b72c7bb4afe$export$980aed36f19060a5 = ({ assignees: assignees, environments: environments, epicIds: epicIds, fixVersions: fixVersions, issueTypeIds: issueTypeIds, text: text })=>{
    const areAllArraysEmpty = [
        assignees,
        epicIds,
        fixVersions,
        issueTypeIds,
        environments.names,
        environments.types
    ].every((arr)=>Array.isArray(arr) && arr.length === 0);
    return !areAllArraysEmpty || text !== '';
};

});

parcelRegister("3iyQa", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $99cad15fbadd26a5$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "coreDataReducer", () => $99cad15fbadd26a5$export$4756a468003ca87b);

var $gEpgE = parcelRequire("gEpgE");
const { LOADING_INITIAL: $99cad15fbadd26a5$var$LOADING_INITIAL, LOADING_NEXT_PAGE: $99cad15fbadd26a5$var$LOADING_NEXT_PAGE, LOADING_SET_VARIABLES: $99cad15fbadd26a5$var$LOADING_SET_VARIABLES, READY: $99cad15fbadd26a5$var$READY, HAS_ERROR: $99cad15fbadd26a5$var$HAS_ERROR } = (0, $gEpgE.LoadingStateOptions);
const $99cad15fbadd26a5$export$d4c72bab9d6cc13a = {
    coreData: null,
    error: null,
    loadingState: $99cad15fbadd26a5$var$LOADING_INITIAL,
    numIssuePages: 1,
    hasNextIssuePage: false,
    hasReachedMaxDeploymentsLimit: false
};
const $99cad15fbadd26a5$export$4756a468003ca87b = (state, action)=>{
    switch(action.type){
        case 'fetchTriggered':
            return {
                ...state,
                loadingState: state.loadingState === $99cad15fbadd26a5$var$LOADING_INITIAL ? $99cad15fbadd26a5$var$LOADING_INITIAL : $99cad15fbadd26a5$var$LOADING_NEXT_PAGE
            };
        case 'fetchSuccess':
            return {
                ...state,
                coreData: action.payload.coreData,
                hasNextIssuePage: action.payload.hasNextIssuePage,
                hasReachedMaxDeploymentsLimit: action.payload.hasReachedMaxDeploymentsLimit,
                loadingState: $99cad15fbadd26a5$var$READY
            };
        case 'fetchFailed':
            return {
                ...state,
                error: action.payload,
                loadingState: $99cad15fbadd26a5$var$HAS_ERROR,
                numIssuePages: state.loadingState === $99cad15fbadd26a5$var$LOADING_NEXT_PAGE ? state.numIssuePages - 1 : state.numIssuePages
            };
        case 'fetchMore':
            return {
                ...state,
                error: null,
                numIssuePages: state.numIssuePages + 1
            };
        case 'filterChanged':
            if (state.loadingState === $99cad15fbadd26a5$var$LOADING_INITIAL) return state;
            return {
                ...state,
                error: null,
                loadingState: $99cad15fbadd26a5$var$LOADING_SET_VARIABLES,
                numIssuePages: 1
            };
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            throw Error('Unhandled core data provider action');
    }
};

});

parcelRegister("2cKta", function(module, exports) {

$parcel$export(module.exports, "isFilterSuitableForAGSQuery", () => $d4d38897aa536d50$export$f2d391fe61d0381f);
const $d4d38897aa536d50$export$f2d391fe61d0381f = ({ assignees: assignees, environments: environments, epicIds: epicIds, fixVersions: fixVersions, issueTypeIds: issueTypeIds, text: text, showIssuesWithoutDeployments: showIssuesWithoutDeployments })=>{
    const areAllArraysEmpty = [
        assignees,
        epicIds,
        fixVersions,
        issueTypeIds,
        environments.names,
        environments.types
    ].every((arr)=>Array.isArray(arr) && arr.length === 0);
    return areAllArraysEmpty && text === '' && !showIssuesWithoutDeployments;
};

});

parcelRegister("kuiLT", function(module, exports) {

$parcel$export(module.exports, "sortIssueByLatestDeploymentsAndLocateEmptyDeploymentsLast", () => $78f2e4b912fbdf0f$export$1e9da6876ae65648);
const $78f2e4b912fbdf0f$export$1e9da6876ae65648 = (issues, deploymentsByIssueId)=>issues.sort((issue1, issue2)=>{
        if (deploymentsByIssueId[issue1.id] === undefined && deploymentsByIssueId[issue2.id] === undefined) return 0;
        if (deploymentsByIssueId[issue1.id] === undefined) return 1;
        if (deploymentsByIssueId[issue2.id] === undefined) return -1;
        return deploymentsByIssueId[issue2.id][0].lastUpdated.getTime() - deploymentsByIssueId[issue1.id][0].lastUpdated.getTime();
    });

});

parcelRegister("dD35P", function(module, exports) {

$parcel$export(module.exports, "transformEnvironmentType", () => $cc29c6cf16ae33d4$export$ba00b851ed83729);
$parcel$export(module.exports, "getDeploymentQueryVariables", () => $cc29c6cf16ae33d4$export$d0727d1238eaf1a8);
$parcel$export(module.exports, "getAGSDeploymentQueryVariables", () => $cc29c6cf16ae33d4$export$fb32234290481120);
$parcel$export(module.exports, "getIssueQueryVariables", () => $cc29c6cf16ae33d4$export$affd77db90a4ee34);
$parcel$export(module.exports, "getNextDeploymentPageCursor", () => $cc29c6cf16ae33d4$export$c2ae8f2ac1effb54);
$parcel$export(module.exports, "getNextDeploymentAGSPageCursor", () => $cc29c6cf16ae33d4$export$c3ea42bc757e5614);
$parcel$export(module.exports, "getNextIssuePageCursor", () => $cc29c6cf16ae33d4$export$53bffa4c240be029);
$parcel$export(module.exports, "groupDeploymentsByIssueId", () => $cc29c6cf16ae33d4$export$758184a248d33f3);

var $huI7r = parcelRequire("huI7r");

var $2YZvw = parcelRequire("2YZvw");

var $yevjV = parcelRequire("yevjV");

var $ePfmq = parcelRequire("ePfmq");
const $cc29c6cf16ae33d4$export$ba00b851ed83729 = (type)=>{
    switch(type){
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION:
            return 'PRODUCTION';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).STAGING:
            return 'STAGING';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).TESTING:
            return 'TESTING';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).DEVELOPMENT:
            return 'DEVELOPMENT';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).UNMAPPED:
            return 'UNMAPPED';
        default:
            throw new Error(`Unhandled environment type: ${type}`);
    }
};
const $cc29c6cf16ae33d4$export$d0727d1238eaf1a8 = ({ issueIds: issueIds, environments: environments, timeWindow: timeWindow }, cloudId, after = null)=>({
        first: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE),
        after: after,
        filter: {
            issueIds: issueIds.map((id)=>(0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'issue',
                    resourceId: id
                })),
            environmentCategories: environments.types.length > 0 ? environments.types.map($cc29c6cf16ae33d4$export$ba00b851ed83729) : null,
            environmentDisplayNames: environments.names.length > 0 ? environments.names : null,
            timeWindow: {
                after: timeWindow.after.toISOString(),
                before: timeWindow.before.toISOString()
            }
        }
    });
const $cc29c6cf16ae33d4$export$fb32234290481120 = ({ issueIds: issueIds, environments: environments, timeWindow: timeWindow }, cloudId, after = null)=>({
        first: (0, $ePfmq.DEPLOYMENTS_PAGE_SIZE),
        after: after,
        filter: {
            and: [
                {
                    to_environmentType: {
                        is: environments.categories?.length ? environments.categories.map($cc29c6cf16ae33d4$export$ba00b851ed83729) : undefined
                    },
                    createdAt: {
                        after: timeWindow.after.toISOString(),
                        before: timeWindow.before.toISOString()
                    }
                }
            ]
        },
        ids: issueIds.map((id)=>(0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'issue',
                resourceId: id
            }))
    });
const $cc29c6cf16ae33d4$var$transformEpicIds = (cloudId, epicIds)=>{
    if (epicIds.length === 0) // Meaning "do not apply filter"
    return null;
    return epicIds.map((id)=>{
        if (id === (0, $2YZvw.UNASSIGNED_EPIC_ID)) // Meaning "include issues that aren't in epics"
        return null;
        return (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: id
        });
    });
};
const $cc29c6cf16ae33d4$var$transformIssueTypeIds = (cloudId, issueTypeIds)=>{
    if (issueTypeIds.length === 0) // Meaning "do not apply filter"
    return null;
    return issueTypeIds.map((id)=>(0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue-type',
            resourceId: id
        }));
};
const $cc29c6cf16ae33d4$export$affd77db90a4ee34 = ({ projectId: projectId, text: text, assignees: assignees, environments: environments, timeWindow: timeWindow, epicIds: epicIds, issueTypeIds: issueTypeIds, fixVersions: fixVersions, showIssuesWithoutDeployments: showIssuesWithoutDeployments }, cloudId, after)=>({
        first: (0, $ePfmq.ISSUE_PAGE_SIZE),
        after: after,
        filter: {
            projectId: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }),
            text: text,
            assignees: assignees.length > 0 ? assignees : null,
            environmentCategories: environments.types.length > 0 ? environments.types.map($cc29c6cf16ae33d4$export$ba00b851ed83729) : null,
            environmentDisplayNames: environments.names.length > 0 ? environments.names : null,
            releaseStatusFilter: showIssuesWithoutDeployments ? 'RELEASED_AND_UNRELEASED' : 'RELEASED',
            timeWindow: {
                after: timeWindow.after.toISOString(),
                before: timeWindow.before.toISOString()
            },
            epicIds: $cc29c6cf16ae33d4$var$transformEpicIds(cloudId, epicIds),
            issueTypes: $cc29c6cf16ae33d4$var$transformIssueTypeIds(cloudId, issueTypeIds),
            fixVersions: fixVersions.length > 0 ? fixVersions : null
        }
    });
const $cc29c6cf16ae33d4$export$c2ae8f2ac1effb54 = (queryData)=>{
    const pageInfo = queryData?.jiraReleases?.deployments?.pageInfo;
    if (pageInfo == null || pageInfo.hasNextPage === false || queryData?.jiraReleases?.deployments?.edges == null) return null;
    const { edges: edges = [] } = queryData.jiraReleases.deployments;
    const lastEdge = edges[edges.length - 1];
    return lastEdge == null ? null : lastEdge.cursor;
};
const $cc29c6cf16ae33d4$export$c3ea42bc757e5614 = (queryData)=>{
    const pageInfo = queryData?.graphStore?.projectAssociatedDeployment?.pageInfo;
    if (pageInfo == null || pageInfo.hasNextPage === false || pageInfo.endCursor == null) return null;
    return pageInfo.endCursor;
};
const $cc29c6cf16ae33d4$export$53bffa4c240be029 = (queryData)=>{
    const pageInfo = queryData?.jiraReleases?.issues?.pageInfo;
    if (pageInfo == null || pageInfo.hasNextPage === false || queryData?.jiraReleases?.issues?.edges == null) return null;
    const { edges: edges = [] } = queryData.jiraReleases.issues;
    const lastEdge = edges[edges.length - 1];
    return lastEdge == null ? null : lastEdge.cursor;
};
const $cc29c6cf16ae33d4$export$758184a248d33f3 = (group)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    group.forEach((value)=>{
        value.issueIds.forEach((key)=>{
            const existing = map[String(key)] || [];
            map[String(key)] = [
                ...existing,
                value
            ];
        });
    });
    return map;
};

});
parcelRegister("2YZvw", function(module, exports) {

$parcel$export(module.exports, "UNASSIGNED_EPIC_ID", () => $05c6d466fa7c2422$export$794f07be04aca3fe);
$parcel$export(module.exports, "DEBOUNCE_MILLISECONDS", () => $05c6d466fa7c2422$export$b32e9a16cec19b92);
$parcel$export(module.exports, "BAD_DEPLOYMENTS_DATA_END_DATE", () => $05c6d466fa7c2422$export$9e3b3ee60efe9cff);
$parcel$export(module.exports, "DATE_FORMAT_DASH", () => $05c6d466fa7c2422$export$22e17f823fe114c5);
$parcel$export(module.exports, "DATE_FORMAT_SLASH", () => $05c6d466fa7c2422$export$7e068236a36256ea);
$parcel$export(module.exports, "DATE_FORMAT_SLASH_PLACEHOLDER", () => $05c6d466fa7c2422$export$995027531bb14705);
$parcel$export(module.exports, "ENVIRONMENT", () => $05c6d466fa7c2422$export$be46596bc6608f3b);
$parcel$export(module.exports, "VERSION", () => $05c6d466fa7c2422$export$a4ad2735b021c132);
$parcel$export(module.exports, "EPIC", () => $05c6d466fa7c2422$export$3cb4a99a332e4186);
$parcel$export(module.exports, "ISSUE_TYPE", () => $05c6d466fa7c2422$export$ebb48b08205007c5);
$parcel$export(module.exports, "DEFAULT_VISIBLE_USERS", () => $05c6d466fa7c2422$export$73c67a7a9d862119);
$parcel$export(module.exports, "MIN_VISIBLE_USERS", () => $05c6d466fa7c2422$export$b77bf6f74e548423);
$parcel$export(module.exports, "USER_AVATAR_WIDTH", () => $05c6d466fa7c2422$export$e792ba4c5f53843c);
$parcel$export(module.exports, "MIN_FILTER_BAR_WIDTH", () => $05c6d466fa7c2422$export$187e8ccd6428cad1);
$parcel$export(module.exports, "MIN_SEARCH_INPUT_WIDTH", () => $05c6d466fa7c2422$export$5218804975321f31);
const $05c6d466fa7c2422$export$794f07be04aca3fe = 'unassigned';
const $05c6d466fa7c2422$export$b32e9a16cec19b92 = 300;
const $05c6d466fa7c2422$export$7ef674586cbc5b17 = {
    'X-ExperimentalApi': 'jira-releases-v0'
};
const $05c6d466fa7c2422$export$dff7676713236bfb = 1280;
const $05c6d466fa7c2422$export$9e3b3ee60efe9cff = new Date('2020-04-01T00:00:00');
const $05c6d466fa7c2422$export$22e17f823fe114c5 = 'yyyy-MM-dd'; // this matches @atlaskit/calendar format
const $05c6d466fa7c2422$export$7e068236a36256ea = 'yyyy/MM/dd'; // date format that is shown to users
const $05c6d466fa7c2422$export$995027531bb14705 = 'YYYY/MM/DD';
const $05c6d466fa7c2422$export$be46596bc6608f3b = 'ENVIRONMENT';
const $05c6d466fa7c2422$export$a4ad2735b021c132 = 'VERSION';
const $05c6d466fa7c2422$export$3cb4a99a332e4186 = 'EPIC';
const $05c6d466fa7c2422$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $05c6d466fa7c2422$export$73c67a7a9d862119 = 5;
const $05c6d466fa7c2422$export$b77bf6f74e548423 = 2;
const $05c6d466fa7c2422$export$e792ba4c5f53843c = 30;
const $05c6d466fa7c2422$export$187e8ccd6428cad1 = 405;
const $05c6d466fa7c2422$export$5218804975321f31 = 120;

});


parcelRegister("asHsD", function(module, exports) {

$parcel$export(module.exports, "isInitialLoad", () => $6619faba8521231e$export$948eee37b09b86b3);
$parcel$export(module.exports, "setInitialLoadFinished", () => $6619faba8521231e$export$978cdbbb4c60b869);
$parcel$export(module.exports, "collectorFromNumIssues", () => $6619faba8521231e$export$5192160f11d8322d);
$parcel$export(module.exports, "collectorFromNumIssuesDeployments", () => $6619faba8521231e$export$4b87834ed988a28a);
$parcel$export(module.exports, "collectorFromCoreData", () => $6619faba8521231e$export$4f2d4ed2aa8c083a);
// Apollo doesn't provide a nice API to distinguish whether or not query hits cache.
// If we naively measure performance for consecutive requests, it will measure duration including queries that hit caches,
// which will pollute our data. Therefore, we will only monitor initial load for now until we find a solution.
let $6619faba8521231e$var$isInitial = true;
const $6619faba8521231e$export$948eee37b09b86b3 = ()=>$6619faba8521231e$var$isInitial;
const $6619faba8521231e$export$978cdbbb4c60b869 = ()=>{
    $6619faba8521231e$var$isInitial = false;
};
const $6619faba8521231e$export$5192160f11d8322d = ({ numIssues: numIssues, deploymentsPageSize: deploymentsPageSize, issuePageSize: issuePageSize })=>({
        numIssues: numIssues,
        deploymentsPageSize: deploymentsPageSize,
        issuePageSize: issuePageSize
    });
const $6619faba8521231e$export$4b87834ed988a28a = ({ numIssues: numIssues, numDeployments: numDeployments, deploymentsPageSize: deploymentsPageSize, issuePageSize: issuePageSize })=>({
        numIssues: numIssues,
        numDeployments: numDeployments,
        deploymentsPageSize: deploymentsPageSize,
        issuePageSize: issuePageSize
    });
const $6619faba8521231e$export$4f2d4ed2aa8c083a = ({ coreData: coreData, deploymentsPageSize: deploymentsPageSize, issuePageSize: issuePageSize })=>({
        numIssues: coreData.issues.length,
        numDeployments: coreData.allDeployments.length,
        deploymentsPageSize: deploymentsPageSize,
        issuePageSize: issuePageSize
    });

});



parcelRegister("gx9jR", function(module, exports) {

$parcel$export(module.exports, "ViewDeploymentsTimelineExperienceStart", () => $919bc1830e5982c3$export$332d4f30baef4cba);
$parcel$export(module.exports, "useViewDeploymentsTimelineExperienceFail", () => $919bc1830e5982c3$export$1b0771861743ccbb);
$parcel$export(module.exports, "ViewDeploymentsTimelineExperienceSuccessTracker", () => $919bc1830e5982c3$export$9f6028ddebc35155);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $eIp1n = parcelRequire("eIp1n");

var $gEpgE = parcelRequire("gEpgE");

var $ab6rA = parcelRequire("ab6rA");

var $OwuLI = parcelRequire("OwuLI");

var $lnbOK = parcelRequire("lnbOK");
const $919bc1830e5982c3$var$viewDeploymentsTimelineExperienceName = 'viewDeploymentsTimeline';
const $919bc1830e5982c3$export$332d4f30baef4cba = ({ experienceId: experienceId })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: $919bc1830e5982c3$var$viewDeploymentsTimelineExperienceName,
        analyticsSource: "deployments",
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $919bc1830e5982c3$export$1b0771861743ccbb = ()=>(0, $4qhD6.useExperienceFail)({
        experience: $919bc1830e5982c3$var$viewDeploymentsTimelineExperienceName
    });
const $919bc1830e5982c3$export$30f065c157611e00 = (coreDataServiceResult)=>coreDataServiceResult.loadingState === (0, $gEpgE.LoadingStateOptions).READY; // Once loadingState becomes READY, we return true. All other cases are false
const $919bc1830e5982c3$export$9f6028ddebc35155 = ()=>{
    const { serviceResult: coreDataServiceResult } = (0, $OwuLI.useCoreData)();
    const attributes = (0, $lnbOK.useProjectAnalyticsAttributes)('DeploymentsTimelineExperienceSuccess');
    if (attributes === null || !$919bc1830e5982c3$export$30f065c157611e00(coreDataServiceResult)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $919bc1830e5982c3$var$viewDeploymentsTimelineExperienceName,
        attributes: attributes
    });
};

});

parcelRegister("5cM2U", function(module, exports) {

$parcel$export(module.exports, "useProjectDetails", () => $9bf2dca26461d2ce$export$43446549442decd6);

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $9bf2dca26461d2ce$var$useProjectKey = ()=>{
    const [projectKey] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey == null) throw new Error('Project key missing');
    return (0, $6vrw7.toProjectKey)(projectKey);
};
const $9bf2dca26461d2ce$var$useProjectContext = ()=>{
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    if (containerContext == null || containerContext.contextType !== 'project') return null;
    return containerContext;
};
const $9bf2dca26461d2ce$var$useProjectId = ()=>{
    const projectContext = $9bf2dca26461d2ce$var$useProjectContext();
    return projectContext === null ? null : (0, $6vrw7.toProjectId)(`${projectContext.project.id}`);
};
const $9bf2dca26461d2ce$var$useProjectName = ()=>{
    const projectContext = $9bf2dca26461d2ce$var$useProjectContext();
    return projectContext === null ? null : projectContext.project.name;
};
const $9bf2dca26461d2ce$var$useIsSimplified = ()=>{
    const projectContext = $9bf2dca26461d2ce$var$useProjectContext();
    return projectContext === null ? null : projectContext.project.isSimplified;
};
const $9bf2dca26461d2ce$export$43446549442decd6 = ()=>{
    const id = $9bf2dca26461d2ce$var$useProjectId();
    const key = $9bf2dca26461d2ce$var$useProjectKey();
    const name = $9bf2dca26461d2ce$var$useProjectName();
    const isSimplified = $9bf2dca26461d2ce$var$useIsSimplified();
    return {
        id: id,
        key: key,
        name: name,
        isSimplified: isSimplified
    };
};

});

parcelRegister("5MsOK", function(module, exports) {

$parcel$export(module.exports, "NotAvailablePage", () => $8da795f39be06180$export$19d4fa0fb5690ba5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kjUtl = parcelRequire("kjUtl");

var $ir5VA = parcelRequire("ir5VA");

var $hw6wn = parcelRequire("hw6wn");
const $8da795f39be06180$export$19d4fa0fb5690ba5 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8da795f39be06180$var$pageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8da795f39be06180$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjUtl.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8da795f39be06180$var$BodyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8da795f39be06180$var$IllustrationWrapper, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ir5VA))),
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, formatMessage((0, $hw6wn.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8da795f39be06180$var$Description, null, formatMessage((0, $hw6wn.default).description))));
};
const $8da795f39be06180$var$pageWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8da795f39be06180$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4zdiv",
            __cmplp.className
        ])
    });
});
const $8da795f39be06180$var$BodyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8da795f39be06180$var$IllustrationWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkoahv",
            __cmplp.className
        ])
    });
});
const $8da795f39be06180$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi _1bsbnklw _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kjUtl", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3602bef5291e20$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $c76ap = parcelRequire("c76ap");

var $4ACoF = parcelRequire("4ACoF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $apDYp = parcelRequire("apDYp");
const $cb3602bef5291e20$var$TitleBreadcrumbs = ({ actions: actions })=>{
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ACoF.PageTopBar), {
        truncateTitle: true,
        disableTitleStyles: true,
        breadcrumbs: breadcrumbs,
        actions: actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3602bef5291e20$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cb3602bef5291e20$var$pageTitleStyles
    }, formatMessage((0, $apDYp.default).title)))));
};
var $cb3602bef5291e20$export$2e2bcd8739ae039 = $cb3602bef5291e20$var$TitleBreadcrumbs;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3602bef5291e20$var$TitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3izwfg",
            __cmplp.className
        ])
    });
});
const $cb3602bef5291e20$var$pageTitleStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0'
});

});
parcelRegister("4ACoF", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $d74ce2d0cb0e9587$export$7e5801dc91bf1819);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $3a8wJ = parcelRequire("3a8wJ");

var $6FP8W = parcelRequire("6FP8W");

const $d74ce2d0cb0e9587$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$90c4434a1e138106),
        xcss: [
            $d74ce2d0cb0e9587$var$wrapperStyles,
            wrapAtMd ? $d74ce2d0cb0e9587$var$wrapAtMdStyle : $d74ce2d0cb0e9587$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$1742330ac6a668f0),
        xcss: [
            $d74ce2d0cb0e9587$var$actionsBoxStyles,
            wrapAtMd && $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $d74ce2d0cb0e9587$export$7e5801dc91bf1819 = (props)=>(0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d74ce2d0cb0e9587$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), props);
const $d74ce2d0cb0e9587$var$noWrapStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'nowrap'
});
const $d74ce2d0cb0e9587$var$wrapAtMdStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $4Ywu9.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $d74ce2d0cb0e9587$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $4Ywu9.media).above.md]: {
        gap: 'space.300'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    [(0, $4Ywu9.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



const $0b51e3566777dd51$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $0b51e3566777dd51$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("apDYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b4be11cd4450b5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $80b4be11cd4450b5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-deployments-title-breadcrumbs.title",
        "defaultMessage": "Deployments"
    },
    beta: {
        "id": "software-deployments-title-breadcrumbs.beta",
        "defaultMessage": "Beta"
    }
});

});


parcelRegister("ir5VA", function(module, exports) {
module.exports = new URL("deployments-not-available.555f049b.svg", import.meta.url).toString();

});

parcelRegister("hw6wn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09a668d07b06b56$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e09a668d07b06b56$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-deployments-precondition.not-available-page.title",
        "defaultMessage": "We can't show you Deployments"
    },
    description: {
        "id": "software-deployments-precondition.not-available-page.description",
        "defaultMessage": "Either Deployments isn't enabled, or you need permission - contact your project admin"
    }
});

});


parcelRegister("4D4hF", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $46f6f0823362b234$export$476aa014e2fd89d5);
const $46f6f0823362b234$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $46f6f0823362b234$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $46f6f0823362b234$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $46f6f0823362b234$var$NetworkErrorMessages = new Set([
    $46f6f0823362b234$var$ERROR_MESSAGE_CHROME,
    $46f6f0823362b234$var$ERROR_MESSAGE_FIREFOX,
    $46f6f0823362b234$var$ERROR_MESSAGE_OTHER
]);
const $46f6f0823362b234$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $46f6f0823362b234$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));

});


parcelRegister("kzQ9s", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a19668df980ef0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");

var $aYtGv = parcelRequire("aYtGv");

var $kIY50 = parcelRequire("kIY50");

var $6FP8W = parcelRequire("6FP8W");

var $h1Cog = parcelRequire("h1Cog");

var $koLS7 = parcelRequire("koLS7");

var $huvdb = parcelRequire("huvdb");

var $gYjv3 = parcelRequire("gYjv3");

var $kyt5X = parcelRequire("kyt5X");

var $fU4Ho = parcelRequire("fU4Ho");

var $2vtNs = parcelRequire("2vtNs");

var $6l4Xu = parcelRequire("6l4Xu");

var $eACCU = parcelRequire("eACCU");

var $6N9m6 = parcelRequire("6N9m6");

var $kuZm4 = parcelRequire("kuZm4");

var $87WY6 = parcelRequire("87WY6");

var $1ZpNL = parcelRequire("1ZpNL");

var $3Pcni = parcelRequire("3Pcni");

var $CwpiB = parcelRequire("CwpiB");

var $foURZ = parcelRequire("foURZ");
const $42a19668df980ef0$export$861edd1ccea2f746 = ({ projectKey: projectKey })=>{
    (0, $foURZ.usePreventSwipeBack)();
    (0, $koLS7.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6N9m6.Providers), {
        projectKey: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1yt4zdiv _c71l1l47 _4t3i1l47 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4"
        ]),
        style: {
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2vtNs.default), {
        leftContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $CwpiB.default), null),
        rightContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Pcni.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fU4Ho.default), null), (0, $6FP8W.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyt5X.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eACCU.default), null), (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyt5X.default), null))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1reo15vq _18m915vq _4t3i1o57 _c71l1lhe _bfhktxrc _otyr4cqu"
        ]),
        style: {
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)),
            "--_1s2b36r": (0, $9t7rW.default)((0, $6l4Xu.HEADER_HEIGHT_PX))
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _1reo15vq _18m915vq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZpNL.default), {
        projectKey: projectKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kuZm4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87WY6.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "performanceTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYjv3.PerformanceTracker), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
        fallback: "unmount",
        eventLocation: "viewDeploymentsExperienceSuccessTracker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huvdb.ViewDeploymentsExperienceSuccessTracker), null))));
};
const $42a19668df980ef0$var$mainDeploymentsWrapperStyles = null;
const $42a19668df980ef0$var$bottomPadding = "var(--ds-space-200, 16px)";
// NOTE Spotlight is wrapping BodyWrapper so we must explicity set the height here
// max-height is given for exceptionally long screens. If the table is viewed in a vertically long screen, user can never trigger pagination, because 40 issues are displayed without vertical scroll at all.
// This could be a temporary fix. We might want to revisit this for a proper solution
const $42a19668df980ef0$var$bodyWrapperStyles = null;
const $42a19668df980ef0$var$tableWrapperStyles = null;
var $42a19668df980ef0$export$2e2bcd8739ae039 = $42a19668df980ef0$export$861edd1ccea2f746;

});
parcelRegister("h1Cog", function(module, exports) {

$parcel$export(module.exports, "NonCriticalErrorBoundary", () => $d8b77080beb51731$export$1625b7ea4c7a5a23);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $d8b77080beb51731$export$1625b7ea4c7a5a23 = ({ fallback: fallback, eventLocation: eventLocation, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: fallback,
        packageName: "jiraSoftwareDeploymentsMain",
        teamName: "fusion-solaris",
        id: eventLocation
    }, children);

});

parcelRegister("koLS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0652b3979909f717$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $kFGm5 = parcelRequire("kFGm5");

var $guiFP = parcelRequire("guiFP");

var $iclz4 = parcelRequire("iclz4");

var $6TQlY = parcelRequire("6TQlY");

var $6go3X = parcelRequire("6go3X");


var $2ZKvN = parcelRequire("2ZKvN");
const $0652b3979909f717$export$7ef51df16d720b86 = ()=>{
    const [topFilterState, topFilterActions] = (0, $6go3X.useTableFilterStore)();
    const [dateFilterState, dateFilterActions] = (0, $6TQlY.useDateFilterStore)();
    const [queryParams, setQueryParams] = (0, $iclz4.useQueryParams)((0, $dddcd6e3ad7448d6$export$e39925d10cebc0b), (0, $dddcd6e3ad7448d6$export$f78d8c81fcad32a2), (0, $dddcd6e3ad7448d6$export$8cf9b9e18011c2d1), (0, $dddcd6e3ad7448d6$export$b98a7875ddbefaac), (0, $dddcd6e3ad7448d6$export$fa7b72626a2e0090), (0, $dddcd6e3ad7448d6$export$69dbccc43af1c6ae), (0, $dddcd6e3ad7448d6$export$477ba84929356db9), (0, $dddcd6e3ad7448d6$export$e20ad73595ecfcd1));
    const dateFilterFromQuery = (0, $eUqFw.useMemo)(()=>{
        try {
            return (0, $2ZKvN.getDateFilterFromQueryParams)(queryParams);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // a user will end up here if they enter a query string with an invalid CUSTOM date format
            // don't let a bad date filter kill the website entirely, just reset it
            (0, $guiFP.default)({
                meta: {
                    id: 'invalidDateFilterQueryString',
                    packageName: 'jiraSoftwareDeployments',
                    teamName: 'fusion-solaris'
                }
            });
            dateFilterActions.resetFilter();
            // need to return default value for use in current render
            return {
                dateFilter: (0, $6TQlY.defaultDateFilter)
            };
        }
    }, [
        queryParams,
        dateFilterActions
    ]);
    const topFilterFromQuery = (0, $eUqFw.useMemo)(()=>(0, $2ZKvN.getFiltersFromQueryParams)(queryParams), [
        queryParams
    ]);
    topFilterFromQuery.environmentTypeConcatNames = topFilterState.environmentTypeConcatNames;
    const filtersFromQuery = (0, $eUqFw.useMemo)(()=>({
            ...topFilterFromQuery,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(dateFilterFromQuery, [
                'type'
            ])
        }), [
        topFilterFromQuery,
        dateFilterFromQuery
    ]);
    const filtersRef = (0, $eUqFw.useRef)(filtersFromQuery);
    const queryFromFilters = (0, $2ZKvN.useQueryParamsFromFilters)();
    const queryRef = (0, $eUqFw.useRef)(queryFromFilters);
    // *** Set the initial state *** \\
    // on initial load Query string is the source of truth
    // This will run on the server render and the initial client render
    const initialLoad = (0, $eUqFw.useRef)(true);
    if (initialLoad.current && Object.values(queryParams).some((value)=>value !== undefined)) {
        topFilterActions.setFilter(topFilterFromQuery);
        dateFilterActions.setDateFilter(dateFilterFromQuery.dateFilter);
    }
    // Effect to update query params using History Replace on initial render
    (0, $eUqFw.useEffect)(()=>{
        if (initialLoad.current) {
            setQueryParams((0, $2ZKvN.filtersToQueryParams)(topFilterFromQuery, (0, $2ZKvN.queryParamDateRange)(dateFilterFromQuery.dateFilter)), {
                sort: false,
                updateType: 'replace'
            });
            initialLoad.current = false;
        }
    }, [
        setQueryParams,
        topFilterFromQuery,
        dateFilterFromQuery
    ]);
    // Effect to sync State to match updated Query
    (0, $eUqFw.useEffect)(()=>{
        const { dateFilter: { startDate: startDate, endDate: endDate } } = dateFilterState;
        const filtersFromState = {
            ...topFilterState,
            startDate: startDate,
            endDate: endDate
        };
        // if filtersRef is not in sync with latest value of filtersFromQuery
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filtersFromQuery, filtersRef.current)) {
            // if query params not in sync with filters
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(filtersFromQuery, filtersFromState)) {
                topFilterActions.setFilter(topFilterFromQuery);
                dateFilterActions.setDateFilter(dateFilterFromQuery.dateFilter);
            }
            filtersRef.current = filtersFromQuery;
        }
    }, [
        filtersFromQuery,
        topFilterFromQuery,
        dateFilterFromQuery,
        topFilterState,
        dateFilterState,
        topFilterActions,
        dateFilterActions
    ]);
    // Effect to sync Query to match updated State
    (0, $eUqFw.useEffect)(()=>{
        // if queryFromFilters is not in sync with latest value
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryFromFilters, queryRef.current)) {
            // if queryRef is not in sync with latest value of queryFromFilters
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(queryParams, queryFromFilters)) setQueryParams(queryFromFilters, {
                sort: false
            });
            queryRef.current = queryFromFilters;
        }
    }, [
        queryParams,
        queryFromFilters,
        setQueryParams
    ]);
};
var $0652b3979909f717$export$2e2bcd8739ae039 = $0652b3979909f717$export$7ef51df16d720b86;

});
parcelRegister("6TQlY", function(module, exports) {

$parcel$export(module.exports, "RelativeDateFilterOptions", () => $c4bb69bf09a9039f$export$a69a88556871432a);
$parcel$export(module.exports, "defaultDateFilter", () => $c4bb69bf09a9039f$export$91d232f60806a8e8);
$parcel$export(module.exports, "initialState", () => $c4bb69bf09a9039f$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "getValidatedDateRange", () => $c4bb69bf09a9039f$export$49dd653eadf85b37);
$parcel$export(module.exports, "useDateFilterStore", () => $c4bb69bf09a9039f$export$d6d9567f1c2f6274);
$parcel$export(module.exports, "useDateFilter", () => $c4bb69bf09a9039f$export$147c4fe28b21c4c5);

var $guiFP = parcelRequire("guiFP");

var $WBLbN = parcelRequire("WBLbN");

var $2WwpS = parcelRequire("2WwpS");
const $c4bb69bf09a9039f$var$PAST_TWO_WEEKS = '-2w';
const $c4bb69bf09a9039f$var$PAST_MONTH = '-1m';
const $c4bb69bf09a9039f$var$PAST_QUARTER = '-3m';
const $c4bb69bf09a9039f$var$PAST_YEAR = '-1y';
const $c4bb69bf09a9039f$var$NOW = 'now';
const $c4bb69bf09a9039f$export$a69a88556871432a = {
    PAST_TWO_WEEKS: $c4bb69bf09a9039f$var$PAST_TWO_WEEKS,
    PAST_MONTH: $c4bb69bf09a9039f$var$PAST_MONTH,
    PAST_QUARTER: $c4bb69bf09a9039f$var$PAST_QUARTER,
    PAST_YEAR: $c4bb69bf09a9039f$var$PAST_YEAR,
    NOW: $c4bb69bf09a9039f$var$NOW
};
const $c4bb69bf09a9039f$export$91d232f60806a8e8 = {
    type: 'RELATIVE',
    startDate: $c4bb69bf09a9039f$export$a69a88556871432a.PAST_QUARTER,
    endDate: $c4bb69bf09a9039f$export$a69a88556871432a.NOW
};
const $c4bb69bf09a9039f$export$d4c72bab9d6cc13a = {
    dateFilter: $c4bb69bf09a9039f$export$91d232f60806a8e8
};
const $c4bb69bf09a9039f$export$49dd653eadf85b37 = ({ startDate: startDate, endDate: endDate })=>{
    let finalStartDate = startDate;
    let finalEndDate = endDate;
    let errorType;
    // start date after end date
    if ((0, $2WwpS.isStartDateAfterEndDate)(finalStartDate, finalEndDate)) {
        finalEndDate = finalStartDate;
        errorType = 'START-AFTER-END';
    }
    // end date is future date
    finalEndDate = (0, $2WwpS.roundBackwardToExcludeFutureDates)(finalEndDate);
    // start date is before bad deployments data date
    finalStartDate = (0, $2WwpS.roundForwardToExcludeBadDeploymentsData)(finalStartDate);
    // date range greater than a year
    if ((0, $2WwpS.isDateRangeMoreThanYearApart)(finalStartDate, finalEndDate)) {
        finalEndDate = (0, $2WwpS.subDays)((0, $2WwpS.addYears)(finalStartDate, 1), 1);
        errorType = 'MORE-THAN-YEAR-APART';
    }
    return {
        startDate: finalStartDate,
        endDate: finalEndDate,
        errorType: // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type '"START-AFTER-END" | "MORE-THAN-YEAR-APART" | undefined'.
        errorType
    };
};
const $c4bb69bf09a9039f$export$e324594224ef24da = {
    setDateFilter: ({ type: type, startDate: startDate, endDate: endDate })=>({ dispatch: dispatch })=>{
            if (type === 'RELATIVE') dispatch($c4bb69bf09a9039f$export$e324594224ef24da.setRelativeDateFilter(startDate));
            else if (type === 'CUSTOM') dispatch($c4bb69bf09a9039f$export$e324594224ef24da.setCustomDateFilter({
                startDate: startDate,
                endDate: endDate
            }));
            else throw new Error('unrecognised date filter type');
        },
    resetFilter: ()=>({ setState: setState })=>setState($c4bb69bf09a9039f$export$d4c72bab9d6cc13a),
    setRelativeDateFilter: (relativeDateFilter)=>({ setState: setState })=>setState({
                dateFilter: {
                    type: 'RELATIVE',
                    startDate: relativeDateFilter,
                    endDate: $c4bb69bf09a9039f$export$a69a88556871432a.NOW
                }
            }),
    setCustomDateFilter: (customDateRange)=>({ setState: setState, dispatch: dispatch })=>{
            const { startDate: startDate, endDate: endDate, errorType: errorType } = $c4bb69bf09a9039f$export$49dd653eadf85b37(customDateRange);
            if (errorType) {
                // a user will end up here if they enter a query string that doesn't satisfy the
                // requirements for a date filter. e.g. more than a year in time span.
                (0, $guiFP.default)({
                    meta: {
                        id: 'invalidDateFilter',
                        packageName: 'jiraSoftwareDeployments',
                        teamName: 'fusion-solaris'
                    },
                    attributes: {
                        startDate: // @ts-expect-error - TS2322 - Type 'Date' is not assignable to type 'string | number | boolean | AnalyticsAttributes | null | undefined'.
                        startDate,
                        endDate: // @ts-expect-error - TS2322 - Type 'Date' is not assignable to type 'string | number | boolean | AnalyticsAttributes | null | undefined'.
                        endDate
                    }
                });
                dispatch($c4bb69bf09a9039f$export$e324594224ef24da.resetFilter());
            } else setState({
                dateFilter: {
                    type: 'CUSTOM',
                    startDate: startDate,
                    endDate: endDate
                }
            });
        }
};
const $c4bb69bf09a9039f$var$Store = (0, $WBLbN.createStore)({
    name: 'useDateFilterStore',
    initialState: $c4bb69bf09a9039f$export$d4c72bab9d6cc13a,
    actions: $c4bb69bf09a9039f$export$e324594224ef24da
});
const $c4bb69bf09a9039f$export$d6d9567f1c2f6274 = (0, $WBLbN.createHook)($c4bb69bf09a9039f$var$Store);
const $c4bb69bf09a9039f$export$147c4fe28b21c4c5 = (0, $WBLbN.createHook)($c4bb69bf09a9039f$var$Store, {
    selector: (state)=>state.dateFilter
});

});
parcelRegister("2WwpS", function(module, exports) {

$parcel$export(module.exports, "getDate", () => $be6df15b1f586370$export$aa350b96d91cd94);
$parcel$export(module.exports, "getDay", () => $be6df15b1f586370$export$1b64bc9c5306ed54);
$parcel$export(module.exports, "getMonth", () => $be6df15b1f586370$export$6ce1b5acc29cb53b);
$parcel$export(module.exports, "getYear", () => $be6df15b1f586370$export$5846dc2d57a5c860);
$parcel$export(module.exports, "startOfDay", () => $be6df15b1f586370$export$63fa379ae8a9ba2);
$parcel$export(module.exports, "endOfDay", () => $be6df15b1f586370$export$eb9a03f0e9aa6cea);
$parcel$export(module.exports, "endOfIsoWeek", () => $be6df15b1f586370$export$169594894f548755);
$parcel$export(module.exports, "formatDate", () => $be6df15b1f586370$export$3ae94a2503e890a1);
$parcel$export(module.exports, "addDays", () => $be6df15b1f586370$export$dd412b56f1e4d8aa);
$parcel$export(module.exports, "addWeeks", () => $be6df15b1f586370$export$ef501a2bb4f3ee6b);
$parcel$export(module.exports, "addYears", () => $be6df15b1f586370$export$3d83eec43f4ea476);
$parcel$export(module.exports, "subDays", () => $be6df15b1f586370$export$70823084e2deb1ea);
$parcel$export(module.exports, "subWeeks", () => $be6df15b1f586370$export$b4d8ae6376193efb);
$parcel$export(module.exports, "subMonths", () => $be6df15b1f586370$export$73d1c15a21f9fae5);
$parcel$export(module.exports, "subYears", () => $be6df15b1f586370$export$14867687ff6c92e2);
$parcel$export(module.exports, "roundForwardToExcludeBadDeploymentsData", () => $be6df15b1f586370$export$3c17bbc0c2c02aac);
$parcel$export(module.exports, "roundBackwardToExcludeFutureDates", () => $be6df15b1f586370$export$6bef4415aacda64c);
$parcel$export(module.exports, "isStartDateAfterEndDate", () => $be6df15b1f586370$export$2bbf1fb60850134e);
$parcel$export(module.exports, "isDateAfterToday", () => $be6df15b1f586370$export$85054dc6276b7ae5);
$parcel$export(module.exports, "isDateBeforeApril", () => $be6df15b1f586370$export$c335a8f90c01bd39);
$parcel$export(module.exports, "isDateRangeMoreThanYearApart", () => $be6df15b1f586370$export$fe352fb618e0f3b8);
$parcel$export(module.exports, "getRoundedDate", () => $be6df15b1f586370$export$a0ab0ab0b2a32522);

var $6wqPF = parcelRequire("6wqPF");
var $kqUc2 = parcelRequire("kqUc2");
var $i6BQA = parcelRequire("i6BQA");
var $7n7Dc = parcelRequire("7n7Dc");
var $6EHSB = parcelRequire("6EHSB");
var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");
var $3jYzf = parcelRequire("3jYzf");
var $9FEvp = parcelRequire("9FEvp");
var $4IszY = parcelRequire("4IszY");
var $5Jma3 = parcelRequire("5Jma3");
var $7HiXn = parcelRequire("7HiXn");

var $8K9kM = parcelRequire("8K9kM");

var $1nxOb = parcelRequire("1nxOb");

var $2YZvw = parcelRequire("2YZvw");
const $be6df15b1f586370$export$a31f4081041e8df3 = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
const $be6df15b1f586370$export$aa350b96d91cd94 = (dateString)=>{
    if (!dateString.length) return 'EMPTY';
    const refinedDateString = dateString.replace(/\//g, '-');
    if (!$be6df15b1f586370$export$a31f4081041e8df3.test(refinedDateString)) return 'INVALID-FORMAT';
    const isValidDate = (0, $7ueqz.default)(new Date((0, $3xcI8.default)(refinedDateString)));
    if (!isValidDate) return 'INVALID-DATE';
    return new Date((0, $3xcI8.default)(refinedDateString));
};
const $be6df15b1f586370$export$1b64bc9c5306ed54 = (date)=>date.getDate();
const $be6df15b1f586370$export$6ce1b5acc29cb53b = (date)=>date.getMonth() + 1;
const $be6df15b1f586370$export$5846dc2d57a5c860 = (date)=>date.getFullYear();
const $be6df15b1f586370$export$63fa379ae8a9ba2 = (date)=>(0, $3jYzf.default)(date);
const $be6df15b1f586370$export$eb9a03f0e9aa6cea = (date)=>(0, $7n7Dc.default)(date);
const $be6df15b1f586370$export$169594894f548755 = (date)=>(0, $6EHSB.default)(date);
const $be6df15b1f586370$export$3ae94a2503e890a1 = (date, dateFormat)=>(0, $EN9B6.default)(date, dateFormat);
const $be6df15b1f586370$export$dd412b56f1e4d8aa = (date, quantity)=>(0, $6wqPF.default)(date, quantity);
const $be6df15b1f586370$export$ef501a2bb4f3ee6b = (date, quantity)=>(0, $kqUc2.default)(date, quantity);
const $be6df15b1f586370$export$3d83eec43f4ea476 = (date, quantity)=>(0, $i6BQA.default)(date, quantity);
const $be6df15b1f586370$export$70823084e2deb1ea = (date, quantity)=>(0, $9FEvp.default)(date, quantity);
const $be6df15b1f586370$export$b4d8ae6376193efb = (date, quantity)=>(0, $5Jma3.default)(date, quantity);
const $be6df15b1f586370$export$73d1c15a21f9fae5 = (date, quantity)=>(0, $4IszY.default)(date, quantity);
const $be6df15b1f586370$export$14867687ff6c92e2 = (date, quantity)=>(0, $7HiXn.default)(date, quantity);
const $be6df15b1f586370$export$3c17bbc0c2c02aac = (date)=>date < (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE) ? (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE) : date;
const $be6df15b1f586370$export$6bef4415aacda64c = (date)=>date > $be6df15b1f586370$export$eb9a03f0e9aa6cea(new Date()) ? new Date() : date;
const $be6df15b1f586370$export$2bbf1fb60850134e = (startDate, endDate)=>startDate > endDate;
const $be6df15b1f586370$export$85054dc6276b7ae5 = (date)=>date > $be6df15b1f586370$export$eb9a03f0e9aa6cea((0, $1nxOb.getToday)());
const $be6df15b1f586370$export$c335a8f90c01bd39 = (date)=>date < (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE);
const $be6df15b1f586370$export$fe352fb618e0f3b8 = (startDate, endDate)=>{
    const duration = (0, $8K9kM.floatDifferenceOfDates)($be6df15b1f586370$export$dd412b56f1e4d8aa(endDate, 1), startDate, 'years');
    return duration > 1;
};
const $be6df15b1f586370$export$a0ab0ab0b2a32522 = (date, { disableFuture: disableFuture = false, disablePast: disablePast = false, minDate: minDate, maxDate: maxDate })=>{
    let roundedDate = date;
    if (disableFuture && date > (0, $1nxOb.getToday)() || disablePast && date < (0, $1nxOb.getToday)()) roundedDate = (0, $1nxOb.getToday)();
    if (minDate && date < minDate) roundedDate = minDate;
    if (maxDate && date > maxDate) roundedDate = maxDate;
    return roundedDate;
};

});
parcelRegister("1nxOb", function(module, exports) {

$parcel$export(module.exports, "getToday", () => $6cae688eefc06803$export$883228a582a7567d);
$parcel$export(module.exports, "getCurrentMonth", () => $6cae688eefc06803$export$4bf68489d4ce7543);
$parcel$export(module.exports, "getCurrentYear", () => $6cae688eefc06803$export$9e4dbf5d4bcd607f);

var $d2wNG = parcelRequire("d2wNG");
var $25XU0 = parcelRequire("25XU0");
var $1ewM9 = parcelRequire("1ewM9");
var $1raUW = parcelRequire("1raUW");
var $gfGP4 = parcelRequire("gfGP4");
var $lgtYg = parcelRequire("lgtYg");
var $7n7Dc = parcelRequire("7n7Dc");
var $EN9B6 = parcelRequire("EN9B6");
var $6Gkyp = parcelRequire("6Gkyp");
var $gzNmz = parcelRequire("gzNmz");
var $fU1L0 = parcelRequire("fU1L0");
var $2JCkO = parcelRequire("2JCkO");
var $3jYzf = parcelRequire("3jYzf");

var $5iWql = parcelRequire("5iWql");

const $6cae688eefc06803$var$diffInSwitch = (identifierName = 'years')=>{
    const diffInFuncs = {
        years: (0, $lgtYg.default),
        months: (0, $1raUW.default),
        days: (0, $d2wNG.default),
        hours: (0, $25XU0.default),
        minutes: (0, $1ewM9.default),
        seconds: (0, $gfGP4.default)
    };
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ years: (dateLeft: number | Date, dateRight: number | Date) => number; months: (dateLeft: number | Date, dateRight: number | Date) => number; days: (dateLeft: number | Date, dateRight: number | Date) => number; hours: (dateLeft: number | Date, dateRight: number | Date) => number; minutes: (dateLeft: number | Date, ...'.
    return diffInFuncs[identifierName];
};
const $6cae688eefc06803$export$883228a582a7567d = (0, $5iWql.default)(()=>{
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
});
const $6cae688eefc06803$export$4bf68489d4ce7543 = (0, $5iWql.default)((today)=>(0, $gzNmz.default)(today));
const $6cae688eefc06803$export$9e4dbf5d4bcd607f = (0, $5iWql.default)((today)=>(0, $fU1L0.default)(today));
const $6cae688eefc06803$export$f30a7e90faea7b14 = (dateISO)=>{
    const now = new Date(dateISO);
    return (0, $3jYzf.default)(now).valueOf();
};
const $6cae688eefc06803$export$dc6626d91a228817 = (dateISO)=>{
    const now = new Date(dateISO);
    return (0, $7n7Dc.default)(now).valueOf();
};
const $6cae688eefc06803$export$f268c901e7fab1f4 = (timestamp, dateFormat = (0, $e35ebf4ae94c14e6$export$45c85543ba71221d))=>(0, $EN9B6.default)(new Date(timestamp), dateFormat);
const $6cae688eefc06803$export$65247a66841b1e1d = (startMilliseconds, endMilliseconds, limitValue = 1, limitUnit = 'years')=>{
    const differenceIn = $6cae688eefc06803$var$diffInSwitch(limitUnit);
    const diff = differenceIn(new Date(endMilliseconds), new Date(startMilliseconds));
    return diff >= limitValue;
};
const $6cae688eefc06803$export$c60135bbc1664093 = (startDate, endDate)=>{
    const interval = {
        start: new Date(startDate),
        end: new Date(endDate)
    };
    const duration = (0, $2JCkO.default)(interval);
    return (0, $6Gkyp.default)(duration, {
        delimiter: ' '
    });
};

});
const $e35ebf4ae94c14e6$export$45c85543ba71221d = 'yyyy/MM/dd';
const $e35ebf4ae94c14e6$export$1f04624003d2da7d = 86400000;




parcelRegister("6go3X", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $67547d28d0c2977e$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "useTableFilterStore", () => $67547d28d0c2977e$export$219df9fe77bc31ac);
$parcel$export(module.exports, "useHasAppliedFilters", () => $67547d28d0c2977e$export$6ec22db926b3085);
$parcel$export(module.exports, "useEnvironmentTypeConcatNamesFilter", () => $67547d28d0c2977e$export$f891aa842f3d0b7e);
$parcel$export(module.exports, "useEpicIdsFilter", () => $67547d28d0c2977e$export$33b17dea751d5ac7);
$parcel$export(module.exports, "useIssueTypeIdsFilter", () => $67547d28d0c2977e$export$705a1182f41cf383);
$parcel$export(module.exports, "useFixVersionsFilter", () => $67547d28d0c2977e$export$da739cd9a4bcf89f);

var $8blac = parcelRequire("8blac");

var $WBLbN = parcelRequire("WBLbN");
const $67547d28d0c2977e$export$d4c72bab9d6cc13a = {
    text: '',
    assignees: [],
    environmentNames: [],
    environmentTypeConcatNames: [],
    epicIds: [],
    issueTypeIds: [],
    fixVersions: []
};
const $67547d28d0c2977e$export$e324594224ef24da = {
    setEpicIdsFilter: (epicIds)=>({ setState: setState })=>setState({
                epicIds: epicIds
            }),
    setIssueTypeIdsFilter: (issueTypeIds)=>({ setState: setState })=>setState({
                issueTypeIds: issueTypeIds
            }),
    setTextFilter: (text)=>({ setState: setState })=>setState({
                text: text
            }),
    toggleAssignee: (assignee)=>({ setState: setState, getState: getState })=>{
            const { assignees: assignees } = getState();
            if (assignees.includes(assignee)) setState({
                assignees: assignees.filter((accountId)=>accountId !== assignee)
            });
            else setState({
                assignees: [
                    ...assignees,
                    assignee
                ]
            });
        },
    setEnvironmentFilter: (environmentNames)=>({ setState: setState })=>setState({
                environmentNames: environmentNames
            }),
    setEnvironmentTypeConcatNameFilter: (environmentTypeConcatNames)=>({ setState: setState })=>setState({
                environmentTypeConcatNames: environmentTypeConcatNames
            }),
    setFixVersionFilter: (fixVersions)=>({ setState: setState })=>setState({
                fixVersions: fixVersions
            }),
    setFilter: (filter)=>({ setState: setState })=>setState(filter),
    resetAllFilters: ()=>({ setState: setState })=>setState($67547d28d0c2977e$export$d4c72bab9d6cc13a)
};
const $67547d28d0c2977e$var$Store = (0, $WBLbN.createStore)({
    name: 'useTableFilterStore',
    initialState: $67547d28d0c2977e$export$d4c72bab9d6cc13a,
    actions: $67547d28d0c2977e$export$e324594224ef24da
});
const $67547d28d0c2977e$export$219df9fe77bc31ac = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store);
const $67547d28d0c2977e$export$6ec22db926b3085 = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store, {
    selector: (state)=>Object.values(state).some((val)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(val))
});
const $67547d28d0c2977e$export$4a4519dfae594a67 = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store, {
    selector: (state)=>state.environmentNames
});
const $67547d28d0c2977e$export$f891aa842f3d0b7e = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store, {
    selector: (state)=>state.environmentTypeConcatNames
});
const $67547d28d0c2977e$export$33b17dea751d5ac7 = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store, {
    selector: (state)=>state.epicIds
});
const $67547d28d0c2977e$export$705a1182f41cf383 = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store, {
    selector: (state)=>state.issueTypeIds
});
const $67547d28d0c2977e$export$da739cd9a4bcf89f = (0, $WBLbN.createHook)($67547d28d0c2977e$var$Store, {
    selector: (state)=>state.fixVersions
});

});

const $dddcd6e3ad7448d6$export$e39925d10cebc0b = 'text';
const $dddcd6e3ad7448d6$export$f78d8c81fcad32a2 = 'assignees';
const $dddcd6e3ad7448d6$export$8cf9b9e18011c2d1 = 'environmentNames';
const $dddcd6e3ad7448d6$export$b98a7875ddbefaac = 'epics';
const $dddcd6e3ad7448d6$export$fa7b72626a2e0090 = 'issueTypes';
const $dddcd6e3ad7448d6$export$69dbccc43af1c6ae = 'fixVersions';
const $dddcd6e3ad7448d6$export$477ba84929356db9 = 'startDate';
const $dddcd6e3ad7448d6$export$e20ad73595ecfcd1 = 'endDate';

parcelRegister("2ZKvN", function(module, exports) {

$parcel$export(module.exports, "getDateFilterFromQueryParams", () => $d3e92beaef6f632a$export$c03dcf828c56ff80);
$parcel$export(module.exports, "getFiltersFromQueryParams", () => $d3e92beaef6f632a$export$dbbcd0e4230f63ce);
$parcel$export(module.exports, "queryParamDateRange", () => $d3e92beaef6f632a$export$29bdcf9cbb435191);
$parcel$export(module.exports, "filtersToQueryParams", () => $d3e92beaef6f632a$export$5d7f9913734d3d5f);
$parcel$export(module.exports, "useQueryParamsFromFilters", () => $d3e92beaef6f632a$export$fc06da9f43822ba7);

var $eUqFw = parcelRequire("eUqFw");

var $6vrw7 = parcelRequire("6vrw7");

var $2YZvw = parcelRequire("2YZvw");

var $2WwpS = parcelRequire("2WwpS");

var $6TQlY = parcelRequire("6TQlY");

var $56t7F = parcelRequire("56t7F");

var $6go3X = parcelRequire("6go3X");

const $d3e92beaef6f632a$var$DELIMITER = ',';
const $d3e92beaef6f632a$var$ENCODED_DELIMITER = encodeURIComponent($d3e92beaef6f632a$var$DELIMITER);
// we need to encode the delimiter to protect our free text values from containing
// the same character that delimits the list.
// e.g.
// env names = ["prod,east", "prod,west"] -> "prod,east,prod,west"
const $d3e92beaef6f632a$var$encodeDelimeter = (// @ts-expect-error - TS2304 - Cannot find name 'IssueTypeId'. | TS2304 - Cannot find name 'AccountId'. | TS2304 - Cannot find name 'EnvironmentName'. | TS2304 - Cannot find name 'FixVersion'. | TS2304 - Cannot find name 'EpicIdOption'.
input)=>{
    const regex = new RegExp($d3e92beaef6f632a$var$DELIMITER, 'g');
    return input.replace(regex, $d3e92beaef6f632a$var$ENCODED_DELIMITER);
};
const $d3e92beaef6f632a$var$decodeDelimeter = (input)=>{
    const regex = new RegExp($d3e92beaef6f632a$var$ENCODED_DELIMITER, 'g');
    return input.replace(regex, $d3e92beaef6f632a$var$DELIMITER);
};
// @ts-expect-error - TS7006 - Parameter 'arr' implicitly has an 'any' type.
const $d3e92beaef6f632a$var$filterToQueryParam = (arr)=>{
    if (arr.length === 0) return undefined;
    // @ts-expect-error - TS7006 - Parameter 'entity' implicitly has an 'any' type.
    return arr.map((entity)=>$d3e92beaef6f632a$var$encodeDelimeter(entity)).join($d3e92beaef6f632a$var$DELIMITER);
};
const $d3e92beaef6f632a$var$queryParamToFilter = (str)=>str.split($d3e92beaef6f632a$var$DELIMITER).map($d3e92beaef6f632a$var$decodeDelimeter);
const $d3e92beaef6f632a$export$c03dcf828c56ff80 = (queryParams)=>{
    const dateFilterState = {
        ...(0, $6TQlY.initialState)
    };
    if (queryParams[0, $dddcd6e3ad7448d6$export$477ba84929356db9] != null && queryParams[0, $dddcd6e3ad7448d6$export$e20ad73595ecfcd1] != null) {
        const startDate = queryParams[0, $dddcd6e3ad7448d6$export$477ba84929356db9];
        const endDate = queryParams[0, $dddcd6e3ad7448d6$export$e20ad73595ecfcd1];
        if ((0, $56t7F.isRelativeDate)(startDate) && startDate !== 'now' && endDate === 'now') dateFilterState.dateFilter = {
            type: 'RELATIVE',
            startDate: (0, $56t7F.toRelativeDate)(startDate) ?? (0, $6TQlY.defaultDateFilter).startDate,
            endDate: (0, $56t7F.toRelativeDate)(endDate) ?? (0, $6TQlY.defaultDateFilter).endDate
        };
        else {
            const validatedStartDate = (0, $2WwpS.getDate)(startDate);
            const validatedEndDate = (0, $2WwpS.getDate)(endDate);
            if (validatedStartDate instanceof Date && validatedEndDate instanceof Date) dateFilterState.dateFilter = {
                type: 'CUSTOM',
                startDate: validatedStartDate,
                endDate: validatedEndDate
            };
            else throw new Error('invalid date filter query param');
        }
    }
    return dateFilterState;
};
const $d3e92beaef6f632a$export$dbbcd0e4230f63ce = (queryParams)=>{
    const topFilterState = {
        ...(0, $6go3X.initialState)
    };
    if (queryParams[0, $dddcd6e3ad7448d6$export$e39925d10cebc0b] != null) topFilterState.text = queryParams[0, $dddcd6e3ad7448d6$export$e39925d10cebc0b];
    if (queryParams[0, $dddcd6e3ad7448d6$export$f78d8c81fcad32a2] != null) topFilterState.assignees = $d3e92beaef6f632a$var$queryParamToFilter(queryParams[0, $dddcd6e3ad7448d6$export$f78d8c81fcad32a2]).map((accountId)=>(0, $6vrw7.toAccountId)(accountId));
    if (queryParams[0, $dddcd6e3ad7448d6$export$8cf9b9e18011c2d1] != null) topFilterState.environmentNames = $d3e92beaef6f632a$var$queryParamToFilter(queryParams[0, $dddcd6e3ad7448d6$export$8cf9b9e18011c2d1]);
    if (queryParams[0, $dddcd6e3ad7448d6$export$b98a7875ddbefaac] != null) topFilterState.epicIds = $d3e92beaef6f632a$var$queryParamToFilter(queryParams[0, $dddcd6e3ad7448d6$export$b98a7875ddbefaac]).map((epicId)=>(0, $6vrw7.toIssueId)(epicId));
    if (queryParams[0, $dddcd6e3ad7448d6$export$fa7b72626a2e0090] != null) topFilterState.issueTypeIds = $d3e92beaef6f632a$var$queryParamToFilter(queryParams[0, $dddcd6e3ad7448d6$export$fa7b72626a2e0090]).map((issueTypeId)=>(0, $6vrw7.toIssueTypeId)(issueTypeId));
    if (queryParams[0, $dddcd6e3ad7448d6$export$69dbccc43af1c6ae] != null) topFilterState.fixVersions = $d3e92beaef6f632a$var$queryParamToFilter(queryParams[0, $dddcd6e3ad7448d6$export$69dbccc43af1c6ae]);
    return topFilterState;
};
const $d3e92beaef6f632a$export$29bdcf9cbb435191 = (dateFilter)=>dateFilter.type === 'RELATIVE' ? {
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate
    } : {
        startDate: (0, $2WwpS.formatDate)(dateFilter.startDate, (0, $2YZvw.DATE_FORMAT_DASH)),
        endDate: (0, $2WwpS.formatDate)(dateFilter.endDate, (0, $2YZvw.DATE_FORMAT_DASH))
    };
const $d3e92beaef6f632a$export$e8960f0b9230851f = ()=>{
    const [{ dateFilter: dateFilter }] = (0, $6TQlY.useDateFilterStore)();
    const { startDate: startDate, endDate: endDate } = $d3e92beaef6f632a$export$29bdcf9cbb435191(dateFilter);
    return [
        startDate,
        endDate
    ];
};
const $d3e92beaef6f632a$export$5d7f9913734d3d5f = (topFilters, dateFilter)=>({
        [(0, $dddcd6e3ad7448d6$export$e39925d10cebc0b)]: topFilters.text || undefined,
        [(0, $dddcd6e3ad7448d6$export$f78d8c81fcad32a2)]: $d3e92beaef6f632a$var$filterToQueryParam(topFilters.assignees),
        [(0, $dddcd6e3ad7448d6$export$8cf9b9e18011c2d1)]: $d3e92beaef6f632a$var$filterToQueryParam(topFilters.environmentNames),
        [(0, $dddcd6e3ad7448d6$export$b98a7875ddbefaac)]: $d3e92beaef6f632a$var$filterToQueryParam(topFilters.epicIds),
        [(0, $dddcd6e3ad7448d6$export$fa7b72626a2e0090)]: $d3e92beaef6f632a$var$filterToQueryParam(topFilters.issueTypeIds),
        [(0, $dddcd6e3ad7448d6$export$69dbccc43af1c6ae)]: $d3e92beaef6f632a$var$filterToQueryParam(topFilters.fixVersions),
        [(0, $dddcd6e3ad7448d6$export$477ba84929356db9)]: dateFilter.startDate,
        [(0, $dddcd6e3ad7448d6$export$e20ad73595ecfcd1)]: dateFilter.endDate
    });
const $d3e92beaef6f632a$export$fc06da9f43822ba7 = ()=>{
    const [filters] = (0, $6go3X.useTableFilterStore)();
    const [startDate, endDate] = $d3e92beaef6f632a$export$e8960f0b9230851f();
    return (0, $eUqFw.useMemo)(()=>$d3e92beaef6f632a$export$5d7f9913734d3d5f(filters, {
            startDate: startDate,
            endDate: endDate
        }), [
        filters,
        startDate,
        endDate
    ]);
};

});
parcelRegister("56t7F", function(module, exports) {

$parcel$export(module.exports, "isRelativeDate", () => $bfd446103bf35221$export$aebd7d4ffee5ebdd);
$parcel$export(module.exports, "toRelativeDate", () => $bfd446103bf35221$export$1e2253635bdddbce);
$parcel$export(module.exports, "useTimeWindowFilter", () => $bfd446103bf35221$export$8f3f8c384b713ec4);

var $hvbu2 = parcelRequire("hvbu2");

var $5iWql = parcelRequire("5iWql");

var $1nxOb = parcelRequire("1nxOb");

var $2WwpS = parcelRequire("2WwpS");

var $6TQlY = parcelRequire("6TQlY");
const $bfd446103bf35221$export$aebd7d4ffee5ebdd = (dateString)=>// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"now" | "-2w" | "-1m" | "-3m" | "-1y"'.
    Object.values((0, $6TQlY.RelativeDateFilterOptions)).includes(dateString);
const $bfd446103bf35221$export$1e2253635bdddbce = (relativeDateString)=>(0, (/*@__PURE__*/$parcel$interopDefault($hvbu2)))((0, $6TQlY.RelativeDateFilterOptions)).find((relativeDate)=>relativeDate === relativeDateString);
const $bfd446103bf35221$export$fbc35200c3b6bd1 = 31535999999;
const $bfd446103bf35221$export$811d62982f6923e7 = ({ after: after, before: before })=>({
        before: before,
        after: new Date(Math.max(before.getTime() - $bfd446103bf35221$export$fbc35200c3b6bd1, after.getTime()))
    });
const $bfd446103bf35221$export$1408a2451dc58071 = (dateFilter)=>{
    switch(dateFilter){
        case '-2w':
            return (0, $2WwpS.subWeeks)((0, $1nxOb.getToday)(), 2);
        case '-1m':
            return (0, $2WwpS.subMonths)((0, $1nxOb.getToday)(), 1);
        case '-3m':
            return (0, $2WwpS.subMonths)((0, $1nxOb.getToday)(), 3);
        case '-1y':
            return (0, $2WwpS.subYears)((0, $2WwpS.addDays)((0, $1nxOb.getToday)(), 1), 1);
        case 'now':
            return (0, $1nxOb.getToday)();
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            dateFilter;
            throw new Error('No date filter option found when getting relative date');
    }
};
const $bfd446103bf35221$export$e3182cdf0fb47989 = (dateFilter)=>$bfd446103bf35221$export$811d62982f6923e7({
        after: (0, $2WwpS.roundForwardToExcludeBadDeploymentsData)((0, $2WwpS.startOfDay)($bfd446103bf35221$export$1408a2451dc58071(dateFilter.startDate))),
        before: (0, $2WwpS.endOfDay)($bfd446103bf35221$export$1408a2451dc58071(dateFilter.endDate))
    });
const $bfd446103bf35221$export$54985027536a3ece = ({ startDate: startDate, endDate: endDate })=>({
        after: (0, $2WwpS.startOfDay)(startDate),
        before: (0, $2WwpS.endOfDay)(endDate)
    });
const $bfd446103bf35221$export$c036911047307763 = (0, $5iWql.default)((dateFilter)=>dateFilter.type === 'RELATIVE' ? $bfd446103bf35221$export$e3182cdf0fb47989(dateFilter) : $bfd446103bf35221$export$54985027536a3ece({
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate
    }));
const $bfd446103bf35221$export$8f3f8c384b713ec4 = ()=>{
    const [dateFilter] = (0, $6TQlY.useDateFilter)();
    return $bfd446103bf35221$export$c036911047307763(dateFilter);
};

});



parcelRegister("gYjv3", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracker", () => $eb65a0f9c0cc2bb8$export$57a2c9a4973f6a35);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");

var $gEpgE = parcelRequire("gEpgE");

var $hPZTO = parcelRequire("hPZTO");

var $ePfmq = parcelRequire("ePfmq");

var $OwuLI = parcelRequire("OwuLI");

var $2cKta = parcelRequire("2cKta");
/**
 * Initially returns `false`. Once the initial batch of deployments have loaded,
 * returns `true` from then on.
 */ const $eb65a0f9c0cc2bb8$var$useHaveInitialDeploymentsLoaded = ()=>{
    const hasInitialLoadCompletedRef = (0, $eUqFw.useRef)(false);
    const { loadingState: loadingState } = (0, $OwuLI.useAllDeployments)();
    if (loadingState === (0, $gEpgE.LoadingStateOptions).READY) hasInitialLoadCompletedRef.current = true;
    return hasInitialLoadCompletedRef.current;
};
/**
 * Initially returns `false`. Once we have fetched 40 issues or we have fetched all required issues we return true
 */ const $eb65a0f9c0cc2bb8$var$useHasPageOfIssuesLoaded = ()=>{
    const hasInitialLoadCompletedRef = (0, $eUqFw.useRef)(false);
    const { loadingState: loadingState, data: data, getNextIssuePage: getNextIssuePage } = (0, $OwuLI.useIssues)();
    const issuesFetched = data?.length || 0;
    if (loadingState === (0, $gEpgE.LoadingStateOptions).READY && (getNextIssuePage === null || issuesFetched >= (0, $ePfmq.ISSUE_PAGE_SIZE))) hasInitialLoadCompletedRef.current = true;
    return hasInitialLoadCompletedRef.current;
};
const $eb65a0f9c0cc2bb8$export$57a2c9a4973f6a35 = ()=>{
    const haveInitialDeploymentsLoaded = $eb65a0f9c0cc2bb8$var$useHaveInitialDeploymentsLoaded();
    const hasPageOfIssuesBeenLoaded = $eb65a0f9c0cc2bb8$var$useHasPageOfIssuesLoaded();
    const filter = (0, $OwuLI.useCoreDataFilter)();
    const isDataFetchingViaAGS = filter && (0, $2cKta.isFilterSuitableForAGSQuery)(filter);
    if (!haveInitialDeploymentsLoaded) return null;
    return isDataFetchingViaAGS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasPageOfIssuesBeenLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "jira-software-deployments",
        ttrSlo: 1000,
        ttiSlo: 4000,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $hPZTO.deploymentsAndIssuePageAGSPageLoad)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "jira-software-deployments",
        ttrSlo: 1000,
        ttiSlo: 4000,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $hPZTO.deploymentsPageLoad)
    });
};

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("hPZTO", function(module, exports) {

$parcel$export(module.exports, "deploymentsPageLoad", () => $8805068b90288f94$export$4a748f308ec826bb);
$parcel$export(module.exports, "deploymentsAndIssuePageAGSPageLoad", () => $8805068b90288f94$export$3662894be7ce8fb7);

var $lNfG4 = parcelRequire("lNfG4");
const $8805068b90288f94$export$4a748f308ec826bb = (0, $lNfG4.metrics).pageLoad({
    key: 'software.deployments',
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});
const $8805068b90288f94$export$3662894be7ce8fb7 = (0, $lNfG4.metrics).pageLoad({
    key: 'software.deployments.ags',
    slo: {
        fmp: {
            initial: {
                threshold: 1000
            },
            transition: {
                threshold: 1000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    }
});

});


parcelRegister("kyt5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeebdc549e134d58$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fUQgT = parcelRequire("fUQgT");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $gVMGb = parcelRequire("gVMGb");

var $brEs0 = parcelRequire("brEs0");

var $hMSDj = parcelRequire("hMSDj");

var $eSK2f = parcelRequire("eSK2f");
const $aeebdc549e134d58$var$ConfigurationButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [sidebarState, sidebarActions] = (0, $brEs0.useSidebarStore)();
    const onOpen = sidebarActions.showConfiguration;
    const onClose = sidebarActions.close;
    const isOpen = sidebarState.status === (0, $hMSDj.SidebarStatuses).SHOWING_CONFIGURATION;
    const tooltipContent = formatMessage((0, $eSK2f.default).tooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "bottom",
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVMGb.default), {
        testId: "software-deployments.ui.configuration-button.configure-view-button",
        onClick: (event, analyticsEvent)=>{
            if (isOpen) {
                onClose();
                return;
            }
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'configureDeployments');
            onOpen();
        },
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fUQgT))), {
            label: formatMessage((0, $eSK2f.default).buttonIconLabel)
        }),
        isSelected: isOpen,
        text: formatMessage((0, $eSK2f.default).configuration)
    }));
};
var $aeebdc549e134d58$export$2e2bcd8739ae039 = $aeebdc549e134d58$var$ConfigurationButton;

});
parcelRegister("fUQgT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b964a2018cb4a0d7$var$_react = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b964a2018cb4a0d7$var$_customize = $b964a2018cb4a0d7$var$_interopRequireDefault((parcelRequire("hmbTp")));
function $b964a2018cb4a0d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b964a2018cb4a0d7$var$PreferencesIcon = (props)=>/*#__PURE__*/ $b964a2018cb4a0d7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $b964a2018cb4a0d7$var$_customize.default
    }));
$b964a2018cb4a0d7$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $b964a2018cb4a0d7$var$_default = module.exports.default = $b964a2018cb4a0d7$var$PreferencesIcon;

});
parcelRegister("hmbTp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78335b71c0abb01e55fd286b4fa17edd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca2db75d20af6d54$var$_react = $ca2db75d20af6d54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca2db75d20af6d54$var$_UNSAFE_baseNew = $ca2db75d20af6d54$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $ca2db75d20af6d54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca2db75d20af6d54$var$CustomizeIcon = (props)=>/*#__PURE__*/ $ca2db75d20af6d54$var$_react.default.createElement($ca2db75d20af6d54$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
    }, props));
$ca2db75d20af6d54$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $ca2db75d20af6d54$var$_default = module.exports.default = $ca2db75d20af6d54$var$CustomizeIcon;

});


parcelRegister("gVMGb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f95a0eb59c00de6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
// ResponsiveButton is a workaround as atlaskit button doesn't correctly handle hiding
// the button text via css. It applies different padding depending on the number of
// children given.
const $0f95a0eb59c00de6$var$ResponsiveButton = ({ icon: icon, text: text, isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClick,
        isSelected: isSelected,
        spacing: "none",
        testId: testId,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3ixy5q _1yt4h8dc _1esr1nxw _8dh11nxw"
        ])
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_8pbhglyw"
        ])
    }, text)));
const $0f95a0eb59c00de6$var$buttonTextStyles = null;
const $0f95a0eb59c00de6$var$buttonContentStyles = null;
var $0f95a0eb59c00de6$export$2e2bcd8739ae039 = $0f95a0eb59c00de6$var$ResponsiveButton;

});

parcelRegister("brEs0", function(module, exports) {

$parcel$export(module.exports, "useSidebarStore", () => $ca1a269a4af4dfb4$export$118f45a8309a4356);
$parcel$export(module.exports, "useSidebarActions", () => $ca1a269a4af4dfb4$export$685a45ff9d61633f);
$parcel$export(module.exports, "useSidebarIssueKey", () => $ca1a269a4af4dfb4$export$f13d78bbfbeaf57a);

var $WBLbN = parcelRequire("WBLbN");

var $hMSDj = parcelRequire("hMSDj");
const { CLOSED: $ca1a269a4af4dfb4$var$CLOSED, SHOWING_ISSUE: $ca1a269a4af4dfb4$var$SHOWING_ISSUE, SHOWING_CONFIGURATION: $ca1a269a4af4dfb4$var$SHOWING_CONFIGURATION, SHOWING_INSIGHTS: $ca1a269a4af4dfb4$var$SHOWING_INSIGHTS } = (0, $hMSDj.SidebarStatuses);
const $ca1a269a4af4dfb4$var$initialState = {
    // NOTE: we store status and issueKey inside a 'state' object because they are
    // related to each other. e.g. if status is ShowingIssue then issueKey must exist
    // flow can't handle this with the main state object because it uses partial state
    state: {
        status: $ca1a269a4af4dfb4$var$CLOSED
    }
};
const $ca1a269a4af4dfb4$export$e324594224ef24da = {
    close: ()=>({ setState: setState })=>setState({
                state: {
                    status: $ca1a269a4af4dfb4$var$CLOSED
                }
            }),
    showIssue: (issueKey)=>({ setState: setState })=>setState({
                state: {
                    status: $ca1a269a4af4dfb4$var$SHOWING_ISSUE,
                    issueKey: issueKey
                }
            }),
    showConfiguration: ()=>({ setState: setState })=>setState({
                state: {
                    status: $ca1a269a4af4dfb4$var$SHOWING_CONFIGURATION
                }
            }),
    showInsights: ()=>({ setState: setState })=>setState({
                state: {
                    status: $ca1a269a4af4dfb4$var$SHOWING_INSIGHTS
                }
            })
};
const $ca1a269a4af4dfb4$var$Store = (0, $WBLbN.createStore)({
    name: 'deploymentsSidebarStore',
    initialState: $ca1a269a4af4dfb4$var$initialState,
    actions: $ca1a269a4af4dfb4$export$e324594224ef24da
});
const $ca1a269a4af4dfb4$var$useStore = (0, $WBLbN.createHook)($ca1a269a4af4dfb4$var$Store);
const $ca1a269a4af4dfb4$export$118f45a8309a4356 = ()=>{
    const [{ state: state }, sidebarActions] = $ca1a269a4af4dfb4$var$useStore();
    return [
        state,
        sidebarActions
    ];
};
const $ca1a269a4af4dfb4$var$useSidebarWithoutState = (0, $WBLbN.createHook)($ca1a269a4af4dfb4$var$Store, {
    selector: null
});
const $ca1a269a4af4dfb4$export$685a45ff9d61633f = ()=>{
    const [, sidebarActions] = $ca1a269a4af4dfb4$var$useSidebarWithoutState();
    return sidebarActions;
};
const $ca1a269a4af4dfb4$export$f13d78bbfbeaf57a = (0, $WBLbN.createHook)($ca1a269a4af4dfb4$var$Store, {
    // @ts-expect-error - TS2339 - Property 'issueKey' does not exist on type 'SidebarState'.
    selector: (state)=>state.state.issueKey || null
});

});
parcelRegister("hMSDj", function(module, exports) {

$parcel$export(module.exports, "SidebarStatuses", () => $ac4ded0efee1ba61$export$a4b0bca2b71ad188);
const $ac4ded0efee1ba61$var$CLOSED = 'CLOSED';
const $ac4ded0efee1ba61$var$SHOWING_ISSUE = 'SHOWING_ISSUE';
const $ac4ded0efee1ba61$var$SHOWING_CONFIGURATION = 'SHOWING_CONFIGURATION';
const $ac4ded0efee1ba61$var$SHOWING_INSIGHTS = 'SHOWING_INSIGHTS';
const $ac4ded0efee1ba61$export$a4b0bca2b71ad188 = {
    CLOSED: $ac4ded0efee1ba61$var$CLOSED,
    SHOWING_ISSUE: $ac4ded0efee1ba61$var$SHOWING_ISSUE,
    SHOWING_CONFIGURATION: $ac4ded0efee1ba61$var$SHOWING_CONFIGURATION,
    SHOWING_INSIGHTS: $ac4ded0efee1ba61$var$SHOWING_INSIGHTS
};

});


parcelRegister("eSK2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $572d7c1a6c5ba2d0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $572d7c1a6c5ba2d0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    configuration: {
        "id": "software-deployments.configuration-button.configuration",
        "defaultMessage": "View settings"
    },
    buttonIconLabel: {
        "id": "software-deployments.configuration-button.button-icon-label",
        "defaultMessage": "Configure view icon"
    },
    tooltip: {
        "id": "software-deployments.configuration-button.tooltip",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("fU4Ho", function(module, exports) {

$parcel$export(module.exports, "default", () => $889c443f7eef9154$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kMHOY = parcelRequire("kMHOY");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $3MV1G = parcelRequire("3MV1G");

var $2eG9N = parcelRequire("2eG9N");

var $kGQen = parcelRequire("kGQen");

var $4ksts = parcelRequire("4ksts");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2YZvw = parcelRequire("2YZvw");

var $gVMGb = parcelRequire("gVMGb");

var $9nueo = parcelRequire("9nueo");

var $2WwpS = parcelRequire("2WwpS");

var $6TQlY = parcelRequire("6TQlY");

var $g19zV = parcelRequire("g19zV");

var $gybYa = parcelRequire("gybYa");

var $laaI5 = parcelRequire("laaI5");

var $i09yJ = parcelRequire("i09yJ");
const $889c443f7eef9154$export$66c597b986300b84 = (dateFilterOption)=>{
    switch(dateFilterOption){
        case '-2w':
            return {
                type: 'RELATIVE',
                buttonText: (0, $laaI5.default).pastTwoWeeksButtonText,
                tooltipText: (0, $laaI5.default).pastTwoWeeksTooltipText
            };
        case '-1m':
            return {
                type: 'RELATIVE',
                buttonText: (0, $laaI5.default).pastMonthButtonText,
                tooltipText: (0, $laaI5.default).pastMonthTooltipText
            };
        case '-3m':
            return {
                type: 'RELATIVE',
                buttonText: (0, $laaI5.default).pastQuarterButtonText,
                tooltipText: (0, $laaI5.default).pastQuarterTooltipText
            };
        case '-1y':
            return {
                type: 'RELATIVE',
                buttonText: (0, $laaI5.default).pastYearButtonText,
                tooltipText: (0, $laaI5.default).pastYearTooltipText
            };
        case 'now':
            throw new Error('Relative date filter value of now should not be selected');
        default:
            throw new Error('No date filter option found when selecting date filter message');
    }
};
const $889c443f7eef9154$export$c80e3d1960c3a294 = ({ startDate: startDate, endDate: endDate })=>({
        type: 'CUSTOM',
        buttonText: `${(0, $2WwpS.formatDate)(startDate, (0, $2YZvw.DATE_FORMAT_SLASH))}- ${(0, $2WwpS.formatDate)(endDate, (0, $2YZvw.DATE_FORMAT_SLASH))}`,
        tooltipText: (0, $laaI5.default).customRangeTooltipText,
        tooltipTextOptions: {
            startDate: (0, $2WwpS.formatDate)(startDate, (0, $2YZvw.DATE_FORMAT_SLASH)),
            endDate: (0, $2WwpS.formatDate)(endDate, (0, $2YZvw.DATE_FORMAT_SLASH))
        }
    });
const $889c443f7eef9154$var$useFireDateFilterKeyboardShortcutPressedAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (dateFilterType)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'dateFilterKeyboardShortcut', {
            dateFilterType: dateFilterType
        });
};
const $889c443f7eef9154$var$DateFilter = ({ isModalDefaultOpen: isModalDefaultOpen = false })=>{
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(isModalDefaultOpen);
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(false);
    const [dateFilter] = (0, $6TQlY.useDateFilter)();
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const fireDateFilterKeyboardShortCutPressedAnalytics = $889c443f7eef9154$var$useFireDateFilterKeyboardShortcutPressedAnalytics();
    const fireDateFilterSelectedAnalytics = (0, $9nueo.useFireDateFilterSelectedAnalytics)();
    const fireFormCancelledAnalytics = (0, $9nueo.useFireFormCancelledAnalytics)();
    const fireKeyboardShortcutAnalytics = (dateFilterType)=>{
        fireDateFilterKeyboardShortCutPressedAnalytics(dateFilterType);
        fireDateFilterSelectedAnalytics(dateFilterType);
    };
    const closePopup = ()=>setIsPopupOpen(false);
    const closeModal = ()=>setIsModalOpen(false);
    const openModal = ()=>setIsModalOpen(true);
    const dateFilterMessages = dateFilter.type === 'CUSTOM' ? $889c443f7eef9154$export$c80e3d1960c3a294({
        startDate: dateFilter.startDate,
        endDate: dateFilter.endDate
    }) : $889c443f7eef9154$export$66c597b986300b84(dateFilter.startDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gybYa.default), {
        onKeyPress: fireKeyboardShortcutAnalytics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isPopupOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i09yJ.default), {
                onOpen: openModal,
                onClose: closePopup
            }),
        onClose: closePopup,
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: dateFilterMessages.type === 'RELATIVE' ? formatMessage(dateFilterMessages.tooltipText) : formatMessage(dateFilterMessages.tooltipText, dateFilterMessages.tooltipTextOptions),
                hideTooltipOnClick: true,
                truncate: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVMGb.default), {
                isSelected: isPopupOpen,
                onClick: (_, analyticsEvent)=>{
                    if (!isPopupOpen) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dateFilterMenuOpen');
                    setIsPopupOpen(!isPopupOpen);
                },
                testId: "software-deployments.ui.date-filter.dropdown-menu",
                text: dateFilterMessages.type === 'RELATIVE' ? formatMessage(dateFilterMessages.buttonText) : dateFilterMessages.buttonText,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
                    label: formatMessage((0, $laaI5.default).dateFilterIcon)
                })
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: ()=>{
            closeModal();
            fireFormCancelledAnalytics();
        },
        width: "702px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $laaI5.default).modalHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g19zV.default), {
        onClose: closeModal
    }))))));
};
var $889c443f7eef9154$export$2e2bcd8739ae039 = $889c443f7eef9154$var$DateFilter;

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("9nueo", function(module, exports) {

$parcel$export(module.exports, "useFireDateFilterSelectedAnalytics", () => $3cc636466dc3a770$export$ddc609961094f913);
$parcel$export(module.exports, "useFireFormCancelledAnalytics", () => $3cc636466dc3a770$export$25e1b3c7cd88431a);

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $3cc636466dc3a770$export$ddc609961094f913 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (dateFilterType)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'dateFilter'
        }), 'dateFilterSelected', {
            dateFilterType: dateFilterType
        });
};
const $3cc636466dc3a770$export$25e1b3c7cd88431a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'cancelled',
            actionSubject: 'form'
        }), 'dateRangePickerCancel');
};

});

parcelRegister("g19zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcfc9b9cd0f7da3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3xcI8 = parcelRequire("3xcI8");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2YZvw = parcelRequire("2YZvw");

var $9nueo = parcelRequire("9nueo");

var $6TQlY = parcelRequire("6TQlY");

var $3ERdS = parcelRequire("3ERdS");

var $bnsXo = parcelRequire("bnsXo");

var $eqpYn = parcelRequire("eqpYn");

var $98Mxq = parcelRequire("98Mxq");
const $9dcfc9b9cd0f7da3$var$disabledDatesBeforeBadDeploymentsEndDate = [
    new Date((0, $3xcI8.default)('2020-03-29')),
    new Date((0, $3xcI8.default)('2020-03-30')),
    new Date((0, $3xcI8.default)('2020-03-31'))
];
const $9dcfc9b9cd0f7da3$var$useFireFormSubmittedAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (duration)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'submitted',
            actionSubject: 'form'
        }), 'dateRangePickerFormSubmit', {
            duration: duration,
            durationInDays: Math.round(duration / 86400000)
        });
};
const $9dcfc9b9cd0f7da3$var$DateRangePicker = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setCustomDateFilter: setCustomDateFilter }] = (0, $6TQlY.useDateFilter)();
    const { startDate: startDate, endDate: endDate, startValidation: startValidation, endValidation: endValidation, startDateInputChangeHandler: startDateInputChangeHandler, endDateInputChangeHandler: endDateInputChangeHandler, startCalendarSelectHandler: startCalendarSelectHandler, endCalendarSelectHandler: endCalendarSelectHandler, isFormValid: isFormValid } = (0, $98Mxq.useDateRangePickerForm)();
    const fireFormSubmittedAnalytics = $9dcfc9b9cd0f7da3$var$useFireFormSubmittedAnalytics();
    const fireFormCancelledAnalytics = (0, $9nueo.useFireFormCancelledAnalytics)();
    const fireDateFilterSelectedAnalytics = (0, $9nueo.useFireDateFilterSelectedAnalytics)(); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submitHandler = (event)=>{
        event.preventDefault();
        if (startDate && endDate) {
            setCustomDateFilter({
                startDate: startDate,
                endDate: endDate
            }); // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            fireFormSubmittedAnalytics(endDate - startDate);
            fireDateFilterSelectedAnalytics('custom-date');
            onClose();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "viewDateRangePicker",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dcfc9b9cd0f7da3$var$StyledForm, {
        onSubmit: submitHandler,
        name: "date-filter-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dcfc9b9cd0f7da3$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnsXo.default), {
        testId: "software-deployments.ui.date-filter.date-range-picker.date-input-start-date",
        label: formatMessage((0, $eqpYn.default).startDateLabel),
        isInvalid: startValidation && startValidation.type === 'ERROR',
        onChange: startDateInputChangeHandler,
        validation: startValidation,
        selected: startDate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ERdS.default), {
        testId: "software-deployments.ui.date-filter.date-range-picker.calendar-start-date",
        disabledDates: $9dcfc9b9cd0f7da3$var$disabledDatesBeforeBadDeploymentsEndDate,
        disableFuture: true,
        minDate: (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE),
        selected: startDate,
        onSelect: startCalendarSelectHandler
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dcfc9b9cd0f7da3$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnsXo.default), {
        testId: "software-deployments.ui.date-filter.date-range-picker.date-input-end-date",
        label: formatMessage((0, $eqpYn.default).endDateLabel),
        isInvalid: endValidation && endValidation.type === 'ERROR',
        onChange: endDateInputChangeHandler,
        validation: endValidation,
        selected: endDate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ERdS.default), {
        testId: "software-deployments.ui.date-filter.date-range-picker.calendar-end-date",
        disabledDates: $9dcfc9b9cd0f7da3$var$disabledDatesBeforeBadDeploymentsEndDate,
        disableFuture: true,
        minDate: startDate ?? (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE),
        selected: endDate,
        onSelect: endCalendarSelectHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9dcfc9b9cd0f7da3$var$FormActions, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: ()=>{
            onClose();
            fireFormCancelledAnalytics();
        }
    }, formatMessage((0, $eqpYn.default).cancelFormSubmission)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-deployments.ui.date-filter.date-range-picker.submit",
        appearance: "primary",
        type: "submit",
        isDisabled: !isFormValid
    }, formatMessage((0, $eqpYn.default).confirmFormSubmission)))))));
};
var $9dcfc9b9cd0f7da3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9dcfc9b9cd0f7da3$var$DateRangePicker;
const $9dcfc9b9cd0f7da3$var$StyledForm = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dcfc9b9cd0f7da3$var$FieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb15f3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9dcfc9b9cd0f7da3$var$FormActions = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi _1e0c1txw _1bahesu3 _n3td1ejb",
            __cmplp.className
        ])
    });
});

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("3ERdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b227ccc806d75a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gSA5V = parcelRequire("gSA5V");

var $2YZvw = parcelRequire("2YZvw");

var $2WwpS = parcelRequire("2WwpS");

var $57umF = parcelRequire("57umF");

var $3lxrH = parcelRequire("3lxrH");
const $a3b227ccc806d75a$var$Calendar = ({ disabledDates: disabledDates, disableFuture: disableFuture = false, disablePast: disablePast = false, minDate: minDate, maxDate: maxDate, onSelect: onSelect, selected: selected, testId: testId })=>{
    const { calendarDate: calendarDate, setCalendar: setCalendar } = (0, $57umF.useCalendar)(selected, {
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate
    });
    const disabled = (0, $3lxrH.useDisabledDates)({
        disabledDates: disabledDates,
        disablePast: disablePast,
        disableFuture: disableFuture,
        minDate: minDate,
        maxDate: maxDate
    });
    const changeHandler = ({ iso: iso, type: type })=>{
        if (iso !== undefined) {
            const date = (0, $2WwpS.getDate)(iso);
            if (date instanceof Date) setCalendar(date, type);
        }
    };
    const selectHandler = ({ iso: iso })=>{
        if (iso !== undefined && onSelect) {
            const date = (0, $2WwpS.getDate)(iso);
            if (date instanceof Date) onSelect(date);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a3b227ccc806d75a$var$CalendarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gSA5V.default), {
        testId: testId,
        disabled: disabled,
        day: (0, $2WwpS.getDay)(calendarDate),
        month: (0, $2WwpS.getMonth)(calendarDate),
        year: (0, $2WwpS.getYear)(calendarDate),
        onChange: changeHandler,
        // @ts-expect-error - TS2322 - Type '({ iso }: ChangeEvent) => void' is not assignable to type '(event: SelectEvent, analyticsEvent: UIAnalyticsEvent) => void'.
        onSelect: selectHandler,
        selected: selected ? [
            (0, $2WwpS.formatDate)(selected, (0, $2YZvw.DATE_FORMAT_DASH))
        ] : []
    }));
};
var $a3b227ccc806d75a$export$2e2bcd8739ae039 = $a3b227ccc806d75a$var$Calendar;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3b227ccc806d75a$var$CalendarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16qsng4a _2rko1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $ki32l = parcelRequire("ki32l");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $ki32l.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});
parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});




parcelRegister("57umF", function(module, exports) {

$parcel$export(module.exports, "useCalendar", () => $1a27da2f5922ffbe$export$3ee915f8151bd4f1);

var $eUqFw = parcelRequire("eUqFw");

var $3sYr7 = parcelRequire("3sYr7");
var $5H0DO = parcelRequire("5H0DO");

var $1nxOb = parcelRequire("1nxOb");

var $2WwpS = parcelRequire("2WwpS");
const $1a27da2f5922ffbe$var$isDateAfterMinMonth = (date, minDate)=>date > (0, $5H0DO.default)(minDate);
const $1a27da2f5922ffbe$var$isDateBeforeMaxMonth = (date, maxDate)=>date < (0, $3sYr7.default)(maxDate);
const $1a27da2f5922ffbe$var$isDateBeforeCurrentMonth = (date)=>date < (0, $3sYr7.default)(new Date());
const $1a27da2f5922ffbe$var$isDateAfterCurrentMonth = (date)=>date > (0, $5H0DO.default)(new Date());
const $1a27da2f5922ffbe$export$53953898c3c2875a = (date, { disableFuture: disableFuture = false, disablePast: disablePast = false, minDate: minDate, maxDate: maxDate })=>(!minDate || $1a27da2f5922ffbe$var$isDateAfterMinMonth(date, minDate)) && (!maxDate || $1a27da2f5922ffbe$var$isDateBeforeMaxMonth(date, maxDate)) && (!disablePast || $1a27da2f5922ffbe$var$isDateAfterCurrentMonth(date)) && (!disableFuture || $1a27da2f5922ffbe$var$isDateBeforeCurrentMonth(date));
const $1a27da2f5922ffbe$export$3ee915f8151bd4f1 = (// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
selected, { disableFuture: disableFuture = false, disablePast: disablePast = false, minDate: minDate, maxDate: maxDate })=>{
    const [calendarDate, setCalendarDate] = (0, $eUqFw.useState)((0, $1nxOb.getToday)());
    const isInitialRenderComplete = (0, $eUqFw.useRef)(false);
    const setCalendar = (date, type)=>{
        if (type !== 'prev' && type !== 'next' || $1a27da2f5922ffbe$export$53953898c3c2875a(date, {
            disablePast: disablePast,
            disableFuture: disableFuture,
            minDate: minDate,
            maxDate: maxDate
        })) setCalendarDate((0, $2WwpS.getRoundedDate)(date, {
            disablePast: disablePast,
            disableFuture: disableFuture,
            minDate: minDate,
            maxDate: maxDate
        }));
    };
    (0, $eUqFw.useEffect)(()=>{
        if (selected !== undefined) setCalendarDate(selected);
    }, [
        selected
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // prevent this hook from running on initial render
        if (isInitialRenderComplete.current) {
            if (minDate !== undefined && minDate > calendarDate) setCalendarDate(minDate);
        } else isInitialRenderComplete.current = true;
    }, [
        calendarDate,
        minDate
    ]);
    return {
        setCalendar: setCalendar,
        calendarDate: calendarDate
    };
};

});

parcelRegister("3lxrH", function(module, exports) {

$parcel$export(module.exports, "useDisabledDates", () => $d246fc929ec5fdfd$export$2e396ce5b7218bcf);

var $eUqFw = parcelRequire("eUqFw");

var $iNMur = parcelRequire("iNMur");

var $6wqPF = parcelRequire("6wqPF");
var $9FEvp = parcelRequire("9FEvp");

var $2YZvw = parcelRequire("2YZvw");

var $2WwpS = parcelRequire("2WwpS");
const $d246fc929ec5fdfd$var$VISIBLE_DAYS_IN_CALENDAR_MONTH = 42;
const $d246fc929ec5fdfd$export$2e396ce5b7218bcf = ({ disabledDates: disabledDates = [], disablePast: disablePast = false, disableFuture: disableFuture = false, minDate: minDate = new Date(), maxDate: maxDate = new Date() })=>{
    const futureDates = (0, (/*@__PURE__*/$parcel$interopDefault($iNMur)))($d246fc929ec5fdfd$var$VISIBLE_DAYS_IN_CALENDAR_MONTH, (i)=>(0, $6wqPF.default)(new Date(), i + 1));
    const pastDates = (0, (/*@__PURE__*/$parcel$interopDefault($iNMur)))($d246fc929ec5fdfd$var$VISIBLE_DAYS_IN_CALENDAR_MONTH, (i)=>(0, $9FEvp.default)(new Date(), i + 1));
    const minDates = (0, (/*@__PURE__*/$parcel$interopDefault($iNMur)))($d246fc929ec5fdfd$var$VISIBLE_DAYS_IN_CALENDAR_MONTH, (i)=>(0, $9FEvp.default)(minDate, i + 1));
    const maxDates = (0, (/*@__PURE__*/$parcel$interopDefault($iNMur)))($d246fc929ec5fdfd$var$VISIBLE_DAYS_IN_CALENDAR_MONTH, (i)=>(0, $6wqPF.default)(maxDate, i + 1));
    const disabled = (0, $eUqFw.useMemo)(()=>[
            ...disabledDates,
            ...disablePast ? pastDates : [],
            ...disableFuture ? futureDates : [],
            ...minDate !== undefined ? minDates : [],
            ...maxDate !== undefined ? maxDates : []
        ].map((date)=>(0, $2WwpS.formatDate)(date, (0, $2YZvw.DATE_FORMAT_DASH))), [
        disableFuture,
        disablePast,
        disabledDates,
        futureDates,
        maxDate,
        maxDates,
        minDate,
        minDates,
        pastDates
    ]);
    return disabled;
};

});
parcelRegister("iNMur", function(module, exports) {

var $655cq = parcelRequire("655cq");

var $cOXK6 = parcelRequire("cOXK6");

var $hNahz = parcelRequire("hNahz");
/** Used as references for various `Number` constants. */ var $db026ab9873b96e8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $db026ab9873b96e8$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $db026ab9873b96e8$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $db026ab9873b96e8$var$times(n, iteratee) {
    n = $hNahz(n);
    if (n < 1 || n > $db026ab9873b96e8$var$MAX_SAFE_INTEGER) return [];
    var index = $db026ab9873b96e8$var$MAX_ARRAY_LENGTH, length = $db026ab9873b96e8$var$nativeMin(n, $db026ab9873b96e8$var$MAX_ARRAY_LENGTH);
    iteratee = $cOXK6(iteratee);
    n -= $db026ab9873b96e8$var$MAX_ARRAY_LENGTH;
    var result = $655cq(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
module.exports = $db026ab9873b96e8$var$times;

});



parcelRegister("bnsXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $833b7b4e0229c094$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $6ROLN = parcelRequire("6ROLN");

var $hI5oG = parcelRequire("hI5oG");

var $kMHOY = parcelRequire("kMHOY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $4ksts = parcelRequire("4ksts");

var $2YZvw = parcelRequire("2YZvw");

var $2WwpS = parcelRequire("2WwpS");

var $f9YPJ = parcelRequire("f9YPJ");

var $5xfMC = parcelRequire("5xfMC");
const $833b7b4e0229c094$var$DateInput = ({ selected: selected, testId: testId, isInvalid: isInvalid = false, onChange: onChange, label: label = 'Date picker', validation: validation })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const [inputValue, setInputValue] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        if (selected) setInputValue((0, $2WwpS.formatDate)(selected, (0, $2YZvw.DATE_FORMAT_SLASH)));
    }, [
        selected
    ]);
    const changeHandler = (e)=>{
        e.preventDefault();
        setInputValue(e.target.value);
        if (onChange) onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "date-input-text-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200",
        as: "span"
    }, label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        id: "date-input-text-field",
        testId: testId,
        onChange: changeHandler,
        placeholder: (0, $2YZvw.DATE_FORMAT_SLASH_PLACEHOLDER),
        isInvalid: isInvalid,
        value: inputValue,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $833b7b4e0229c094$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
            label: formatMessage((0, $f9YPJ.default).calendarIconLabel)
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_19pk1b66 _4t3igktf"
        ])
    }, validation !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5xfMC.default), {
        testId: testId !== undefined ? `${testId}.validation-message` : undefined,
        type: validation.type
    }, formatMessage(validation.message, {
        dateType: label
    }))));
};
const $833b7b4e0229c094$var$validationWrapperStyles = null;
const $833b7b4e0229c094$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.100'
});
var $833b7b4e0229c094$export$2e2bcd8739ae039 = $833b7b4e0229c094$var$DateInput;

});
parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("f9YPJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9783944d98caef$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9d9783944d98caef$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    calendarIconLabel: {
        "id": "software-deployments.date-filter.date-range-picker.date-input.calendar-icon-label",
        "defaultMessage": "Calendar Icon"
    }
});

});

parcelRegister("5xfMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fcd24be9355e78$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");
const $87fcd24be9355e78$var$ValidationMessage = ({ children: children, testId: testId, type: type })=>{
    switch(type){
        case 'HELPER':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), {
                testId: testId
            }, children);
        case 'VALID':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ValidMessage), {
                testId: testId
            }, children);
        case 'ERROR':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
                testId: testId
            }, children);
        default:
            // prettier-ignore
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            type;
            throw new Error('Unhandled validation message type');
    }
};
var $87fcd24be9355e78$export$2e2bcd8739ae039 = $87fcd24be9355e78$var$ValidationMessage;

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});




parcelRegister("eqpYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ed1759c660cc51$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $36ed1759c660cc51$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    startDateLabel: {
        "id": "software-deployments.date-filter.date-range-picker.start-date-label",
        "defaultMessage": "Start date"
    },
    endDateLabel: {
        "id": "software-deployments.date-filter.date-range-picker.end-date-label",
        "defaultMessage": "End date"
    },
    invalidDateFormatHelperMessage: {
        "id": "software-deployments.date-filter.date-range-picker.invalid-date-format-helper-message",
        "defaultMessage": "Date format should be YYYY/MM/DD"
    },
    invalidDateErrorMessage: {
        "id": "software-deployments.date-filter.date-range-picker.invalid-date-error-message",
        "defaultMessage": "Date invalid"
    },
    beforeAprilDateErrorMessage: {
        "id": "software-deployments.date-filter.date-range-picker.before-april-date-error-message",
        "defaultMessage": "Date before April 2020 not allowed"
    },
    futureDateErrorMessage: {
        "id": "software-deployments.date-filter.date-range-picker.future-date-error-message",
        "defaultMessage": "Future date not allowed"
    },
    startDateAfterEndDateErrorMessage: {
        "id": "software-deployments.date-filter.date-range-picker.start-date-after-end-date-error-message",
        "defaultMessage": "Start date must be before end date"
    },
    dateRangeMoreThanYearApartErrorMessage: {
        "id": "software-deployments.date-filter.date-range-picker.date-range-more-than-year-apart-error-message",
        "defaultMessage": "Date range must be less than a year apart"
    },
    dateSuccessMessage: {
        "id": "software-deployments.date-filter.date-range-picker.date-success-message",
        "defaultMessage": "{dateType} selected"
    },
    editorSuccessIcon: {
        "id": "software-deployments.date-filter.date-range-picker.editor-success-icon",
        "defaultMessage": "Editor Success Icon"
    },
    errorIcon: {
        "id": "software-deployments.date-filter.date-range-picker.error-icon",
        "defaultMessage": "Error Icon"
    },
    confirmFormSubmission: {
        "id": "software-deployments.date-filter.date-range-picker.confirm-form-submission",
        "defaultMessage": "Confirm"
    },
    cancelFormSubmission: {
        "id": "software-deployments.date-filter.date-range-picker.cancel-form-submission",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("98Mxq", function(module, exports) {

$parcel$export(module.exports, "useDateRangePickerForm", () => $209297e37a8b611c$export$2ccc353393e21bd);

var $eUqFw = parcelRequire("eUqFw");

var $2YZvw = parcelRequire("2YZvw");

var $2WwpS = parcelRequire("2WwpS");

var $6TQlY = parcelRequire("6TQlY");

var $eqpYn = parcelRequire("eqpYn");
const $209297e37a8b611c$export$efe4a022b765ba2f = (date)=>{
    if ((0, $2WwpS.isDateAfterToday)(date)) return {
        type: 'ERROR',
        message: (0, $eqpYn.default).futureDateErrorMessage
    };
    if ((0, $2WwpS.isDateBeforeApril)(date)) return {
        type: 'ERROR',
        message: (0, $eqpYn.default).beforeAprilDateErrorMessage
    };
    return {
        type: 'VALID',
        message: (0, $eqpYn.default).dateSuccessMessage
    };
};
const $209297e37a8b611c$var$getInvalidDateErrorMessage = (invalidDateType)=>{
    if (invalidDateType === 'INVALID-DATE') return {
        type: 'ERROR',
        message: (0, $eqpYn.default).invalidDateErrorMessage
    };
    if (invalidDateType === 'INVALID-FORMAT') return {
        type: 'HELPER',
        message: (0, $eqpYn.default).invalidDateFormatHelperMessage
    };
    return undefined;
};
const $209297e37a8b611c$export$da20da99bcceb97 = (dateRangeState)=>{
    switch(dateRangeState){
        case 'MORE-THAN-YEAR-APART':
            return {
                type: 'ERROR',
                message: (0, $eqpYn.default).dateRangeMoreThanYearApartErrorMessage
            };
        case 'START-AFTER-END':
            return {
                type: 'ERROR',
                message: (0, $eqpYn.default).startDateAfterEndDateErrorMessage
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            dateRangeState;
            throw new Error('No date range validation enum found when setting start date');
    }
};
const $209297e37a8b611c$export$2ccc353393e21bd = ()=>{
    const [dateFilter] = (0, $6TQlY.useDateFilter)();
    const [startDate, setStartDate] = (0, $eUqFw.useState)(dateFilter.type === 'CUSTOM' ? dateFilter.startDate : undefined);
    const [endDate, setEndDate] = (0, $eUqFw.useState)(dateFilter.type === 'CUSTOM' ? dateFilter.endDate : undefined);
    const [startValidation, setStartValidation] = (0, $eUqFw.useState)();
    const [endValidation, setEndValidation] = (0, $eUqFw.useState)();
    const [isStartDateInputValid, setIsStartDateInputValid] = (0, $eUqFw.useState)(dateFilter.type === 'CUSTOM');
    const [isEndDateInputValid, setIsEndDateInputValid] = (0, $eUqFw.useState)(dateFilter.type === 'CUSTOM');
    const startDateInputChangeHandler = (value)=>{
        const date = (0, $2WwpS.getDate)(value);
        if (date instanceof Date) {
            setStartValidation($209297e37a8b611c$export$efe4a022b765ba2f(date));
            setIsStartDateInputValid(true);
            if (isEndDateInputValid) setEndValidation({
                type: 'VALID',
                message: (0, $eqpYn.default).dateSuccessMessage
            });
            return setStartDate((0, $2WwpS.startOfDay)((0, $2WwpS.getRoundedDate)(date, {
                disableFuture: true,
                minDate: (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE)
            })));
        }
        setIsStartDateInputValid(false);
        return setStartValidation($209297e37a8b611c$var$getInvalidDateErrorMessage(date));
    };
    const endDateInputChangeHandler = (value)=>{
        const date = (0, $2WwpS.getDate)(value);
        if (date instanceof Date) {
            setEndValidation($209297e37a8b611c$export$efe4a022b765ba2f(date));
            setIsEndDateInputValid(true);
            if (isStartDateInputValid) setStartValidation({
                type: 'VALID',
                message: (0, $eqpYn.default).dateSuccessMessage
            });
            return setEndDate((0, $2WwpS.getRoundedDate)(date, {
                disableFuture: true,
                minDate: (0, $2YZvw.BAD_DEPLOYMENTS_DATA_END_DATE)
            }));
        }
        setIsEndDateInputValid(false);
        return setEndValidation($209297e37a8b611c$var$getInvalidDateErrorMessage(date));
    };
    const startCalendarSelectHandler = (date)=>{
        setStartDate(date);
        setIsStartDateInputValid(true);
        setStartValidation({
            type: 'VALID',
            message: (0, $eqpYn.default).dateSuccessMessage
        });
        if (isEndDateInputValid) setEndValidation({
            type: 'VALID',
            message: (0, $eqpYn.default).dateSuccessMessage
        });
    };
    const endCalendarSelectHandler = (date)=>{
        setEndDate(date);
        setIsEndDateInputValid(true);
        setEndValidation({
            type: 'VALID',
            message: (0, $eqpYn.default).dateSuccessMessage
        });
        if (isStartDateInputValid) setStartValidation({
            type: 'VALID',
            message: (0, $eqpYn.default).dateSuccessMessage
        });
    };
    (0, $eUqFw.useEffect)(()=>{
        if (startDate && endDate) {
            const { startDate: validatedStartDate, endDate: validatedEndDate, errorType: errorType } = (0, $6TQlY.getValidatedDateRange)({
                startDate: startDate,
                endDate: endDate
            });
            setStartDate(validatedStartDate);
            setEndDate(validatedEndDate);
            if (errorType) {
                setStartValidation($209297e37a8b611c$export$da20da99bcceb97(errorType));
                setEndValidation(undefined);
            }
        }
    }, [
        endDate,
        startDate
    ]);
    const isFormValid = Boolean(startDate && endDate && isStartDateInputValid && isEndDateInputValid);
    return {
        startDate: startDate,
        endDate: endDate,
        startValidation: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ValidationMessage | undefined'.
        startValidation,
        endValidation: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'ValidationMessage | undefined'.
        endValidation,
        startDateInputChangeHandler: startDateInputChangeHandler,
        endDateInputChangeHandler: endDateInputChangeHandler,
        startCalendarSelectHandler: startCalendarSelectHandler,
        endCalendarSelectHandler: endCalendarSelectHandler,
        isFormValid: isFormValid
    };
};

});


parcelRegister("gybYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2384ee80066c946e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");

var $6TQlY = parcelRequire("6TQlY");
const $2384ee80066c946e$var$KeyboardShortcuts = ({ onKeyPress: onKeyPress })=>{
    const [, { setRelativeDateFilter: setRelativeDateFilter }] = (0, $6TQlY.useDateFilter)();
    const keyMap = {
        m: {
            callback: ()=>{
                setRelativeDateFilter((0, $6TQlY.RelativeDateFilterOptions).PAST_MONTH);
                onKeyPress((0, $6TQlY.RelativeDateFilterOptions).PAST_MONTH.toLowerCase());
            }
        },
        q: {
            callback: ()=>{
                setRelativeDateFilter((0, $6TQlY.RelativeDateFilterOptions).PAST_QUARTER);
                onKeyPress((0, $6TQlY.RelativeDateFilterOptions).PAST_QUARTER.toLowerCase());
            }
        },
        w: {
            callback: ()=>{
                setRelativeDateFilter((0, $6TQlY.RelativeDateFilterOptions).PAST_TWO_WEEKS);
                onKeyPress((0, $6TQlY.RelativeDateFilterOptions).PAST_TWO_WEEKS.toLowerCase());
            }
        },
        y: {
            callback: ()=>{
                setRelativeDateFilter((0, $6TQlY.RelativeDateFilterOptions).PAST_YEAR);
                onKeyPress((0, $6TQlY.RelativeDateFilterOptions).PAST_YEAR.toLowerCase());
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    });
};
var $2384ee80066c946e$export$2e2bcd8739ae039 = $2384ee80066c946e$var$KeyboardShortcuts;

});
parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});

parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("laaI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dacd7cb60bdc616$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6dacd7cb60bdc616$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    pastTwoWeeksButtonText: {
        "id": "software-deployments.date-filter.past-two-weeks-button-text",
        "defaultMessage": "2 Weeks"
    },
    pastMonthButtonText: {
        "id": "software-deployments.date-filter.past-month-button-text",
        "defaultMessage": "Month"
    },
    pastQuarterButtonText: {
        "id": "software-deployments.date-filter.past-quarter-button-text",
        "defaultMessage": "Quarter"
    },
    pastYearButtonText: {
        "id": "software-deployments.date-filter.past-year-button-text",
        "defaultMessage": "Year"
    },
    dateFilterIcon: {
        "id": "software-deployments.date-filter.date-filter-icon",
        "defaultMessage": "Date Filter Icon"
    },
    pastTwoWeeksTooltipText: {
        "id": "software-deployments.date-filter.past-two-weeks-tooltip-text",
        "defaultMessage": "Dates filtered to the past 2 weeks"
    },
    pastMonthTooltipText: {
        "id": "software-deployments.date-filter.past-month-tooltip-text",
        "defaultMessage": "Dates filtered to the past month"
    },
    pastQuarterTooltipText: {
        "id": "software-deployments.date-filter.past-quarter-tooltip-text",
        "defaultMessage": "Dates filtered to the past quarter"
    },
    pastYearTooltipText: {
        "id": "software-deployments.date-filter.past-year-tooltip-text",
        "defaultMessage": "Dates filtered to the past year"
    },
    customRangeTooltipText: {
        "id": "software-deployments.date-filter.custom-range-tooltip-text",
        "defaultMessage": "Dates filtered from {startDate} - {endDate}"
    },
    modalHeading: {
        "id": "software-deployments.date-filter.modal-heading",
        "defaultMessage": "Select custom date range"
    }
});

});

parcelRegister("i09yJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bdee7afd92715be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bULPy = parcelRequire("bULPy");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9nueo = parcelRequire("9nueo");

var $6TQlY = parcelRequire("6TQlY");

var $bnmIm = parcelRequire("bnmIm");
const $6bdee7afd92715be$var$relativeOptions = [
    {
        value: (0, $6TQlY.RelativeDateFilterOptions).PAST_TWO_WEEKS,
        label: (0, $bnmIm.default).pastTwoWeeksLabel,
        keyboardShortcut: 'w'
    },
    {
        value: (0, $6TQlY.RelativeDateFilterOptions).PAST_MONTH,
        label: (0, $bnmIm.default).pastMonthLabel,
        keyboardShortcut: 'm'
    },
    {
        value: (0, $6TQlY.RelativeDateFilterOptions).PAST_QUARTER,
        label: (0, $bnmIm.default).pastQuarterLabel,
        keyboardShortcut: 'q'
    },
    {
        value: (0, $6TQlY.RelativeDateFilterOptions).PAST_YEAR,
        label: (0, $bnmIm.default).pastYearLabel,
        keyboardShortcut: 'y'
    }
];
const $6bdee7afd92715be$var$useFireDateFilterMenuItemClickedAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (dateFilterType)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'dateFilterMenuItem', {
            dateFilterType: dateFilterType
        });
};
const $6bdee7afd92715be$var$PopupContent = ({ onOpen: onOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setRelativeDateFilter: setRelativeDateFilter }] = (0, $6TQlY.useDateFilter)();
    const fireDateFilterMenuItemClickedAnalytics = $6bdee7afd92715be$var$useFireDateFilterMenuItemClickedAnalytics();
    const fireDateFilterSelectedAnalytics = (0, $9nueo.useFireDateFilterSelectedAnalytics)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "viewDateFilterMenu",
        sourceType: (0, $41ea3621645e2acc$export$d1123261ca8831d2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        title: formatMessage((0, $bnmIm.default).dateFilterTitle)
    }, $6bdee7afd92715be$var$relativeOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
            testId: `software-deployments.ui.date-filter.popup-content.button-item-${option.value.toLowerCase()}`,
            key: option.value,
            onClick: ()=>{
                onClose();
                setRelativeDateFilter(option.value);
                fireDateFilterMenuItemClickedAnalytics(option.value.toLowerCase());
                fireDateFilterSelectedAnalytics(option.value.toLowerCase());
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bdee7afd92715be$var$ButtonItemContent, null, formatMessage(option.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6bdee7afd92715be$var$ShortcutIcon, null, option.keyboardShortcut))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        testId: "software-deployments.ui.date-filter.popup-content.button-item-custom-date",
        onClick: ()=>{
            onClose();
            onOpen();
            fireDateFilterMenuItemClickedAnalytics('custom-date');
        }
    }, formatMessage((0, $bnmIm.default).customRangeLabel)))));
};
var $6bdee7afd92715be$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6bdee7afd92715be$var$PopupContent;
const $6bdee7afd92715be$var$ButtonItemContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb9rak _1e0c1txw _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6bdee7afd92715be$var$ShortcutIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbgktf _4t3igktf _bfhk1s4m _syaz1ybm _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bnmIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b7f9b45152d32d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $19b7f9b45152d32d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dateFilterTitle: {
        "id": "software-deployments.date-filter.popup-content.date-filter-title",
        "defaultMessage": "Date Range"
    },
    pastTwoWeeksLabel: {
        "id": "software-deployments.date-filter.popup-content.past-two-weeks-label",
        "defaultMessage": "Past 2 weeks"
    },
    pastMonthLabel: {
        "id": "software-deployments.date-filter.popup-content.past-month-label",
        "defaultMessage": "Past month"
    },
    pastQuarterLabel: {
        "id": "software-deployments.date-filter.popup-content.past-quarter-label",
        "defaultMessage": "Past quarter"
    },
    pastYearLabel: {
        "id": "software-deployments.date-filter.popup-content.past-year-label",
        "defaultMessage": "Past year"
    },
    customRangeLabel: {
        "id": "software-deployments.date-filter.popup-content.custom-range-label",
        "defaultMessage": "Custom Range"
    }
});

});



parcelRegister("2vtNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a2ecfde7d75536$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bLFgh = parcelRequire("bLFgh");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $9zysr = parcelRequire("9zysr");

var $g9zol = parcelRequire("g9zol");

var $4ACoF = parcelRequire("4ACoF");

var $6FP8W = parcelRequire("6FP8W");

var $huI7r = parcelRequire("huI7r");

var $6vrw7 = parcelRequire("6vrw7");

var $5kyEc = parcelRequire("5kyEc");

var $bNrYl = parcelRequire("bNrYl");

var $kjUtl = parcelRequire("kjUtl");

var $dWLk9 = parcelRequire("dWLk9");

var $h1Cog = parcelRequire("h1Cog");

var $lnbOK = parcelRequire("lnbOK");

var $2uDXJ = parcelRequire("2uDXJ");
const $39a2ecfde7d75536$var$HeaderNew = ({ leftContent: leftContent, rightContent: rightContent })=>{
    const { data: data } = (0, $lnbOK.useProjectContextServiceQueryResult)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const buttonGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9zol.default), {
        from: (0, $huI7r.createAri)({
            resourceId: data?.projectId.toString() ?? '',
            resourceType: 'project',
            resourceOwner: 'jira',
            cloudId: cloudId
        })
    }), rightContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $39a2ecfde7d75536$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
        fallback: "flag",
        eventLocation: "exportButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uDXJ.default), {
        isIconOnly: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $39a2ecfde7d75536$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNrYl.default), {
        isProjectAdmin: data?.isProjectAdmin ?? false,
        isSimplified: data?.simplified ?? false,
        projectKey: (0, $6vrw7.toProjectKey)(data?.projectKey ?? ''),
        hasDeployments: true
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ACoF.PageTopBar), {
        bottomBar: leftContent,
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $39a2ecfde7d75536$var$actionBarStyles
        }, buttonGroup),
        wrapAtMd: true
    });
};
const $39a2ecfde7d75536$var$HeaderOld = ({ leftContent: leftContent, rightContent: rightContent })=>{
    const { data: data } = (0, $lnbOK.useProjectContextServiceQueryResult)();
    const cloudId = (0, $dWLk9.useCloudId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjUtl.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9zol.default), {
            from: (0, $huI7r.createAri)({
                resourceId: data?.projectId.toString() ?? '',
                resourceType: 'project',
                resourceOwner: 'jira',
                cloudId: cloudId
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
            fallback: "unmount",
            eventLocation: "feedbackButton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kyEc.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
            fallback: "flag",
            eventLocation: "exportButton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2uDXJ.default), null)), data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNrYl.default), {
            isProjectAdmin: data.isProjectAdmin ?? false,
            isSimplified: data.simplified,
            projectKey: (0, $6vrw7.toProjectKey)(data.projectKey),
            hasDeployments: true
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _18s8zu5n _1n261tfl _45zz1q9c"
        ])
    }, leftContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $39a2ecfde7d75536$var$rightContentWrapperStyles
    }, rightContent)));
};
const $39a2ecfde7d75536$var$filtersRowContainerStyles = null;
const $39a2ecfde7d75536$var$buttonStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    marginLeft: 'space.050'
});
const $39a2ecfde7d75536$var$actionBarStyles = (0, $1ZAYh.xcss)({
    // enough width to fit all action buttons without shrinking
    minWidth: '275px',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'flex-end'
});
const $39a2ecfde7d75536$var$rightContentWrapperStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'flex-end',
    display: 'flex',
    flex: '1 1 auto',
    [(0, $4Ywu9.media).above.md]: {
        flex: '0 1 auto'
    }
});
var $39a2ecfde7d75536$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>(0, $6FP8W.getWillShowNav4)(), $39a2ecfde7d75536$var$HeaderNew, $39a2ecfde7d75536$var$HeaderOld);

});
parcelRegister("g9zol", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0e43edf6bdb42d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $5JgJ2 = parcelRequire("5JgJ2");

var $yyqSx = parcelRequire("yyqSx");

var $gd0Sp = parcelRequire("gd0Sp");


var $9OYB0 = parcelRequire("9OYB0");

var $jmsjD = parcelRequire("jmsjD");
function $0a0e43edf6bdb42d$var$Graph({ from: from }) {
    const { environment: environment } = (0, $gd0Sp.useTenantContext)();
    const graphURL = `${environment === 'staging' ? (0, $8df28cd2923155d9$export$b1c73a3711ffd2e1) : (0, $8df28cd2923155d9$export$b105bca7736ab247)}?ari=${from}`;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: graphURL,
        "aria-label": formatMessage((0, $jmsjD.default).graphButtonLabelNonFinal),
        target: "_blank",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9OYB0.GraphIcon), null)
    });
}
var $0a0e43edf6bdb42d$export$2e2bcd8739ae039 = (0, $9zysr.componentWithCondition)(()=>!(0, $yyqSx.isDevopsFeatureDisabledInFedRamp)() && (0, $1ybV0.ff)('otc.show-me-the-graph'), $0a0e43edf6bdb42d$var$Graph, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
()=>null);

});
const $8df28cd2923155d9$export$b105bca7736ab247 = 'https://atlassian-graph.prod-east.frontend.public.atl-paas.net/';
const $8df28cd2923155d9$export$b1c73a3711ffd2e1 = 'https://atlassian-graph.stg-east.frontend.public.atl-paas.net/';

parcelRegister("9OYB0", function(module, exports) {

$parcel$export(module.exports, "GraphIcon", () => $9f207142d711682c$export$717a5ffb6a14ac74);

var $eUqFw = parcelRequire("eUqFw");

const $9f207142d711682c$export$717a5ffb6a14ac74 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: `var(--ds-icon-discovery, ${(0, $73a5c9d720aa66e1$exports).P500})`,
        viewBox: "0 0 256 256"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M200,152a31.84,31.84,0,0,0-19.53,6.68l-23.11-18A31.65,31.65,0,0,0,160,128c0-.74,0-1.48-.08-2.21l13.23-4.41A32,32,0,1,0,168,104c0,.74,0,1.48.08,2.21l-13.23,4.41A32,32,0,0,0,128,96a32.59,32.59,0,0,0-5.27.44L115.89,81A32,32,0,1,0,96,88a32.59,32.59,0,0,0,5.27-.44l6.84,15.4a31.92,31.92,0,0,0-8.57,39.64L73.83,165.44a32.06,32.06,0,1,0,10.63,12l25.71-22.84a31.91,31.91,0,0,0,37.36-1.24l23.11,18A31.65,31.65,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"
    }));

});

parcelRegister("jmsjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8bcb16afed37fb9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a8bcb16afed37fb9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    graphButtonLabelNonFinal: {
        "id": "graph.graph-button-label-non-final",
        "defaultMessage": "Open the graph"
    }
});

});


parcelRegister("5kyEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c804448635aed067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1c02D = parcelRequire("1c02D");

var $bCwLs = parcelRequire("bCwLs");

var $ixwgj = parcelRequire("ixwgj");

var $68pQc = parcelRequire("68pQc");

var $k8FH2 = parcelRequire("k8FH2");

var $32Xmj = parcelRequire("32Xmj");

var $lB25E = parcelRequire("lB25E");
const $c804448635aed067$var$FEEDBACK_COLLECTOR_LOCATION = 'deployments.page.header';
const $c804448635aed067$export$eecbca8d093722d5 = ()=>(0, $32Xmj.resourceResultToServiceQueryResult)((0, $lB25E.useResource)((0, $ixwgj.projectContextResource)));
const $c804448635aed067$export$116fedbe5e2e2bd8 = ()=>{
    const { data: project } = $c804448635aed067$export$eecbca8d093722d5();
    const { data: deploymentProviders, error: errorDeploymentProvider } = (0, $68pQc.useDeploymentProviders)();
    (0, $eUqFw.useEffect)(()=>{
        if (errorDeploymentProvider) (0, $guiFP.trackFetchErrors)({
            error: errorDeploymentProvider,
            id: 'retrieveContexts',
            packageName: 'jiraSoftwareDeploymentsFeedbackButton',
            logToSentry: true
        });
    }, [
        errorDeploymentProvider
    ]);
    const additionalFeedbackEntries = [
        {
            id: (0, $1c02D.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: $c804448635aed067$var$FEEDBACK_COLLECTOR_LOCATION
        },
        {
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project ? project.simplified.toString() : ''
        },
        {
            id: (0, $1c02D.EntryKeys).IS_ADMIN,
            value: project ? (project.isProjectAdmin ?? false).toString() : ''
        },
        {
            id: (0, $1c02D.EntryKeys).DEPLOYMENT_PROVIDERS,
            value: deploymentProviders ? (0, $k8FH2.hideUGCProviderName)(deploymentProviders).map((deploymentProvider)=>deploymentProvider.name).join(', ') : ''
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bCwLs.FeedbackCollectorButton), {
        entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackContext: additionalFeedbackEntries
    });
};
var $c804448635aed067$export$2e2bcd8739ae039 = $c804448635aed067$export$116fedbe5e2e2bd8;

});
parcelRegister("bCwLs", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $096795107747cbd5$export$b39479f42d974760);

var $eUqFw = parcelRequire("eUqFw");

var $c5IEJ = parcelRequire("c5IEJ");

var $2eG9N = parcelRequire("2eG9N");

var $bAQOb = parcelRequire("bAQOb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $1c02D = parcelRequire("1c02D");

var $irg9D = parcelRequire("irg9D");

var $k74dc = parcelRequire("k74dc");

var $3liet = parcelRequire("3liet");
const $096795107747cbd5$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: customLabel || formatMessage((0, $k74dc.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
};
const $096795107747cbd5$export$941c5fcac2e843ea = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>openFeedbackCollector({
            ...feedbackCollectorProps,
            triggerRef: buttonRef
        }), [
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};
const $096795107747cbd5$var$FeedbackCollectorButtonNew = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($c5IEJ))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const buttonRef = (0, $eUqFw.useRef)(null);
    const onOpen = (0, $eUqFw.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $1c02D.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $1c02D.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($096795107747cbd5$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3liet.StyledButton), {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
            // typesupression below can be removed once icon migration completes
            // @ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes & IconProps'.ts(2322)
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback)
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $k74dc.messages).leaveFeedback))));
};
const $096795107747cbd5$export$b39479f42d974760 = (0, $bAQOb.componentWithFF)('jff.magma.passing-cloudid-in-feedback-button_hif5t', $096795107747cbd5$var$FeedbackCollectorButtonNew, $096795107747cbd5$export$941c5fcac2e843ea);

});
parcelRegister("c5IEJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cd8976d9d4f34ae$var$_react = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $8cd8976d9d4f34ae$var$_feedback = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("3kIcQ")));

var $8cd8976d9d4f34ae$var$_feedback2 = $8cd8976d9d4f34ae$var$_interopRequireDefault((parcelRequire("l2ZYW")));
function $8cd8976d9d4f34ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cd8976d9d4f34ae$var$FeedbackIcon = (props)=>/*#__PURE__*/ $8cd8976d9d4f34ae$var$_react.default.createElement($8cd8976d9d4f34ae$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $8cd8976d9d4f34ae$var$_feedback2.default
    }, props));
$8cd8976d9d4f34ae$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $8cd8976d9d4f34ae$var$_default = module.exports.default = $8cd8976d9d4f34ae$var$FeedbackIcon;

});
parcelRegister("3kIcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26d587cb75b7e288$var$_react = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $26d587cb75b7e288$var$_UNSAFE_baseNew = $26d587cb75b7e288$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $26d587cb75b7e288$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $26d587cb75b7e288$var$FeedbackIcon = (props)=>/*#__PURE__*/ $26d587cb75b7e288$var$_react.default.createElement($26d587cb75b7e288$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$26d587cb75b7e288$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $26d587cb75b7e288$var$_default = module.exports.default = $26d587cb75b7e288$var$FeedbackIcon;

});

parcelRegister("l2ZYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f529dd351378d429$var$_react = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f529dd351378d429$var$_feedback = $f529dd351378d429$var$_interopRequireDefault((parcelRequire("3kIcQ")));
function $f529dd351378d429$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f529dd351378d429$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f529dd351378d429$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $f529dd351378d429$var$_feedback.default
    }));
$f529dd351378d429$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $f529dd351378d429$var$_default = module.exports.default = $f529dd351378d429$var$FeedbackIcon;

});


parcelRegister("k74dc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a622284001ff525a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a622284001ff525a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});

parcelRegister("3liet", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $37102939becff71f$export$2d5d2ba3c7c8c40b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $37102939becff71f$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
            __cmplp.className
        ])
    });
});

});


parcelRegister("68pQc", function(module, exports) {

$parcel$export(module.exports, "useDeploymentProviders", () => $7da57bfaef849845$export$29125d17c01d4dd4);
$parcel$export(module.exports, "DeploymentProvidersInfoProvider", () => $7da57bfaef849845$export$a516226a9640cf25);
$parcel$export(module.exports, "useDeploymentProvidersInfoContext", () => $7da57bfaef849845$export$6251344ce2dc3a61);
$parcel$export(module.exports, "useVCSProviders", () => $7da57bfaef849845$export$29eeae32fa3976ef);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");

var $k8FH2 = parcelRequire("k8FH2");
const $7da57bfaef849845$export$67c00945e310134c = ()=>{
    const baseUrl = '';
    const request = (0, $eUqFw.useCallback)(()=>(0, $2OdyW.default)(`${baseUrl}/rest/dev-status/1.0/provider/capabilities`), [
        baseUrl
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eEzyV.useService)(request);
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch
    };
};
const $7da57bfaef849845$var$useMemoByProviderId = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    if (ref.current.length !== value.length || !ref.current.every((x, i)=>x.providerId === value[i].providerId)) ref.current = value;
    return ref.current;
};
const $7da57bfaef849845$export$20e408ba77735d66 = (devOpsProviders)=>{
    const isBitbucketConnectedToJira = devOpsProviders.some((0, $k8FH2.isBitbucketSCMProvider));
    const isBitbucketPipelineFound = devOpsProviders.some((0, $k8FH2.isBitbucketPipelineProvider));
    // All tenants should have the bitbucket pipeline provider. Only return it if they have the "bitbucket" provider - indicating they have set up the bitbucket integration
    if (!isBitbucketConnectedToJira && isBitbucketPipelineFound) return devOpsProviders.filter((x)=>!(0, $k8FH2.isBitbucketProvider)(x));
    return devOpsProviders;
};
const $7da57bfaef849845$var$useMemoizedDeploymentProviders = (devOpsProviderResult)=>{
    const data = devOpsProviderResult.data ? $7da57bfaef849845$export$20e408ba77735d66(devOpsProviderResult.data).filter((x)=>x.capabilities.includes('DEPLOYMENT')) : [];
    return $7da57bfaef849845$var$useMemoByProviderId(data);
};
const $7da57bfaef849845$export$29125d17c01d4dd4 = ()=>{
    const devOpsProviderResult = $7da57bfaef849845$export$67c00945e310134c();
    const memoizedProviders = $7da57bfaef849845$var$useMemoizedDeploymentProviders(devOpsProviderResult);
    return devOpsProviderResult.data ? {
        ...devOpsProviderResult,
        data: memoizedProviders
    } : devOpsProviderResult;
};
const $7da57bfaef849845$export$f96e97389b7d3d58 = ()=>{
    const devOpsProviderResult = $7da57bfaef849845$export$67c00945e310134c();
    const memoizedProviders = $7da57bfaef849845$var$useMemoizedDeploymentProviders(devOpsProviderResult);
    return devOpsProviderResult.data ? {
        ...devOpsProviderResult,
        data: {
            deploymentProviders: memoizedProviders,
            isBitbucketDvcsConnectedToJira: devOpsProviderResult.data.some((0, $k8FH2.isBitbucketSCMProvider))
        }
    } : {
        ...devOpsProviderResult,
        data: undefined
    };
};
const $7da57bfaef849845$export$77e6c6311405f4e8 = /*#__PURE__*/ (0, $eUqFw.createContext)();
const $7da57bfaef849845$export$a516226a9640cf25 = ({ children: children })=>{
    const deploymentProvidersState = $7da57bfaef849845$export$f96e97389b7d3d58();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7da57bfaef849845$export$77e6c6311405f4e8.Provider, {
        value: deploymentProvidersState
    }, children);
};
const $7da57bfaef849845$export$6251344ce2dc3a61 = ()=>{
    const result = (0, $eUqFw.useContext)($7da57bfaef849845$export$77e6c6311405f4e8);
    if (result === undefined) throw new Error('Missing service provider');
    return result;
};
const $7da57bfaef849845$export$29eeae32fa3976ef = ()=>{
    const devOpsProviderResult = $7da57bfaef849845$export$67c00945e310134c();
    const data = devOpsProviderResult.data ? devOpsProviderResult.data.filter((x)=>x.capabilities.includes('COMMIT')) : [];
    const memoizedData = $7da57bfaef849845$var$useMemoByProviderId(data);
    return devOpsProviderResult.data ? {
        ...devOpsProviderResult,
        data: memoizedData
    } : devOpsProviderResult;
};

});
parcelRegister("k8FH2", function(module, exports) {

$parcel$export(module.exports, "isBitbucketPipelineProvider", () => $92d4a65fda799c43$export$e945008be2be190e);
$parcel$export(module.exports, "isBitbucketSCMProvider", () => $92d4a65fda799c43$export$43d8b667cc725f05);
$parcel$export(module.exports, "isBitbucketProvider", () => $92d4a65fda799c43$export$1f508885be28c4e);
$parcel$export(module.exports, "hideUGCProviderName", () => $92d4a65fda799c43$export$6159c89b7d198212);

const $92d4a65fda799c43$export$e945008be2be190e = (provider)=>provider.providerId === (0, $9f1111bfef433d24$export$832d1d859726f915) || provider.providerId === (0, $9f1111bfef433d24$export$5007979ef33118fc);
const $92d4a65fda799c43$export$43d8b667cc725f05 = (provider)=>provider.providerId === (0, $9f1111bfef433d24$export$d7f081d6dd0e72fc);
const $92d4a65fda799c43$export$4deeacd9e5868b0b = (provider)=>{
    if (provider.iconUrl !== undefined && provider.iconUrl !== '' && provider.iconUrl.toLowerCase().includes('jenkins')) return true;
    if (provider.name.toLowerCase().includes('jenkins')) return true;
    return false;
};
const $92d4a65fda799c43$export$1f508885be28c4e = (provider)=>$92d4a65fda799c43$export$43d8b667cc725f05(provider) || $92d4a65fda799c43$export$e945008be2be190e(provider);
const $92d4a65fda799c43$export$b77d18aa396395e0 = (provider)=>provider.providerNamespace === 'oauth';
const $92d4a65fda799c43$export$6159c89b7d198212 = (providers)=>providers.map((provider)=>$92d4a65fda799c43$export$b77d18aa396395e0(provider) ? {
            ...provider,
            name: 'UGC provider name hidden'
        } : provider);

});
const $9f1111bfef433d24$export$d7f081d6dd0e72fc = 'bitbucket';
const $9f1111bfef433d24$export$6c3cd1b276cbaf84 = 'Bitbucket';
const $9f1111bfef433d24$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $9f1111bfef433d24$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
const $9f1111bfef433d24$export$bcf99e811ad95bcc = 'Bitbucket Pipelines';
const $9f1111bfef433d24$export$e6fc9659354ecbb5 = 'jenkins';
const $9f1111bfef433d24$export$4510fd9cc92926bb = 'Jenkins';




parcelRegister("bNrYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfb19ba0a6d260a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $7JXZ0 = parcelRequire("7JXZ0");

var $jG1wZ = parcelRequire("jG1wZ");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kIY50 = parcelRequire("kIY50");

var $6FP8W = parcelRequire("6FP8W");

var $eDgaT = parcelRequire("eDgaT");

var $5kyEc = parcelRequire("5kyEc");

var $7g46C = parcelRequire("7g46C");

var $8rQuz = parcelRequire("8rQuz");

var $balOk = parcelRequire("balOk");
const $9bfb19ba0a6d260a$var$MANAGE_APPS_URL = 'plugins/servlet/upm';
const $9bfb19ba0a6d260a$export$4064a259f24837dd = ({ isProjectAdmin: isProjectAdmin, isSimplified: isSimplified, projectKey: projectKey, hasDeployments: hasDeployments = false, defaultOpen: defaultOpen = false })=>{
    const [isEmptyStateTutorialOpen, setIsEmptyStateTutorialOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const hasProjectKey = !!projectKey;
    const MANAGE_FEATURES_URL = `jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/features`;
    const showMenu = isProjectAdmin || hasDeployments;
    const closeEmptyStateTutorial = ()=>setIsEmptyStateTutorialOpen(false);
    return showMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        defaultOpen: defaultOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>// eslint-disable-next-line no-nested-ternary
            (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($7JXZ0))),
                label: formatMessage((0, $balOk.messages).buttonLabel),
                ref: triggerRef,
                isTooltipDisabled: false
            }) : (0, $6FP8W.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDgaT.ResponsiveButton), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))),
                label: formatMessage((0, $balOk.messages).buttonLabel),
                ref: triggerRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "More actions"
                }),
                ref: triggerRef
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, isProjectAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $6FP8W.getWillShowNav4)() && hasProjectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        href: `/${MANAGE_FEATURES_URL}`,
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $balOk.messages).manageProjectFeaturesButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        href: `/${$9bfb19ba0a6d260a$var$MANAGE_APPS_URL}`,
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $balOk.messages).manageInstalledAppsButtonLabel)), (0, $kIY50.getWillShowNav3)() && hasProjectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        href: `/${MANAGE_FEATURES_URL}`,
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $balOk.messages).manageProjectFeaturesButtonLabel))) : null, hasDeployments ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>setIsEmptyStateTutorialOpen(true)
    }, formatMessage((0, $balOk.messages).usingDeploymentsButtonLabel)) : null, (0, $6FP8W.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraSoftwareDeploymentsHeaderMeatballMenu",
        teamName: "fusion-solaris",
        id: "feedbackButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bfb19ba0a6d260a$var$MenuButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kyEc.default), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isEmptyStateTutorialOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: closeEmptyStateTutorial,
        width: 592
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9bfb19ba0a6d260a$var$ModalContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7g46C.EmptyStateTutorialEntryPoint), {
        isOpen: isEmptyStateTutorialOpen,
        onClose: closeEmptyStateTutorial
    }))))) : null)) : null;
};
var $9bfb19ba0a6d260a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9bfb19ba0a6d260a$export$4064a259f24837dd;
const $9bfb19ba0a6d260a$var$ModalContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u010v4 _1bsb1bn8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9bfb19ba0a6d260a$var$MenuButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _1q9t4jg8 _6pup18uv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("eDgaT", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $ad0d3127c7a37420$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $ad0d3127c7a37420$export$50fd17babcd996ef);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");
var $fI650 = parcelRequire("fI650");
var $8GeQ6 = parcelRequire("8GeQ6");

var $9Amv1 = parcelRequire("9Amv1");

var $5ARvW = parcelRequire("5ARvW");
var $eT0WN = parcelRequire("eT0WN");

var $2eG9N = parcelRequire("2eG9N");

const $ad0d3127c7a37420$export$47e82d861696e68c = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $eT0WN.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $eUqFw.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $ad0d3127c7a37420$export$50fd17babcd996ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $eT0WN.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $eUqFw.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GeQ6.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ARvW.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $d189205948d5eb28$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
parcelRegister("fI650", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b28527f26e4865$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kMup = parcelRequire("4kMup");

var $3Ucf8 = parcelRequire("3Ucf8");
const $f7b28527f26e4865$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const baseProps = (0, $3Ucf8.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
        ...saferRest,
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        /**
			 * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
			 * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
			 */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }, baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $f7b28527f26e4865$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($f7b28527f26e4865$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $f7b28527f26e4865$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($f7b28527f26e4865$var$WithRef);
var $f7b28527f26e4865$export$2e2bcd8739ae039 = $f7b28527f26e4865$var$LinkButton;

});

parcelRegister("5ARvW", function(module, exports) {

$parcel$export(module.exports, "Show", () => $c749d80f6b8dab23$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $9SiaN = parcelRequire("9SiaN");
function $c749d80f6b8dab23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c749d80f6b8dab23$var$showAboveQueries = (0, $9SiaN.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$showBelowQueries = (0, $9SiaN.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $c749d80f6b8dab23$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $c749d80f6b8dab23$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $1ZAYh.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $byn9U.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $c749d80f6b8dab23$var$defaultHiddenStyles,
            above && $c749d80f6b8dab23$var$showAboveQueries[above],
            below && $c749d80f6b8dab23$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("9SiaN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $gnQiH = parcelRequire("gnQiH");

var $4Ywu9 = parcelRequire("4Ywu9");
const $1d5ed0ecf6688fbc$export$918f8818cfbbeb2c = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $1d5ed0ecf6688fbc$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $gnQiH.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $4Ywu9.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("gnQiH", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $8ce21554f3c8bfb7$export$2d293d9871c38e91);
const $8ce21554f3c8bfb7$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $8ce21554f3c8bfb7$export$2d293d9871c38e91 = Object.keys($8ce21554f3c8bfb7$export$e5ee4fe8b989fd09);
const $8ce21554f3c8bfb7$export$b7ed752a57b4177b = $8ce21554f3c8bfb7$export$2d293d9871c38e91[0];

});



const $d189205948d5eb28$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("7g46C", function(module, exports) {

$parcel$export(module.exports, "EmptyStateTutorialEntryPoint", () => $d5fa02e56ab3b18a$export$8a9a1228e8cca7cc);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $bNe1g = parcelRequire("bNe1g");

var $cHn5l = parcelRequire("cHn5l");

var $dWLk9 = parcelRequire("dWLk9");

var $iXSs5 = parcelRequire("iXSs5");

var $bkvB3 = parcelRequire("bkvB3");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d5fa02e56ab3b18a$var$EmptyStateTutorial = (0, $7rh0R.lazy)(()=>(parcelRequire("F3ICD")).then((mod)=>mod.EmptyStateTutorial), {
    moduleId: "./src/packages/software/empty-state-experience/deployments/src/ui/index.tsx"
}); // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences

const $d5fa02e56ab3b18a$var$EmptyStateTutorialQueryLoader = (0, $7rh0R.lazy)(()=>(parcelRequire("F3ICD")).then((mod)=>mod.EmptyStateTutorialQueryLoader), {
    moduleId: "./src/packages/software/empty-state-experience/deployments/src/ui/index.tsx"
}); /**
     * Async loaded version of the empty state tutorial component. Use this if you
     * wish to compose the component into a larger query.
     *
     * This component omits its own error boundary to ensure that errors are propogated to
     * the parent empty state page for SLI/SLO tracking
     *
     * If you wish for both query loading and component rendering to occur simultaneously,
     * refer to {@link EmptyStateTutorialEntryPoint}
     */ 
const $d5fa02e56ab3b18a$export$7a6c550df9fc06e6 = ({ emptyStateTutorial: emptyStateTutorial })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "empty-state-tutorial",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5fa02e56ab3b18a$var$Loading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5fa02e56ab3b18a$var$EmptyStateTutorial, {
        fragmentReference: emptyStateTutorial,
        origin: "deployments-empty-state"
    })); /**
                  * Entry point for the empty state tutorial component. Use this if you require
                  * both the query loading and component rendering to occur.
                  *
                  * If you wish to compose this into a larger query, refer to {@link AsyncEmptyStateTutorial}
                  */ 
const $d5fa02e56ab3b18a$export$8a9a1228e8cca7cc = ({ isOpen: isOpen, queryReference: initialQueryReference, onClose: onClose, onInstallBitbucket: onInstallBitbucket, origin: origin = 'deployments-empty-state' })=>{
    const [queryReference, loadQuery] = (0, $iWLL0.useQueryLoader)((0, $cHn5l.default), initialQueryReference);
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const onViewExperienceFail = (0, $bkvB3.useViewDeploymentsEmptyStateTutorialExperienceFail)();
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (projectContext?.projectId != null && isOpen) loadQuery({
            cloudId: cloudId,
            projectAri: (0, $iXSs5.createProjectAri)(cloudId, projectContext.projectId) ?? ''
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        isOpen,
        loadQuery,
        cloudId,
        projectContext
    ]);
    return projectContext != null && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bkvB3.ViewDeploymentsEmptyStateTutorialExperienceStart), {
        experienceId: String(projectContext.projectId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "emptyStateTutorialEntryPoint",
        packageName: "jiraSoftwareDeploymentsEmptyStateTutorial",
        teamName: "fusion-solaris",
        onError: (location, error)=>{
            onViewExperienceFail(location, error);
            if (onClose) onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "empty-state-tutorial-query-loader",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5fa02e56ab3b18a$var$Loading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }))
    }, queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5fa02e56ab3b18a$var$EmptyStateTutorialQueryLoader, {
        queryReference: queryReference,
        onInstallBitbucket: onInstallBitbucket,
        origin: origin
    }) : null))) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5fa02e56ab3b18a$var$Loading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _4cvr1h6o _6a6z1h6o _1yt4koci",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cHn5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea22188114b91412$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8282a3ea3adf36bf0f3aba6c99524c4b>>
 * @relayHash 8ff8bb7722274dd0f92763bd4cc818ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dff4ed0df05c628ba404a0173e495e6fc4bb55e13c4923d1102315d1ba05fb9
const $ea22188114b91412$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v3 = {
        "kind": "Variable",
        "name": "from",
        "variableName": "projectAri"
    }, v4 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v5 = [
        {
            "concreteType": "AriGraphRelationship",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiDeploymentsEmptyStateExperienceQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_softwareEmptyStateExperienceDeployments_EmptyStateTutorial"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiDeploymentsEmptyStateExperienceQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": [
                                        "DEPLOYMENT"
                                    ]
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "devOpsProviders",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraDevOpsProvider"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "connectAppId"
                                        }
                                    ],
                                    "type": "JiraClassicConnectDevOpsProvider"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "oauthAppId"
                                        }
                                    ],
                                    "type": "JiraOAuthDevOpsProvider"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "projectAri"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraDeploymentApp",
                                    "kind": "LinkedField",
                                    "name": "selectedDeploymentAppsProperty",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "appKey"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ClientExtension",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "DevOps",
                    "kind": "LinkedField",
                    "name": "devOps",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AriGraph",
                            "kind": "LinkedField",
                            "name": "ariGraph",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "deploymentRelationships",
                                    "args": [
                                        {
                                            "fields": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "project-associated-deployment"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                },
                                {
                                    "alias": "repoRelationships",
                                    "args": [
                                        {
                                            "fields": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "Literal",
                                                    "name": "type",
                                                    "value": "project-associated-repo"
                                                }
                                            ],
                                            "kind": "ObjectValue",
                                            "name": "filter"
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "relationships",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7dff4ed0df05c628ba404a0173e495e6fc4bb55e13c4923d1102315d1ba05fb9",
            "metadata": {},
            "name": "uiDeploymentsEmptyStateExperienceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ea22188114b91412$var$node.hash = "72c2bd6fec55bbd5bd454b21e837eed0";
var $ea22188114b91412$export$2e2bcd8739ae039 = $ea22188114b91412$var$node;

});

parcelRegister("iXSs5", function(module, exports) {

$parcel$export(module.exports, "createProjectAri", () => $c40b1eb8d0dd89dd$export$e12cf9774899f456);

var $huI7r = parcelRequire("huI7r");
const $c40b1eb8d0dd89dd$export$e12cf9774899f456 = (cloudId, projectId)=>projectId == null ? null : (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: `${projectId}`
    });

});

parcelRegister("bkvB3", function(module, exports) {

$parcel$export(module.exports, "ViewDeploymentsEmptyStateTutorialExperienceStart", () => $f2c02ee84fd0d916$export$ed1e08321fe47d48);
$parcel$export(module.exports, "useViewDeploymentsEmptyStateTutorialExperienceFail", () => $f2c02ee84fd0d916$export$eb1b773dcb40a966);
$parcel$export(module.exports, "ViewDeploymentsEmptyStateTutorialExperienceSuccessTracker", () => $f2c02ee84fd0d916$export$ed035a09dc5ee3b9);

var $eUqFw = parcelRequire("eUqFw");

var $4qhD6 = parcelRequire("4qhD6");

var $bDhRl = parcelRequire("bDhRl");

var $fDZ6r = parcelRequire("fDZ6r");

var $bNe1g = parcelRequire("bNe1g");

var $eIp1n = parcelRequire("eIp1n");

var $ab6rA = parcelRequire("ab6rA");
const $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME = 'viewDeploymentsEmptyStateTutorial';
const $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EXPERIENCE_NAME = 'viewDeployments';
const $f2c02ee84fd0d916$export$ed1e08321fe47d48 = ({ experienceId: experienceId })=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
        experienceId: experienceId,
        experience: $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME,
        analyticsSource: "deploymentsEmptyStateTutorial",
        edition: appEditions.software,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    });
};
const $f2c02ee84fd0d916$export$eb1b773dcb40a966 = ()=>{
    const onViewDeploymentsEmptyStateTutorialFailure = (0, $4qhD6.useExperienceFail)({
        experience: $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME
    });
    // TODO: Deduplicate this call when the entire empty state page is migrated to Relay
    // https://softwareteams.atlassian.net/browse/RLSS-2722
    const onViewDeploymentsFailure = (0, $4qhD6.useExperienceFail)({
        experience: $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EXPERIENCE_NAME,
        attributes: {
            hasDeployments: false
        }
    });
    return (location, error)=>{
        onViewDeploymentsEmptyStateTutorialFailure(location, error);
        onViewDeploymentsFailure(location, error);
    };
};
const $f2c02ee84fd0d916$export$ed035a09dc5ee3b9 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    const { projectId: projectId, isProjectAdmin: isProjectAdmin, simplified: simplified } = data ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EMPTY_STATE_TUTORIAL_EXPERIENCE_NAME,
        // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'.
        attributes: {
            projectId: projectId,
            isProjectAdmin: isProjectAdmin,
            simplified: simplified
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDZ6r.ExperienceSuccess), {
        experience: $f2c02ee84fd0d916$var$VIEW_DEPLOYMENTS_EXPERIENCE_NAME,
        // @ts-expect-error - TS2322 - Type 'number | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'. | TS2322 - Type 'boolean | undefined' is not assignable to type 'string | number | boolean | null'.
        attributes: {
            projectId: projectId,
            isProjectAdmin: isProjectAdmin,
            simplified: simplified,
            hasDeployments: false
        }
    }));
};

});

parcelRegister("F3ICD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("fTrqg")
]).then(()=>parcelRequire('gn299'));

});


parcelRegister("balOk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9783035ce0091574$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9783035ce0091574$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    buttonLabel: {
        "id": "software-deployments-header-meatball-menu.button-label",
        "defaultMessage": "More"
    },
    manageInstalledAppsButtonLabel: {
        "id": "software-deployments-header-meatball-menu.manage-installed-apps-button-label",
        "defaultMessage": "Manage installed apps"
    },
    manageProjectFeaturesButtonLabel: {
        "id": "software-deployments-header-meatball-menu.manage-project-features-button-label",
        "defaultMessage": "Manage project features"
    },
    usingDeploymentsButtonLabel: {
        "id": "software-deployments-header-meatball-menu.using-deployments-button-label",
        "defaultMessage": "Using Deployments in Jira"
    }
});

});


parcelRegister("2uDXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3158880c9b10b36f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $j9fWg = parcelRequire("j9fWg");

var $eAa4t = parcelRequire("eAa4t");

var $5oiKm = parcelRequire("5oiKm");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $8rQuz = parcelRequire("8rQuz");

var $2MXPY = parcelRequire("2MXPY");

var $lUlvV = parcelRequire("lUlvV");
const $3158880c9b10b36f$var$ExportButton = ({ appearance: appearance = 'default', isIconOnly: isIconOnly = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const exporter = (0, $lUlvV.useCsvExporter)();
    if (exporter.status === 'failed') throw exporter.error;
    return (0, $8rQuz.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        label: formatMessage((0, $2MXPY.default).exportButtonLabel),
        isLoading: exporter.status === 'exporting',
        isDisabled: exporter.status === 'initializing',
        onClick: (event, analyticsEvent)=>{
            // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"initializing" | "exporting"' and '"failed"' have no overlap.
            if (exporter.status === 'ready' || exporter.status === 'failed') {
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportDeploymentsCsv');
                exporter.beginExport();
            }
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eAa4t))),
        isTooltipDisabled: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: appearance,
        isLoading: exporter.status === 'exporting',
        isDisabled: exporter.status === 'initializing',
        onClick: (event, analyticsEvent)=>{
            // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"initializing" | "exporting"' and '"failed"' have no overlap.
            if (exporter.status === 'ready' || exporter.status === 'failed') {
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'exportDeploymentsCsv');
                exporter.beginExport();
            }
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5oiKm))), {
            label: ""
        })
    }, !isIconOnly && formatMessage((0, $2MXPY.default).exportButtonLabel));
};
var $3158880c9b10b36f$export$2e2bcd8739ae039 = $3158880c9b10b36f$var$ExportButton;

});
parcelRegister("eAa4t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dee6396e12806214e5fd6f6b74ec1829>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9dc3d64ee8756d8$var$_react = $a9dc3d64ee8756d8$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9dc3d64ee8756d8$var$_upload = $a9dc3d64ee8756d8$var$_interopRequireDefault((parcelRequire("3Mygk")));

var $a9dc3d64ee8756d8$var$_export = $a9dc3d64ee8756d8$var$_interopRequireDefault((parcelRequire("5oiKm")));
function $a9dc3d64ee8756d8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for UploadIcon.
 * This component is UploadIcon, with `UNSAFE_fallbackIcon` set to "ExportIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9dc3d64ee8756d8$var$UploadIcon = (props)=>/*#__PURE__*/ $a9dc3d64ee8756d8$var$_react.default.createElement($a9dc3d64ee8756d8$var$_upload.default, Object.assign({
        LEGACY_fallbackIcon: $a9dc3d64ee8756d8$var$_export.default
    }, props));
$a9dc3d64ee8756d8$var$UploadIcon.Name = 'UploadIconMigration';
var $a9dc3d64ee8756d8$var$_default = module.exports.default = $a9dc3d64ee8756d8$var$UploadIcon;

});
parcelRegister("3Mygk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebc22958da752d07e6dcf81116f518ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c106e989d1556d4$var$_react = $2c106e989d1556d4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2c106e989d1556d4$var$_UNSAFE_baseNew = $2c106e989d1556d4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $2c106e989d1556d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c106e989d1556d4$var$UploadIcon = (props)=>/*#__PURE__*/ $2c106e989d1556d4$var$_react.default.createElement($2c106e989d1556d4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
    }, props));
$2c106e989d1556d4$var$UploadIcon.displayName = 'UploadIcon';
var $2c106e989d1556d4$var$_default = module.exports.default = $2c106e989d1556d4$var$UploadIcon;

});

parcelRegister("5oiKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0103517d4ae70c89$var$_react = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $0103517d4ae70c89$var$_upload = $0103517d4ae70c89$var$_interopRequireDefault((parcelRequire("3Mygk")));
function $0103517d4ae70c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0103517d4ae70c89$var$ExportIcon = (props)=>/*#__PURE__*/ $0103517d4ae70c89$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $0103517d4ae70c89$var$_upload.default
    }));
$0103517d4ae70c89$var$ExportIcon.displayName = 'ExportIcon';
var $0103517d4ae70c89$var$_default = module.exports.default = $0103517d4ae70c89$var$ExportIcon;

});


parcelRegister("2MXPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2010cabe6187828$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d2010cabe6187828$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    exportButtonLabel: {
        "id": "software-deployments.header.export-button.export-button-label",
        "defaultMessage": "Export"
    }
});

});

parcelRegister("lUlvV", function(module, exports) {

$parcel$export(module.exports, "useCsvExporter", () => $a342b34522949eb4$export$1f42b01d3037e733);

var $eUqFw = parcelRequire("eUqFw");

var $fG8Rc = parcelRequire("fG8Rc");

var $iWLL0 = parcelRequire("iWLL0");

var $dWLk9 = parcelRequire("dWLk9");

var $OwuLI = parcelRequire("OwuLI");

var $lnbOK = parcelRequire("lnbOK");

var $gVtkA = parcelRequire("gVtkA");

var $793kb = parcelRequire("793kb");
const $a342b34522949eb4$var$maximumIssuePages = 10;
const $a342b34522949eb4$var$useIssueUrlBuilder = ()=>{
    const { hostname: hostname } = window.location;
    return (key)=>`https://${hostname}/browse/${key}`;
};
const $a342b34522949eb4$export$1f42b01d3037e733 = ()=>{
    const [isExporting, setIsExporting] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const buildUrl = $a342b34522949eb4$var$useIssueUrlBuilder();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: project } = (0, $lnbOK.useProject)();
    const filter = (0, $OwuLI.useCoreDataFilter)();
    const environment = (0, $iWLL0.useRelayEnvironment)();
    if (isExporting) return {
        status: 'exporting'
    };
    if (filter === null || project === undefined) return {
        status: 'initializing'
    };
    const beginExport = async ()=>{
        try {
            setIsExporting(true);
            setError(null);
            const result = await (0, $OwuLI.fetchCoreData)(environment, filter, $a342b34522949eb4$var$maximumIssuePages, project.id, cloudId);
            if (result === null) throw Error('Error fetching data for CSV export');
            const { allDeployments: allDeployments, issuesByIssueId: issuesByIssueId } = result.coreData;
            const csv = (0, $gVtkA.buildCsv)(allDeployments, issuesByIssueId, buildUrl);
            const filename = (0, $793kb.buildFilename)(project.key, new Date());
            const blob = new Blob([
                csv
            ], {
                type: 'text/csv;charset=utf-8;'
            });
            (0, $fG8Rc.saveAs)(blob, filename);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            setError(e);
        } finally{
            setIsExporting(false);
        }
    };
    if (error) return {
        status: 'failed',
        error: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error'.
        error,
        beginExport: ()=>{
            beginExport();
        }
    };
    return {
        status: 'ready',
        beginExport: ()=>{
            beginExport();
        }
    };
};

});
parcelRegister("fG8Rc", function(module, exports) {
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $b6a1a615ff478201$var$saveAs = $b6a1a615ff478201$var$saveAs || function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document, get_URL = function() {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000 // in ms
    , revoke = function(file) {
        var revoker = function() {
            if (typeof file === "string") get_URL().revokeObjectURL(file);
            else file.remove();
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    }, auto_bom = function(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            String.fromCharCode(0xFEFF),
            blob
        ], {
            type: blob.type
        });
        return blob;
    }, FileSaver = function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function() {
            if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                    var popup = view.open(url, '_blank');
                    if (!popup) view.location.href = url;
                    url = undefined; // release reference before dispatching
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (!object_url) object_url = get_URL().createObjectURL(blob);
            if (force) view.location.href = object_url;
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        name = name || blob.name || "download";
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name);
    };
    FS_proto.abort = function() {};
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
if (0, module.exports) module.exports.saveAs = $b6a1a615ff478201$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $b6a1a615ff478201$var$saveAs;
});

});

parcelRegister("gVtkA", function(module, exports) {

$parcel$export(module.exports, "buildCsv", () => $a346b76d8ff6f85e$export$1f193a818c5d30ee);

var $EN9B6 = parcelRequire("EN9B6");
const $a346b76d8ff6f85e$var$header = {
    issueKey: 'Issue key',
    issueSummary: 'Issue summary',
    issueUrl: 'Issue URL',
    deploymentDate: 'Deployment date',
    deploymentState: 'Deployment state',
    environmentType: 'Environment type',
    environmentName: 'Environment name'
};
const $a346b76d8ff6f85e$var$buildRow = (issue, deployment, buildUrl)=>({
        issueKey: issue.key,
        issueSummary: issue.summary,
        issueUrl: buildUrl(issue.key),
        deploymentDate: (0, $EN9B6.default)(deployment.lastUpdated, 'yyyy-MM-dd HH:mm:ss'),
        deploymentState: deployment.state,
        environmentType: deployment.environment.type,
        environmentName: deployment.environment.displayName
    });
const $a346b76d8ff6f85e$var$stringifyRow = (row)=>{
    const fields = [
        row.issueKey,
        row.issueSummary,
        row.issueUrl,
        row.deploymentDate,
        row.deploymentState,
        row.environmentType,
        row.environmentName
    ];
    const escapeField = (field)=>field.replace(/"/g, '""');
    const quoteField = (field)=>`"${field}"`;
    return fields.map(escapeField).map(quoteField).join(',');
};
const $a346b76d8ff6f85e$export$1f193a818c5d30ee = (deployments, issues, buildUrl)=>{
    const rows = deployments.flatMap((deployment)=>deployment.issueIds.filter((id)=>issues[id] !== undefined).map((id)=>[
                issues[id],
                deployment
            ]))// @ts-expect-error - TS2345 - Argument of type '([issue, deployment]: [any, any]) => Row' is not assignable to parameter of type '(value: (Deployment | Issue | undefined)[], index: number, array: (Deployment | Issue | undefined)[][]) => Row'.
    .map(([issue, deployment])=>$a346b76d8ff6f85e$var$buildRow(issue, deployment, buildUrl)); // eslint-disable-line @typescript-eslint/no-explicit-any
    const rowsWithHeader = [
        $a346b76d8ff6f85e$var$header,
        ...rows
    ];
    return rowsWithHeader.map($a346b76d8ff6f85e$var$stringifyRow).join('\r\n');
};

});

parcelRegister("793kb", function(module, exports) {

$parcel$export(module.exports, "buildFilename", () => $5ecf129538acffab$export$6d3ba775e2331472);

var $EN9B6 = parcelRequire("EN9B6");
const $5ecf129538acffab$var$formatDate = (date)=>(0, $EN9B6.default)(date, 'yyyy_MM_dd');
const $5ecf129538acffab$export$6d3ba775e2331472 = (projectKey, date)=>`deployments_${projectKey}_${$5ecf129538acffab$var$formatDate(date)}.csv`;

});




parcelRegister("6l4Xu", function(module, exports) {

$parcel$export(module.exports, "HEADER_HEIGHT_PX", () => $af9521b603c1e14c$export$ee899b9e52416cba);

var $c9TLT = parcelRequire("c9TLT");
const $af9521b603c1e14c$export$ee899b9e52416cba = `${(0, $c9TLT.gridSize) * 20}px`;

});

parcelRegister("eACCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5492508eabef2a32$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5tgfW = parcelRequire("5tgfW");

var $2eG9N = parcelRequire("2eG9N");

var $4lw2o = parcelRequire("4lw2o");

var $bc03u = parcelRequire("bc03u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $c7H0g = parcelRequire("c7H0g");

var $1R3n5 = parcelRequire("1R3n5");

var $gVMGb = parcelRequire("gVMGb");

var $brEs0 = parcelRequire("brEs0");

var $hMSDj = parcelRequire("hMSDj");

var $lnbOK = parcelRequire("lnbOK");

var $hVxh9 = parcelRequire("hVxh9");
const $5492508eabef2a32$var$VIEW_AGGREGATED_DATA_PERMISSION = 'VIEW_AGGREGATED_DATA';
const $5492508eabef2a32$var$isButtonDisabled = (project, hasPermission)=>{
    if (project === undefined) return true;
    if (project.isSimplified) return false;
    return !hasPermission;
};
const $5492508eabef2a32$var$InsightsButton = ()=>{
    const isSupported = (0, $4lw2o.useIsCurrentBrowserSupported)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [sidebarState, sidebarActions] = (0, $brEs0.useSidebarStore)();
    const isShowingInsights = sidebarState.status === (0, $hMSDj.SidebarStatuses).SHOWING_INSIGHTS;
    const { data: project, loading: projectLoading } = (0, $lnbOK.useProject)();
    const { hasPermission: hasPermission, isLoading: permissionLoading } = (0, $bc03u.useHasPermission)($5492508eabef2a32$var$VIEW_AGGREGATED_DATA_PERMISSION);
    const isDisabled = $5492508eabef2a32$var$isButtonDisabled(project, hasPermission);
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const isProjectAdmin = !!project?.isProjectAdmin;
    const fireAnalytics = !permissionLoading && !projectLoading;
    const onClick = (event, analyticsEvent)=>{
        if (isShowingInsights) {
            sidebarActions.close();
            return;
        }
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewInsights', {
            isDisabled: isDisabled
        });
        sidebarActions.showInsights();
    };
    const isKindOfAdmin = !!(isSiteAdmin || isAdmin || isProjectAdmin);
    const disabledTooltipText = isKindOfAdmin ? formatMessage((0, $hVxh9.default).buttonDisabledForAdmins) : formatMessage((0, $hVxh9.default).buttonDisabledForNonAdmins);
    const enabledTooltipText = formatMessage((0, $hVxh9.default).tooltip);
    const tooltipContent = isDisabled ? disabledTooltipText : enabledTooltipText;
    if (!isSupported) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fireAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "rendered",
        actionSubject: "button",
        actionSubjectId: "toggleInsightsPanel",
        attributes: {
            disabled: isDisabled
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "bottom",
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVMGb.default), {
        isDisabled: isDisabled,
        onClick: onClick,
        isSelected: isShowingInsights,
        text: formatMessage((0, $hVxh9.default).insights),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tgfW))), {
            label: ""
        }),
        // Note: This test ID is used in Pollinator checks
        testId: "software-deployments.ui.insights-button"
    })));
};
var $5492508eabef2a32$export$2e2bcd8739ae039 = $5492508eabef2a32$var$InsightsButton;

});
parcelRegister("5tgfW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3fbc4552fa192c48$var$_react = $3fbc4552fa192c48$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3fbc4552fa192c48$var$_chartTrend = $3fbc4552fa192c48$var$_interopRequireDefault((parcelRequire("dzHsw")));
function $3fbc4552fa192c48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3fbc4552fa192c48$var$GraphLineIcon = (props)=>/*#__PURE__*/ $3fbc4552fa192c48$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $3fbc4552fa192c48$var$_chartTrend.default
    }));
$3fbc4552fa192c48$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $3fbc4552fa192c48$var$_default = module.exports.default = $3fbc4552fa192c48$var$GraphLineIcon;

});
parcelRegister("dzHsw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c87cea19f3e54fed45de6b49a026def6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e204153f650b711$var$_react = $9e204153f650b711$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e204153f650b711$var$_UNSAFE_baseNew = $9e204153f650b711$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e204153f650b711$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e204153f650b711$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $9e204153f650b711$var$_react.default.createElement($9e204153f650b711$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 1v9.75M15 14.25H3c-.69 0-1.25-.56-1.25-1.25v-2.25m0 0 4.5-4.5L8.5 8.5l5.25-5.25m.5 3.75V2.75H10"/>`
    }, props));
$9e204153f650b711$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $9e204153f650b711$var$_default = module.exports.default = $9e204153f650b711$var$ChartTrendIcon;

});


parcelRegister("4lw2o", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentBrowserSupported", () => $b1e8cc8b3c1e64fa$export$e2f83ae69f04608f);

var $eUqFw = parcelRequire("eUqFw");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b1e8cc8b3c1e64fa$var$isDefined = (value)=>value !== null && value !== undefined;
const $b1e8cc8b3c1e64fa$var$isCurrentBrowserSupported = ()=>{
    // Supported from:
    // Chrome 66
    // Safari 12.1
    // Edge 16
    if (!$b1e8cc8b3c1e64fa$var$isDefined(window?.AbortController)) return false;
    return true;
};
const $b1e8cc8b3c1e64fa$export$e2f83ae69f04608f = ()=>{
    const isSupported = (0, $eUqFw.useMemo)(()=>$b1e8cc8b3c1e64fa$var$isCurrentBrowserSupported(), []);
    return isSupported;
};

});

parcelRegister("bc03u", function(module, exports) {

$parcel$export(module.exports, "useHasPermission", () => $087873530f6d2c6e$export$d60723317f8600e2);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $8gjGw = parcelRequire("8gjGw");

var $SEaoU = parcelRequire("SEaoU");
const $087873530f6d2c6e$var$PACKAGE_LOCATION = 'jira.insights.common';
const $087873530f6d2c6e$export$d60723317f8600e2 = (permissionName)=>{
    const [hasPermission, setHasPermission] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const [{ data: data }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const projectContext = data && data.project ? data.project : null;
    const projectId = projectContext && projectContext.id || 0;
    const isSimplified = projectContext != null && projectContext.isSimplified;
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        if (isSimplified) {
            setHasPermission(true);
            setIsLoading(false);
            return;
        }
        try {
            const response = await (0, $8gjGw.fetchJson)(`/rest/api/2/mypermissions?permissions=${permissionName}&projectId=${projectId}`);
            const permission = response && response.permissions && response.permissions[permissionName] ? response.permissions[permissionName].havePermission : false;
            setHasPermission(permission);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData($087873530f6d2c6e$var$PACKAGE_LOCATION, `Failed to fetch permission ${permissionName}`, e);
            setHasPermission(false);
        }
        setIsLoading(false);
    }, [
        permissionName,
        projectId,
        isSimplified
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (projectContext) fetchData();
        else setIsLoading(false);
    }, [
        fetchData,
        projectContext
    ]);
    return {
        hasPermission: hasPermission,
        isLoading: isLoading
    };
};

});

parcelRegister("hVxh9", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfb6d1f9dd01eec8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dfb6d1f9dd01eec8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    insights: {
        "id": "software-deployments.insights-button.insights",
        "defaultMessage": "Insights"
    },
    buttonDisabledForAdmins: {
        "id": "software-deployments.insights-button.button-disabled-for-admins",
        "defaultMessage": "To view insights about this project, enable the View aggregated data permission in your settings."
    },
    buttonDisabledForNonAdmins: {
        "id": "software-deployments.insights-button.button-disabled-for-non-admins",
        "defaultMessage": "To view insights about this project, ask your project admin to enable the View aggregated data permission."
    },
    tooltip: {
        "id": "software-deployments.insights-button.tooltip",
        "defaultMessage": "Deployment insights"
    }
});

});


parcelRegister("6N9m6", function(module, exports) {

$parcel$export(module.exports, "Providers", () => $7da4505a08464a61$export$797a850985de4c33);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $8Jeh9 = parcelRequire("8Jeh9");

var $f90uP = parcelRequire("f90uP");

var $56t7F = parcelRequire("56t7F");

var $6go3X = parcelRequire("6go3X");

var $OwuLI = parcelRequire("OwuLI");

var $lnbOK = parcelRequire("lnbOK");

var $h3FVp = parcelRequire("h3FVp");
/**
 * Returns null if useEnvironmentTypesFilter is not ready yet.
 */ const $7da4505a08464a61$var$useCoreDataFilter = (projectKey)=>{
    const [filterStore] = (0, $6go3X.useTableFilterStore)();
    const timeWindow = (0, $56t7F.useTimeWindowFilter)();
    const environmentTypesFilter = (0, $h3FVp.useEnvironmentTypesFilter)();
    const issueConfigPreference = (0, $h3FVp.useIssueConfigurationPreference)();
    return (0, $f90uP.useDeepMemo)(environmentTypesFilter === null || issueConfigPreference == null ? null : {
        projectKey: projectKey,
        text: filterStore.text,
        assignees: filterStore.assignees,
        timeWindow: timeWindow,
        epicIds: filterStore.epicIds,
        issueTypeIds: filterStore.issueTypeIds,
        environments: {
            names: filterStore.environmentNames,
            types: environmentTypesFilter,
            categories: (0, $8Jeh9.toEnvironmentCategoryTypeFilter)(filterStore.environmentTypeConcatNames)
        },
        fixVersions: filterStore.fixVersions,
        showIssuesWithoutDeployments: issueConfigPreference.showIssuesWithoutDeployments
    });
};
const $7da4505a08464a61$var$CoreDataProvider = ({ children: children, projectKey: projectKey })=>{
    const filter = $7da4505a08464a61$var$useCoreDataFilter(projectKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OwuLI.CoreDataFilterProvider), {
        filter: filter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $OwuLI.CoreDataServiceProvider), null, children));
};
const $7da4505a08464a61$var$AnalyticsContextProvider = ({ children: children })=>{
    const projectInfo = (0, $lnbOK.useProjectAnalyticsAttributes)('deploymentsPage');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "deploymentsPage",
        containerType: "project",
        containerId: projectInfo?.projectId,
        attributes: {
            ...projectInfo
        }
    }, children);
};
const $7da4505a08464a61$export$797a850985de4c33 = ({ children: children, projectKey: projectKey })=>// will cause the whole tree to re-render.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lnbOK.ProjectKeyContext).Provider, {
        value: projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7da4505a08464a61$var$AnalyticsContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7da4505a08464a61$var$CoreDataProvider, {
        projectKey: projectKey
    }, children)));

});
parcelRegister("8Jeh9", function(module, exports) {

$parcel$export(module.exports, "toEnvironmentTypeFilter", () => $9b64b7fcdbf91738$export$e122bba9140acf6d);
$parcel$export(module.exports, "toEnvironmentCategoryTypeFilter", () => $9b64b7fcdbf91738$export$b429508908120680);

var $yevjV = parcelRequire("yevjV");
const $9b64b7fcdbf91738$export$e122bba9140acf6d = (configuration)=>{
    const areAllEnvironmentTypesSelected = Object.values(configuration).every((isSelected)=>isSelected);
    if (areAllEnvironmentTypesSelected) return [];
    const { production: production, staging: staging, development: development, testing: testing, unmapped: unmapped } = configuration;
    return [
        ...production ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION
        ] : [],
        ...staging ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).STAGING
        ] : [],
        ...development ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).DEVELOPMENT
        ] : [],
        ...testing ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).TESTING
        ] : [],
        ...unmapped ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).UNMAPPED
        ] : []
    ];
};
const $9b64b7fcdbf91738$export$b429508908120680 = (types)=>{
    if (types.length === 0) return [];
    // Types are in the format of `PRODUCTION-prod`, `STAGING-staging`, etc.
    const categories = types.map((item)=>{
        const parts = item.split('-');
        return parts[0].toLowerCase();
    });
    return [
        ...categories.includes('production') ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION
        ] : [],
        ...categories.includes('staging') ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).STAGING
        ] : [],
        ...categories.includes('development') ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).DEVELOPMENT
        ] : [],
        ...categories.includes('testing') ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).TESTING
        ] : [],
        ...categories.includes('unmapped') ? [
            (0, $yevjV.DeploymentEnvironmentTypeOptions).UNMAPPED
        ] : []
    ];
};

});

parcelRegister("f90uP", function(module, exports) {

$parcel$export(module.exports, "useDeepMemo", () => $d3bf3c9a7bdf1c1c$export$722debc0e56fea39);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
const $d3bf3c9a7bdf1c1c$export$722debc0e56fea39 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(value, ref.current)) ref.current = value;
    return ref.current;
};

});

parcelRegister("h3FVp", function(module, exports) {

$parcel$export(module.exports, "useViewConfigurationPreference", () => $1e3dd3ab1bdd783d$export$fe05866defd0ace);
$parcel$export(module.exports, "useEnvironmentTypesFilter", () => $1e3dd3ab1bdd783d$export$9cdf04ea90db5ada);
$parcel$export(module.exports, "useIconsConfigurationPreference", () => $1e3dd3ab1bdd783d$export$1f88de01baf9fb79);
$parcel$export(module.exports, "useIssueConfigurationPreference", () => $1e3dd3ab1bdd783d$export$9865df1f35d7facb);
$parcel$export(module.exports, "useSetViewConfigurationPreference", () => $1e3dd3ab1bdd783d$export$528796fcca6abf2a);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $8Jeh9 = parcelRequire("8Jeh9");

var $jXtkF = parcelRequire("jXtkF");

var $lkEWe = parcelRequire("lkEWe");

var $cIfg4 = parcelRequire("cIfg4");

var $6DjQO = parcelRequire("6DjQO");
const $1e3dd3ab1bdd783d$export$fe05866defd0ace = ()=>{
    const giraClient = (0, $jXtkF.useGiraClient)();
    const queryResult = (0, $iZuDo.useQuery)((0, $cIfg4.MY_PREFERENCE_QUERY), {
        variables: {
            keys: [
                (0, $lkEWe.VIEW_CONFIGURATION_PREFERENCE_KEY)
            ]
        },
        client: giraClient
    });
    return (0, $6DjQO.transformEnvironmentViewPreferenceQueryResult)(queryResult);
};
const $1e3dd3ab1bdd783d$export$9cdf04ea90db5ada = ()=>{
    const { loading: loading, error: error, data: data } = $1e3dd3ab1bdd783d$export$fe05866defd0ace();
    if (error) throw error;
    if (loading || data === undefined) return null;
    return (0, $8Jeh9.toEnvironmentTypeFilter)(data.environmentType);
};
const $1e3dd3ab1bdd783d$export$1f88de01baf9fb79 = ()=>{
    const { loading: loading, error: error, data: data } = $1e3dd3ab1bdd783d$export$fe05866defd0ace();
    if (error) throw error;
    if (loading || data === undefined) return null;
    return data.icons;
};
const $1e3dd3ab1bdd783d$export$9865df1f35d7facb = ()=>{
    const { loading: loading, error: error, data: data } = $1e3dd3ab1bdd783d$export$fe05866defd0ace();
    if (error) throw error;
    if (loading || data === undefined) return null;
    return data.issues;
};
const $1e3dd3ab1bdd783d$export$528796fcca6abf2a = ()=>{
    const giraClient = (0, $jXtkF.useGiraClient)();
    const [setMyPreference, { loading: loading, error: error, called: called }] = (0, $iZuDo.useMutation)((0, $cIfg4.SET_MY_PREFERENCE_MUTATION), {
        // @ts-expect-error - TS2322 - Type 'ApolloClient<unknown>' is not assignable to type 'ApolloClient<object>'.
        client: giraClient
    });
    const setEnvironmentViewPreferenceFn = (0, $eUqFw.useCallback)((newConfig)=>{
        const stringifiedNewConfig = JSON.stringify(newConfig);
        setMyPreference({
            variables: {
                input: {
                    key: (0, $lkEWe.VIEW_CONFIGURATION_PREFERENCE_KEY),
                    value: stringifiedNewConfig
                }
            },
            optimisticResponse: {
                setMyPreference: {
                    __typename: 'SetMyPreferenceOutput',
                    success: true
                }
            },
            update: (proxy, mutationResponse)=>{
                if (mutationResponse.data == null || mutationResponse.data.setMyPreference == null || mutationResponse.data.setMyPreference.success === false) // In case mutation fails, returning here will revert optimistic update
                return;
                const newData = {
                    myPreferences: {}
                };
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"jira.user.deployments.timeline.view.configuration"' can't be used to index type '{}'.
                newData.myPreferences[0, $lkEWe.VIEW_CONFIGURATION_PREFERENCE_KEY] = stringifiedNewConfig;
                proxy.writeQuery({
                    query: (0, $cIfg4.MY_PREFERENCE_QUERY),
                    variables: {
                        keys: [
                            (0, $lkEWe.VIEW_CONFIGURATION_PREFERENCE_KEY)
                        ]
                    },
                    // @ts-expect-error - TS2345 - Argument of type '{ query: DocumentNode; variables: { keys: string[]; }; client: ApolloClient<unknown>; data: { myPreferences: {}; }; }' is not assignable to parameter of type 'WriteQueryOptions<jira_deploymentsPage_getMyPreferences_Query, jira_deploymentsPage_getMyPreferences_QueryVariables>'.
                    client: giraClient,
                    data: newData
                });
            }
        });
    }, [
        giraClient,
        setMyPreference
    ]);
    return [
        setEnvironmentViewPreferenceFn,
        {
            loading: loading,
            error: error,
            called: called
        }
    ];
};

});
parcelRegister("lkEWe", function(module, exports) {

$parcel$export(module.exports, "VIEW_CONFIGURATION_PREFERENCE_KEY", () => $02be9dcd1bed95a4$export$cefbb7826820e706);
$parcel$export(module.exports, "DEFAULT_VIEW_CONFIGURATION_PREFERENCE", () => $02be9dcd1bed95a4$export$e932560432056f35);
const $02be9dcd1bed95a4$export$cefbb7826820e706 = 'jira.user.deployments.timeline.view.configuration';
const $02be9dcd1bed95a4$export$e932560432056f35 = {
    environmentType: {
        production: true,
        staging: true,
        testing: true,
        development: true,
        unmapped: true
    },
    icons: {
        showIconKey: true,
        showMultipleDeploymentsIcon: true
    },
    issues: {
        showIssuesWithoutDeployments: false
    }
};

});

parcelRegister("cIfg4", function(module, exports) {

$parcel$export(module.exports, "MY_PREFERENCE_QUERY", () => $6b6fa3262f29de71$export$ef45cf18d6a63d93);
$parcel$export(module.exports, "SET_MY_PREFERENCE_MUTATION", () => $6b6fa3262f29de71$export$7a5db5a9a5d681f5);

var $9ypom = parcelRequire("9ypom");
const $6b6fa3262f29de71$export$ef45cf18d6a63d93 = (0, $9ypom.default)`
    query jira_deploymentsPage_getMyPreferences_Query($keys: [String!]!) {
        myPreferences(keys: $keys)
    }
`;
const $6b6fa3262f29de71$export$7a5db5a9a5d681f5 = (0, $9ypom.default)`
    mutation jira_deploymentsPage_setMyPreference_Mutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;

});

parcelRegister("6DjQO", function(module, exports) {

$parcel$export(module.exports, "transformEnvironmentViewPreferenceQueryResult", () => $54dbc2220af1273a$export$16616df2809321aa);

var $lkEWe = parcelRequire("lkEWe");
const $54dbc2220af1273a$var$transformJsonString = (jsonString)=>{
    try {
        // When we add more config props to it, merging the result from DEFAULT_VIEW_CONFIGURATION_PREFERENCE will prevent from type errors.
        return {
            ...(0, $lkEWe.DEFAULT_VIEW_CONFIGURATION_PREFERENCE),
            ...JSON.parse(jsonString)
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Error('Invalid ViewConfigurationPreference json string is received');
    }
};
const $54dbc2220af1273a$export$16616df2809321aa = ({ loading: loading, error: error, data: data })=>{
    if (loading) return {
        loading: true
    };
    if (error || data == null || data.myPreferences == null) return {
        error: error || new Error('Unexpected error: data or myPreferences field is null.'),
        loading: false
    };
    if (data.myPreferences[0, $lkEWe.VIEW_CONFIGURATION_PREFERENCE_KEY] == null) return {
        loading: false,
        data: (0, $lkEWe.DEFAULT_VIEW_CONFIGURATION_PREFERENCE)
    };
    const result = $54dbc2220af1273a$var$transformJsonString(data.myPreferences[0, $lkEWe.VIEW_CONFIGURATION_PREFERENCE_KEY]);
    return result instanceof Error ? {
        error: result,
        loading: false
    } : {
        data: result,
        loading: false
    };
};

});



parcelRegister("kuZm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1122032590bc6e29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $hzcvF = parcelRequire("hzcvF");

var $eJPjg = parcelRequire("eJPjg");

var $brEs0 = parcelRequire("brEs0");

var $hMSDj = parcelRequire("hMSDj");

var $cs4t6 = parcelRequire("cs4t6");
const $1122032590bc6e29$var$sidebarWidth = (0, $c9TLT.gridSize) * 50; // 400px
const $1122032590bc6e29$export$1ba59dacbcbf90fe = ({ children: children })=>{
    const [sidebarState] = (0, $brEs0.useSidebarStore)();
    const isOpen = sidebarState.status !== (0, $hMSDj.SidebarStatuses).CLOSED;
    const wasOpen = (0, $hzcvF.usePreviousWithInitial)(isOpen);
    const scrollState = false ? null : (0, $eJPjg.timelineScroller).getScrollState();
    (0, $eUqFw.useEffect)(()=>{
        if (wasOpen && !isOpen && scrollState) {
            const scrollAmount = (0, $cs4t6.getScrollAmountForSidebarClosing)(scrollState, $1122032590bc6e29$var$sidebarWidth);
            (0, $eJPjg.timelineScroller).scrollByPixels({
                left: scrollAmount
            });
        } else if (isOpen && !wasOpen) (0, $eJPjg.timelineScroller).scrollByPixels({
            left: $1122032590bc6e29$var$sidebarWidth
        });
    }, [
        isOpen,
        wasOpen,
        scrollState
    ]);
    return isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1122032590bc6e29$var$SidebarContainer, {
        "data-testid": "software-deployments.ui.sidebar.sidebar-container",
        width: $1122032590bc6e29$var$sidebarWidth
    }, children) : null;
};
var $1122032590bc6e29$export$2e2bcd8739ae039 = $1122032590bc6e29$export$1ba59dacbcbf90fe;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1122032590bc6e29$var$SidebarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _kqswh2mm _19bv1ejb _vchhusvi _bfhktxrc _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eJPjg", function(module, exports) {

$parcel$export(module.exports, "TIMELINE_ID", () => $8f340285deb946d0$export$80a4040613c38228);
$parcel$export(module.exports, "timelineScroller", () => $8f340285deb946d0$export$e3f9523c9658dc67);

var $8YJjX = parcelRequire("8YJjX");

var $c9TLT = parcelRequire("c9TLT");
const $8f340285deb946d0$export$3231e969238304f3 = (0, $c9TLT.gridSize) * -4;
const $8f340285deb946d0$export$80a4040613c38228 = 'sr-timeline';
/* WARNING: THIS IS AN ESCAPE HATCH. USE SPARINGLY.
 * If components from outside the table need to manipulate the timeline, use this.
 * E.g. a today button in the header that scrolls the user to todays' date.
 */ const $8f340285deb946d0$var$scrollToPercentages = ({ left: left, top: top, offset: offset = $8f340285deb946d0$export$3231e969238304f3, behavior: behavior = 'auto' })=>{
    const timelineElem = document.getElementById($8f340285deb946d0$export$80a4040613c38228);
    if (timelineElem !== null) {
        const { scrollWidth: scrollWidth } = timelineElem;
        timelineElem.scrollTo({
            left: left !== undefined ? left / 100 * scrollWidth + offset : undefined,
            top: top !== undefined ? top / 100 * scrollWidth + offset : undefined,
            behavior: (0, $8YJjX.isReducedMotion)() ? 'auto' : behavior
        });
    }
};
// NOTE - we don't use Elem.scrollBy as it breaks IE Edge 18
const $8f340285deb946d0$var$scrollByPixels = ({ left: left = 0, top: top = 0 })=>{
    const timelineElem = document.getElementById($8f340285deb946d0$export$80a4040613c38228);
    if (timelineElem !== null) {
        timelineElem.scrollLeft += left;
        timelineElem.scrollTop += top;
    }
};
const $8f340285deb946d0$var$getScrollState = ()=>{
    const timelineElem = document.getElementById($8f340285deb946d0$export$80a4040613c38228);
    if (timelineElem === null) return {
        clientWidth: 0,
        scrollWidth: 0,
        scrollLeft: 0
    };
    const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = timelineElem;
    return {
        clientWidth: clientWidth,
        scrollWidth: scrollWidth,
        scrollLeft: scrollLeft
    };
};
const $8f340285deb946d0$export$e3f9523c9658dc67 = {
    getScrollState: $8f340285deb946d0$var$getScrollState,
    scrollByPixels: $8f340285deb946d0$var$scrollByPixels,
    scrollToPercentages: $8f340285deb946d0$var$scrollToPercentages
};

});

parcelRegister("cs4t6", function(module, exports) {

$parcel$export(module.exports, "getScrollAmountForSidebarClosing", () => $168bedcaacb28258$export$ee50bdd5a590ee87);
const $168bedcaacb28258$export$ee50bdd5a590ee87 = (scrollState, sidebarWidth)=>{
    const { scrollWidth: scrollWidth, scrollLeft: scrollLeft, clientWidth: clientWidth } = scrollState;
    const distanceToRightEdge = scrollWidth - scrollLeft - clientWidth;
    // When the sidebar is closing, we need to scroll right to "undo" what we did when
    // it opened. There's an edge-case though: when the scroll distance to the right edge
    // is less than the width of the sidebar, scrolling by the full sidebar width would
    // scroll too far.
    if (distanceToRightEdge < sidebarWidth) return -distanceToRightEdge;
    return -sidebarWidth;
};

});


parcelRegister("87WY6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdca741b857cf0a0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $brEs0 = parcelRequire("brEs0");

var $hMSDj = parcelRequire("hMSDj");

var $e4wZr = parcelRequire("e4wZr");

var $boqrb = parcelRequire("boqrb");

var $9iCj5 = parcelRequire("9iCj5");
const $bdca741b857cf0a0$export$49e8f7b58a4df4ea = ()=>{
    const [sidebarState, sidebarActions] = (0, $brEs0.useSidebarStore)();
    const onClose = sidebarActions.close;
    switch(sidebarState.status){
        case (0, $hMSDj.SidebarStatuses).CLOSED:
            return null;
        case (0, $hMSDj.SidebarStatuses).SHOWING_ISSUE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9iCj5.default), {
                issueKey: sidebarState.issueKey,
                onClose: onClose
            });
        case (0, $hMSDj.SidebarStatuses).SHOWING_CONFIGURATION:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e4wZr.default), {
                onClose: onClose
            });
        case (0, $hMSDj.SidebarStatuses).SHOWING_INSIGHTS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boqrb.default), {
                onClose: onClose
            });
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'status' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sidebarState.status;
            throw Error('Unhandled sidebar status');
    }
};
var $bdca741b857cf0a0$export$2e2bcd8739ae039 = $bdca741b857cf0a0$export$49e8f7b58a4df4ea;

});
parcelRegister("e4wZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe2f7d2fd869c95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $bT7k5 = parcelRequire("bT7k5");

var $hI5oG = parcelRequire("hI5oG");

var $jWuk1 = parcelRequire("jWuk1");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");

var $OwuLI = parcelRequire("OwuLI");

var $2cKta = parcelRequire("2cKta");

var $h3FVp = parcelRequire("h3FVp");

var $bAuA7 = parcelRequire("bAuA7");

var $9keUK = parcelRequire("9keUK");

var $c3TZW = parcelRequire("c3TZW");
const $efe2f7d2fd869c95$export$fa89be98fe0936f2 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const filter = (0, $OwuLI.useCoreDataFilter)();
    const { loading: queryLoading, error: queryError, data: remoteConfig } = (0, $h3FVp.useViewConfigurationPreference)();
    const [setEnvironmentViewPreference, mutationState] = (0, $h3FVp.useSetViewConfigurationPreference)();
    const showIssuesWithoutDeploymentConfig = !(filter && (0, $2cKta.isFilterSuitableForAGSQuery)(filter));
    if (queryError) throw new Error(`Could not load view configuration preference. Details: ${queryError.message}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, mutationState.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: mutationState.error,
        title: (0, $c3TZW.default).configMutationErrorFlagTitle,
        description: (0, $c3TZW.default).configMutationErrorFlagDescription
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efe2f7d2fd869c95$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_syaz1fxt _19pkpxbi"
        ])
    }, formatMessage((0, $c3TZW.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Close"
        }),
        appearance: "subtle",
        onClick: onClose,
        spacing: "default"
    })), queryLoading || remoteConfig == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_otyr1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bAuA7.default), {
        onChange: (newEnvironmentTypeViewConfig)=>{
            setEnvironmentViewPreference({
                ...remoteConfig,
                environmentType: newEnvironmentTypeViewConfig
            });
        },
        environmentTypeViewConfig: remoteConfig.environmentType
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_otyr1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9keUK.default), {
        onChange: (iconsViewConfiguration)=>{
            setEnvironmentViewPreference({
                ...remoteConfig,
                icons: iconsViewConfiguration
            });
        },
        iconsViewConfiguration: remoteConfig.icons
    })), showIssuesWithoutDeploymentConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_otyr1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _19pkidpf _otyr19bv"
        ])
    }, formatMessage((0, $c3TZW.default).issuesSection))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: remoteConfig.issues.showIssuesWithoutDeployments,
        label: formatMessage((0, $c3TZW.default).showIssuesWithoutDeployments),
        onChange: (evt, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'toggleShowIssuesWithoutDeployments', {
                toggleTo: evt.target.checked
            });
            setEnvironmentViewPreference({
                ...remoteConfig,
                issues: {
                    showIssuesWithoutDeployments: evt.target.checked
                }
            });
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_otyr1ejb"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _19pkidpf _otyr19bv"
        ])
    }, formatMessage((0, $c3TZW.default).issuesSection))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: false,
        label: formatMessage((0, $c3TZW.default).showIssuesWithoutDeployments),
        isDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $c3TZW.default).showIssuesWithoutDeploymentsRemoved)))));
};
const $efe2f7d2fd869c95$var$bottomMarginStyles = null;
const $efe2f7d2fd869c95$var$titleStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efe2f7d2fd869c95$var$TitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $efe2f7d2fd869c95$var$sectionTitleStyles = null;
var $efe2f7d2fd869c95$export$2e2bcd8739ae039 = $efe2f7d2fd869c95$export$fa89be98fe0936f2;

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("dWGNJ", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $1e474dd65cc72606$export$518ba8e0e60f145f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $izafr = parcelRequire("izafr");
const $1e474dd65cc72606$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $7byHA.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
            flag: {
                type: 'warning',
                title: title,
                description: errorMessage,
                testId: (0, $1ybV0.ff)('relay-migration-issue-fields-number_q0em4') ? 'issue-error-flag.error-flag.warning' : undefined
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izafr.FlagRenderer), {
        flag: {
            type: 'error',
            title: title,
            description: description,
            testId: (0, $1ybV0.ff)('relay-migration-issue-fields-number_q0em4') ? 'issue-error-flag.error-flag.error' : undefined
        }
    });
};

});
parcelRegister("izafr", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a);

var $gf6nQ = parcelRequire("gf6nQ");

var $5oIBC = parcelRequire("5oIBC");
const $e43c89914c6fc6a2$export$7c38ebd1f7ca6a5a = (0, $5oIBC.default)((0, $gf6nQ.default));

});
parcelRegister("gf6nQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7eec4e9461c786a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
class $7eec4e9461c786a4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $8vPhU.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("bAuA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ade5edfd49bb3cc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $yevjV = parcelRequire("yevjV");

var $aB3OO = parcelRequire("aB3OO");
const { PRODUCTION: $9ade5edfd49bb3cc$var$PRODUCTION, STAGING: $9ade5edfd49bb3cc$var$STAGING, TESTING: $9ade5edfd49bb3cc$var$TESTING, DEVELOPMENT: $9ade5edfd49bb3cc$var$DEVELOPMENT, UNMAPPED: $9ade5edfd49bb3cc$var$UNMAPPED } = (0, $yevjV.DeploymentEnvironmentTypeOptions);
const $9ade5edfd49bb3cc$var$isOnlyOneLeft = (environmentTypeViewConfig)=>{
    let tickCount = 0;
    Object.keys(environmentTypeViewConfig).forEach((environmentType)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'EnvironmentTypeViewConfiguration'.
        if (environmentTypeViewConfig[environmentType]) tickCount += 1;
    });
    return tickCount === 1;
};
// TODO: Kill this function & change `EnvironmentTypeViewConfiguration` to use
// the `DeploymentEnvironmentTypeOptions` values as keys directly.
const $9ade5edfd49bb3cc$var$getPropKeyFromEnvType = (envType)=>{
    switch(envType){
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION:
            return 'production';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).STAGING:
            return 'staging';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).TESTING:
            return 'testing';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).DEVELOPMENT:
            return 'development';
        case (0, $yevjV.DeploymentEnvironmentTypeOptions).UNMAPPED:
            return 'unmapped';
        default:
            throw new Error('Unexpected environment type is given');
    }
};
const $9ade5edfd49bb3cc$export$4659b77264b13270 = ({ onChange: onChange, environmentTypeViewConfig: environmentTypeViewConfig })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onCheckboxChange = (newValue, environmentType, analyticsEvent)=>{
        if (newValue === false && $9ade5edfd49bb3cc$var$isOnlyOneLeft(environmentTypeViewConfig)) return;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'toggleDeploymentEnvironment', {
            environment: environmentType,
            enabled: newValue
        });
        const newConfig = {
            ...environmentTypeViewConfig
        };
        newConfig[$9ade5edfd49bb3cc$var$getPropKeyFromEnvType(environmentType)] = newValue;
        onChange(newConfig);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        testId: "software-deployments.ui.sidebar-content.configuration.environment-type.title",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _19pkidpf _otyru2gc"
        ])
    }, formatMessage((0, $aB3OO.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: environmentTypeViewConfig.production,
        label: formatMessage((0, $aB3OO.default).production),
        onChange: (event, analyticsEvent)=>{
            onCheckboxChange(event.target.checked, $9ade5edfd49bb3cc$var$PRODUCTION, analyticsEvent);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: environmentTypeViewConfig.staging,
        label: formatMessage((0, $aB3OO.default).staging),
        onChange: (event, analyticsEvent)=>{
            onCheckboxChange(event.target.checked, $9ade5edfd49bb3cc$var$STAGING, analyticsEvent);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: environmentTypeViewConfig.testing,
        label: formatMessage((0, $aB3OO.default).testing),
        onChange: (event, analyticsEvent)=>{
            onCheckboxChange(event.target.checked, $9ade5edfd49bb3cc$var$TESTING, analyticsEvent);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: environmentTypeViewConfig.development,
        label: formatMessage((0, $aB3OO.default).development),
        onChange: (event, analyticsEvent)=>{
            onCheckboxChange(event.target.checked, $9ade5edfd49bb3cc$var$DEVELOPMENT, analyticsEvent);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: environmentTypeViewConfig.unmapped,
        label: formatMessage((0, $aB3OO.default).unmapped),
        onChange: (event, analyticsEvent)=>{
            onCheckboxChange(event.target.checked, $9ade5edfd49bb3cc$var$UNMAPPED, analyticsEvent);
        }
    }));
};
const $9ade5edfd49bb3cc$var$titleStyles = null;
var $9ade5edfd49bb3cc$export$2e2bcd8739ae039 = $9ade5edfd49bb3cc$export$4659b77264b13270;

});
parcelRegister("aB3OO", function(module, exports) {

$parcel$export(module.exports, "default", () => $db4bd345dca263a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db4bd345dca263a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-deployments.sidebar-content.configuration.environment-type.title",
        "defaultMessage": "Environment types"
    },
    production: {
        "id": "software-deployments.sidebar-content.configuration.environment-type.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "software-deployments.sidebar-content.configuration.environment-type.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "software-deployments.sidebar-content.configuration.environment-type.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "software-deployments.sidebar-content.configuration.environment-type.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "software-deployments.sidebar-content.configuration.environment-type.unmapped",
        "defaultMessage": "Unmapped"
    }
});

});


parcelRegister("9keUK", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfed0a54e704b9f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jxomu = parcelRequire("jxomu");
const $dfed0a54e704b9f9$export$e376c72ccc8eeed0 = ({ onChange: onChange, iconsViewConfiguration: iconsViewConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        testId: "software-deployments.ui.sidebar-content.configuration.icons.title",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfed0a54e704b9f9$var$Title, null, formatMessage((0, $jxomu.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        testId: "software-deployments.ui.sidebar-content.configuration.icons.show-icon-key",
        isChecked: iconsViewConfiguration.showIconKey,
        label: formatMessage((0, $jxomu.default).showIconKey),
        onChange: (e)=>{
            const newConfig = {
                ...iconsViewConfiguration,
                showIconKey: e.target.checked
            };
            onChange(newConfig);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: iconsViewConfiguration.showMultipleDeploymentsIcon,
        label: formatMessage((0, $jxomu.default).multipleDeploymentsIconLabel),
        onChange: (e)=>{
            const newConfig = {
                ...iconsViewConfiguration,
                showMultipleDeploymentsIcon: e.target.checked
            };
            onChange(newConfig);
        }
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dfed0a54e704b9f9$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _19pkidpf _otyr19bv",
            __cmplp.className
        ])
    });
});
var $dfed0a54e704b9f9$export$2e2bcd8739ae039 = $dfed0a54e704b9f9$export$e376c72ccc8eeed0;

});
parcelRegister("jxomu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e6b1ba91cf9867d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e6b1ba91cf9867d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-deployments.sidebar-content.configuration.icons.title",
        "defaultMessage": "Icons"
    },
    showIconKey: {
        "id": "software-deployments.sidebar-content.configuration.icons.show-icon-key",
        "defaultMessage": "Deployment Key"
    },
    multipleDeploymentsIconLabel: {
        "id": "software-deployments.sidebar-content.configuration.icons.multiple-deployments-icon-label",
        "defaultMessage": "Multiple Deployments"
    }
});

});


parcelRegister("c3TZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a061355ce5ddb7c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a061355ce5ddb7c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "software-deployments.sidebar-content.configuration.title",
        "defaultMessage": "Deployments Settings"
    },
    issuesSection: {
        "id": "software-deployments.sidebar-content.configuration.issues-section",
        "defaultMessage": "Issues"
    },
    showIssuesWithoutDeployments: {
        "id": "software-deployments.sidebar-content.configuration.show-issues-without-deployments",
        "defaultMessage": "Show issues without deployments"
    },
    confirmButtonLabel: {
        "id": "software-deployments.sidebar-content.configuration.confirm-button-label",
        "defaultMessage": "Save changes"
    },
    cancelButtonLabel: {
        "id": "software-deployments.sidebar-content.configuration.cancel-button-label",
        "defaultMessage": "Cancel"
    },
    configLoadingErrorFlagTitle: {
        "id": "software-deployments.sidebar-content.configuration.config-loading-error-flag-title",
        "defaultMessage": "Unable to load view configuration."
    },
    configLoadingErrorFlagDescription: {
        "id": "software-deployments.sidebar-content.configuration.config-loading-error-flag-description",
        "defaultMessage": "Please refresh the page to load your view configuration."
    },
    configMutationErrorFlagTitle: {
        "id": "software-deployments.sidebar-content.configuration.config-mutation-error-flag-title",
        "defaultMessage": "Unable to save your view settings."
    },
    configMutationErrorFlagDescription: {
        "id": "software-deployments.sidebar-content.configuration.config-mutation-error-flag-description",
        "defaultMessage": "Please try again to configure your Deployments view."
    },
    showIssuesWithoutDeploymentsRemoved: {
        "id": "software-deployments.sidebar-content.configuration.show-issues-without-deployments-removed",
        "defaultMessage": "You can no longer filter issues without deployments."
    }
});

});


parcelRegister("boqrb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b54c28ed36a77a4a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b54c28ed36a77a4a$var$Insights = (0, $7rh0R.lazy)(()=>(parcelRequire("4Aja3")), {
    moduleId: "./src/packages/software/deployments/main/src/ui/sidebar-content/insights/index.tsx"
});
const $b54c28ed36a77a4a$var$AsyncInsights = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "deployments-insights-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b54c28ed36a77a4a$var$Insights, props));
var $b54c28ed36a77a4a$export$2e2bcd8739ae039 = $b54c28ed36a77a4a$var$AsyncInsights;

});
parcelRegister("4Aja3", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("bx46k")
]).then(()=>parcelRequire('baNId'));

});


parcelRegister("9iCj5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a0a8196e87292aa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");


var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5a0a8196e87292aa$var$IssueApp = (0, $7rh0R.lazy)(()=>(parcelRequire("kT5hT")), {
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $5a0a8196e87292aa$var$Issue = ({ issueKey: issueKey, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "deploymentsIssue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a0a8196e87292aa$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a0a8196e87292aa$var$IssueApp, {
        viewModeOptions: {
            viewMode: 'SIDEBAR'
        },
        issueKey: issueKey,
        analyticsSource: (0, $0100842672acae20$export$778b4609e784cb27),
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        onClose: onClose,
        isLoadedWithPage: false,
        isSpaEnabled: false
    }))));
var $5a0a8196e87292aa$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5a0a8196e87292aa$var$Issue;
const $5a0a8196e87292aa$var$DetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1reo15vq _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("kT5hT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("kWrFZ"),
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("dsiAd"),
    $d1Cng("eNmuD"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kMAKK")
]).then(()=>parcelRequire('9zAkH'));

});



parcelRegister("1ZpNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $493ff0dbf16c04a3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $luerf = parcelRequire("luerf");

var $9FEvp = parcelRequire("9FEvp");

var $dWGNJ = parcelRequire("dWGNJ");

var $d6f6c = parcelRequire("d6f6c");

var $8GsYw = parcelRequire("8GsYw");

var $36Dty = parcelRequire("36Dty");

var $gEpgE = parcelRequire("gEpgE");

var $2WwpS = parcelRequire("2WwpS");

var $kq9yX = parcelRequire("kq9yX");

var $56t7F = parcelRequire("56t7F");

var $brEs0 = parcelRequire("brEs0");

var $8QgAU = parcelRequire("8QgAU");

var $OwuLI = parcelRequire("OwuLI");

var $lnbOK = parcelRequire("lnbOK");

var $gx9jR = parcelRequire("gx9jR");

var $6qFlO = parcelRequire("6qFlO");

var $3wiDP = parcelRequire("3wiDP");

var $9R8v8 = parcelRequire("9R8v8");

var $jkcwt = parcelRequire("jkcwt");

var $1Ohdz = parcelRequire("1Ohdz");

var $iZi2c = parcelRequire("iZi2c");

var $aPkMj = parcelRequire("aPkMj");

var $53ni8 = parcelRequire("53ni8");

var $hUc9F = parcelRequire("hUc9F");

var $1YzcJ = parcelRequire("1YzcJ");

var $iQqTb = parcelRequire("iQqTb");
// @ts-expect-error - TS2315 - Type 'Partial' is not generic.
const $493ff0dbf16c04a3$var$useTimelineComponents = ()=>({
        Bar: (0, $3wiDP.default),
        Loader: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9R8v8.default), null),
        NoMatches: $1YzcJ.default,
        Legend: $1Ohdz.Legend,
        ChartIndicators: $6qFlO.default,
        IssueTitle: $jkcwt.default,
        ListItemContent: $iZi2c.default,
        ListItemContentTooltip: $aPkMj.default
    });
const $493ff0dbf16c04a3$export$e6a97ba2cae5bb94 = ()=>{
    const { data: projectData, loading: projectLoading, error: projectError } = (0, $lnbOK.useProject)();
    const { data: issuesData, loadingState: issuesLoadingState, error: issuesError } = (0, $OwuLI.useIssues)();
    const sidebarActions = (0, $brEs0.useSidebarActions)();
    const timelineComponents = $493ff0dbf16c04a3$var$useTimelineComponents();
    const [selectedIssueKey] = (0, $brEs0.useSidebarIssueKey)();
    const [timelineMode] = (0, $8QgAU.useTimelineMode)();
    const timeWindowFilter = (0, $56t7F.useTimeWindowFilter)();
    const endTimelineStartOfDay = (0, $2WwpS.startOfDay)(timeWindowFilter.before);
    const today = (0, $2WwpS.startOfDay)(new Date());
    const timelineDuration = (0, $kq9yX.getTimelineDurationFromTimeWindowFilter)(timeWindowFilter);
    const timelineDefaultPosition = (0, $36Dty.getPositionForTimestamp)(endTimelineStartOfDay, timelineDuration);
    const earliestVisibleDeploymentDate = (0, $OwuLI.useEarliestVisibleDeploymentDate)();
    // The "adjusted" window will update as new deployments are loaded. This has the effect
    // of moving the left edge of the blanket/overlay back in time as more data is loaded.
    // The intent is to visually indicate the point at which we haven't loaded data for.
    const adjustedTimeWindow = {
        // Subtracting one day so the blanket starts just *before* the earliest deployment, rather
        // than literally on top of it.
        after: earliestVisibleDeploymentDate === null ? timeWindowFilter.after : (0, $luerf.default)([
            timeWindowFilter.after,
            (0, $9FEvp.default)(earliestVisibleDeploymentDate, 1)
        ]),
        before: timeWindowFilter.before
    };
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const issues = issuesData ?? [];
    // maps issue id to issue key
    const onItemClick = (0, $eUqFw.useCallback)((clickedId)=>{
        const clickedIssue = issues.find(({ id: id })=>id === clickedId);
        if (clickedIssue != null) sidebarActions.showIssue(clickedIssue.key);
    }, [
        issues,
        sidebarActions
    ]);
    const selectedItem = issues.find((issue)=>issue.key === selectedIssueKey);
    // TODO - passing selectedItemId down from here causes the whole table to re-render
    // would be better to consume selectedIssueKey in ListItem
    const selectedItemId = selectedItem?.id;
    if (issuesLoadingState === (0, $gEpgE.LoadingStateOptions).LOADING_INITIAL || projectLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53ni8.default), null);
    if (projectError || !projectData) throw projectError;
    if (issues.length === 0 && issuesError) throw issuesError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, issues.length > 0 && issuesError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: issuesError,
        title: (0, $hUc9F.default).loadingNextIssuePageFailedFlagTitle,
        description: (0, $hUc9F.default).loadingNextIssuePageFailedFlagDescription
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GsYw.default), {
        key: JSON.stringify(timelineDuration),
        today: today,
        isHighlightToday: true,
        scope: "software-deployments",
        components: timelineComponents,
        timelineDefaultPosition: timelineDefaultPosition,
        timelineMode: timelineMode,
        projects: [
            (0, $iQqTb.toTableItemProject)(projectData)
        ],
        timelineDuration: timelineDuration,
        timelineWindow: adjustedTimeWindow,
        items: issues.map((0, $iQqTb.toTableItem)),
        onItemClick: onItemClick,
        selectedItemId: selectedItemId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gx9jR.ViewDeploymentsTimelineExperienceSuccessTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
var $493ff0dbf16c04a3$export$2e2bcd8739ae039 = $493ff0dbf16c04a3$export$e6a97ba2cae5bb94;

});
parcelRegister("8GsYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $50755833e599418f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");


var $94TFJ = parcelRequire("94TFJ");

var $2HUeD = parcelRequire("2HUeD");

var $gaouB = parcelRequire("gaouB");

var $i49Zg = parcelRequire("i49Zg");
function $50755833e599418f$var$Table(props) {
    const { scope: scope, styleMarshal: styleMarshal, ...mainProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2HUeD.default), {
        scope: scope,
        ...styleMarshal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gaouB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i49Zg.default), mainProps)));
}
$50755833e599418f$var$Table.defaultProps = {
    isSelectEnabled: true,
    isHoverEnabled: false,
    isResizeEnabled: true,
    isHighlightToday: true,
    isHideScrollbar: false,
    items: [],
    activeLevel: (0, $94TFJ.DEFAULT_LEVEL),
    expandedItems: {},
    components: {},
    styleMarshal: {},
    selectedItemId: undefined,
    itemHeight: (0, $d736b332644d7251$export$f898a7479a35465b),
    listWidth: (0, $d736b332644d7251$export$58590494eb7f9f92),
    onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onItemExpandChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTimelineUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSetListWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $50755833e599418f$export$2e2bcd8739ae039 = $50755833e599418f$var$Table;

});
parcelRegister("2HUeD", function(module, exports) {

$parcel$export(module.exports, "default", () => $75648292180082e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3wg8U = parcelRequire("3wg8U");

var $30unQ = parcelRequire("30unQ");

var $7eocX = parcelRequire("7eocX");

var $iMlZB = parcelRequire("iMlZB");

var $55xA4 = parcelRequire("55xA4");
class $75648292180082e2$export$a64c1f4f77c1f171 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            custom: {},
            overrides: {}
        };
    }
    constructor(props){
        super(props);
        this.onRowMouseEnter = (id)=>{
            if (id !== this.selectedIssueId) this.insertStyle($7eocX.row(id), $55xA4.itemHoverStyles);
        };
        this.onRowMouseLeave = (id)=>{
            if (id !== this.selectedIssueId) this.removeStyle($7eocX.row(id));
        };
        this.onRowSelect = (id)=>{
            this.selectedIssueId = id;
            this.insertStyle($7eocX.row(id), $55xA4.itemSelectedStyles);
        };
        this.onRowDeselect = (id)=>{
            if (this.selectedIssueId === id) this.selectedIssueId = undefined;
            this.removeStyle($7eocX.row(id));
        };
        this.selectedIssueId = undefined;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const custom = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const overrides = {};
        /**
		 * binding happens in the constructor as we don't expect these function
		 * to change during execution
		 */ Object.keys(props.custom).forEach((key)=>{
            /**
			 * bind custom marshal handlers to component instance
			 * reminder, that all handlers must be regular "function"s, rather than lambdas
			 * to make it work
			 */ custom[key] = props.custom[key].bind(this);
        });
        Object.keys(props.overrides).forEach((key)=>{
            // bind overrides functions
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<RoadmapStyleMarshalProps>'.
            overrides[key] = props.overrides[key].bind(this);
        });
        this.roadmapContext = {
            onRowMouseEnter: this.onRowMouseEnter,
            onRowMouseLeave: this.onRowMouseLeave,
            onRowSelect: this.onRowSelect,
            onRowDeselect: this.onRowDeselect,
            ...overrides,
            customStyleMarshal: custom
        };
    }
    insertStyle(className, rule) {
        this.props.insertStyle(className, rule);
    }
    removeStyle(className) {
        this.props.removeStyle(className);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMlZB.Provider), {
            value: this.roadmapContext
        }, children);
    }
}
const $75648292180082e2$var$WrappedRoadmapProvider = (0, $30unQ.default)($75648292180082e2$export$a64c1f4f77c1f171);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$75648292180082e2$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3wg8U.default), {
        scope: props.scope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75648292180082e2$var$WrappedRoadmapProvider, {
        overrides: props.overrides,
        custom: props.custom
    }, props.children));

});
parcelRegister("3wg8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd25adaf42ffb1e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gSx6s = parcelRequire("gSx6s");
const $bd25adaf42ffb1e1$var$toSelector = (className)=>`.${String(className)}`;
class $bd25adaf42ffb1e1$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            scope: 'default'
        };
    }
    constructor(props){
        super(props);
        this.onInsertCssRule = (className, rule)=>{
            this.onRemoveCssRule(className);
            this.insertRule($bd25adaf42ffb1e1$var$toSelector(className), rule);
        };
        this.onRemoveCssRule = (className)=>{
            const ruleIndex = this.getRuleIndex($bd25adaf42ffb1e1$var$toSelector(className));
            if (ruleIndex !== -1) this?.styleElement?.sheet?.deleteRule(ruleIndex);
        };
        this.styleElement = document.createElement('style');
        this.styleElement.type = 'text/css';
        this.styleElement.id = 'roadmap-data-styles';
        const head = document.querySelector('head');
        if (head) head.appendChild(this.styleElement);
    }
    componentWillUnmount() {
        const parent = this.styleElement.parentNode;
        if (parent) parent.removeChild(this.styleElement);
    }
    getRuleIndex(selector) {
        return Array.from(this?.styleElement?.sheet?.cssRules ?? []).findIndex(// @ts-expect-error - TS2339 - Property 'selectorText' does not exist on type 'CSSRule'.
        (rule)=>rule.selectorText === `.${this.props.scope} ${selector}`);
    }
    insertRule(selector, rule) {
        this?.styleElement?.sheet?.insertRule(`.${this.props.scope} ${String(selector)} {${rule.replace('\n', ' ')}}`, this.styleElement.sheet.cssRules.length);
    }
    render() {
        const { children: children, scope: scope } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gSx6s.Provider), {
            value: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                insert: this.onInsertCssRule,
                remove: this.onRemoveCssRule
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: scope
        }, children));
    }
}

});
parcelRegister("gSx6s", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $7b556d9cee558ab9$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $7b556d9cee558ab9$export$b3bffd4bb7da6b8f);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const { Provider: $7b556d9cee558ab9$export$2881499e37b75b9a, Consumer: $7b556d9cee558ab9$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $eUqFw.createContext)({
    insert: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    remove: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});

});


parcelRegister("30unQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $eea7ffd4404569bf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gSx6s = parcelRequire("gSx6s");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eea7ffd4404569bf$export$2e2bcd8739ae039 = (Component)=>// @ts-expect-error - TS2344 - Type 'TProps' does not satisfy the constraint 'StyleMarshalContext'.
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gSx6s.Consumer), null, ({ insert: insert, remove: remove })=>// @ts-expect-error - TS2322 - Type '{ insertStyle: (className: string, rule: string) => void; removeStyle: (className: string) => void; } & Diff<TProps, StyleMarshalContext> & { ...; }' is not assignable to type 'IntrinsicAttributes & TProps & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                insertStyle: insert,
                removeStyle: remove,
                ...props
            }, props.children));

});

parcelRegister("7eocX", function(module, exports) {

$parcel$export(module.exports, "row", () => $a7c2aca5c685c6d7$export$120ff0929b202a6d);
$parcel$export(module.exports, "rowChild", () => $a7c2aca5c685c6d7$export$4eca918fd1db28c4);

var $cFEO5 = parcelRequire("cFEO5");
const $a7c2aca5c685c6d7$export$120ff0929b202a6d = (id)=>(0, $cFEO5.toClassName)(`row-${id}`);
const $a7c2aca5c685c6d7$export$4eca918fd1db28c4 = (id)=>(0, $cFEO5.toClassName)(`row-child-${id}`);

});
parcelRegister("cFEO5", function(module, exports) {

$parcel$export(module.exports, "toClassName", () => $2821d90d9191e72d$export$4370d69198e9314a);
$parcel$export(module.exports, "getStyle", () => $2821d90d9191e72d$export$3d2f074408bd1b82);
const $2821d90d9191e72d$export$4370d69198e9314a = (classNameString)=>classNameString;
const $2821d90d9191e72d$export$3d2f074408bd1b82 = (className)=>({
        className: Array.isArray(className) ? className.join(' ') : className
    });

});


parcelRegister("iMlZB", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $2153d5eef34b7778$export$2881499e37b75b9a);
$parcel$export(module.exports, "default", () => $2153d5eef34b7778$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $2153d5eef34b7778$var$RoadmapStyleMarshalContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    onRowMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowSelect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onRowDeselect: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    customStyleMarshal: {}
});
const { Provider: $2153d5eef34b7778$export$2881499e37b75b9a, Consumer: $2153d5eef34b7778$export$b3bffd4bb7da6b8f } = $2153d5eef34b7778$var$RoadmapStyleMarshalContext;
var $2153d5eef34b7778$export$2e2bcd8739ae039 = $2153d5eef34b7778$var$RoadmapStyleMarshalContext;

});

parcelRegister("55xA4", function(module, exports) {

$parcel$export(module.exports, "itemHoverStyles", () => $36acbc49034a7570$export$2cd8b1a8104d385e);
$parcel$export(module.exports, "itemSelectedStyles", () => $36acbc49034a7570$export$a9cf36bf792708a5);

const $36acbc49034a7570$export$2cd8b1a8104d385e = `
  --item-hover-color: ${`var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$exports).N30})`};
`;
const $36acbc49034a7570$export$a9cf36bf792708a5 = ` 
  --item-selected-color: ${`var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$exports).B50})`};
`;

});


parcelRegister("gaouB", function(module, exports) {

$parcel$export(module.exports, "default", () => $db73866bef420925$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGMPC = parcelRequire("eGMPC");

var $87Ygr = parcelRequire("87Ygr");
const $db73866bef420925$var$requestCancellableAnimationFrame = (0, $eGMPC.default)();
// eslint-disable-next-line jira/react/no-class-components
class $db73866bef420925$var$ScrollSynchronizeProvider extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onRegister = (node, syncAxis)=>{
            // Assert: element is not already registered
            if (this.findListener(node) !== undefined) throw new Error('An element should only be registered once. Is it being registered in a sensible component life-cycle (e.g. componentDidMount)?');
            this.listenOnNode(node);
            this.listeners.push({
                node: node,
                syncAxis: syncAxis
            });
        };
        this.onUnregister = (node)=>{
            // Assert: element is already registered
            if (this.findListener(node) === undefined) throw new Error('The element is not registered, it cannot be unregistered.');
            this.stopListeningOnNode(node);
            // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'Listener' and 'HTMLElement' have no overlap.
            this.listeners = this.listeners.filter((listener)=>listener !== node);
        };
        this.onScroll = (event)=>{
            // @ts-expect-error - TS2339 - Property 'node' does not exist on type 'Listener | undefined'. | TS2339 - Property 'syncAxis' does not exist on type 'Listener | undefined'. | TS2345 - Argument of type 'EventTarget | null' is not assignable to parameter of type 'HTMLElement'.
            const { node: node, syncAxis: syncAxis } = this.findListener(event.target);
            $db73866bef420925$var$requestCancellableAnimationFrame(()=>{
                this.synchronizeScrollPositions(node, syncAxis);
            });
        };
        this.frame = null;
        this.listeners = [];
        // It is being used, but only as a whole state object and the linter does not recognize that
        /* eslint-disable react/no-unused-state */ this.state = {
            register: this.onRegister,
            unregister: this.onUnregister
        };
    /* eslint-enable react/no-unused-state */ }
    synchronizeScrollPositions(scrollingNode, scrollingSyncAxis) {
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = scrollingNode;
        const scrollTopOffset = scrollHeight - clientHeight;
        const scrollLeftOffset = scrollWidth - clientWidth;
        this.listeners.forEach(({ node: node, syncAxis: syncAxis })=>{
            /* For the areas that are not scrolling:
			 * 1) Stop listening to scroll events so we don't get stuck in a scroll loop
			 * 2) Synchronize the scroll positions with the current scrolling area
			 * 3) Start listening to scroll events again
			 */ if (node !== scrollingNode) {
                this.stopListeningOnNode(node);
                /* The synchronized areas could be different heights. The scroll offsets
				 * need to be updated relative to the current scrolling area, rather than
				 * set to it's absolute value.
				 */ const paneHeight = node.scrollHeight - clientHeight;
                const paneWidth = node.scrollWidth - clientWidth;
                // If currently not overflowed, could get a divide by 0
                if (scrollTopOffset > 0 && syncAxis !== 'x' && scrollingSyncAxis !== 'x') {
                    const newScrollTop = paneHeight * scrollTop / scrollTopOffset;
                    // eslint-disable-next-line no-param-reassign
                    node.scrollTop = newScrollTop;
                }
                if (scrollLeftOffset > 0 && syncAxis !== 'y' && scrollingSyncAxis !== 'y') {
                    const newScrollLeft = paneWidth * scrollLeft / scrollLeftOffset;
                    // eslint-disable-next-line no-param-reassign
                    node.scrollLeft = newScrollLeft;
                }
                // Don't attach the listener until the next frame, AFTER the scrolling has stopped
                // We always have to restore listener, so we should never cancel this frame
                requestAnimationFrame(()=>{
                    this.listenOnNode(node);
                });
            }
        });
    }
    findListener(node) {
        return this.listeners.find((listener)=>listener.node === node);
    }
    listenOnNode(node) {
        node.addEventListener('scroll', this.onScroll);
    }
    stopListeningOnNode(node) {
        node.removeEventListener('scroll', this.onScroll);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87Ygr.default).Provider, {
            value: this.state
        }, children);
    }
}
var $db73866bef420925$export$2e2bcd8739ae039 = $db73866bef420925$var$ScrollSynchronizeProvider;

});
parcelRegister("eGMPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe176fd42535cb3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $1fe176fd42535cb3$export$2e2bcd8739ae039 = ()=>{
    let frameId = null;
    return (callback)=>{
        if (frameId) cancelAnimationFrame(frameId);
        frameId = requestAnimationFrame(callback);
    };
};

});

parcelRegister("87Ygr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e708a7ce6f6bd58$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
const $2e708a7ce6f6bd58$var$ScrollSynchronizerContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    register: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    unregister: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
var $2e708a7ce6f6bd58$export$2e2bcd8739ae039 = $2e708a7ce6f6bd58$var$ScrollSynchronizerContext;

});


parcelRegister("i49Zg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae328b9a13c7b3a4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dxIU5 = parcelRequire("dxIU5");


var $94TFJ = parcelRequire("94TFJ");

var $bIMUg = parcelRequire("bIMUg");

var $9muhp = parcelRequire("9muhp");

var $lgUFL = parcelRequire("lgUFL");

var $aqFQz = parcelRequire("aqFQz");
// eslint-disable-next-line jira/react/no-class-components
class $ae328b9a13c7b3a4$var$TableMain extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.updateMaxListWidth();
        }, (0, $94TFJ.RESIZE_DEBOUNCE_MS));
        this.onSetTableRef = (elem)=>{
            this.tableRef = elem;
        };
        this.state = {
            maxListWidth: props.listWidth
        };
    }
    componentDidMount() {
        if (this.props.isResizeEnabled) {
            this.updateMaxListWidth();
            window.addEventListener('resize', this.onWindowResize);
        }
    }
    componentWillUnmount() {
        if (this.props.isResizeEnabled) window.removeEventListener('resize', this.onWindowResize);
    }
    updateMaxListWidth() {
        if (this.tableRef) {
            const tableBoundingClient = this.tableRef.getBoundingClientRect();
            const maxListWidth = (0, $lgUFL.default)(tableBoundingClient.width);
            this.setState({
                maxListWidth: maxListWidth
            });
        }
    }
    render() {
        const { isSelectEnabled: isSelectEnabled, isHoverEnabled: isHoverEnabled, isResizeEnabled: isResizeEnabled, isHighlightToday: isHighlightToday, isHideScrollbar: isHideScrollbar, items: items, itemHeight: itemHeight, selectedItemId: selectedItemId, activeLevel: activeLevel, expandedItems: expandedItems, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWindow: timelineWindow, timelineDefaultPosition: timelineDefaultPosition, today: today, listWidth: listWidth, onTimelineUpdated: onTimelineUpdated, onItemClick: onItemClick, onItemExpandChanged: onItemExpandChanged, onSetListWidth: onSetListWidth, components: components, projects: projects } = this.props;
        const { maxListWidth: maxListWidth } = this.state;
        const { listItems: listItems, chartItems: chartItems } = (0, $aqFQz.default)(items);
        const { List: List, Chart: Chart, listComponents: listComponents, chartComponents: chartComponents } = (0, $9muhp.default)(components);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bIMUg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae328b9a13c7b3a4$var$MainTableContainer, {
            ref: this.onSetTableRef,
            "data-testid": "deployments.common.components.table.main.table"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(List, {
            isResizeEnabled: isResizeEnabled,
            isSelectEnabled: isSelectEnabled,
            isHoverEnabled: isHoverEnabled,
            selectedItemId: selectedItemId,
            items: listItems,
            itemHeight: itemHeight,
            expandedItems: expandedItems,
            activeLevel: activeLevel,
            listWidth: listWidth,
            maxListWidth: maxListWidth,
            // @ts-expect-error - TS2322 - Type '{ ListItem: ComponentType<Flow.Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>> | ListItemComponentType; ListItemContent: (({ id }: APIProps) => JSX.Element) | ListItemContentComponentType; NoMatches: NoMatchesComponentType | (() => null); Loader: ChartLoaderComponentType...' is not assignable to type 'ListComponents'.
            components: listComponents,
            onItemClick: onItemClick,
            onItemExpandChanged: onItemExpandChanged,
            onSetListWidth: onSetListWidth,
            projects: projects
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chart, {
            onTimelineUpdated: onTimelineUpdated,
            isSelectEnabled: isSelectEnabled,
            isHoverEnabled: isHoverEnabled,
            isHighlightToday: isHighlightToday,
            isHideScrollbar: isHideScrollbar,
            items: chartItems,
            itemHeight: itemHeight,
            expandedItems: expandedItems,
            activeLevel: activeLevel,
            listWidth: listWidth,
            today: today,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineWindow: timelineWindow,
            timelineDefaultPosition: timelineDefaultPosition,
            components: chartComponents,
            onItemClick: onItemClick
        })));
    }
}
const $ae328b9a13c7b3a4$var$primaryBorder = `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N30})`}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae328b9a13c7b3a4$var$MainTableContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_i6nvwm": (0, $9t7rW.default)($ae328b9a13c7b3a4$var$primaryBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _2rko1l7b _19itkbi4",
            __cmplp.className
        ])
    });
});
var $ae328b9a13c7b3a4$export$2e2bcd8739ae039 = $ae328b9a13c7b3a4$var$TableMain;

});
parcelRegister("bIMUg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6366df8eb9e8b4d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $e0dS9 = parcelRequire("e0dS9");

var $9E36O = parcelRequire("9E36O");
const $6366df8eb9e8b4d1$var$MISSING_REF_ERROR_MESSAGE = 'Viewport element was null. Only make this request when it is certain to be available (e.g. not in componentDidMount)';
// eslint-disable-next-line jira/react/no-class-components
class $6366df8eb9e8b4d1$var$ViewportProvider extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.requestBoundingClient = ()=>{
            const viewportOffset = (0, $e0dS9.default)();
            if (!this.ref) throw new Error($6366df8eb9e8b4d1$var$MISSING_REF_ERROR_MESSAGE);
            if (viewportOffset) {
                const boundingClient = this.ref.getBoundingClientRect();
                const transformedBoundingClient = {
                    width: boundingClient.width - viewportOffset,
                    height: boundingClient.height - viewportOffset,
                    right: boundingClient.right - viewportOffset,
                    bottom: boundingClient.bottom - viewportOffset,
                    left: boundingClient.left,
                    top: boundingClient.top
                };
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return transformedBoundingClient;
            }
            return this.ref.getBoundingClientRect();
        };
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.requestScrollBounding = ()=>{
            if (!this.ref) throw new Error($6366df8eb9e8b4d1$var$MISSING_REF_ERROR_MESSAGE);
            const { scrollTop: scrollTop, scrollLeft: scrollLeft, scrollHeight: scrollHeight, scrollWidth: scrollWidth, clientWidth: clientWidth, clientHeight: clientHeight } = this.ref;
            // TODO getting clientWidth causes reflow - can we memoize clientWidth somehow?
            // The table will only change size on window resize or popping out the sidebar.
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollRight: scrollWidth > clientWidth ? scrollWidth - clientWidth - scrollLeft : 0,
                scrollHeight: scrollHeight,
                scrollWidth: scrollWidth,
                isOverflowY: scrollHeight > clientHeight
            };
        };
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.listenToScroll = (callback)=>{
            if (!this.ref) throw new Error($6366df8eb9e8b4d1$var$MISSING_REF_ERROR_MESSAGE);
            this.ref.addEventListener('scroll', callback);
        };
        // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.stopListeningToScroll = (callback)=>{
            if (this.ref) this.ref.removeEventListener('scroll', callback);
        };
        this.onSetRef = (elem)=>{
            this.ref = elem;
        };
        // It is being used, but only as a whole state object and the linter does not recognize that
        /* eslint-disable react/no-unused-state */ this.state = {
            requestViewportBoundingClient: this.requestBoundingClient,
            requestViewportScrollBounding: this.requestScrollBounding,
            listenToViewportScroll: this.listenToScroll,
            stopListeningToViewportScroll: this.stopListeningToScroll,
            setRef: this.onSetRef
        };
    /* eslint-enable react/no-unused-state */ }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9E36O.Provider), {
            value: this.state
        }, children);
    }
}
var $6366df8eb9e8b4d1$export$2e2bcd8739ae039 = $6366df8eb9e8b4d1$var$ViewportProvider;

});
parcelRegister("e0dS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ba6e8d6cd238d26$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// The REAL scrollbar size
// memoizeOne because it's expensive and we only need to calculate this once
// the server render will always return 0 but don't need to worry about
// a hydration mismatch as the client calls render, not hydrate.
const $2ba6e8d6cd238d26$var$getScrollbarSize = (0, $5iWql.default)(()=>{
    if (document && document.body) {
        const scrollbarContainer = document.createElement('div');
        const { style: style } = scrollbarContainer;
        style.position = 'absolute';
        style.width = '100px';
        style.height = '100px';
        style.overflow = 'scroll';
        style.top = '-9999px';
        document.body.appendChild(scrollbarContainer);
        // Pick arbitrary axis, both should have the same bar size
        const scrollbarSize = scrollbarContainer.offsetWidth - scrollbarContainer.clientWidth;
        document.body.removeChild(scrollbarContainer);
        return scrollbarSize;
    }
    return 0;
});
var $2ba6e8d6cd238d26$export$2e2bcd8739ae039 = $2ba6e8d6cd238d26$var$getScrollbarSize;

});

parcelRegister("9E36O", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $fcff3459f542de0c$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $fcff3459f542de0c$export$b3bffd4bb7da6b8f);
$parcel$export(module.exports, "useViewport", () => $fcff3459f542de0c$export$297ec8eb77d6211d);
$parcel$export(module.exports, "default", () => $fcff3459f542de0c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $fcff3459f542de0c$var$DEFAULT_BOUNDING_CLIENT = {
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const $fcff3459f542de0c$var$DEFAULT_SCROLL_BOUNDING = {
    scrollTop: 0,
    scrollLeft: 0,
    scrollRight: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    isOverflowY: false
};
const $fcff3459f542de0c$var$ViewportContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    requestViewportBoundingClient: ()=>$fcff3459f542de0c$var$DEFAULT_BOUNDING_CLIENT,
    requestViewportScrollBounding: ()=>$fcff3459f542de0c$var$DEFAULT_SCROLL_BOUNDING,
    listenToViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    stopListeningToViewportScroll: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    setRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
const { Provider: $fcff3459f542de0c$export$2881499e37b75b9a, Consumer: $fcff3459f542de0c$export$b3bffd4bb7da6b8f } = $fcff3459f542de0c$var$ViewportContext;
const $fcff3459f542de0c$export$297ec8eb77d6211d = ()=>{
    const viewportContext = (0, $eUqFw.useContext)($fcff3459f542de0c$var$ViewportContext);
    return viewportContext;
};
var $fcff3459f542de0c$export$2e2bcd8739ae039 = $fcff3459f542de0c$var$ViewportContext;

});


parcelRegister("9muhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9c04dc3ce8e11b$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $azwQz = parcelRequire("azwQz");
var // Default any components not provided by the consumer using the standard ones.
$7e9c04dc3ce8e11b$export$2e2bcd8739ae039 = (0, $5iWql.default)((customComponents)=>{
    const safeComponents = {
        ...(0, $azwQz.components),
        ...customComponents
    };
    return {
        List: safeComponents.List,
        Chart: safeComponents.Chart,
        listComponents: {
            ListItem: safeComponents.ListItem,
            ListItemContent: safeComponents.ListItemContent,
            ListItemContentTooltip: safeComponents.ListItemContentTooltip,
            NoMatches: safeComponents.NoMatches,
            Loader: safeComponents.Loader,
            IssueTitle: safeComponents.IssueTitle
        },
        chartComponents: {
            ChartItem: safeComponents.ChartItem,
            Bar: safeComponents.Bar,
            ChartOverlay: safeComponents.ChartOverlay,
            Legend: safeComponents.Legend,
            ChartIndicators: safeComponents.ChartIndicators
        }
    };
});

});
parcelRegister("azwQz", function(module, exports) {

$parcel$export(module.exports, "components", () => $1395561f19a21d34$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $bcnsi = parcelRequire("bcnsi");

var $gm5c3 = parcelRequire("gm5c3");

var $sXAvT = parcelRequire("sXAvT");

var $bJAAL = parcelRequire("bJAAL");

var $47ZAf = parcelRequire("47ZAf");

var $27qNz = parcelRequire("27qNz");

var $76Y53 = parcelRequire("76Y53");

var $f9LXG = parcelRequire("f9LXG");

var $58j2j = parcelRequire("58j2j");

var $ieW1v = parcelRequire("ieW1v");
const $1395561f19a21d34$export$9b5ac10f59f76296 = {
    List: $ieW1v.default,
    ListItem: $58j2j.default,
    ListItemContent: $76Y53.default,
    ListItemContentTooltip: $f9LXG.default,
    Chart: $gm5c3.default,
    ChartItem: $bJAAL.default,
    Bar: $bcnsi.default,
    ChartOverlay: $47ZAf.default,
    Legend: $27qNz.default,
    Loader: ()=>null,
    NoMatches: ()=>null,
    ChartIndicators: $sXAvT.default,
    IssueTitle: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, "Issues Title")
};

});
parcelRegister("bcnsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc46155fcc02e18$export$2e2bcd8739ae039);
function $1bc46155fcc02e18$var$Bar(_) {
    return null;
}
var $1bc46155fcc02e18$export$2e2bcd8739ae039 = $1bc46155fcc02e18$var$Bar;

});

parcelRegister("gm5c3", function(module, exports) {

$parcel$export(module.exports, "default", () => $022367d66e5cf346$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5GPm9 = parcelRequire("5GPm9");

var $l6dxJ = parcelRequire("l6dxJ");

var $8ZA5i = parcelRequire("8ZA5i");

var $7fxv4 = parcelRequire("7fxv4");

var $gX8FC = parcelRequire("gX8FC");

var $3qVaN = parcelRequire("3qVaN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$022367d66e5cf346$export$2e2bcd8739ae039 = ({ timelineDefaultPosition: timelineDefaultPosition, ...props })=>{
    const { timelineMode: timelineMode, timelineDuration: timelineDuration } = props;
    /* The consumer of the table only needs to understand relative values - it knows durations, not pixels.
	 * For convenience, we convert the value to the tables absolute domain value and pass it down.
	 * 1px offset is to account for the column borders.
	 */ const absoluteTimelinePosition = timelineDefaultPosition * (0, $5GPm9.getTimelineWidth)(timelineMode, timelineDuration) + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3qVaN.default), {
        ...props,
        timelineDefaultPosition: absoluteTimelinePosition,
        ChartHeader: (0, $l6dxJ.default),
        HeaderCells: (0, $7fxv4.default),
        ColumnsOverlay: (0, $8ZA5i.default),
        Items: (0, $gX8FC.default)
    });
};

});
parcelRegister("l6dxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc29f55b8bbb05e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hI5oG = parcelRequire("hI5oG");


var $7E5Lc = parcelRequire("7E5Lc");
// eslint-disable-next-line jira/react/no-class-components
class $fbc29f55b8bbb05e$var$ChartHeader extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.timelineDefaultPosition !== prevState.timelineDefaultPosition && prevState.isScrollSyncEnabled === true) return {
            isScrollSyncEnabled: false
        };
        return null;
    }
    constructor(props){
        super(props);
        this.onScroll = ()=>{
            this.props.onTimelineUpdated();
            this.headerScrollRef && this.headerScrollRef.removeEventListener('scroll', this.onScroll);
        };
        this.onSetScrollbarRef = (elem)=>{
            this.headerScrollRef = elem;
        };
        /**
     * We set timelineDefaultPosition in state even though we are not using it
     * so that we can compare it in getDerivedStateFromProps
     */ this.state = {
            isScrollSyncEnabled: true,
            timelineDefaultPosition: props.timelineDefaultPosition
        };
    }
    componentDidMount() {
        this.listenToHeaderScroll();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.timelineDefaultPosition !== prevProps.timelineDefaultPosition) this.setState({
            timelineDefaultPosition: this.props.timelineDefaultPosition,
            isScrollSyncEnabled: true
        });
        if (this.state.isScrollSyncEnabled && this.state.isScrollSyncEnabled !== prevState.isScrollSyncEnabled) // call onTimelineUpdated once header has done scrolling
        this.listenToHeaderScroll();
    }
    listenToHeaderScroll() {
        this.headerScrollRef && this.headerScrollRef.addEventListener('scroll', this.onScroll);
    }
    render() {
        const { today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, isHighlightToday: isHighlightToday, HeaderCells: HeaderCells, width: width, timelineWindow: timelineWindow } = this.props;
        const { isScrollSyncEnabled: isScrollSyncEnabled } = this.state;
        const ScrollbarComponent = isScrollSyncEnabled ? $fbc29f55b8bbb05e$var$SynchronizedScrollbar : $fbc29f55b8bbb05e$var$HiddenScrollbar;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xsmall",
            as: "div"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fbc29f55b8bbb05e$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ScrollbarComponent, {
            ref: this.onSetScrollbarRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fbc29f55b8bbb05e$var$HeightCorrector, {
            width: width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderCells, {
            today: today,
            timelineWindow: timelineWindow,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            columnDurations: columnDurations,
            isHighlightToday: isHighlightToday
        })))));
    }
}
const $fbc29f55b8bbb05e$var$secondaryBorder = `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`;
// RLSS-2812 replace color.background.neutral into color.background.accent.gray.subtlest
const $fbc29f55b8bbb05e$var$baseHeaderStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $fbc29f55b8bbb05e$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1p5ufam": (0, $9t7rW.default)($fbc29f55b8bbb05e$var$secondaryBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i8vuz _vchhusvi _n7zl1hum _bfhk1s4m _19pkidpf _1s7zglyw _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $fbc29f55b8bbb05e$var$HiddenScrollbar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1reo1wug _18m915vq _n3td12am",
            __cmplp.className
        ])
    });
});
const $fbc29f55b8bbb05e$var$HeightCorrector = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i4bvh _1bsb1efm",
            __cmplp.className
        ])
    });
});
const $fbc29f55b8bbb05e$var$SynchronizedScrollbar = (0, $7E5Lc.default)($fbc29f55b8bbb05e$var$HiddenScrollbar, {
    syncAxis: 'x',
    isCompiledComponent: true
});
var $fbc29f55b8bbb05e$export$2e2bcd8739ae039 = $fbc29f55b8bbb05e$var$ChartHeader;

});
parcelRegister("7E5Lc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b04ae07d71d098b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $87Ygr = parcelRequire("87Ygr");
const $9b04ae07d71d098b$var$withSynchronizedScroll = (WrappedComponent, { syncAxis: syncAxis, isCompiledComponent: isCompiledComponent } = {
    syncAxis: undefined,
    isCompiledComponent: false
})=>{
    // eslint-disable-next-line jira/react/no-class-components
    class WithSynchronizedScroll extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
            };
        }
        static{
            // go/jfe-eslint
            // eslint-disable-next-line react/sort-comp
            this.contextType = (0, $87Ygr.default);
        }
        componentDidMount() {
            // @ts-expect-error - TS2339 - Property 'register' does not exist on type 'unknown'.
            const { register: register } = this.context;
            if (this.ref) register(this.ref, syncAxis);
        }
        componentWillUnmount() {
            // @ts-expect-error - TS2339 - Property 'unregister' does not exist on type 'unknown'.
            const { unregister: unregister } = this.context;
            if (this.ref) unregister(this.ref);
        }
        render() {
            const { children: children, ...props } = this.props;
            const refProp = isCompiledComponent ? {
                ref: this.onSetRef,
                innerRef: undefined
            } : {
                innerRef: this.onSetRef
            };
            return(// @ts-expect-error - TS2769 - No overload matches this call.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                ...refProp
            }, children));
        }
        constructor(...args){
            super(...args);
            this.onSetRef = (elem)=>{
                const { innerRef: innerRef, forwardedRef: forwardedRef } = this.props;
                if (forwardedRef != null && typeof forwardedRef === 'function') forwardedRef(elem);
                this.ref = elem;
                innerRef(elem);
            };
        }
    }
    return /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSynchronizedScroll, {
            ...props,
            forwardedRef: ref
        }));
};
var $9b04ae07d71d098b$export$2e2bcd8739ae039 = $9b04ae07d71d098b$var$withSynchronizedScroll;

});


parcelRegister("8ZA5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2a0a2d97e000d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dvpld = parcelRequire("dvpld");

var $eXnWS = parcelRequire("eXnWS");

var $jsu2J = parcelRequire("jsu2J");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e2a0a2d97e000d1$export$2e2bcd8739ae039 = ({ timelineWindow: timelineWindow, timelineDuration: timelineDuration, columnDurations: columnDurations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsu2J.default), {
        columnPositions: (0, $dvpld.getColumnPositions)(timelineDuration, columnDurations),
        endPosition: (0, $eXnWS.getPosition)(timelineWindow.before, timelineDuration),
        startPosition: (0, $eXnWS.getPosition)(timelineWindow.after, timelineDuration)
    });

});
parcelRegister("dvpld", function(module, exports) {

$parcel$export(module.exports, "getColumnPositions", () => $f7b50cc85e82a38c$export$1f04562dc761554b);
$parcel$export(module.exports, "getTodayColumnIndex", () => $f7b50cc85e82a38c$export$ce237023318dfe05);

var $5iWql = parcelRequire("5iWql");

var $36Dty = parcelRequire("36Dty");
const $f7b50cc85e82a38c$export$1f04562dc761554b = (0, $5iWql.default)((timelineDuration, columnDurations)=>{
    let left = 0;
    if (columnDurations.length > 0) // Column start can be earlier than the timeline start. This means the first column left can be a negative value.
    // Example where this can happen is in the export table where the timeline duration is clamped to the selected date range.
    left = (0, $36Dty.getDatePercentage)(columnDurations[0].startDate, timelineDuration.startDate, timelineDuration.endDate) * 100;
    const timelineTotalMilliseconds = (0, $36Dty.getTotalMilliseconds)(timelineDuration);
    return columnDurations.map((columnDuration)=>{
        const width = (0, $36Dty.getTotalMilliseconds)(columnDuration) / timelineTotalMilliseconds * 100;
        left += width;
        return [
            left - width,
            100 - left
        ];
    });
});
const $f7b50cc85e82a38c$export$ce237023318dfe05 = (0, $5iWql.default)((today, columnDurations)=>{
    let todayColumnIndex = 0;
    columnDurations.some(({ startDate: startDate, endDate: endDate })=>{
        if (today >= startDate && today < endDate) return true;
        todayColumnIndex += 1;
        return false;
    });
    return todayColumnIndex;
});

});

parcelRegister("eXnWS", function(module, exports) {

$parcel$export(module.exports, "getPosition", () => $fe27539585f6e8f9$export$1690e12b840569b9);

var $5iWql = parcelRequire("5iWql");

var $36Dty = parcelRequire("36Dty");
const $fe27539585f6e8f9$export$1690e12b840569b9 = (0, $5iWql.default)((date, timelineDuration)=>(date - timelineDuration.startDate) / (0, $36Dty.getTotalMilliseconds)(timelineDuration) * 100);

});

parcelRegister("jsu2J", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f6a40c6616380ee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $4q38b = parcelRequire("4q38b");
function $2f6a40c6616380ee$var$ColumnsOverlay({ columnPositions: columnPositions, endPosition: endPosition, startPosition: startPosition }) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f6a40c6616380ee$var$Container, null, endPosition < 100 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f6a40c6616380ee$var$GreyOverlay, {
        left: endPosition,
        right: 0,
        isDarkMode: isDarkMode
    }), startPosition > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f6a40c6616380ee$var$GreyOverlay, {
        left: 0,
        right: 100 - startPosition,
        isDarkMode: isDarkMode
    }), columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f6a40c6616380ee$var$Column, {
            key: index,
            left: left,
            right: right
        })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f6a40c6616380ee$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1e0c1txw _1bsb1osq _4t3i1osq _1pbykb7n _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $2f6a40c6616380ee$var$secondaryBorder = `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f6a40c6616380ee$var$Column = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, right: right, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_15yv70l": (0, $9t7rW.default)(`${__cmplp.left.toFixed(2)}%`),
            "--_7tf0pk": (0, $9t7rW.default)(`${__cmplp.right.toFixed(2)}%`),
            "--_1p5ufam": (0, $9t7rW.default)($2f6a40c6616380ee$var$secondaryBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ltv1uqs _1xi211gj _kqswstnw _154iidpf _94n5idpf _16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _vov91hum",
            __cmplp.className
        ])
    });
});
const $2f6a40c6616380ee$var$GreyOverlay = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, right: right, isDarkMode: isDarkMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_15yv70l": (0, $9t7rW.default)(`${__cmplp.left.toFixed(2)}%`),
            "--_7tf0pk": (0, $9t7rW.default)(`${__cmplp.right.toFixed(2)}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ltv1uqs _1xi211gj _kqswstnw _154iidpf _4t3i1osq",
            __cmplp.isDarkMode ? "_bfhk1pdr" : "_bfhk111p",
            __cmplp.className
        ])
    });
});
var $2f6a40c6616380ee$export$2e2bcd8739ae039 = $2f6a40c6616380ee$var$ColumnsOverlay;

});


parcelRegister("7fxv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0fef885d5076b15$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6FXly = parcelRequire("6FXly");

var $dAx7E = parcelRequire("dAx7E");

var $1fnqm = parcelRequire("1fnqm");

var $cTvDs = parcelRequire("cTvDs");

var $bpFrL = parcelRequire("bpFrL");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c0fef885d5076b15$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTvDs.default), {
        ...props,
        DayCell: (0, $6FXly.default),
        WeekCell: (0, $bpFrL.default),
        MonthCell: (0, $dAx7E.default),
        QuarterCell: (0, $1fnqm.default)
    });

});
parcelRegister("6FXly", function(module, exports) {

$parcel$export(module.exports, "default", () => $7321670335b1bb9b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $EN9B6 = parcelRequire("EN9B6");

var $hI5oG = parcelRequire("hI5oG");

var $94TFJ = parcelRequire("94TFJ");
const $7321670335b1bb9b$var$isSameDate = (dateA, dateB)=>dateA.toDateString() === dateB.toDateString();
const $7321670335b1bb9b$var$DayCell = ({ hours: hours, isHighlightToday: isHighlightToday, date: date, today: today })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7321670335b1bb9b$var$StyledHeader, {
        highlight: isHighlightToday && $7321670335b1bb9b$var$isSameDate(today, date)
    }, (0, $EN9B6.default)(date, 'EEE, MMM do'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7321670335b1bb9b$var$HoursContainer, null, hours.map((hour, dayIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7321670335b1bb9b$var$Hour, {
            key: dayIndex,
            isHighlighted: false
        }, hour))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7321670335b1bb9b$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _19pkidpf",
            __cmplp.className
        ])
    });
});
const $7321670335b1bb9b$var$StyledHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $7321670335b1bb9b$var$Header, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.highlight ? "_syaz8qn4" : "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $7321670335b1bb9b$var$hourWidth = 1 / (24 / (0, $94TFJ.DAY_VIEW_COLUMN_HOUR_INTERVAL)) * 100;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7321670335b1bb9b$var$Hour = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbuovw _11c8qk37 _y3gn1h6o _1i4q1hna _vchhusvi",
            __cmplp.isHighlighted ? "_syaz8qn4" : "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $7321670335b1bb9b$var$HoursContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
var $7321670335b1bb9b$export$2e2bcd8739ae039 = $7321670335b1bb9b$var$DayCell;

});

parcelRegister("dAx7E", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d338b6be5f456bd$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k0kqY = parcelRequire("k0kqY");
function $8d338b6be5f456bd$var$MonthCell(props) {
    const { monthNumber: monthNumber, yearCaption: yearCaption } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8d338b6be5f456bd$var$Header, null, formatMessage((0, $k0kqY.inMonthOrder)[monthNumber]), " ", yearCaption));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d338b6be5f456bd$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _19pkidpf",
            __cmplp.className
        ])
    });
});
$8d338b6be5f456bd$var$MonthCell.defaultProps = {
    yearCaption: null
};
var $8d338b6be5f456bd$export$2e2bcd8739ae039 = $8d338b6be5f456bd$var$MonthCell;

});
parcelRegister("k0kqY", function(module, exports) {

$parcel$export(module.exports, "inWeekOrder", () => $717d1049a975b41f$export$b7dd7c64470aa506);
$parcel$export(module.exports, "inMonthOrder", () => $717d1049a975b41f$export$12c2656d1700ed6e);
$parcel$export(module.exports, "inQuarterOrder", () => $717d1049a975b41f$export$62f5e462247f69c8);

var $90IgZ = parcelRequire("90IgZ");
const $717d1049a975b41f$var$messages = (0, $90IgZ.defineMessages)({
    january: {
        "id": "deployments.common.components.table.components.chart.header-cells.january",
        "defaultMessage": "Jan"
    },
    february: {
        "id": "deployments.common.components.table.components.chart.header-cells.february",
        "defaultMessage": "Feb"
    },
    march: {
        "id": "deployments.common.components.table.components.chart.header-cells.march",
        "defaultMessage": "Mar"
    },
    april: {
        "id": "deployments.common.components.table.components.chart.header-cells.april",
        "defaultMessage": "Apr"
    },
    may: {
        "id": "deployments.common.components.table.components.chart.header-cells.may",
        "defaultMessage": "May"
    },
    june: {
        "id": "deployments.common.components.table.components.chart.header-cells.june",
        "defaultMessage": "Jun"
    },
    july: {
        "id": "deployments.common.components.table.components.chart.header-cells.july",
        "defaultMessage": "Jul"
    },
    august: {
        "id": "deployments.common.components.table.components.chart.header-cells.august",
        "defaultMessage": "Aug"
    },
    september: {
        "id": "deployments.common.components.table.components.chart.header-cells.september",
        "defaultMessage": "Sep"
    },
    october: {
        "id": "deployments.common.components.table.components.chart.header-cells.october",
        "defaultMessage": "Oct"
    },
    november: {
        "id": "deployments.common.components.table.components.chart.header-cells.november",
        "defaultMessage": "Nov"
    },
    december: {
        "id": "deployments.common.components.table.components.chart.header-cells.december",
        "defaultMessage": "Dec"
    },
    monday: {
        "id": "deployments.common.components.table.components.chart.header-cells.monday",
        "defaultMessage": "M"
    },
    tuesday: {
        "id": "deployments.common.components.table.components.chart.header-cells.tuesday",
        "defaultMessage": "T"
    },
    wednesday: {
        "id": "deployments.common.components.table.components.chart.header-cells.wednesday",
        "defaultMessage": "W"
    },
    thursday: {
        "id": "deployments.common.components.table.components.chart.header-cells.thursday",
        "defaultMessage": "T"
    },
    friday: {
        "id": "deployments.common.components.table.components.chart.header-cells.friday",
        "defaultMessage": "F"
    },
    saturday: {
        "id": "deployments.common.components.table.components.chart.header-cells.saturday",
        "defaultMessage": "S"
    },
    sunday: {
        "id": "deployments.common.components.table.components.chart.header-cells.sunday",
        "defaultMessage": "S"
    }
});
const $717d1049a975b41f$export$b7dd7c64470aa506 = [
    $717d1049a975b41f$var$messages.monday,
    $717d1049a975b41f$var$messages.tuesday,
    $717d1049a975b41f$var$messages.wednesday,
    $717d1049a975b41f$var$messages.thursday,
    $717d1049a975b41f$var$messages.friday,
    $717d1049a975b41f$var$messages.saturday,
    $717d1049a975b41f$var$messages.sunday
];
const $717d1049a975b41f$export$12c2656d1700ed6e = [
    $717d1049a975b41f$var$messages.january,
    $717d1049a975b41f$var$messages.february,
    $717d1049a975b41f$var$messages.march,
    $717d1049a975b41f$var$messages.april,
    $717d1049a975b41f$var$messages.may,
    $717d1049a975b41f$var$messages.june,
    $717d1049a975b41f$var$messages.july,
    $717d1049a975b41f$var$messages.august,
    $717d1049a975b41f$var$messages.september,
    $717d1049a975b41f$var$messages.october,
    $717d1049a975b41f$var$messages.november,
    $717d1049a975b41f$var$messages.december
];
const $717d1049a975b41f$export$62f5e462247f69c8 = [
    {
        startMonth: $717d1049a975b41f$var$messages.january,
        endMonth: $717d1049a975b41f$var$messages.march
    },
    {
        startMonth: $717d1049a975b41f$var$messages.april,
        endMonth: $717d1049a975b41f$var$messages.june
    },
    {
        startMonth: $717d1049a975b41f$var$messages.july,
        endMonth: $717d1049a975b41f$var$messages.september
    },
    {
        startMonth: $717d1049a975b41f$var$messages.october,
        endMonth: $717d1049a975b41f$var$messages.december
    }
];
var $717d1049a975b41f$export$2e2bcd8739ae039 = $717d1049a975b41f$var$messages;

});


parcelRegister("1fnqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $514b872ad90c7875$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k0kqY = parcelRequire("k0kqY");
function $514b872ad90c7875$var$QuarterCell(props) {
    const { quarterNumber: quarterNumber, yearCaption: yearCaption } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { startMonth: startMonth, endMonth: endMonth } = (0, $k0kqY.inQuarterOrder)[quarterNumber];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($514b872ad90c7875$var$Header, null, `${formatMessage(startMonth)} \u{2013} ${formatMessage(endMonth)}`, " ", yearCaption));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $514b872ad90c7875$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _19pkidpf",
            __cmplp.className
        ])
    });
});
$514b872ad90c7875$var$QuarterCell.defaultProps = {
    yearCaption: null
};
var $514b872ad90c7875$export$2e2bcd8739ae039 = $514b872ad90c7875$var$QuarterCell;

});

parcelRegister("cTvDs", function(module, exports) {

$parcel$export(module.exports, "default", () => $21b0ab0e5095094b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $gsGpO = parcelRequire("gsGpO");

var $1nxOb = parcelRequire("1nxOb");

var $dvpld = parcelRequire("dvpld");

var $8ZA5i = parcelRequire("8ZA5i");

var $1P0vT = parcelRequire("1P0vT");
const { DAYS: $21b0ab0e5095094b$var$DAYS, WEEKS: $21b0ab0e5095094b$var$WEEKS, MONTHS: $21b0ab0e5095094b$var$MONTHS, QUARTERS: $21b0ab0e5095094b$var$QUARTERS } = (0, $gsGpO.TimelineModeOptions);
// eslint-disable-next-line jira/react/no-class-components
class $21b0ab0e5095094b$var$HeaderCells extends (0, $eUqFw.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.whyDidYouRender = true;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.today !== nextProps.today) {
            this.dayCellElement = undefined;
            this.weekCellElement = undefined;
            this.monthCellElement = undefined;
            this.quarterCellElement = undefined;
        }
    }
    renderDayCells(columnPositions) {
        const { today: today, columnDurations: columnDurations, DayCell: DayCell, isHighlightToday: isHighlightToday } = this.props;
        const columnHours = (0, $1P0vT.getColumnHours)(columnDurations);
        this.dayCellElement = columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21b0ab0e5095094b$var$Container, {
                key: index,
                left: left,
                right: right
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DayCell, {
                isHighlightToday: isHighlightToday,
                hours: columnHours[index],
                date: columnDurations[index].startDate,
                today: today
            })));
        return this.dayCellElement;
    }
    renderWeekCells(columnPositions) {
        const { today: today, columnDurations: columnDurations, WeekCell: WeekCell, isHighlightToday: isHighlightToday, timelineDuration: timelineDuration } = this.props;
        const todayCoordinates = isHighlightToday && (0, $1P0vT.isDateWithinTimelineDuration)(today, timelineDuration) ? (0, $1P0vT.getTodayCoordinates)(today, columnDurations) : undefined;
        const columnWeekNumbers = (0, $1P0vT.getColumnWeekNumbers)(columnDurations);
        const currentMonth = (0, $1nxOb.getCurrentMonth)(today);
        const yearCaptions = (0, $1P0vT.getColumnYearCaptions)(today, columnDurations);
        this.weekCellElement = columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21b0ab0e5095094b$var$Container, {
                key: index,
                left: left,
                right: right
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WeekCell, {
                columnIndex: index,
                isHighlightToday: isHighlightToday,
                // @ts-expect-error - TS2322 - Type 'readonly [number, number] | undefined' is not assignable to type '[number, number] | undefined'.
                todayCoordinates: todayCoordinates,
                weekNumbers: columnWeekNumbers[index],
                currentMonth: currentMonth,
                yearCaption: yearCaptions[index]
            })));
        return this.weekCellElement;
    }
    renderMonthCells(columnPositions) {
        const { today: today, columnDurations: columnDurations, MonthCell: MonthCell } = this.props;
        const columnMonthNumbers = (0, $1P0vT.getColumnMonthNumbers)(columnDurations);
        const yearCaptions = (0, $1P0vT.getColumnYearCaptions)(today, columnDurations);
        this.monthCellElement = columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21b0ab0e5095094b$var$Container, {
                key: index,
                left: left,
                right: right
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MonthCell, {
                monthNumber: columnMonthNumbers[index],
                yearCaption: yearCaptions[index]
            })));
        return this.monthCellElement;
    }
    renderQuarterCells(columnPositions) {
        const { today: today, columnDurations: columnDurations, QuarterCell: QuarterCell } = this.props;
        const columnQuarterNumbers = (0, $1P0vT.getColumnQuarterNumbers)(columnDurations);
        const yearCaptions = (0, $1P0vT.getColumnYearCaptions)(today, columnDurations);
        this.quarterCellElement = columnPositions.map(([left, right], index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21b0ab0e5095094b$var$Container, {
                key: index,
                left: left,
                right: right
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(QuarterCell, {
                quarterNumber: columnQuarterNumbers[index],
                yearCaption: yearCaptions[index]
            })));
        return this.quarterCellElement;
    }
    renderColumnsForMode() {
        const { timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations } = this.props;
        const columnPositions = (0, $dvpld.getColumnPositions)(timelineDuration, columnDurations);
        if (timelineMode === $21b0ab0e5095094b$var$DAYS) return this.dayCellElement || this.renderDayCells(columnPositions);
        if (timelineMode === $21b0ab0e5095094b$var$WEEKS) return this.weekCellElement || this.renderWeekCells(columnPositions);
        if (timelineMode === $21b0ab0e5095094b$var$MONTHS) return this.monthCellElement || this.renderMonthCells(columnPositions);
        if (timelineMode === $21b0ab0e5095094b$var$QUARTERS) return this.quarterCellElement || this.renderQuarterCells(columnPositions);
        throw Error('mode not found');
    }
    render() {
        const { timelineWindow: timelineWindow, timelineDuration: timelineDuration, columnDurations: columnDurations } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($21b0ab0e5095094b$var$CellsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZA5i.default), {
            timelineWindow: timelineWindow,
            timelineDuration: timelineDuration,
            columnDurations: columnDurations
        }), this.renderColumnsForMode());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21b0ab0e5095094b$var$CellsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $21b0ab0e5095094b$var$secondaryBorder = `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $21b0ab0e5095094b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, right: right, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_4mu95x": (0, $9t7rW.default)(__cmplp.left.toFixed(2), "%"),
            "--_11zw10e": (0, $9t7rW.default)(__cmplp.right.toFixed(2), "%"),
            "--_1p5ufam": (0, $9t7rW.default)($21b0ab0e5095094b$var$secondaryBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ltvjhlj _1xi21xjo _kqswstnw _154iidpf _94n5idpf _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _vchhusvi _vov91hum",
            __cmplp.className
        ])
    });
});
var $21b0ab0e5095094b$export$2e2bcd8739ae039 = $21b0ab0e5095094b$var$HeaderCells;

});
parcelRegister("1P0vT", function(module, exports) {

$parcel$export(module.exports, "getColumnMonthNumbers", () => $e4575f8f846adeaa$export$2db9691736ad99a0);
$parcel$export(module.exports, "getColumnQuarterNumbers", () => $e4575f8f846adeaa$export$f8f2585f7189f116);
$parcel$export(module.exports, "getColumnYearCaptions", () => $e4575f8f846adeaa$export$318e116da7ff1363);
$parcel$export(module.exports, "getColumnHours", () => $e4575f8f846adeaa$export$37b637579d97036a);
$parcel$export(module.exports, "getColumnWeekNumbers", () => $e4575f8f846adeaa$export$a1fb8a69eea17cba);
$parcel$export(module.exports, "getTodayCoordinates", () => $e4575f8f846adeaa$export$1c186d1bc45d38b7);
$parcel$export(module.exports, "isDateWithinTimelineDuration", () => $e4575f8f846adeaa$export$35158457a2b83dcf);

var $6wqPF = parcelRequire("6wqPF");
var $aiENI = parcelRequire("aiENI");
var $gzNmz = parcelRequire("gzNmz");
var $b2bbj = parcelRequire("b2bbj");
var $fU1L0 = parcelRequire("fU1L0");

var $5iWql = parcelRequire("5iWql");

var $1nxOb = parcelRequire("1nxOb");

var $94TFJ = parcelRequire("94TFJ");

var $dvpld = parcelRequire("dvpld");
const $e4575f8f846adeaa$export$2db9691736ad99a0 = (0, $5iWql.default)((columnDurations)=>// Months are 0 indexed by date-fns
    columnDurations.map((columnDuration)=>(0, $gzNmz.default)(columnDuration.startDate)));
const $e4575f8f846adeaa$export$f8f2585f7189f116 = (0, $5iWql.default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, $b2bbj.default)(columnDuration.startDate) - 1));
const $e4575f8f846adeaa$export$318e116da7ff1363 = (0, $5iWql.default)((today, columnDurations)=>{
    const currentYear = (0, $1nxOb.getCurrentYear)(today);
    return columnDurations.map((columnDuration)=>{
        const yearNumber = (0, $fU1L0.default)(columnDuration.startDate);
        return currentYear !== yearNumber ? `'${yearNumber.toString().slice(2)}` : undefined;
    });
});
const $e4575f8f846adeaa$export$37b637579d97036a = (0, $5iWql.default)((columnDurations)=>columnDurations.map(()=>{
        const hoursArray = [
            ...new Array(24 / (0, $94TFJ.DAY_VIEW_COLUMN_HOUR_INTERVAL))
        ];
        const dayNumbers = hoursArray.map((element, i)=>i * (0, $94TFJ.DAY_VIEW_COLUMN_HOUR_INTERVAL));
        return dayNumbers;
    }));
const $e4575f8f846adeaa$export$a1fb8a69eea17cba = (0, $5iWql.default)((columnDurations)=>columnDurations.map((columnDuration)=>{
        const { startDate: startDate } = columnDuration;
        const daysArray = [
            ...new Array(7)
        ];
        const weekNumbers = daysArray.map((element, i)=>{
            const columnMoment = (0, $6wqPF.default)(startDate, i);
            return {
                day: (0, $aiENI.default)(columnMoment),
                month: (0, $gzNmz.default)(columnMoment)
            };
        });
        return weekNumbers;
    }));
const $e4575f8f846adeaa$export$1c186d1bc45d38b7 = (0, $5iWql.default)((today, columnDurations)=>{
    let todayDayIndex = 0;
    const todayNumber = (0, $aiENI.default)(today);
    const todayColumnIndex = (0, $dvpld.getTodayColumnIndex)(today, columnDurations);
    const weekNumbers = $e4575f8f846adeaa$export$a1fb8a69eea17cba(columnDurations);
    weekNumbers[todayColumnIndex].forEach((weekNumber, index)=>{
        if (weekNumber.day === todayNumber) todayDayIndex = index;
    });
    return [
        todayColumnIndex,
        todayDayIndex
    ];
});
const $e4575f8f846adeaa$export$35158457a2b83dcf = (date, timelineDuration)=>date >= timelineDuration.startDate && date <= timelineDuration.endDate;

});


parcelRegister("bpFrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $16dca19164db19aa$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $k0kqY = parcelRequire("k0kqY");
function $16dca19164db19aa$var$WeekCell(props) {
    const { columnIndex: columnIndex, weekNumbers: weekNumbers, todayCoordinates: todayCoordinates, yearCaption: yearCaption, isHighlightToday: isHighlightToday } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // For the weeks granularity, the 4th day of the week determines the month that week falls in
    const monthNumber = weekNumbers[3].month;
    const todayIndex = weekNumbers.findIndex((element, i)=>isHighlightToday && todayCoordinates && todayCoordinates[0] === columnIndex && todayCoordinates[1] === i);
    const isCurrentWeek = todayIndex >= 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16dca19164db19aa$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "span",
        level: "h100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16dca19164db19aa$var$StyledHeader, {
        currentWeek: isCurrentWeek
    }, formatMessage((0, $k0kqY.inMonthOrder)[monthNumber]), " ", yearCaption))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16dca19164db19aa$var$DaysContainer, {
        todayIndex: todayIndex
    }, weekNumbers.map(({ day: day }, dayIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($16dca19164db19aa$var$Day, {
            isHighlighted: dayIndex === todayIndex,
            key: dayIndex
        }, `${formatMessage((0, $k0kqY.inWeekOrder)[dayIndex])} ${day}`))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16dca19164db19aa$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16dca19164db19aa$var$StyledHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { currentWeek: currentWeek, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _19pkidpf",
            __cmplp.currentWeek ? "_syaz8qn4" : "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $16dca19164db19aa$var$dayWidth = 1 / 7 * 100;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $16dca19164db19aa$var$Day = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb14zn _11c8qk37 _y3gn1h6o _1i4q1hna _vchhusvi _19bvutpp _u5f3utpp",
            __cmplp.isHighlighted ? "_syaz8qn4" : "_syaz1rc1",
            __cmplp.className
        ])
    });
});
const $16dca19164db19aa$var$DaysContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
$16dca19164db19aa$var$WeekCell.defaultProps = {
    yearCaption: null
};
var $16dca19164db19aa$export$2e2bcd8739ae039 = $16dca19164db19aa$var$WeekCell;

});


parcelRegister("gX8FC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e19cf4d8718b089$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $hFmdR = parcelRequire("hFmdR");

var $8un0w = parcelRequire("8un0w");

var $23Jil = parcelRequire("23Jil");
var $2e19cf4d8718b089$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)('issue'), (0, $8un0w.default)({
    onItemClick: 'issue'
}))((0, $23Jil.default));

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("23Jil", function(module, exports) {

$parcel$export(module.exports, "default", () => $333633a25fb68ce4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eGI9v = parcelRequire("eGI9v");

var $5vuGW = parcelRequire("5vuGW");

var $5GPm9 = parcelRequire("5GPm9");
// eslint-disable-next-line jira/react/no-class-components
class $333633a25fb68ce4$var$RoadmapChartItems extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            items: [],
            expandedItems: {},
            onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    render() {
        const { items: items, expandedItems: expandedItems, activeLevel: activeLevel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5vuGW.default), {
            items: items,
            expandedItems: expandedItems,
            activeLevel: activeLevel,
            renderItem: this.renderItem
        });
    }
    constructor(...args){
        super(...args);
        this.renderItem = (item, { parentId: parentId })=>{
            const { timelineMode: timelineMode, timelineDuration: timelineDuration, components: components, isSelectEnabled: isSelectEnabled, isHoverEnabled: isHoverEnabled, onItemClick: onItemClick, itemHeight: itemHeight } = this.props;
            const { id: id, level: level } = item;
            const getPositionFromDate = (0, $5GPm9.getPositionFromDateFn)(timelineDuration.startDate, timelineDuration.endDate, timelineMode);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.ChartItem, {
                key: id,
                id: id,
                parentId: parentId,
                level: level,
                timelineMode: timelineMode,
                timelineDuration: timelineDuration,
                itemHeight: itemHeight,
                isSelectEnabled: isSelectEnabled,
                isHoverEnabled: isHoverEnabled,
                getPositionFromDate: getPositionFromDate,
                onClick: onItemClick,
                Bar: components.Bar
            });
        };
    }
}
var $333633a25fb68ce4$export$2e2bcd8739ae039 = (0, $eGI9v.default)('bar', {
    onItemClick: 'clicked'
})($333633a25fb68ce4$var$RoadmapChartItems);

});
parcelRegister("5vuGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b62fbf79c6f89445$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $jX8uM = parcelRequire("jX8uM");

var $5kSiY = parcelRequire("5kSiY");
const $b62fbf79c6f89445$var$defaultRenderItemContainer = (item, meta, index, children)=>children;
/* A centralised component that encapsulates the logic for flattening the item hierarchy
 * so its' structure can be shared between the list and the chart. Metadata is derived from
 * the structure and passed to each item to retain the context of the hierarchy.
 */ // eslint-disable-next-line jira/react/no-class-components
class $b62fbf79c6f89445$var$FlatItems extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            renderItemContainer: $b62fbf79c6f89445$var$defaultRenderItemContainer
        };
    }
    render() {
        const { items: items, expandedItems: expandedItems, activeLevel: activeLevel, renderItem: renderItem, renderItemContainer: renderItemContainer } = this.props;
        const enrichedItems = (0, $5kSiY.getHierarchyEnrichedItems)(items, expandedItems, activeLevel);
        const itemContainerMeta = {
            lastItemIndex: (0, $jX8uM.getLastTopLevelFlatIndex)(items, expandedItems)
        };
        const flatItemElements = [];
        enrichedItems.forEach((enrichedItem)=>{
            // Group an item and its children inside a container element
            if (enrichedItem.type === (0, $551ff1441727f2b6$export$e0a522cf395aec9b)) {
                const { item: item, childItems: childItems, meta: meta, flatIndex: flatIndex } = enrichedItem;
                const itemContainerChildren = [
                    renderItem(item, meta, flatIndex)
                ];
                childItems.forEach((childItem)=>{
                    itemContainerChildren.push(// @ts-expect-error - TS2345 - Argument of type 'GenericChildItem' is not assignable to parameter of type 'ChildItemType | ItemType'.
                    renderItem(childItem.item, childItem.meta, childItem.flatIndex));
                });
                flatItemElements.push(renderItemContainer(item, itemContainerMeta, flatIndex, itemContainerChildren));
            }
        });
        return flatItemElements;
    }
}
var $b62fbf79c6f89445$export$2e2bcd8739ae039 = $b62fbf79c6f89445$var$FlatItems;

});
const $551ff1441727f2b6$export$e0a522cf395aec9b = 'ITEM_TYPE';
const $551ff1441727f2b6$export$a0e7fecde97f31f9 = 'CHILD_ITEM_TYPE';

parcelRegister("jX8uM", function(module, exports) {

$parcel$export(module.exports, "getLastTopLevelFlatIndex", () => $3c5bc0cb76014118$export$ec2a8201cfc6df1d);

var $5iWql = parcelRequire("5iWql");
const $3c5bc0cb76014118$export$ec2a8201cfc6df1d = (0, $5iWql.default)((items, expandedItems)=>{
    if (items.length === 0) return 0;
    const lastTopLevelItem = items[items.length - 1];
    const lastIndex = items.reduce((count, item)=>count + 1 + (expandedItems[item.id] ? item.childItems.length : 0), -1);
    if (expandedItems[lastTopLevelItem.id]) return lastIndex - lastTopLevelItem.childItems.length;
    return lastIndex;
});

});

parcelRegister("5kSiY", function(module, exports) {

$parcel$export(module.exports, "getHierarchyEnrichedItems", () => $97f831f6976ebebf$export$29090c866cb2cf07);

const $97f831f6976ebebf$var$enrichChildItem = (item, parentItem, rootIndex, flatIndex)=>({
        type: (0, $551ff1441727f2b6$export$a0e7fecde97f31f9),
        item: item,
        meta: {
            parentId: parentItem.id,
            isParent: false,
            isExpanded: false
        },
        flatIndex: flatIndex
    });
const $97f831f6976ebebf$var$enrichItem = (item, childItems, expandedItems, rootIndex, flatIndex)=>({
        type: (0, $551ff1441727f2b6$export$e0a522cf395aec9b),
        item: item,
        childItems: childItems,
        meta: {
            parentId: undefined,
            isParent: item.childItems.length > 0,
            isExpanded: Boolean(expandedItems[item.id])
        },
        flatIndex: flatIndex
    });
const $97f831f6976ebebf$export$29090c866cb2cf07 = (items, expandedItems, _activeLevel)=>{
    const enrichedItems = [];
    // Represents the position of an item if the tree was flattened
    let flatIndex = 0;
    items.forEach((item, rootIndex)=>{
        const { id: id, childItems: childItems } = item;
        const flatParentIndex = flatIndex;
        const enrichedChildItems = [];
        /* Increase the index to account for the parent item, which will inserted first,
		 * but requires the child items to be generated beforehand.
		 */ flatIndex += 1;
        // Child items are only visible if their parent has been expanded
        if (expandedItems[id]) childItems.forEach((childItem)=>{
            enrichedChildItems.push($97f831f6976ebebf$var$enrichChildItem(childItem, item, rootIndex, flatIndex));
            flatIndex += 1;
        });
        const enrichedItem = $97f831f6976ebebf$var$enrichItem(item, enrichedChildItems, expandedItems, rootIndex, flatParentIndex);
        enrichedItems.push(enrichedItem);
    });
    return enrichedItems;
};

});




parcelRegister("3qVaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $633925dd67c56bf7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $eEVEv = parcelRequire("eEVEv");

var $7E5Lc = parcelRequire("7E5Lc");

var $e0dS9 = parcelRequire("e0dS9");

var $5GPm9 = parcelRequire("5GPm9");

var $4j6Z7 = parcelRequire("4j6Z7");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $633925dd67c56bf7$var$HiddenScrollbarPanel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { scrollbarSize: scrollbarSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dpmgq9-": (0, $9t7rW.default)(__cmplp.scrollbarSize, "px", "-")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _1ltvidpf _94n5idpf _1reo15zi _18m915zi",
            __cmplp.scrollbarSize > 0 && "_1xi2dgz0 _94n5dgz0",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$SynchronizedScrollbar = (0, $7E5Lc.default)($633925dd67c56bf7$var$HiddenScrollbarPanel, {
    syncAxis: 'y',
    isCompiledComponent: true
});
// eslint-disable-next-line jira/react/no-class-components
class $633925dd67c56bf7$var$Chart extends (0, $eUqFw.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.whyDidYouRender = true;
    }
    static{
        this.defaultProps = {
            isSelectEnabled: true,
            isHoverEnabled: false,
            isHighlightToday: true,
            isHideScrollbar: false,
            items: [],
            expandedItems: {},
            onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onTimelineUpdated: undefined
        };
    }
    // invalidate cached ColumnsOverlay when today changes
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.today !== nextProps.today) this.columnsOverlayElements = {};
    }
    renderHeader() {
        const { today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, isHighlightToday: isHighlightToday, ChartHeader: ChartHeader, onTimelineUpdated: onTimelineUpdated, timelineDefaultPosition: timelineDefaultPosition, HeaderCells: HeaderCells, timelineWindow: timelineWindow } = this.props;
        const columnDurations = (0, $eEVEv.getColumnDurationsByDateRange)(timelineMode, timelineDuration);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChartHeader, {
            width: (0, $5GPm9.getTimelineWidth)(timelineMode, timelineDuration),
            isHighlightToday: isHighlightToday,
            columnDurations: columnDurations,
            timelineDuration: timelineDuration,
            timelineMode: timelineMode,
            timelineWindow: timelineWindow,
            onTimelineUpdated: onTimelineUpdated,
            today: today,
            timelineDefaultPosition: timelineDefaultPosition,
            HeaderCells: HeaderCells
        });
    }
    renderTimeline() {
        const { items: items, expandedItems: expandedItems, activeLevel: activeLevel, timelineMode: timelineMode, timelineWindow: timelineWindow, timelineDuration: timelineDuration, timelineDefaultPosition: timelineDefaultPosition, components: components, isSelectEnabled: isSelectEnabled, isHoverEnabled: isHoverEnabled, onItemClick: onItemClick, ColumnsOverlay: ColumnsOverlay, Items: Items, listWidth: listWidth, itemHeight: itemHeight } = this.props;
        if (!this.columnsOverlayElements[timelineMode]) {
            const columnDurations = (0, $eEVEv.getColumnDurationsByDateRange)(timelineMode, timelineDuration);
            this.columnsOverlayElements[timelineMode] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ColumnsOverlay, {
                timelineWindow: timelineWindow,
                timelineDuration: timelineDuration,
                columnDurations: columnDurations
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$Timeline, {
            width: (0, $5GPm9.getTimelineWidth)(timelineMode, timelineDuration)
        }, this.columnsOverlayElements[timelineMode], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$OverlayContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.ChartOverlay, {
            timelineWindow: timelineWindow,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$ItemsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Items, {
            items: items,
            expandedItems: expandedItems,
            listWidth: listWidth,
            itemHeight: itemHeight,
            activeLevel: activeLevel,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineDefaultPosition: timelineDefaultPosition,
            components: {
                ChartItem: components.ChartItem,
                Bar: components.Bar
            },
            isSelectEnabled: isSelectEnabled,
            isHoverEnabled: isHoverEnabled,
            onItemClick: onItemClick
        }), items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$ItemsBottomPadding, null)));
    }
    render() {
        const { timelineDuration: timelineDuration, timelineDefaultPosition: timelineDefaultPosition, isHideScrollbar: isHideScrollbar, components: components, items: items, timelineMode: timelineMode } = this.props;
        const getPositionFromDate = (0, $5GPm9.getPositionFromDateFn)(timelineDuration.startDate, timelineDuration.endDate, timelineMode);
        const scrollbarSize = (0, $e0dS9.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$ChartContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$BorderShadow, null), this.renderHeader(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$ChartBodyContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$ChartOverlayVerticalSyncContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$SynchronizedScrollbar, {
            scrollbarSize: scrollbarSize
        }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.ChartIndicators, {
                key: item.id,
                id: item.id,
                getPositionFromDate: getPositionFromDate
            })), items.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$ItemsBottomPadding, {
            invisible: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4j6Z7.default), {
            timelineDefaultPosition: timelineDefaultPosition,
            isHideScrollbar: isHideScrollbar
        }, this.renderTimeline()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($633925dd67c56bf7$var$LegendContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.Legend, null))));
    }
    constructor(...args){
        super(...args);
        this.columnsOverlayElements = {};
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $633925dd67c56bf7$var$ItemsBottomPadding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invisible: invisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3icmky _bfhk15cr _kqswh2mm",
            __cmplp.invisible ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$ChartContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1bsb1osq _1reo15vq _18m915vq _2rko1wxp _1tkeidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$ChartBodyContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $633925dd67c56bf7$var$Timeline = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1efm _kqswh2mm _1tke1osq",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$OverlayContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _lcxvglyw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbycs5v",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$ItemsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1ph8",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$LegendContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _94n5utpp _1xi2utpp _1pbyl7yj _c71l1osq _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$ChartOverlayVerticalSyncContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbyqfx8 _1bsb1osq _4t3i1osq _1reo15vq _18m915vq _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $633925dd67c56bf7$var$BorderShadow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pbyqfx8 _1bsb1l7b _154iidpf _94n5idpf _4t3i1osq _1s7z2bfg _11q714e5 _t9ecuifj",
            __cmplp.className
        ])
    });
});
var $633925dd67c56bf7$export$2e2bcd8739ae039 = $633925dd67c56bf7$var$Chart;

});
parcelRegister("eEVEv", function(module, exports) {

$parcel$export(module.exports, "getColumnDurationsByDateRange", () => $b740cb735febaa32$export$1017944bf6471979);

var $6wqPF = parcelRequire("6wqPF");
var $kG69s = parcelRequire("kG69s");
var $5STnX = parcelRequire("5STnX");
var $kqUc2 = parcelRequire("kqUc2");
var $7n7Dc = parcelRequire("7n7Dc");
var $6EHSB = parcelRequire("6EHSB");
var $3sYr7 = parcelRequire("3sYr7");
var $6WQhi = parcelRequire("6WQhi");
var $c05Om = parcelRequire("c05Om");
var $3jYzf = parcelRequire("3jYzf");
var $dnnKy = parcelRequire("dnnKy");
var $5H0DO = parcelRequire("5H0DO");
var $jqhqi = parcelRequire("jqhqi");
var $1HEy1 = parcelRequire("1HEy1");

var $5iWql = parcelRequire("5iWql");

var $gsGpO = parcelRequire("gsGpO");
const { DAYS: $b740cb735febaa32$var$DAYS, WEEKS: $b740cb735febaa32$var$WEEKS, QUARTERS: $b740cb735febaa32$var$QUARTERS, MONTHS: $b740cb735febaa32$var$MONTHS } = (0, $gsGpO.TimelineModeOptions);
const $b740cb735febaa32$var$getColumnDurationsForMode = (timelineDuration, momentIdentifier)=>{
    const columnDurations = [];
    const { startDate: startDate, endDate: endDate } = timelineDuration;
    // Sanitize. We still want to *round* to an ISO week, but you can't *add* an ISO week (it fails silently).
    const momentAddIdentifier = momentIdentifier === 'isoWeek' ? 'week' : momentIdentifier;
    const startOfswitch = (identifierName = 'day')=>{
        const startOfFuncs = {
            day: (0, $3jYzf.default),
            week: (0, $1HEy1.default),
            isoWeek: (0, $dnnKy.default),
            month: (0, $5H0DO.default),
            quarter: (0, $jqhqi.default)
        };
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ day: (date: number | Date) => Date; week: (date: number | Date, options?: { locale?: Locale | undefined; weekStartsOn?: 0 | 1 | 2 | 4 | 3 | 5 | 6 | undefined; } | undefined) => Date; isoWeek: (date: number | Date) => Date; month: (date: number | Date) => Date; quarter: (date: number | Date) => Date; }'.
        return startOfFuncs[identifierName];
    };
    const endOfswitch = (identifierName = 'day')=>{
        const endOfFuncs = {
            day: (0, $7n7Dc.default),
            week: (0, $c05Om.default),
            isoWeek: (0, $6EHSB.default),
            month: (0, $3sYr7.default),
            quarter: (0, $6WQhi.default)
        };
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ day: (date: number | Date) => Date; week: (date: number | Date, options?: { locale?: Locale | undefined; weekStartsOn?: 0 | 1 | 2 | 4 | 3 | 5 | 6 | undefined; } | undefined) => Date; isoWeek: (date: number | Date) => Date; month: (date: number | Date) => Date; quarter: (date: number | Date) => Date; }'.
        return endOfFuncs[identifierName];
    };
    const addTimeSwitch = (identifierName = 'day')=>{
        const addTimeFuncs = {
            day: (0, $6wqPF.default),
            week: (0, $kqUc2.default),
            month: (0, $5STnX.default)
        };
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ day: (date: number | Date, amount: number) => Date; week: (date: number | Date, amount: number) => Date; month: (date: number | Date, amount: number) => Date; }'.
        return addTimeFuncs[identifierName];
    };
    const startOf = startOfswitch(momentIdentifier);
    const endOf = endOfswitch(momentIdentifier);
    let startDateFns = startOf(startDate);
    const addTime = addTimeSwitch(momentAddIdentifier);
    while(startDateFns.valueOf() < endDate){
        const endMoment = (0, $kG69s.default)(endOf(startDateFns), 1);
        columnDurations.push({
            startDate: new Date(startDateFns.valueOf()),
            endDate: new Date(endMoment.valueOf())
        });
        startDateFns = addTime(startDateFns, 1);
    }
    return columnDurations;
};
const $b740cb735febaa32$export$1017944bf6471979 = (0, $5iWql.default)((timelineMode, timelineDuration)=>{
    if (timelineMode === $b740cb735febaa32$var$QUARTERS) return $b740cb735febaa32$var$getColumnDurationsForMode(timelineDuration, 'quarter');
    if (timelineMode === $b740cb735febaa32$var$MONTHS) return $b740cb735febaa32$var$getColumnDurationsForMode(timelineDuration, 'month');
    /* We always want a week column to start on Monday. The 'week' parameter
		 * is locale aware which could start on Sunday. An ISO week on the other
		 * hand always starts on the Monday.
		 */ if (timelineMode === $b740cb735febaa32$var$WEEKS) return $b740cb735febaa32$var$getColumnDurationsForMode(timelineDuration, 'isoWeek');
    if (timelineMode === $b740cb735febaa32$var$DAYS) return $b740cb735febaa32$var$getColumnDurationsForMode(timelineDuration, 'day');
    throw Error('mode not found');
});

});

parcelRegister("4j6Z7", function(module, exports) {

$parcel$export(module.exports, "default", () => $caa10ddff0b808c8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dxIU5 = parcelRequire("dxIU5");

var $9PQaz = parcelRequire("9PQaz");

var $eGMPC = parcelRequire("eGMPC");

var $eJPjg = parcelRequire("eJPjg");

var $2s3Va = parcelRequire("2s3Va");

var $94TFJ = parcelRequire("94TFJ");

var $7E5Lc = parcelRequire("7E5Lc");

var $ebIaA = parcelRequire("ebIaA");

var $e0dS9 = parcelRequire("e0dS9");

var $l6IdI = parcelRequire("l6IdI");
const $caa10ddff0b808c8$var$THUMB_DRAG_THRESHOLD = 0.1;
const $caa10ddff0b808c8$var$requestAnimationFrame = (0, $eGMPC.default)();
// eslint-disable-next-line jira/react/no-class-components
class $caa10ddff0b808c8$var$Scrollbars extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        // ====================== //
        // === EVENT HANDLING === //
        // ====================== //
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.scheduleUpdateCustomScrollParameters();
        }, (0, $94TFJ.RESIZE_DEBOUNCE_MS));
        this.onScroll = ()=>{
            const { horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize } = this.state;
            this.setHorizontalOffset(horizontalThumbSize);
            this.setVerticalOffset(verticalThumbSize);
        };
        this.onDragHorizontalThumb = (from, to)=>this.setScrollLeftFromPosition(to.x);
        this.onStartDragHorizontalThumb = ()=>this.setState({
                isHorizontalThumbBeingDragged: true
            });
        this.onEndDragHorizontalThumb = ()=>this.setState({
                isHorizontalThumbBeingDragged: false
            });
        this.onDragVerticalThumb = (from, to)=>this.setScrollTopFromPosition(to.y);
        this.onStartDragVerticalThumb = ()=>this.setState({
                isVerticalThumbBeingDragged: true
            });
        this.onEndDragVerticalThumb = ()=>this.setState({
                isVerticalThumbBeingDragged: false
            });
        this.onMouseDownHorizontalThumb = (event)=>{
            if (this.horizontalThumbRef) {
                const { left: left } = this.horizontalThumbRef.getBoundingClientRect();
                const relativeMousePosition = event.clientX - left;
                this.horizontalThumbOffset = Math.round(this.state.horizontalThumbSize / 2 - relativeMousePosition);
            } else this.horizontalThumbOffset = 0;
        };
        this.onMouseDownVerticalThumb = (event)=>{
            if (this.verticalThumbRef) {
                const { top: top } = this.verticalThumbRef.getBoundingClientRect();
                const relativeMousePosition = event.clientY - top;
                this.verticalThumbOffset = Math.round(this.state.verticalThumbSize / 2 - relativeMousePosition);
            } else this.verticalThumbOffset = 0;
        };
        this.onMouseDownHorizontalTrack = (event)=>{
            this.horizontalThumbOffset = 0;
            this.setScrollLeftFromPosition(event.pageX);
        };
        this.onMouseDownVerticalTrack = (event)=>{
            this.verticalThumbOffset = 0;
            this.setScrollTopFromPosition(event.pageY);
        };
        // ============ //
        // === REFS === //
        // ============ //
        // eslint-disable-next-line jira/react-no-unneeded-arrow-function-properties
        this.onSetContainerRef = (elem)=>{
            if (elem) this.containerRef = elem;
        };
        this.onSetContentRef = (elem)=>{
            if (elem) this.contentRef = elem;
        };
        this.onSetHorizontalTrackRef = (elem)=>{
            if (elem) this.horizontalTrackRef = elem;
        };
        this.onSetHorizontalThumbRef = (elem)=>{
            if (elem) this.horizontalThumbRef = elem;
        };
        this.onSetVerticalTrackRef = (elem)=>{
            if (elem) this.verticalTrackRef = elem;
        };
        this.onSetVerticalThumbRef = (elem)=>{
            if (elem) this.verticalThumbRef = elem;
        };
        this.onInnerRef = (elem)=>{
            const { setRef: setViewportRef } = this.props;
            setViewportRef(elem);
            this.onSetContainerRef(elem);
        };
        const scrollbarSize = (0, $e0dS9.default)();
        this.state = {
            scrollbarSize: scrollbarSize,
            verticalThumbSize: 0,
            horizontalThumbSize: 0,
            isHorizontalOverflow: false,
            isVerticalOverflow: false,
            isHorizontalThumbBeingDragged: false,
            isVerticalThumbBeingDragged: false
        };
    }
    componentDidMount() {
        if (this.state.scrollbarSize > 0) {
            window.addEventListener('resize', this.onWindowResize);
            // We want to update the dimensions ASAP, before the user sees them
            this.scheduleUpdateCustomScrollParameters();
        }
        // for some unknown reason the VR refuses to scroll the timeline to the right
        // it also breaks the nav indicators so we turn it off the VR tests
        if (!(0, $9PQaz.isVisualRegressionTest)) this.setScrollLeft(this.props.timelineDefaultPosition);
    }
    getSnapshotBeforeUpdate(prevProps) {
        // If children have changed, store their dimensions to check on update
        if (this.contentRef && prevProps.children !== this.props.children) {
            const { clientWidth: clientWidth, clientHeight: clientHeight } = this.contentRef;
            return {
                contentWidth: clientWidth,
                contentHeight: clientHeight
            };
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { timelineDefaultPosition: timelineDefaultPosition } = this.props;
        const { scrollbarSize: scrollbarSize } = this.state;
        // If the children's dimensions have changed, we need to update the scroll parameters
        if (scrollbarSize > 0 && snapshot !== null && this.contentRef) {
            const { clientWidth: clientWidth, clientHeight: clientHeight } = this.contentRef;
            if (clientWidth !== snapshot.contentWidth || clientHeight !== snapshot.contentHeight) this.scheduleUpdateCustomScrollParameters();
        }
        // Each timeline mode has a different default position to scroll to
        if (this.containerRef && timelineDefaultPosition !== prevProps.timelineDefaultPosition) this.setScrollLeft(timelineDefaultPosition);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
    }
    // ========================= //
    // === GETTERS / SETTERS === //
    // ========================= //
    getHorizontalThumbSize() {
        if (!this.containerRef || !this.horizontalTrackRef) throw new Error('An element required to get the horizontal thumb size was null');
        const { scrollWidth: scrollWidth, clientWidth: containerWidth } = this.containerRef;
        const { clientWidth: horizontalTrackWidth } = this.horizontalTrackRef;
        return (0, $l6IdI.getThumbSize)(containerWidth, scrollWidth, horizontalTrackWidth);
    }
    getVerticalThumbSize() {
        if (!this.containerRef || !this.verticalTrackRef) throw new Error('An element required to get the vertical thumb size was null');
        const { scrollHeight: scrollHeight, clientHeight: containerHeight } = this.containerRef;
        const { clientHeight: verticalTrackHeight } = this.verticalTrackRef;
        return (0, $l6IdI.getThumbSize)(containerHeight, scrollHeight, verticalTrackHeight);
    }
    // Get the offset relative to the track for the custom horizontal thumb
    setHorizontalOffset(horizontalThumbSize) {
        if (!this.containerRef || !this.horizontalTrackRef || !this.horizontalThumbRef) throw new Error('An element required to get the horizontal thumb offset was null');
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: containerWidth } = this.containerRef;
        const { clientWidth: horizontalTrackWidth } = this.horizontalTrackRef;
        // Set the style directly, we want to avoid a render cycle of the children
        this.horizontalThumbRef.style.transform = `translateX(${(0, $l6IdI.getThumbOffset)(scrollLeft, scrollWidth, containerWidth, horizontalTrackWidth, horizontalThumbSize)}px)`;
    }
    // Get the offset relative to the track for the custom vertical thumb
    setVerticalOffset(verticalThumbSize) {
        if (!this.containerRef || !this.verticalTrackRef || !this.verticalThumbRef) throw new Error('An element required to get the vertical thumb offset was null');
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: containerHeight } = this.containerRef;
        const { clientHeight: verticalTrackHeight } = this.verticalTrackRef;
        // Set the style directly, we want to avoid a render cycle of the children
        this.verticalThumbRef.style.transform = `translateY(${(0, $l6IdI.getThumbOffset)(scrollTop, scrollHeight, containerHeight, verticalTrackHeight, verticalThumbSize)}px)`;
    }
    // Set the scroll left on the real scrollbar based on a pageX position from click/drag
    setScrollLeftFromPosition(position) {
        if (!this.containerRef || !this.horizontalTrackRef || !this.contentRef) throw new Error('An element required to set the scroll left position was null');
        const { horizontalThumbSize: horizontalThumbSize } = this.state;
        const { clientWidth: contentWidth } = this.contentRef;
        const { left: trackLeft, width: trackWidth } = this.horizontalTrackRef.getBoundingClientRect();
        this.containerRef.scrollLeft = (0, $l6IdI.getScrollFromPosition)(position + this.horizontalThumbOffset, horizontalThumbSize, contentWidth, trackWidth, trackLeft);
    }
    // Set the scroll top on the real scrollbar based on a pageY position from click/drag
    setScrollTopFromPosition(position) {
        if (!this.containerRef || !this.verticalTrackRef || !this.contentRef) throw new Error('An element required to set the scroll top position was null');
        const { verticalThumbSize: verticalThumbSize } = this.state;
        const { clientHeight: contentHeight } = this.contentRef;
        const { top: trackTop, height: trackHeight } = this.verticalTrackRef.getBoundingClientRect();
        this.containerRef.scrollTop = (0, $l6IdI.getScrollFromPosition)(position + this.verticalThumbOffset, verticalThumbSize, contentHeight, trackHeight, trackTop);
    }
    // Not to be confused with setScrollLeftFromPosition. This is for raw offset values.
    setScrollLeft(left) {
        if (this.containerRef) this.containerRef.scrollLeft = left;
    }
    updateCustomScrollParameters() {
        // Track/thumb refs may not be *required* because there may be no overflow
        if (!this.containerRef || !this.contentRef) throw new Error('An element required to get the custom scroll parameters was null');
        const { clientWidth: contentWidth, clientHeight: contentHeight } = this.contentRef;
        const { clientWidth: containerWidth, clientHeight: containerHeight } = this.containerRef;
        let horizontalParameters = {
            isHorizontalOverflow: false
        };
        let verticalParameters = {
            isVerticalOverflow: false
        };
        // Content is wider than viewport
        if (contentWidth > containerWidth) {
            const horizontalThumbSize = this.getHorizontalThumbSize();
            this.setHorizontalOffset(horizontalThumbSize);
            horizontalParameters = {
                ...horizontalParameters,
                horizontalThumbSize: // @ts-expect-error - TS2322 - Type '{ horizontalThumbSize: number; isHorizontalOverflow: true; }' is not assignable to type '{ isHorizontalOverflow: boolean; }'.
                horizontalThumbSize,
                isHorizontalOverflow: true
            };
        }
        // Content is higher than viewport
        if (contentHeight > containerHeight) {
            const verticalThumbSize = this.getVerticalThumbSize();
            this.setVerticalOffset(verticalThumbSize);
            verticalParameters = {
                ...verticalParameters,
                verticalThumbSize: // @ts-expect-error - TS2322 - Type '{ verticalThumbSize: number; isVerticalOverflow: true; }' is not assignable to type '{ isVerticalOverflow: boolean; }'.
                verticalThumbSize,
                isVerticalOverflow: true
            };
        }
        this.setState({
            ...horizontalParameters,
            ...verticalParameters
        });
    }
    scheduleUpdateCustomScrollParameters() {
        $caa10ddff0b808c8$var$requestAnimationFrame(()=>{
            this.updateCustomScrollParameters();
        });
    }
    renderCustomTrack() {
        const { isHideScrollbar: isHideScrollbar } = this.props;
        const { horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize, isHorizontalOverflow: isHorizontalOverflow, isVerticalOverflow: isVerticalOverflow, isHorizontalThumbBeingDragged: isHorizontalThumbBeingDragged, isVerticalThumbBeingDragged: isVerticalThumbBeingDragged } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caa10ddff0b808c8$var$HorizontalTrack, {
            ref: this.onSetHorizontalTrackRef,
            isVisible: isHorizontalOverflow && !isHideScrollbar,
            isTrackThumbBeingDragged: isHorizontalThumbBeingDragged,
            onMouseDown: this.onMouseDownHorizontalTrack
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caa10ddff0b808c8$var$DraggableHorizontalThumb, {
            onDrag: this.onDragHorizontalThumb,
            onDragStart: this.onStartDragHorizontalThumb,
            onDragEnd: this.onEndDragHorizontalThumb,
            size: horizontalThumbSize,
            ref: this.onSetHorizontalThumbRef,
            // @ts-expect-error - TS2322 - Type '(event: MouseEvent) => void' is not assignable to type 'OnMouseDown'.
            onMouseDown: this.onMouseDownHorizontalThumb
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caa10ddff0b808c8$var$VerticalTrack, {
            ref: this.onSetVerticalTrackRef,
            isVisible: isVerticalOverflow && !isHideScrollbar,
            isTrackThumbBeingDragged: isVerticalThumbBeingDragged,
            onMouseDown: this.onMouseDownVerticalTrack
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caa10ddff0b808c8$var$DraggableVerticalThumb, {
            onDrag: this.onDragVerticalThumb,
            onDragStart: this.onStartDragVerticalThumb,
            onDragEnd: this.onEndDragVerticalThumb,
            size: verticalThumbSize,
            ref: this.onSetVerticalThumbRef,
            // @ts-expect-error - TS2322 - Type '(event: MouseEvent) => void' is not assignable to type 'OnMouseDown'.
            onMouseDown: this.onMouseDownVerticalThumb
        })));
    }
    render() {
        const { children: children } = this.props;
        const { scrollbarSize: scrollbarSize } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caa10ddff0b808c8$var$CustomScrollbarsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($caa10ddff0b808c8$var$SynchronizedScrollbar, {
            // @ts-expect-error - Property 'id' does not exist on type 'IntrinsicAttributes & ((Props | Omit<Props & RefAttributes<Component<Props, any, any>>, "ref">) & RefAttributes<...>)'.
            id: (0, $eJPjg.TIMELINE_ID),
            ref: this.onInnerRef,
            scrollbarSize: scrollbarSize,
            onScroll: scrollbarSize > 0 ? this.onScroll : undefined
        }, /*#__PURE__*/ (0, $eUqFw.cloneElement)(children, {
            ref: this.onSetContentRef
        })), scrollbarSize > 0 && this.renderCustomTrack());
    }
}
const $caa10ddff0b808c8$var$CustomScrollbars = (0, $ebIaA.default)($caa10ddff0b808c8$var$Scrollbars);
var $caa10ddff0b808c8$export$2e2bcd8739ae039 = $caa10ddff0b808c8$var$CustomScrollbars;
// =========================== //
// === CUSTOM SCROLL VIEWS === //
// =========================== //
const $caa10ddff0b808c8$var$CUSTOM_SCROLLBAR_SIZE = '10px';
// Stops overlap when scrolled to the end of both tracks
const $caa10ddff0b808c8$var$CUSTOM_SCROLLBAR_OFFSET = '7px';
const $caa10ddff0b808c8$var$baseTrackStyles = null;
const $caa10ddff0b808c8$var$baseThumbStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $caa10ddff0b808c8$var$VerticalTrack = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pby1406 _154i1v6z _94n51v6z _1bsb19bv _1xi2idpf _o7ks1fkz _irr31fy5",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.isTrackThumbBeingDragged && "_ku441fy5",
            __cmplp.className
        ])
    });
});
const $caa10ddff0b808c8$var$HorizontalTrack = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rko19bv _1pby1406 _1xi21v6z _1ltv1v6z _4t3i19bv _94n5idpf _o7ks1fkz _irr31fy5",
            __cmplp.isVisible ? "_3um0ewfl" : "_3um015vq",
            __cmplp.isTrackThumbBeingDragged && "_ku441fy5",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $caa10ddff0b808c8$var$VerticalThumb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $9t7rW.default)(__cmplp.size, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhk70z6 _1bsb1osq _4t3i1vpm",
            __cmplp.className
        ])
    });
});
const $caa10ddff0b808c8$var$HorizontalThumb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $9t7rW.default)(__cmplp.size, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _2rko19bv _bfhk70z6 _4t3i1osq _1bsb1vpm",
            __cmplp.className
        ])
    });
});
const $caa10ddff0b808c8$var$CustomScrollbarsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $caa10ddff0b808c8$var$HiddenScrollbarPanel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { scrollbarSize: scrollbarSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dpmgq9-": (0, $9t7rW.default)(__cmplp.scrollbarSize, "px", "-")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1xi2idpf _1ltvidpf _94n5idpf _1reo15zi _18m915zi",
            __cmplp.scrollbarSize > 0 && "_1xi2dgz0 _94n5dgz0",
            __cmplp.className
        ])
    });
});
const $caa10ddff0b808c8$var$DraggableHorizontalThumb = (0, $2s3Va.default)($caa10ddff0b808c8$var$HorizontalThumb, $caa10ddff0b808c8$var$THUMB_DRAG_THRESHOLD);
const $caa10ddff0b808c8$var$DraggableVerticalThumb = (0, $2s3Va.default)($caa10ddff0b808c8$var$VerticalThumb, $caa10ddff0b808c8$var$THUMB_DRAG_THRESHOLD);
// @ts-expect-error - TS2345 - Argument of type 'ComponentType<{ scrollbarSize: number; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps>' is not assignable to parameter of type 'ComponentType<Props>'
const $caa10ddff0b808c8$var$SynchronizedScrollbar = (0, $7E5Lc.default)($caa10ddff0b808c8$var$HiddenScrollbarPanel, {
    isCompiledComponent: true,
    syncAxis: undefined
});

});
parcelRegister("9PQaz", function(module, exports) {

$parcel$export(module.exports, "isVisualRegressionTest", () => $ee28b1cf4b79f252$export$55bd40a455281847);
/**
 * Will be `true` if the code is running in a visual regression test (go/jira-vr for details).
 *
 * If you're trying to fix animation-related test flakiness, this util is **NOT** what you want.
 * Instead, make sure your code supports the `prefers-reduced-motion` user preference, which is
 * automatically enabled for VR tests.
 *
 * To support `prefers-reduced-motion`, you can either:
 * - Make your animations CSS-driven (in which case global CSS overrides will handle it for you).
 * - Make use of the Atlaskit motion `useIsReducedMotion()` hook.
 */ const $ee28b1cf4b79f252$export$55bd40a455281847 = !false && window?.location ? Boolean(new URL(window.location.href).searchParams.get('eyes-storybook')) : false;

});

parcelRegister("2s3Va", function(module, exports) {

$parcel$export(module.exports, "default", () => $078f9b90189268df$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $kFGm5 = parcelRequire("kFGm5");

var $eGMPC = parcelRequire("eGMPC");
const $078f9b90189268df$var$DEFAULT_DRAG_THRESHOLD = 3;
const $078f9b90189268df$var$DISABLED_DRAG_PROPS = [
    'onMouseDown',
    'onDragStart',
    'onDrag',
    'onDragEnd'
];
const $078f9b90189268df$var$ENABLED_DRAG_PROPS = [
    'onMouseDown',
    'onClick',
    'onDragStart',
    'onDrag',
    'onDragEnd'
];
const $078f9b90189268df$var$getMousePosition = (event)=>({
        x: event.pageX,
        y: event.pageY
    });
const $078f9b90189268df$var$requestAnimationFrame = (0, $eGMPC.default)();
const $078f9b90189268df$var$withDragObserver = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
WrappedComponent, threshold = $078f9b90189268df$var$DEFAULT_DRAG_THRESHOLD)=>{
    // eslint-disable-next-line jira/react/no-class-components
    class DragObserver extends (0, $eUqFw.PureComponent) {
        static{
            this.defaultProps = {
                isDisabled: false,
                onMouseDown: undefined,
                onDragStart: undefined,
                onDrag: undefined,
                onDragEnd: undefined,
                onClick: undefined
            };
        }
        constructor(props){
            super(props);
            this.onChildMouseDown = (event)=>{
                if (this.props.isDisabled) return;
                event.preventDefault();
                event.stopPropagation();
                window.addEventListener('mousemove', this.onWindowMouseMove);
                window.addEventListener('mouseup', this.onWindowMouseUp);
                const dragStart = $078f9b90189268df$var$getMousePosition(event);
                this.setState({
                    isDragging: false,
                    dragStart: dragStart,
                    previousDragPosition: dragStart
                });
                this.onMouseDown(event);
            };
            this.onWindowMouseMove = (event)=>{
                event.preventDefault();
                const mouse = $078f9b90189268df$var$getMousePosition(event);
                const { isDragging: isDragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
                if (!dragStart || !previousDragPosition) throw Error('Assertion failed: dragStart or previousDragPosition are not defined. Each mouseMove should only be called after an initial mouseDown where these values were set.');
                if (!isDragging) {
                    if (Math.abs(mouse.x - dragStart.x) > threshold || Math.abs(mouse.y - dragStart.y) > threshold) {
                        this.setState({
                            isDragging: true
                        });
                        this.onDragStart(dragStart);
                    }
                } else {
                    const from = previousDragPosition;
                    const to = mouse;
                    this.setState({
                        previousDragPosition: mouse
                    });
                    this.onDrag(from, to, dragStart);
                }
            };
            this.onWindowMouseUp = (event)=>{
                const { isDragging: isDragging, dragStart: dragStart } = this.state;
                if (!dragStart) throw Error('Assertion failed: dragStart is not defined. Each mouseUp should be paired with a mouseDown where dragStart was set.');
                if (isDragging) {
                    const mouse = $078f9b90189268df$var$getMousePosition(event);
                    const start = dragStart;
                    const end = mouse;
                    if (this.mounted) this.setState({
                        isDragging: false
                    });
                    this.onDragEnd(start, end);
                } else this.onClick(event);
                window.removeEventListener('mousemove', this.onWindowMouseMove);
                window.removeEventListener('mouseup', this.onWindowMouseUp);
            };
            this.mounted = false;
            this.state = {
                isDragging: false
            };
        }
        componentDidMount() {
            this.mounted = true;
            // eslint-disable-next-line react/no-find-dom-node
            this.ref = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(this);
            if (this.ref) // @ts-expect-error - TS2345 - Argument of type '(event: MouseEvent) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
            this.ref.addEventListener('mousedown', this.onChildMouseDown);
        }
        componentWillUnmount() {
            if (this.ref) // @ts-expect-error - TS2345 - Argument of type '(event: MouseEvent) => void' is not assignable to parameter of type 'EventListenerOrEventListenerObject'.
            this.ref.removeEventListener('mousedown', this.onChildMouseDown);
            this.mounted = false;
        }
        onMouseDown(event) {
            if (this.props.onMouseDown) this.props.onMouseDown(event);
        }
        onDragStart(from) {
            if (this.props.onDragStart) this.props.onDragStart(from);
        }
        onDrag(from, to, start) {
            if (this.props.onDrag) $078f9b90189268df$var$requestAnimationFrame(()=>{
                // Flow thinks we haven't checked for defined of onDrag due to the new function scope
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                this.props.onDrag(from, to, start);
            });
        }
        onDragEnd(from, to) {
            if (this.props.onDragEnd) this.props.onDragEnd(from, to);
        }
        onClick(event) {
            if (this.props.onClick) this.props.onClick(event);
        }
        render() {
            const { isDisabled: isDisabled, forwardedRef: forwardedRef } = this.props;
            const { isDragging: isDragging } = this.state;
            /* When dragging is disabled, clicking should still be enabled.
			 * Rather than try handle onClick in this HOC, we instead just allow
			 * the onClick passed in to make it to the underlying component.
			 */ const safeProps = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(this.props, isDisabled ? $078f9b90189268df$var$DISABLED_DRAG_PROPS : $078f9b90189268df$var$ENABLED_DRAG_PROPS);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                isDragging: isDragging,
                ...safeProps,
                ref: forwardedRef
            });
        }
    }
    return /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DragObserver, {
            ...props,
            forwardedRef: ref
        }));
};
var $078f9b90189268df$export$2e2bcd8739ae039 = $078f9b90189268df$var$withDragObserver;

});

parcelRegister("ebIaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8078f3c8757ddc20$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9E36O = parcelRequire("9E36O");
const $8078f3c8757ddc20$var$withViewportContext = (WrappedComponent)=>// @ts-expect-error - TS2322 - Type '(props: Config) => JSX.Element' is not assignable to type 'AbstractComponent<Config, any>'.
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9E36O.Consumer), null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $8078f3c8757ddc20$export$2e2bcd8739ae039 = $8078f3c8757ddc20$var$withViewportContext;

});

parcelRegister("l6IdI", function(module, exports) {

$parcel$export(module.exports, "getThumbSize", () => $a2116dc1e8e7a58d$export$7b14c3f3cc4d1eca);
$parcel$export(module.exports, "getThumbOffset", () => $a2116dc1e8e7a58d$export$9ef6984ec058dafe);
$parcel$export(module.exports, "getScrollFromPosition", () => $a2116dc1e8e7a58d$export$b65a5d45c08f7f45);
const $a2116dc1e8e7a58d$var$MINIMUM_THUMB_SIZE = 20;
const $a2116dc1e8e7a58d$export$7b14c3f3cc4d1eca = (containerSize, contentSize, trackSize)=>{
    // Limit it proportionally to the track size, since it is not 1:1 with the panel size
    const size = Math.round(containerSize / contentSize * trackSize);
    return Math.max($a2116dc1e8e7a58d$var$MINIMUM_THUMB_SIZE, size);
};
const $a2116dc1e8e7a58d$export$9ef6984ec058dafe = (scrollOffset, scrollSize, containerSize, trackSize, thumbSize)=>scrollOffset / (scrollSize - containerSize) * (trackSize - thumbSize);
const $a2116dc1e8e7a58d$export$b65a5d45c08f7f45 = (position, thumbSize, contentSize, trackSize, trackPosition)=>{
    const relativePosition = position - trackPosition;
    const newThumbOffset = relativePosition - thumbSize / 2;
    return newThumbOffset / trackSize * contentSize;
};

});




parcelRegister("sXAvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $be0a1ad7f74e9534$export$2e2bcd8739ae039);
function $be0a1ad7f74e9534$var$ChartIndicators(_) {
    return null;
}
var $be0a1ad7f74e9534$export$2e2bcd8739ae039 = $be0a1ad7f74e9534$var$ChartIndicators;

});

parcelRegister("bJAAL", function(module, exports) {

$parcel$export(module.exports, "default", () => $36479abee3c47ef0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5GPm9 = parcelRequire("5GPm9");

var $bFDL3 = parcelRequire("bFDL3");
const $36479abee3c47ef0$var$WrappedChartItem = ({ timelineMode: timelineMode, timelineDuration: timelineDuration, ...props })=>{
    const timelineWidth = (0, $5GPm9.getTimelineWidth)(timelineMode, timelineDuration);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bFDL3.default), {
        ...props,
        timelineWidth: timelineWidth
    });
};
var $36479abee3c47ef0$export$2e2bcd8739ae039 = $36479abee3c47ef0$var$WrappedChartItem;

});
parcelRegister("bFDL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbc16332b240a20$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hrOWs = parcelRequire("hrOWs");


var $94TFJ = parcelRequire("94TFJ");

var $8YmtL = parcelRequire("8YmtL");

var $iMlZB = parcelRequire("iMlZB");
// eslint-disable-next-line jira/react/no-class-components
class $acbc16332b240a20$var$ChartItem extends (0, $eUqFw.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.whyDidYouRender = true;
    }
    static{
        this.defaultProps = {
            level: (0, $94TFJ.DEFAULT_LEVEL)
        };
    }
    static{
        this.contextType = (0, $iMlZB.default);
    }
    renderBar() {
        const { id: id, isSelectEnabled: isSelectEnabled, getPositionFromDate: getPositionFromDate, Bar: Bar } = this.props;
        const { isBarHovered: isBarHovered } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Bar, {
            id: id,
            innerRef: this.onSetBarRef,
            isSelectEnabled: isSelectEnabled,
            isHovered: isBarHovered,
            isDone: false,
            onClick: this.onBarClick,
            onMouseEnter: this.onBarMouseEnter,
            onMouseLeave: this.onBarMouseLeave,
            getPositionFromDate: getPositionFromDate
        });
    }
    render() {
        const { id: id, parentId: parentId, level: level, itemHeight: itemHeight } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($acbc16332b240a20$var$Container, {
            level: level,
            itemHeight: (0, $hrOWs.isBaseLevel)(level) ? (0, $d736b332644d7251$export$bb47e7a2358e2727) : itemHeight,
            onMouseEnter: this.onRowMouseEnter,
            onMouseLeave: this.onRowMouseLeave,
            ...(0, $8YmtL.getRowStyle)(id, parentId)
        }, this.renderBar());
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBarHovered: false
        };
        this.onSetBarRef = (elem)=>{
            if (elem) this.barRef = elem;
        };
        this.onBarClick = ()=>{
            const { id: id, onClick: onClick, isSelectEnabled: isSelectEnabled } = this.props;
            onClick(id);
            if (isSelectEnabled) this.context.onRowSelect(id);
        };
        this.onBarMouseEnter = ()=>{
            const { isHoverEnabled: isHoverEnabled } = this.props;
            if (isHoverEnabled) this.setState({
                isBarHovered: true
            });
        };
        this.onBarMouseLeave = ()=>{
            const { isHoverEnabled: isHoverEnabled } = this.props;
            if (isHoverEnabled) this.setState({
                isBarHovered: false
            });
        };
        this.onRowMouseEnter = ()=>{
            const { id: id } = this.props;
            const { onRowMouseEnter: onRowMouseEnter } = this.context;
            onRowMouseEnter(id);
        };
        this.onRowMouseLeave = ()=>{
            const { id: id } = this.props;
            const { onRowMouseLeave: onRowMouseLeave } = this.context;
            onRowMouseLeave(id);
        };
    }
}
// RLSS-2812 replace the first color.background.input to color.background.accent.gray.subtlest
//           replace the second color.background.neutral to color.background.accent.gray.subtler
//           Consider finding even a better token than the suggested ones here.
const $acbc16332b240a20$var$baseItemStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $acbc16332b240a20$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { level: level, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1kh969l": (0, $9t7rW.default)(__cmplp.itemHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _4t3i15s1 _v564lfip _1m1tsi59 _bfhk19i9 _8obu1j9a _yqfzlui3",
            (0, $hrOWs.isBaseLevel)(__cmplp.level) ? "_1reoewfl _18m9ewfl" : "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
var $acbc16332b240a20$export$2e2bcd8739ae039 = $acbc16332b240a20$var$ChartItem;

});
parcelRegister("hrOWs", function(module, exports) {

$parcel$export(module.exports, "isBaseLevel", () => $351a2216e64624db$export$3f3fbf12338c09a4);
const $351a2216e64624db$export$d5993e01b9439be4 = 0;
const $351a2216e64624db$export$3f3fbf12338c09a4 = (level)=>level === $351a2216e64624db$export$d5993e01b9439be4;

});

parcelRegister("8YmtL", function(module, exports) {

$parcel$export(module.exports, "getRowStyle", () => $aa6e34d16ee2af89$export$e2792826a7716f);

var $cFEO5 = parcelRequire("cFEO5");

var $7eocX = parcelRequire("7eocX");
const $aa6e34d16ee2af89$export$e2792826a7716f = (id, parentId)=>{
    const rowClassName = $7eocX.row(id);
    const classes = parentId !== undefined ? [
        rowClassName,
        $7eocX.rowChild(parentId)
    ] : rowClassName;
    return (0, $cFEO5.getStyle)(classes);
};

});



parcelRegister("47ZAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ddc347c27004c7$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$45ddc347c27004c7$export$2e2bcd8739ae039 = ()=>null;

});

parcelRegister("27qNz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acf9c8ab5b75c45$export$2e2bcd8739ae039);
const $0acf9c8ab5b75c45$var$Legend = ()=>null;
var $0acf9c8ab5b75c45$export$2e2bcd8739ae039 = $0acf9c8ab5b75c45$var$Legend;

});

parcelRegister("76Y53", function(module, exports) {

$parcel$export(module.exports, "default", () => $685287c94c599f62$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $685287c94c599f62$var$ListItemContent = ({ id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Issue ", id);
var $685287c94c599f62$export$2e2bcd8739ae039 = $685287c94c599f62$var$ListItemContent;

});

parcelRegister("f9LXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd39626d35eef6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");
const $ddd39626d35eef6d$var$ListItemContentTooltip = ({ id: id, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: `issue ${id}`
    }, children);
var $ddd39626d35eef6d$export$2e2bcd8739ae039 = $ddd39626d35eef6d$var$ListItemContentTooltip;

});

parcelRegister("58j2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $363424fcc3bf4d6b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");


var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");

var $hrOWs = parcelRequire("hrOWs");


var $94TFJ = parcelRequire("94TFJ");

var $8YmtL = parcelRequire("8YmtL");

var $iMlZB = parcelRequire("iMlZB");

var $9KEVo = parcelRequire("9KEVo");

var $6fciN = parcelRequire("6fciN");
// eslint-disable-next-line jira/react/no-class-components
class $363424fcc3bf4d6b$var$ListItem extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            isParent: false,
            isExpanded: false,
            isSelected: false,
            isSelectEnabled: true,
            level: (0, $94TFJ.DEFAULT_LEVEL)
        };
    }
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.contextType = (0, $iMlZB.default);
    }
    componentDidMount() {
        this.updateRowStyles();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.isSelected !== this.props.isSelected) this.updateRowStyles();
    }
    updateRowStyles() {
        const { id: id, isSelected: isSelected, isSelectEnabled: isSelectEnabled } = this.props;
        const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = this.context;
        if (isSelectEnabled) isSelected ? onRowSelect(id) : onRowDeselect(id);
    }
    render() {
        const { id: id, parentId: parentId, itemHeight: itemHeight, level: level, isParent: isParent, isSelectEnabled: isSelectEnabled, isExpanded: isExpanded, intl: { formatMessage: formatMessage }, Content: Content, ContentTooltip: ContentTooltip } = this.props;
        const contentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($363424fcc3bf4d6b$var$ContentContainer, {
            "data-testid": `deployments.common.components.table.components.list-item.base.content-container-${id}`,
            ref: this.onSetContentContainerRef,
            tabIndex: 0,
            isParent: isParent,
            level: level,
            onClick: this.onContentClick,
            onKeyDown: this.onContentKeyDown
        }, isParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KEVo.default), {
            onClick: this.onChevronClick,
            onKeyDown: this.onChevronKeyDown,
            isExpanded: isExpanded,
            label: formatMessage((0, $6fciN.default).chevronLabel)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Content, {
            id: id
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($363424fcc3bf4d6b$var$Container, {
            "data-testid": "deployments.common.components.table.components.list-item.container",
            ref: this.onSetContainerRef,
            isSelectEnabled: isSelectEnabled,
            itemHeight: (0, $hrOWs.isBaseLevel)(level) ? (0, $d736b332644d7251$export$bb47e7a2358e2727) : itemHeight,
            onMouseEnter: this.onRowMouseEnter,
            onMouseLeave: this.onRowMouseLeave,
            onFocus: this.onRowMouseEnter,
            onBlur: this.onRowMouseLeave,
            ...(0, $8YmtL.getRowStyle)(id, parentId)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentTooltip, {
            id: id
        }, contentContainer));
    }
    constructor(...args){
        super(...args);
        this.onSetContainerRef = (element)=>{
            this.containerRef = element;
        };
        this.onSetContentContainerRef = (element)=>{
            this.contentContainerRef = element;
        } // ================== //
        ;
        // ENTER/LEAVE EVENTS //
        // ================== //
        this.onRowMouseEnter = ()=>{
            const { id: id } = this.props;
            const { onRowMouseEnter: onRowMouseEnter } = this.context;
            onRowMouseEnter(id);
        };
        this.onRowMouseLeave = ()=>{
            const { id: id } = this.props;
            const { onRowMouseLeave: onRowMouseLeave } = this.context;
            onRowMouseLeave(id);
        };
        // ============ //
        // CLICK EVENTS //
        // ============ //
        this.onContentClick = ()=>{
            const { id: id, onClick: onClick, level: level } = this.props;
            onClick(id, level);
        };
        this.onContentKeyDown = (event)=>{
            if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('space')) {
                event.preventDefault();
                this.onContentClick();
            }
        };
        this.onChevronClick = ()=>{
            const { id: id, isExpanded: isExpanded, onExpandChanged: onExpandChanged } = this.props;
            onExpandChanged(id, isExpanded);
        };
        this.onChevronKeyDown = ()=>{
            const { id: id, isExpanded: isExpanded, onExpandChanged: onExpandChanged } = this.props;
            onExpandChanged(id, isExpanded);
        };
        this.containerRef = null;
        this.contentContainerRef = null;
    }
}
//           replace the second color.background.neutral to color.background.accent.gray.subtler
//           Consider finding even a better token than the suggested ones here.
const $363424fcc3bf4d6b$var$baseItemStyles = null;
const $363424fcc3bf4d6b$var$BASE_LEVEL_CONTENT_PADDING = (0, $c9TLT.gridSize) * 6;
const $363424fcc3bf4d6b$var$DEFAULT_CONTENT_PADDING = (0, $c9TLT.gridSize) * 3;
const $363424fcc3bf4d6b$var$getContentPadding = (isParent, level)=>{
    if (isParent) return 0;
    if ((0, $hrOWs.isBaseLevel)(level)) return $363424fcc3bf4d6b$var$BASE_LEVEL_CONTENT_PADDING;
    return $363424fcc3bf4d6b$var$DEFAULT_CONTENT_PADDING;
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $363424fcc3bf4d6b$var$getMouseCursor = (props)=>{
    if (props.isSelectEnabled) return 'pointer';
    return 'default';
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $363424fcc3bf4d6b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1kh969l": (0, $9t7rW.default)(__cmplp.itemHeight, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _4t3i15s1 _v564lfip _1m1tsi59 _bfhk19i9 _8obu1j9a _80omtlke _yqfzlui3",
            __cmplp.className
        ])
    });
});
const $363424fcc3bf4d6b$var$boxShadow = `0 0 0 2px ${`var(--ds-shadow-raised, ${(0, $73a5c9d720aa66e1$exports).B100})`}`; /* A focus border that appears only when focus is attained via the keyboard.
                                                                             * Implemented via the .focus-visible class that comes from the 'focus-visible' polyfill.
                                                                             * Native outline is always disabled as as we either have:
                                                                             * 1) A mouse user who does not need the focus style
                                                                             * 2) A keyboard user, who will see our custom focus border
                                                                             */ 
const $363424fcc3bf4d6b$var$focusBorder = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $363424fcc3bf4d6b$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, level: level, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_tvwn3e": (0, $9t7rW.default)(`${$363424fcc3bf4d6b$var$getContentPadding(__cmplp.isParent, __cmplp.level)}px`),
            "--_kgvpqr": (0, $9t7rW.default)($363424fcc3bf4d6b$var$boxShadow)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _16jlkb7n _1reo15vq _18m915vq _4t3i1osq _19bv132m _u5f3u2gc _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _11r76a9y",
            __cmplp.className
        ])
    });
});
var $363424fcc3bf4d6b$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($363424fcc3bf4d6b$var$ListItem);

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("9KEVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c508c032435ee36$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $dtaN9 = parcelRequire("dtaN9");

// eslint-disable-next-line jira/react/no-class-components
class $4c508c032435ee36$var$ListItemChevron extends (0, $eUqFw.Component) {
    render() {
        const { isExpanded: isExpanded, label: label } = this.props;
        /**
     * Wrapping Atlaskit icon and pass the colour value in the parent props, so we can replace those values with actual colour value.
     *
     * Atlaskit icon component uses primaryColor and secondaryColor to set 'currentColor' and 'inherit' in fill attribute.
     * html2canvas library does not properly render currentColor and inherit values to colors.
     */ // RLSS-2812 replace color.icon.subtle into color.icon.accent.gray
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c508c032435ee36$var$ButtonWrapper, {
            role: "button",
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number | undefined'.
            tabIndex: "0",
            "aria-expanded": isExpanded,
            primarycolor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
            onKeyDown: this.onKeyDown,
            onClick: this.onClick,
            isExpanded: isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$exports).N500})`,
            label: label
        }));
    }
    constructor(...args){
        super(...args);
        this.onKeyDown = (event)=>{
            if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('space')) {
                event.preventDefault();
                event.stopPropagation();
                this.props.onKeyDown();
            }
        };
        this.onClick = (event)=>{
            event.stopPropagation();
            this.props.onClick();
        };
    }
}
const $4c508c032435ee36$var$boxShadow = `0 0 0 2px ${`var(--ds-shadow-raised, ${(0, $73a5c9d720aa66e1$exports).B100})`}`;
/* A focus border that appears only when focus is attained via the keyboard.
 * Implemented via the .focus-visible class that comes from the 'focus-visible' polyfill.
 * Native outline is always disabled as as we either have:
 * 1) A mouse user who does not need the focus style
 * 2) A keyboard user, who will see our custom focus border
 */ const $4c508c032435ee36$var$focusBorderStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c508c032435ee36$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_kgvpqr": (0, $9t7rW.default)($4c508c032435ee36$var$boxShadow)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_8hrz1qre _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _80omtlke _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _11r76a9y",
            __cmplp.isExpanded ? "_t9ec14w8" : "_t9ec1ul7",
            __cmplp.className
        ])
    });
});
var $4c508c032435ee36$export$2e2bcd8739ae039 = $4c508c032435ee36$var$ListItemChevron;

});

parcelRegister("6fciN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d1c3be5adfc857$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d6d1c3be5adfc857$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    chevronLabel: {
        "id": "deployments.common.components.table.components.list-item.chevron-label",
        "defaultMessage": "Show children"
    }
});

});


parcelRegister("ieW1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $94a1b70fd3c1551d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $hI5oG = parcelRequire("hI5oG");



var $eGMPC = parcelRequire("eGMPC");

var $9vpFm = parcelRequire("9vpFm");

var $ev13P = parcelRequire("ev13P");

var $g6gh6 = parcelRequire("g6gh6");

var $9FmX3 = parcelRequire("9FmX3");
const $94a1b70fd3c1551d$var$requestAnimationFrame = (0, $eGMPC.default)();
// eslint-disable-next-line jira/react/no-class-components
class $94a1b70fd3c1551d$var$List extends (0, $eUqFw.PureComponent) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.whyDidYouRender = true;
    }
    static{
        this.defaultProps = {
            isSelectEnabled: true,
            isHoverEnabled: false,
            items: [],
            expandedItems: {},
            selectedItemId: undefined,
            listWidth: (0, $d736b332644d7251$export$58590494eb7f9f92),
            onItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onItemExpandChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onSetListWidth: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.isResizeEnabled && state.width > props.maxListWidth) return {
            width: props.maxListWidth
        };
        return null;
    }
    constructor(props){
        super(props);
        this.onResize = (width)=>{
            const { width: currentWidth } = this.state;
            const { maxListWidth: maxListWidth } = this.props;
            const newWidth = Math.min(width, maxListWidth);
            if (currentWidth !== newWidth) $94a1b70fd3c1551d$var$requestAnimationFrame(()=>{
                this.setState({
                    width: newWidth
                });
            });
        };
        this.onEndResize = ()=>{
            this.props.onSetListWidth(this.state.width);
        };
        this.state = {
            width: props.listWidth
        };
    }
    renderItems() {
        const { isSelectEnabled: isSelectEnabled, items: items, itemHeight: itemHeight, expandedItems: expandedItems, selectedItemId: selectedItemId, activeLevel: activeLevel, components: { ListItem: ListItem, ListItemContent: ListItemContent, ListItemContentTooltip: ListItemContentTooltip }, onItemClick: onItemClick, onItemExpandChanged: onItemExpandChanged, projects: projects } = this.props;
        const typeName = (0, $9vpFm.getProjectItemTypeForLevel)(projects, projects[0].id, activeLevel).name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ev13P.default), {
            isSelectEnabled: isSelectEnabled,
            items: items,
            itemHeight: itemHeight,
            expandedItems: expandedItems,
            selectedItemId: selectedItemId,
            activeLevel: activeLevel,
            components: {
                ListItem: ListItem,
                ListItemContent: ListItemContent,
                ListItemContentTooltip: ListItemContentTooltip
            },
            onItemClick: onItemClick,
            onItemExpandChanged: onItemExpandChanged,
            typeName: typeName,
            projects: projects
        });
    }
    render() {
        const { items: items, isResizeEnabled: isResizeEnabled, components: components } = this.props;
        const { width: listWidth } = this.state;
        const listWidthWithoutBorder = listWidth - 2;
        const isListEmpty = items.length === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94a1b70fd3c1551d$var$Container, {
            width: listWidth,
            "data-testid": "deployments.common.components.table.components.list.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94a1b70fd3c1551d$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.IssueTitle, null), isResizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6gh6.default), {
            width: listWidth,
            onResize: this.onResize,
            onEndResize: this.onEndResize
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94a1b70fd3c1551d$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9FmX3.default), {
            isScrollable: !isListEmpty
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94a1b70fd3c1551d$var$WidthCorrector, {
            width: listWidthWithoutBorder
        }, this.renderItems(), !isListEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94a1b70fd3c1551d$var$ItemsBottomPadding, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.Loader, null)), isListEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.NoMatches, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94a1b70fd3c1551d$var$HeightCorrector, {
            width: listWidthWithoutBorder
        })));
    }
}
const $94a1b70fd3c1551d$var$borderWidth = 1;
const $94a1b70fd3c1551d$var$primaryBorder = `${$94a1b70fd3c1551d$var$borderWidth}px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N30})`}`;
const $94a1b70fd3c1551d$var$secondaryBorder = `${$94a1b70fd3c1551d$var$borderWidth}px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$exports).N40})`}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94a1b70fd3c1551d$var$ItemsBottomPadding = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { invisible: invisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3icmky _bfhk15cr _kqswh2mm",
            __cmplp.invisible ? "_tzy4idpf" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $94a1b70fd3c1551d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4 _kqswh2mm _4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});
const $94a1b70fd3c1551d$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1p5ufam": (0, $9t7rW.default)($94a1b70fd3c1551d$var$secondaryBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i8vuz _vchhusvi _n7zl1hum _bfhk1s4m _19pkidpf _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _1yt41g30 _2rkopped _syaz1rr7",
            __cmplp.className
        ])
    });
});
const $94a1b70fd3c1551d$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _16jlkb7n _1o9zkb7n _i0dl1wug _2lx21bp4 _1e0c1txw _18u0x0bf _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
/* Set the width for this explicitly (adjusted for border).
 * We want to correct any calculations based on the hidden scroll parent,
 * whose width is affected by the padding and scrollbar visibility.
 * We cannot fix this through border-box since we need the padding to be
 * excluded from the width to hide the scrollbar.
 */ // RLSS-2812 replace color.background.neutral into color.background.accent.gray.subtlest
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94a1b70fd3c1551d$var$WidthCorrector = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _bfhk1ph8 _18u0u2gc",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94a1b70fd3c1551d$var$HeightCorrector = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hideLeftBorder: hideLeftBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_i6nvwm": (0, $9t7rW.default)($94a1b70fd3c1551d$var$primaryBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _16jlkb7n _1o9zkb7n _i0dl1wug _1s7zkbi4 _18u0u2gc",
            __cmplp.hideLeftBorder ? "_1kl7idpf" : "_1kl7kbi4",
            __cmplp.className
        ])
    });
});
var $94a1b70fd3c1551d$export$2e2bcd8739ae039 = $94a1b70fd3c1551d$var$List;

});
parcelRegister("9vpFm", function(module, exports) {

$parcel$export(module.exports, "getProjectItemTypeForLevel", () => $b25371c1c9e758e4$export$8129a37ea7374d64);

var $fUTZC = parcelRequire("fUTZC");

var $5iWql = parcelRequire("5iWql");
const $b25371c1c9e758e4$export$c9dd2d915229d040 = (0, $5iWql.default)((projects, projectId)=>projects.find(({ id: id })=>id === projectId) || projects[0]);
const $b25371c1c9e758e4$export$540930dd5d424e25 = (projects, projectId)=>$b25371c1c9e758e4$export$c9dd2d915229d040(projects, projectId).itemTypes;
const $b25371c1c9e758e4$export$8129a37ea7374d64 = (projects, projectId, level)=>$b25371c1c9e758e4$export$540930dd5d424e25(projects, projectId)[level][0];
const $b25371c1c9e758e4$export$e7d296627333d18d = (0, $5iWql.default)((projects, projectId)=>{
    const itemTypes = $b25371c1c9e758e4$export$540930dd5d424e25(projects, projectId);
    const lookup = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(itemTypes, (itemTypesPerLevel)=>{
        itemTypesPerLevel.forEach((itemTypePerLevel)=>{
            lookup[`${itemTypePerLevel.id}`] = itemTypePerLevel;
        });
    });
    return lookup;
});

});

parcelRegister("ev13P", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c222c655f3e9bb2$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $hFmdR = parcelRequire("hFmdR");

var $8un0w = parcelRequire("8un0w");

var $RaefL = parcelRequire("RaefL");
var $8c222c655f3e9bb2$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)('issue'), (0, $8un0w.default)({
    onItemClick: (id, level)=>({
            name: 'issue',
            level: level
        }),
    onItemExpandChanged: (id, isExpanded)=>({
            name: 'issue',
            type: isExpanded ? 'collapsed' : 'expanded'
        })
}))((0, $RaefL.default));

});
parcelRegister("RaefL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4464d15e0dfb236$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $5vuGW = parcelRequire("5vuGW");
class $c4464d15e0dfb236$export$d6aa4b9b00bca3e1 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            items: [],
            expandedItems: {}
        };
    }
    render() {
        const { items: items, expandedItems: expandedItems, activeLevel: activeLevel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5vuGW.default), {
            items: items,
            expandedItems: expandedItems,
            activeLevel: activeLevel,
            renderItem: this.renderItem
        });
    }
    constructor(...args){
        super(...args);
        this.renderItem = (item, { parentId: parentId, isParent: isParent, isExpanded: isExpanded })=>{
            const { isSelectEnabled: isSelectEnabled, itemHeight: itemHeight, selectedItemId: selectedItemId, components: components, onItemClick: onItemClick, onItemExpandChanged: onItemExpandChanged } = this.props;
            const { id: id, level: level } = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(components.ListItem, {
                key: id,
                id: id,
                parentId: parentId,
                itemHeight: itemHeight,
                level: level,
                isSelectEnabled: isSelectEnabled,
                isSelected: id !== undefined && id === selectedItemId,
                isParent: isParent,
                isExpanded: isExpanded,
                onClick: onItemClick,
                onExpandChanged: onItemExpandChanged,
                Content: components.ListItemContent,
                ContentTooltip: components.ListItemContentTooltip
            });
        };
    }
}
var $c4464d15e0dfb236$export$2e2bcd8739ae039 = (0, $eGI9v.default)('listItem', {
    onItemClick: 'clicked',
    onItemExpandChanged: 'expansionStateChanged'
})($c4464d15e0dfb236$export$d6aa4b9b00bca3e1);

});


parcelRegister("g6gh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $407f5cf16ebaa2b1$export$2e2bcd8739ae039);

var $8un0w = parcelRequire("8un0w");

var $hEX3H = parcelRequire("hEX3H");
var $407f5cf16ebaa2b1$export$2e2bcd8739ae039 = (0, $8un0w.default)({
    onEndResize: 'resized'
})((0, $hEX3H.default));

});
parcelRegister("hEX3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $dee656d6b64e2e3c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kn6GU = parcelRequire("kn6GU");

var $eGI9v = parcelRequire("eGI9v");


var $2s3Va = parcelRequire("2s3Va");
// eslint-disable-next-line jira/react/no-class-components
class $dee656d6b64e2e3c$var$ListResizer extends (0, $eUqFw.Component) {
    onResize(diffX) {
        const { onResize: onResize } = this.props;
        onResize(diffX);
    }
    calculateListWidth(diffX) {
        const newWidth = Math.round(this.width + diffX);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kn6GU)))(newWidth, (0, $d736b332644d7251$export$58590494eb7f9f92), Infinity);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dee656d6b64e2e3c$var$ResizeHandlerDrag, {
            onDrag: this.onDrag,
            onDragStart: this.onStartDrag,
            onDragEnd: this.onEndDrag,
            isDisabled: false,
            onMouseDown: undefined,
            onClick: undefined
        });
    }
    constructor(...args){
        super(...args);
        this.onDrag = (from, to, start)=>{
            const diffX = this.calculateListWidth(to.x - start.x);
            this.onResize(diffX);
        };
        this.onStartDrag = ()=>{
            this.width = this.props.width;
        };
        this.onEndDrag = ()=>{
            const { onEndResize: onEndResize } = this.props;
            onEndResize(this.width);
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dee656d6b64e2e3c$var$ResizeHandler = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1xi2r5cr _154iidpf _1bsbu2gc _4t3i1osq _80omuf7j _1pbycs5v _tzy4idpf _v564ryu7 _11fnglyw _18postnw _32rxv77o _15l2idpf _z0aiv77o _1qdg1osq _1ywu1ule _aetrf705 _16r21cey _16l4kb7n",
            __cmplp.className
        ])
    });
});
const $dee656d6b64e2e3c$var$ResizeHandlerDrag = (0, $2s3Va.default)($dee656d6b64e2e3c$var$ResizeHandler);
var $dee656d6b64e2e3c$export$2e2bcd8739ae039 = (0, $eGI9v.default)('list', {
    onEndResize: 'resized'
})($dee656d6b64e2e3c$var$ListResizer);

});
parcelRegister("kn6GU", function(module, exports) {

var $1ImyS = parcelRequire("1ImyS");

var $7kP6w = parcelRequire("7kP6w");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $ed4b255301b8301f$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $7kP6w(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $7kP6w(lower);
        lower = lower === lower ? lower : 0;
    }
    return $1ImyS($7kP6w(number), lower, upper);
}
module.exports = $ed4b255301b8301f$var$clamp;

});
parcelRegister("1ImyS", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $13fb66c0c405b8c7$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $13fb66c0c405b8c7$var$baseClamp;

});




parcelRegister("9FmX3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5290118e9959878f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7E5Lc = parcelRequire("7E5Lc");
function $5290118e9959878f$var$ScrollArea(props) {
    const { isScrollable: isScrollable, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5290118e9959878f$var$ScrollBarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5290118e9959878f$var$SynchronizedScrollbar, {
        "data-testid": "deployments.common.components.table.components.list.scroll-area.hidden-scrollbar",
        /* @ts-expect-error - TS2769 - No overload matches this call. */ isScrollable: isScrollable
    }, children));
}
$5290118e9959878f$var$ScrollArea.defaultProps = {
    isScrollable: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5290118e9959878f$var$ScrollBarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $5290118e9959878f$var$HiddenScrollbar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isScrollable: isScrollable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1osq _u5f312am",
            __cmplp.isScrollable ? "_18m91wug" : "_18m915vq",
            __cmplp.className
        ])
    });
});
const $5290118e9959878f$var$SynchronizedScrollbar = (0, $7E5Lc.default)($5290118e9959878f$var$HiddenScrollbar, {
    syncAxis: 'y',
    isCompiledComponent: true
});
var $5290118e9959878f$export$2e2bcd8739ae039 = $5290118e9959878f$var$ScrollArea;

});




parcelRegister("lgUFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d28fb2e5e2d3b7f$export$2e2bcd8739ae039);

const $2d28fb2e5e2d3b7f$var$MAX_WIDTH_RATIO = 0.9;
var /* The list section of the table can be resized.
 * It should not become larger than the overall size of the table,
 * but it should also not become smaller than its default size.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d28fb2e5e2d3b7f$export$2e2bcd8739ae039 = (tableWidth)=>{
    const tableLimitedWidth = Math.round(tableWidth * $2d28fb2e5e2d3b7f$var$MAX_WIDTH_RATIO);
    return Math.max((0, $d736b332644d7251$export$58590494eb7f9f92), tableLimitedWidth);
};

});

parcelRegister("aqFQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b37878f1243134$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");

var $94TFJ = parcelRequire("94TFJ");
const $18b37878f1243134$var$DEFAULT_ITEMS = {
    listItems: [],
    chartItems: []
};
const $18b37878f1243134$var$DEFAULT_CHILD_ITEMS = {
    listChildItems: [],
    chartChildItems: []
};
const $18b37878f1243134$var$normaliseChildItems = (item)=>{
    const { childItems: childItems } = item;
    if (!childItems) return $18b37878f1243134$var$DEFAULT_CHILD_ITEMS;
    // @ts-expect-error - TS2315 - Type 'ChildItem' is not generic. | TS2304 - Cannot find name 'ListData'.
    const listChildItems = [];
    // @ts-expect-error - TS2315 - Type 'ChildItem' is not generic. | TS2304 - Cannot find name 'ChartData'.
    const chartChildItems = [];
    childItems.forEach((childItem)=>{
        const { id: id, level: level = (0, $94TFJ.DEFAULT_LEVEL) - 1, listData: listData, chartData: chartData } = childItem;
        listChildItems.push({
            id: id,
            level: level,
            ...listData
        });
        chartChildItems.push({
            id: id,
            level: level,
            ...chartData
        });
    });
    return {
        listChildItems: listChildItems,
        chartChildItems: chartChildItems
    };
};
var $18b37878f1243134$export$2e2bcd8739ae039 = (0, $5iWql.default)((items)=>{
    if (items.length === 0) // @ts-expect-error - TS2322 - Type '{ readonly listItems: readonly []; readonly chartItems: readonly []; }' is not assignable to type 'TransformedItems'.
    return $18b37878f1243134$var$DEFAULT_ITEMS;
    const listItems = [];
    const chartItems = [];
    items.forEach((item)=>{
        const { id: id, listData: listData, chartData: chartData, level: level = (0, $94TFJ.DEFAULT_LEVEL) } = item;
        const { listChildItems: listChildItems, chartChildItems: chartChildItems } = $18b37878f1243134$var$normaliseChildItems(item);
        listItems.push({
            id: id,
            level: level,
            // @ts-expect-error - TS2322 - Type 'any[] | readonly []' is not assignable to type 'ChildItem<ListData>[]'.
            childItems: listChildItems,
            ...listData
        });
        chartItems.push({
            id: id,
            level: level,
            // @ts-expect-error - TS2322 - Type 'any[] | readonly []' is not assignable to type 'ChildItem<ChartData>[]'.
            childItems: chartChildItems,
            ...chartData
        });
    });
    return {
        listItems: listItems,
        chartItems: chartItems
    };
});

});



parcelRegister("kq9yX", function(module, exports) {

$parcel$export(module.exports, "getTimelineDurationFromTimeWindowFilter", () => $ed3e68b07122e840$export$51c91479a429146b);

var $2WwpS = parcelRequire("2WwpS");
const $ed3e68b07122e840$var$MINIMUM_NUMBER_WEEKS = 6;
const $ed3e68b07122e840$var$THURSDAY = 4;
const $ed3e68b07122e840$var$SUNDAY = 0;
const $ed3e68b07122e840$export$3ee8fbdbeceaef0e = (startDate, endDate)=>{
    const minStartDate = (0, $2WwpS.startOfDay)((0, $2WwpS.subWeeks)(endDate, $ed3e68b07122e840$var$MINIMUM_NUMBER_WEEKS));
    return startDate > minStartDate ? minStartDate : startDate;
};
// deployment labels are sometimes cut off towards the end of the week especially after Thursday
// resolve this issue by adding an extra week if day is after Thursday
const $ed3e68b07122e840$var$shouldAddExtraWeek = (endDate)=>endDate.getDay() > $ed3e68b07122e840$var$THURSDAY || endDate.getDay() === $ed3e68b07122e840$var$SUNDAY;
const $ed3e68b07122e840$export$7874fb380758be78 = (endDate)=>$ed3e68b07122e840$var$shouldAddExtraWeek(endDate) ? (0, $2WwpS.endOfIsoWeek)((0, $2WwpS.addWeeks)(endDate, 1)) : (0, $2WwpS.endOfIsoWeek)(endDate);
const $ed3e68b07122e840$export$51c91479a429146b = (timeWindowFilter)=>({
        startDate: $ed3e68b07122e840$export$3ee8fbdbeceaef0e(timeWindowFilter.after, timeWindowFilter.before),
        endDate: $ed3e68b07122e840$export$7874fb380758be78(timeWindowFilter.before)
    });

});

parcelRegister("8QgAU", function(module, exports) {

$parcel$export(module.exports, "useTimelineMode", () => $fe3a20c93987af9e$export$b24716f357c4a825);

var $gsGpO = parcelRequire("gsGpO");

var $WBLbN = parcelRequire("WBLbN");
const $fe3a20c93987af9e$export$d4c72bab9d6cc13a = {
    timelineMode: (0, $gsGpO.TimelineModeOptions).WEEKS
};
const $fe3a20c93987af9e$export$e324594224ef24da = {
    setTimelineMode: (timelineMode)=>({ setState: setState })=>setState({
                timelineMode: timelineMode
            })
};
const $fe3a20c93987af9e$var$Store = (0, $WBLbN.createStore)({
    name: 'useTimelineMode',
    initialState: $fe3a20c93987af9e$export$d4c72bab9d6cc13a,
    actions: $fe3a20c93987af9e$export$e324594224ef24da
});
const $fe3a20c93987af9e$export$e22b1b4eb47b65e6 = (0, $WBLbN.createHook)($fe3a20c93987af9e$var$Store);
const $fe3a20c93987af9e$export$b24716f357c4a825 = (0, $WBLbN.createHook)($fe3a20c93987af9e$var$Store, {
    selector: (state)=>state.timelineMode
});

});

parcelRegister("6qFlO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b73408cf32931b53$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $OwuLI = parcelRequire("OwuLI");

var $2ExlL = parcelRequire("2ExlL");
const $b73408cf32931b53$var$ChartIndicators = ({ id: issueId, getPositionFromDate: getPositionFromDate })=>{
    const deploymentsResult = (0, $OwuLI.useIssueDeployments)(issueId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ExlL.default), {
        deployments: deploymentsResult.data || [],
        getPositionFromDate: getPositionFromDate
    });
};
var $b73408cf32931b53$export$2e2bcd8739ae039 = $b73408cf32931b53$var$ChartIndicators;

});
parcelRegister("2ExlL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e63a3a4dcc2bb9b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $9E36O = parcelRequire("9E36O");

var $eJPjg = parcelRequire("eJPjg");

var $2LmzR = parcelRequire("2LmzR");

var $27PCa = parcelRequire("27PCa");

var $gx6F1 = parcelRequire("gx6F1");

var $8QgAU = parcelRequire("8QgAU");

var $fbtGf = parcelRequire("fbtGf");
const $4e63a3a4dcc2bb9b$var$NavigateIndicators = ({ deployments: deploymentsSorted, getPositionFromDate: getPositionFromDate })=>{
    const [timelineMode] = (0, $8QgAU.useTimelineMode)();
    const deploymentGroups = (0, $2LmzR.getGroupedDeployments)(deploymentsSorted, getPositionFromDate, timelineMode);
    const singleDeployments = deploymentGroups.map((group)=>group.deployments[0]);
    const direction = (0, $27PCa.useNavigateIndicatorInfo)(singleDeployments, getPositionFromDate);
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $eUqFw.useContext)((0, $9E36O.default));
    const firstMostMeaningfulDeployment = (0, $eUqFw.useMemo)(()=>deploymentGroups.length > 0 ? (0, $2LmzR.getMostMeaningfulDeployment)(deploymentGroups[deploymentGroups.length - 1].deployments) : undefined, [
        deploymentGroups
    ]);
    const lastMostMeaningfulDeployment = (0, $eUqFw.useMemo)(()=>deploymentGroups.length > 0 ? (0, $2LmzR.getMostMeaningfulDeployment)(deploymentGroups[0].deployments) : undefined, [
        deploymentGroups
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _4t3i1ady _1yt4otz2"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbtGf.default), {
        show: direction === (0, $27PCa.Directions).LEFT,
        direction: (0, $27PCa.Directions).LEFT,
        deployment: lastMostMeaningfulDeployment,
        onClick: ()=>{
            const { scrollLeft: scrollLeft, scrollWidth: scrollWidth } = requestViewportScrollBounding();
            const past = (0, $gx6F1.getPastIndicatorInfo)(getPositionFromDate(singleDeployments[0].lastUpdated).right, scrollLeft, scrollWidth);
            if (past !== null) (0, $eJPjg.timelineScroller).scrollToPercentages({
                left: past.scrollTo,
                offset: (0, $c9TLT.gridSize) * -5,
                // this leaves a single grid space as padding
                behavior: 'smooth'
            });
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbtGf.default), {
        show: direction === (0, $27PCa.Directions).RIGHT,
        direction: (0, $27PCa.Directions).RIGHT,
        deployment: firstMostMeaningfulDeployment,
        onClick: ()=>{
            const { scrollRight: scrollRight, scrollWidth: scrollWidth } = requestViewportScrollBounding();
            const future = (0, $gx6F1.getFutureIndicatorInfo)(getPositionFromDate(singleDeployments[deploymentGroups.length - 1].lastUpdated).left, scrollRight, scrollWidth);
            if (future !== null) (0, $eJPjg.timelineScroller).scrollToPercentages({
                left: future.scrollTo,
                offset: (0, $c9TLT.gridSize) * -0.5,
                // this leaves a single grid space as padding
                behavior: 'smooth'
            });
        }
    }));
};
const $4e63a3a4dcc2bb9b$var$isEqual = ({ deployments: prevDeps }, { deployments: nextDeps })=>(0, $2LmzR.areDeploymentsEqual)(prevDeps, nextDeps);
const $4e63a3a4dcc2bb9b$var$navigateIndicatorsWrapperStyles = null;
var $4e63a3a4dcc2bb9b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4e63a3a4dcc2bb9b$var$NavigateIndicators, $4e63a3a4dcc2bb9b$var$isEqual);

});
parcelRegister("27PCa", function(module, exports) {

$parcel$export(module.exports, "Directions", () => $23354e1671d1b977$export$86ae6e8ac17a67c6);
$parcel$export(module.exports, "useNavigateIndicatorInfo", () => $23354e1671d1b977$export$fd3ee598a35c450b);

var $eUqFw = parcelRequire("eUqFw");

var $9E36O = parcelRequire("9E36O");

var $gx6F1 = parcelRequire("gx6F1");
const $23354e1671d1b977$export$86ae6e8ac17a67c6 = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT'
};
const { LEFT: $23354e1671d1b977$var$LEFT, RIGHT: $23354e1671d1b977$var$RIGHT } = $23354e1671d1b977$export$86ae6e8ac17a67c6;
const $23354e1671d1b977$export$fd3ee598a35c450b = (deploymentsSorted, getPositionFromDate)=>{
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll, requestViewportScrollBounding: requestViewportScrollBounding } = (0, $eUqFw.useContext)((0, $9E36O.default));
    const [indicatorDirection, setIndicatorDirection] = (0, $eUqFw.useState)(null);
    const calculateIndicatorDirection = (0, $eUqFw.useCallback)(()=>{
        if (deploymentsSorted.length === 0) {
            setIndicatorDirection(null);
            return;
        }
        const { scrollLeft: scrollLeft, scrollRight: scrollRight, scrollWidth: scrollWidth } = requestViewportScrollBounding();
        const past = (0, $gx6F1.getPastIndicatorInfo)(getPositionFromDate(deploymentsSorted[0].lastUpdated).right, scrollLeft, scrollWidth);
        const future = (0, $gx6F1.getFutureIndicatorInfo)(getPositionFromDate(deploymentsSorted[deploymentsSorted.length - 1].lastUpdated).left, scrollRight, scrollWidth);
        if (past !== null) {
            if (indicatorDirection !== $23354e1671d1b977$var$LEFT) setIndicatorDirection($23354e1671d1b977$var$LEFT);
        } else if (future !== null) {
            if (indicatorDirection !== $23354e1671d1b977$var$RIGHT) setIndicatorDirection($23354e1671d1b977$var$RIGHT);
        } else if (indicatorDirection !== null) setIndicatorDirection(null);
    }, [
        deploymentsSorted,
        getPositionFromDate,
        indicatorDirection,
        requestViewportScrollBounding
    ]);
    (0, $eUqFw.useEffect)(()=>{
        calculateIndicatorDirection();
        listenToViewportScroll(calculateIndicatorDirection);
        return ()=>{
            stopListeningToViewportScroll(calculateIndicatorDirection);
        };
    }, [
        listenToViewportScroll,
        calculateIndicatorDirection,
        stopListeningToViewportScroll
    ]);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Direction'.
    return indicatorDirection;
};

});
parcelRegister("gx6F1", function(module, exports) {

$parcel$export(module.exports, "getPastIndicatorInfo", () => $da18824d65dc4a77$export$fcc4c6fe68369a3c);
$parcel$export(module.exports, "getFutureIndicatorInfo", () => $da18824d65dc4a77$export$cb1003bccedef88d);
const $da18824d65dc4a77$var$scrollLeftToPercentage = (scrollLeft, scrollWidth)=>scrollLeft / scrollWidth * 100;
const $da18824d65dc4a77$var$scrollRightToPercentage = (scrollRight, scrollWidth)=>scrollRight / scrollWidth * 100;
const $da18824d65dc4a77$var$invertLeftOrRightPercentage = (leftOrRight)=>100 - leftOrRight;
const $da18824d65dc4a77$export$fcc4c6fe68369a3c = (latestDeploymentRight, scrollLeft, scrollWidth)=>{
    const scrollLeftPercentage = $da18824d65dc4a77$var$scrollLeftToPercentage(scrollLeft, scrollWidth);
    if ($da18824d65dc4a77$var$invertLeftOrRightPercentage(latestDeploymentRight) <= scrollLeftPercentage) return {
        scrollTo: $da18824d65dc4a77$var$invertLeftOrRightPercentage(latestDeploymentRight),
        left: scrollLeftPercentage
    };
    return null;
};
const $da18824d65dc4a77$export$cb1003bccedef88d = (oldestDeploymentLeft, scrollRight, scrollWidth)=>{
    const scrollRightPercentage = $da18824d65dc4a77$var$scrollRightToPercentage(scrollRight, scrollWidth);
    if ($da18824d65dc4a77$var$invertLeftOrRightPercentage(oldestDeploymentLeft) <= scrollRightPercentage) return {
        scrollTo: oldestDeploymentLeft,
        right: scrollRightPercentage
    };
    return null;
};

});


parcelRegister("fbtGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04a2c2bac6824db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $4GOUU = parcelRequire("4GOUU");

var $dtaN9 = parcelRequire("dtaN9");

var $9PQaz = parcelRequire("9PQaz");

var $aBjAC = parcelRequire("aBjAC");

var $27PCa = parcelRequire("27PCa");
const $c04a2c2bac6824db$export$c2dabe2581a8a494 = ({ show: show, direction: direction, deployment: deployment, onClick: onClick })=>{
    const isFlipped = direction === (0, $27PCa.Directions).RIGHT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c04a2c2bac6824db$var$Container, {
        // add classname for VR test waitForScreenshot element
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: show ? 'show' : undefined,
        show: show,
        isFlipped: isFlipped,
        onClick: onClick,
        "data-testid": "software-deployments.ui.timeline.chart-indicators.navigate-indicators.navigate-indicator.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c04a2c2bac6824db$var$ArrowContainer, {
        isFlipped: isFlipped
    }, direction === (0, $27PCa.Directions).LEFT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GOUU))), {
        label: ""
    }), direction === (0, $27PCa.Directions).RIGHT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: ""
    })), deployment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c04a2c2bac6824db$var$IconContainer, {
        isFlipped: isFlipped
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBjAC.default), {
        deployments: [
            deployment
        ],
        showMultipleDeploymentsIcon: false,
        hasBorder: false
    })));
};
const $c04a2c2bac6824db$var$flexCenterStyles = null;
const $c04a2c2bac6824db$var$animateInStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c04a2c2bac6824db$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlipped: isFlipped, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gz20x6": (0, $9t7rW.default)((0, $9PQaz.isVisualRegressionTest) ? 'none' : 'opacity 200ms ease-in-out, transform 200ms ease-out')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbckbl _4t3izwfg _1e0c1txw _4cvr1h6o _11q7hp5a _16qsi2bf _2rko7vkz _80omtlke _tzy4idpf _v5641k4r _t9ec18zh",
            __cmplp.isFlipped ? "_2lx21sbv" : "_2lx2vrvc",
            __cmplp.show && "_tzy4kb7n _t9ec161g",
            __cmplp.show ? "_lcxv1wug" : "_lcxvglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c04a2c2bac6824db$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlipped: isFlipped, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.isFlipped ? "_18u01b66" : "_18u0r5cr",
            __cmplp.className
        ])
    });
});
const $c04a2c2bac6824db$var$ArrowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlipped: isFlipped, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.isFlipped ? "_2hwxidpf" : "_2hwx1b66",
            __cmplp.className
        ])
    });
});
var $c04a2c2bac6824db$export$2e2bcd8739ae039 = $c04a2c2bac6824db$export$c2dabe2581a8a494;

});
parcelRegister("4GOUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36a294b3fe9eadec$var$_react = $36a294b3fe9eadec$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $36a294b3fe9eadec$var$_chevronLeft = $36a294b3fe9eadec$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $36a294b3fe9eadec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36a294b3fe9eadec$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $36a294b3fe9eadec$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $36a294b3fe9eadec$var$_chevronLeft.default,
        iconType: "utility"
    }));
$36a294b3fe9eadec$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $36a294b3fe9eadec$var$_default = module.exports.default = $36a294b3fe9eadec$var$ChevronLeftIcon;

});

parcelRegister("aBjAC", function(module, exports) {

$parcel$export(module.exports, "getDeploymentIconState", () => $e55bd338d86e70a2$export$5e9887435c09039f);
$parcel$export(module.exports, "default", () => $e55bd338d86e70a2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3oKhY = parcelRequire("3oKhY");

var $jV3Wn = parcelRequire("jV3Wn");

var $yevjV = parcelRequire("yevjV");

var $2LmzR = parcelRequire("2LmzR");
const $e55bd338d86e70a2$export$5e9887435c09039f = (state, environmentType)=>state === (0, $yevjV.DeploymentStateOptions).SUCCESSFUL && environmentType !== (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION ? (0, $jV3Wn.DeploymentStateOptions).SUCCESSFULNONPRODUCTION : state;
const $e55bd338d86e70a2$var$DeploymentIcon = ({ deployments: deployments, showMultipleDeploymentsIcon: showMultipleDeploymentsIcon, hasBorder: hasBorder })=>{
    const deployment = (0, $2LmzR.getMostMeaningfulDeployment)(deployments);
    const color = (0, $2LmzR.getColorForDeploymentState)(deployment.state);
    const isMulti = showMultipleDeploymentsIcon && deployments.length > 1;
    const hasMoreThanNineDeployments = deployments.length > 9;
    const shouldShowIcon = !(isMulti && hasMoreThanNineDeployments);
    const deploymentState = $e55bd338d86e70a2$export$5e9887435c09039f(deployment.state, deployment.environment.type);
    return isMulti ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e55bd338d86e70a2$var$Wrapper, {
        hasBorder: hasBorder,
        color: color,
        singleChild: hasMoreThanNineDeployments,
        isMulti: isMulti
    }, shouldShowIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
        deploymentState: deploymentState,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e55bd338d86e70a2$var$Count, {
        shouldShowIcon: shouldShowIcon,
        "data-testid": "software-deployments.common.ui.deployment-icon.deployment-icon-count"
    }, hasMoreThanNineDeployments ? '9+' : deployments.length)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
        deploymentState: deploymentState,
        size: "small"
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e55bd338d86e70a2$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { singleChild: singleChild, isMulti: isMulti, hasBorder: hasBorder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1uodq60": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _11c81vlj _syaz15cr _4t3i7vkz _2rkodlk8 _1h6d19i9",
            __cmplp.color ? "_bfhk1o7t" : "_bfhkn7od",
            __cmplp.singleChild ? "_1bah1h6o" : "_1bah1yb4",
            __cmplp.isMulti ? "_1bsb1f4h" : "_1bsb7vkz",
            __cmplp.hasBorder ? "_19it1axk" : "_19itglyw",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e55bd338d86e70a2$var$Count = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowIcon: shouldShowIcon, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldShowIcon ? "_u5f31b66" : "_u5f3idpf",
            __cmplp.className
        ])
    });
});
var $e55bd338d86e70a2$export$2e2bcd8739ae039 = $e55bd338d86e70a2$var$DeploymentIcon;

});
parcelRegister("3oKhY", function(module, exports) {

$parcel$export(module.exports, "DeploymentIcons", () => $8bdf916238e64d28$export$5202eabf0ef214b4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $90EwC = parcelRequire("90EwC");

var $5FxEu = parcelRequire("5FxEu");

var $2VvCK = parcelRequire("2VvCK");

var $172mV = parcelRequire("172mV");

var $5xL3w = parcelRequire("5xL3w");

var $4R69K = parcelRequire("4R69K");

var $6DPSE = parcelRequire("6DPSE");

var $jV3Wn = parcelRequire("jV3Wn");

var $3275y = parcelRequire("3275y");
const $8bdf916238e64d28$export$16b26cd5e98d9100 = (state)=>{
    switch(state){
        case (0, $jV3Wn.DeploymentStateOptions).PENDING:
            return 0, $172mV.default;
        case (0, $jV3Wn.DeploymentStateOptions).IN_PROGRESS:
            return 0, $2VvCK.default;
        case (0, $jV3Wn.DeploymentStateOptions).SUCCESSFUL:
            return 0, $6DPSE.default;
        case (0, $jV3Wn.DeploymentStateOptions).SUCCESSFULNONPRODUCTION:
            return 0, $4R69K.default;
        case (0, $jV3Wn.DeploymentStateOptions).CANCELLED:
            return 0, $90EwC.default;
        case (0, $jV3Wn.DeploymentStateOptions).FAILED:
            return 0, $5FxEu.default;
        case (0, $jV3Wn.DeploymentStateOptions).ROLLED_BACK:
            return 0, $5xL3w.default;
        case (0, $jV3Wn.DeploymentStateOptions).UNKNOWN:
            return 0, $3275y.default;
        default:
            throw Error(`Unhandled deployment state - ${state}`);
    }
};
const $8bdf916238e64d28$export$c7835fd8b8ca1d68 = {
    width: '20',
    height: '20',
    padding: '2'
};
const $8bdf916238e64d28$export$148e312beb132853 = {
    width: '16',
    height: '16',
    padding: '0'
};
const $8bdf916238e64d28$export$31b21d0167753bb4 = (state)=>{
    switch(state){
        case 'small':
            return $8bdf916238e64d28$export$148e312beb132853;
        case 'medium':
            return $8bdf916238e64d28$export$c7835fd8b8ca1d68;
        default:
            return $8bdf916238e64d28$export$148e312beb132853;
    }
};
const $8bdf916238e64d28$export$5202eabf0ef214b4 = ({ deploymentState: deploymentState, size: size })=>{
    const Icon = $8bdf916238e64d28$export$16b26cd5e98d9100(deploymentState);
    const iconSize = $8bdf916238e64d28$export$31b21d0167753bb4(size);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8bdf916238e64d28$var$Wrapper, {
        "data-testid": `software-deployments-icons-common.ui.wrapper-${deploymentState}`,
        width: iconSize.width,
        height: iconSize.height,
        padding: iconSize.padding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8bdf916238e64d28$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { padding: padding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width, "px"),
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height, "px"),
            "--_fl6vf6": (0, $9t7rW.default)(__cmplp.padding, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1rkg _4t3i1474 _19pk1wug _2hwxidpf _otyr1wug _18u0idpf _1yt4gesh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("90EwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ede440a3dd103644$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $ede440a3dd103644$var$cancelledIcon = `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y300})`;
const $ede440a3dd103644$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $ede440a3dd103644$var$CancelledIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $ede440a3dd103644$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.184 9h8V7h-8v2zm11.367-4.102a8.039 8.039 0 0 0-1.703-2.546A8.122 8.122 0 0 0 11.293.641 7.769 7.769 0 0 0 8.184 0a7.789 7.789 0 0 0-3.102.633 8.043 8.043 0 0 0-2.547 1.703A8.11 8.11 0 0 0 .824 4.891 7.747 7.747 0 0 0 .184 8c0 1.083.211 2.117.632 3.102.422.984.99 1.833 1.704 2.546a8.084 8.084 0 0 0 2.554 1.711 7.766 7.766 0 0 0 3.11.641 7.788 7.788 0 0 0 3.101-.633 8.043 8.043 0 0 0 2.547-1.703 8.133 8.133 0 0 0 1.711-2.555A7.765 7.765 0 0 0 16.184 8a7.796 7.796 0 0 0-.633-3.102z",
        fill: $ede440a3dd103644$var$cancelledIcon,
        fillRule: "evenodd"
    }));
$ede440a3dd103644$var$CancelledIcon.displayName = 'CancelledIcon';
var $ede440a3dd103644$export$2e2bcd8739ae039 = $ede440a3dd103644$var$CancelledIcon;

});

parcelRegister("5FxEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1f3716fc3673e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $ce1f3716fc3673e9$var$failedColor = `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
const $ce1f3716fc3673e9$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $ce1f3716fc3673e9$var$FailedIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "6",
        cx: "8",
        cy: "8",
        fill: $ce1f3716fc3673e9$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $ce1f3716fc3673e9$var$failedColor,
        fillRule: "evenodd",
        d: "M.768 9.768a2.5 2.5 0 010-3.536L6.232.768a2.5 2.5 0 013.536 0l5.464 5.464a2.5 2.5 0 010 3.536l-5.464 5.464a2.5 2.5 0 01-3.536 0L.768 9.768zM7 4a1 1 0 112 0v4a1 1 0 01-2 0V4zm1 8a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd"
    }));
$ce1f3716fc3673e9$var$FailedIcon.displayName = 'FailedIcon';
var $ce1f3716fc3673e9$export$2e2bcd8739ae039 = $ce1f3716fc3673e9$var$FailedIcon;

});

parcelRegister("2VvCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e5767ae44dbd10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

const $c7e5767ae44dbd10$var$inProgressColor = `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B300})`;
const $c7e5767ae44dbd10$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $c7e5767ae44dbd10$var$InProgressIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7e5767ae44dbd10$var$SpinningSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $c7e5767ae44dbd10$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $c7e5767ae44dbd10$var$inProgressColor,
        d: "M8 0a8 8 0 100 16A8 8 0 008 0zm0 12.444A4.445 4.445 0 013.556 8a.889.889 0 111.777 0A2.667 2.667 0 008 10.667a.888.888 0 110 1.777zm3.556-3.555a.889.889 0 01-.89-.889A2.667 2.667 0 008 5.333a.889.889 0 010-1.777A4.445 4.445 0 0112.444 8a.888.888 0 01-.888.889z"
    }));
$c7e5767ae44dbd10$var$InProgressIcon.displayName = 'InProgressIcon';
var $c7e5767ae44dbd10$export$2e2bcd8739ae039 = $c7e5767ae44dbd10$var$InProgressIcon;
const $c7e5767ae44dbd10$var$spin = null;
// 1.5s matches the same animation on bitbucket for builds
const $c7e5767ae44dbd10$var$spinAnimation = `${$c7e5767ae44dbd10$var$spin} 1.5s linear infinite`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7e5767ae44dbd10$var$SpinningSvg = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1xz6pnn": (0, $9t7rW.default)($c7e5767ae44dbd10$var$spinAnimation)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y44v1wf2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("172mV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c798ddbfac1954e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $2c798ddbfac1954e$var$pendingColor = `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$exports).B300})`;
const $2c798ddbfac1954e$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $2c798ddbfac1954e$var$PendingIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $2c798ddbfac1954e$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $2c798ddbfac1954e$var$pendingColor,
        d: "M13.657 2.343A8 8 0 102.343 13.657 8 8 0 0013.657 2.343zm-2.308 9.006a1 1 0 01-1.389.024L7.294 8.707a.988.988 0 01-.217-.325l.002.007-.005-.013.003.006A.993.993 0 017 8V4a1 1 0 012 0v3.587l2.373 2.373a1 1 0 01-.024 1.389z"
    }));
$2c798ddbfac1954e$var$PendingIcon.displayName = 'PendingIcon';
var $2c798ddbfac1954e$export$2e2bcd8739ae039 = $2c798ddbfac1954e$var$PendingIcon;

});

parcelRegister("5xL3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $49f24f22a5783234$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $49f24f22a5783234$var$rolledBackColor = `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y400})`;
const $49f24f22a5783234$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $49f24f22a5783234$var$RolledBackIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $49f24f22a5783234$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $49f24f22a5783234$var$rolledBackColor,
        fillRule: "evenodd",
        d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM7.707 3.293a1 1 0 010 1.414L7.414 5H8.6C10.516 5 12 6.606 12 8.5S10.516 12 8.6 12H7a1 1 0 110-2h1.6c.735 0 1.4-.633 1.4-1.5S9.335 7 8.6 7H7.414l.293.293a1 1 0 01-1.414 1.414l-2-2a1 1 0 010-1.414l2-2a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
$49f24f22a5783234$var$RolledBackIcon.displayName = 'RolledBackIcon';
var $49f24f22a5783234$export$2e2bcd8739ae039 = $49f24f22a5783234$var$RolledBackIcon;

});

parcelRegister("4R69K", function(module, exports) {

$parcel$export(module.exports, "default", () => $05f279b31bea95d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $05f279b31bea95d3$var$successColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $05f279b31bea95d3$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $05f279b31bea95d3$var$SuccessNonProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $05f279b31bea95d3$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $05f279b31bea95d3$var$successColor,
        fillRule: "evenodd",
        d: "M14 8A6 6 0 112 8a6 6 0 0112 0zm2 0A8 8 0 110 8a8 8 0 0116 0zm-4.293-1.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$05f279b31bea95d3$var$SuccessNonProductionIcon.displayName = 'SuccessNonProductionIcon';
var $05f279b31bea95d3$export$2e2bcd8739ae039 = $05f279b31bea95d3$var$SuccessNonProductionIcon;

});

parcelRegister("6DPSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d2b4a7cc011df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $907d2b4a7cc011df$var$successColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $907d2b4a7cc011df$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $907d2b4a7cc011df$var$SuccessProductionIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $907d2b4a7cc011df$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $907d2b4a7cc011df$var$successColor,
        fillRule: "evenodd",
        d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
$907d2b4a7cc011df$var$SuccessProductionIcon.displayName = 'SuccessProductionIcon';
var $907d2b4a7cc011df$export$2e2bcd8739ae039 = $907d2b4a7cc011df$var$SuccessProductionIcon;

});

parcelRegister("jV3Wn", function(module, exports) {

$parcel$export(module.exports, "DeploymentStateOptions", () => $a6f4e1105c83e0f3$export$a761da6c19e008f6);
const $a6f4e1105c83e0f3$var$PENDING = 'PENDING';
const $a6f4e1105c83e0f3$var$IN_PROGRESS = 'IN_PROGRESS';
const $a6f4e1105c83e0f3$var$SUCCESSFUL = 'SUCCESSFUL';
const $a6f4e1105c83e0f3$var$SUCCESSFULNONPRODUCTION = 'SUCCESSFULNONPRODUCTION';
const $a6f4e1105c83e0f3$var$CANCELLED = 'CANCELLED';
const $a6f4e1105c83e0f3$var$FAILED = 'FAILED';
const $a6f4e1105c83e0f3$var$ROLLED_BACK = 'ROLLED_BACK';
const $a6f4e1105c83e0f3$var$UNKNOWN = 'UNKNOWN';
const $a6f4e1105c83e0f3$export$a761da6c19e008f6 = {
    PENDING: $a6f4e1105c83e0f3$var$PENDING,
    IN_PROGRESS: $a6f4e1105c83e0f3$var$IN_PROGRESS,
    SUCCESSFUL: $a6f4e1105c83e0f3$var$SUCCESSFUL,
    SUCCESSFULNONPRODUCTION: $a6f4e1105c83e0f3$var$SUCCESSFULNONPRODUCTION,
    CANCELLED: $a6f4e1105c83e0f3$var$CANCELLED,
    FAILED: $a6f4e1105c83e0f3$var$FAILED,
    ROLLED_BACK: $a6f4e1105c83e0f3$var$ROLLED_BACK,
    UNKNOWN: $a6f4e1105c83e0f3$var$UNKNOWN
};

});

parcelRegister("3275y", function(module, exports) {

$parcel$export(module.exports, "default", () => $258a218a3e327f9b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $258a218a3e327f9b$var$unknownColor = `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$exports).G300})`;
const $258a218a3e327f9b$var$backgroundColor = `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`;
const $258a218a3e327f9b$var$Unknown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        r: "7",
        cx: "8",
        cy: "8",
        fill: $258a218a3e327f9b$var$backgroundColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "path-1-inside-1",
        fill: $258a218a3e327f9b$var$backgroundColor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        d: "M15.367 4.898a8.039 8.039 0 00-1.703-2.546A8.118 8.118 0 0011.11.641 7.777 7.777 0 008 0a7.784 7.784 0 00-3.101.633 8.032 8.032 0 00-2.547 1.703A8.11 8.11 0 00.641 4.891 7.748 7.748 0 000 8c0 1.083.211 2.117.633 3.102a8.022 8.022 0 001.703 2.546 8.1 8.1 0 002.555 1.711A7.762 7.762 0 008 16a7.796 7.796 0 003.102-.633 8.055 8.055 0 002.547-1.703 8.15 8.15 0 001.711-2.555C15.786 10.12 16 9.083 16 8a7.796 7.796 0 00-.633-3.102z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $258a218a3e327f9b$var$unknownColor,
        d: "M11.11.641l.793-1.836H11.9L11.11.64zM4.899.633l.788 1.838L4.9.633zM.641 4.891l1.836.794v-.002L.641 4.891zm-.008 6.211l-1.838.788 1.838-.788zm1.703 2.546l1.415-1.413-.002-.002-1.413 1.415zm2.555 1.711l.793-1.836-.793 1.836zm6.211.008l.788 1.838-.788-1.838zm2.547-1.703l1.413 1.415.002-.002-1.415-1.413zm1.711-2.555l1.836.794V11.9l-1.836-.791zm1.845-7A10.037 10.037 0 0015.078.939L12.25 3.766a6.041 6.041 0 011.279 1.92l3.676-1.576zM15.078.939a10.116 10.116 0 00-3.175-2.133l-1.586 3.672a6.12 6.12 0 011.933 1.29l2.828-2.83zm-3.177-2.134A9.777 9.777 0 008-2v4c.811 0 1.578.159 2.319.478L11.9-1.196zM8-2a9.784 9.784 0 00-3.89.795L5.688 2.47A5.784 5.784 0 018 2v-4zm-3.889.795A10.031 10.031 0 00.938.922L3.766 3.75a6.034 6.034 0 011.92-1.279L4.112-1.205zM.938.922a10.11 10.11 0 00-2.133 3.177l3.672 1.584a6.113 6.113 0 011.29-1.933L.936.922zm-2.132 3.175A9.748 9.748 0 00-2 8h4c0-.813.158-1.58.476-2.315l-3.67-1.588zM-2 8c0 1.35.265 2.653.795 3.89l3.676-1.576A5.796 5.796 0 012 8h-4zm.795 3.89a10.021 10.021 0 002.128 3.173l2.826-2.83a6.024 6.024 0 01-1.278-1.92l-3.676 1.577zM.92 15.061a10.1 10.1 0 003.178 2.134l1.584-3.672a6.1 6.1 0 01-1.932-1.288L.921 15.06zm3.177 2.134A9.763 9.763 0 008 18v-4a5.76 5.76 0 01-2.316-.477l-1.586 3.672zM8 18c1.35 0 2.653-.265 3.89-.795l-1.576-3.676C9.581 13.843 8.815 14 8 14v4zm3.89-.795a10.054 10.054 0 003.172-2.126l-2.826-2.83a6.056 6.056 0 01-1.922 1.28l1.576 3.676zm3.174-2.128c.902-.903 1.61-1.969 2.132-3.174l-3.672-1.588a6.152 6.152 0 01-1.29 1.936l2.83 2.826zm2.133-3.177A9.78 9.78 0 0018 8h-4c0 .812-.159 1.58-.477 2.318l3.674 1.582zM18 8c0-1.35-.265-2.653-.795-3.89L13.53 5.686C13.843 6.419 14 7.185 14 8h4z",
        mask: "url(#path-1-inside-1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: $258a218a3e327f9b$var$unknownColor,
        d: "M5.419 6.425h1.456c.032-.607.44-1 1.058-1 .612 0 1.02.371 1.02.882 0 .51-.21.773-.902 1.187-.741.435-1.037.918-.967 1.761l.01.312h1.424v-.285c0-.526.199-.79.913-1.203.758-.446 1.15-1.01 1.15-1.82 0-1.225-1.016-2.08-2.552-2.08-1.649 0-2.583.924-2.61 2.246zm2.444 5.73c.601 0 .972-.343.972-.896 0-.559-.37-.903-.972-.903s-.978.344-.978.903c0 .553.376.897.978.897z"
    }));
$258a218a3e327f9b$var$Unknown.displayName = 'Unknown';
var $258a218a3e327f9b$export$2e2bcd8739ae039 = $258a218a3e327f9b$var$Unknown;

});






parcelRegister("3wiDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb09202e271902c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8QgAU = parcelRequire("8QgAU");

var $OwuLI = parcelRequire("OwuLI");

var $lkEWe = parcelRequire("lkEWe");

var $h3FVp = parcelRequire("h3FVp");

var $7BnyS = parcelRequire("7BnyS");

var $g7ZmE = parcelRequire("g7ZmE");
const $ecb09202e271902c$var$DeploymentsBar = ({ id: issueId, getPositionFromDate: getPositionFromDate })=>{
    const [timelineMode] = (0, $8QgAU.useTimelineMode)();
    const deploymentsResult = (0, $OwuLI.useIssueDeployments)(issueId);
    const iconsConfig = (0, $h3FVp.useIconsConfigurationPreference)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, deploymentsResult.data && deploymentsResult.data.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_kqswstnw _1pby11wp _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g7ZmE.default), {
        deployments: deploymentsResult.data,
        timelineMode: timelineMode,
        getPositionFromDate: getPositionFromDate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BnyS.default), {
        deployments: deploymentsResult.data,
        timelineMode: timelineMode,
        issueId: issueId,
        showMultipleDeploymentsIcon: iconsConfig?.showMultipleDeploymentsIcon ?? (0, $lkEWe.DEFAULT_VIEW_CONFIGURATION_PREFERENCE).icons.showMultipleDeploymentsIcon,
        getPositionFromDate: getPositionFromDate
    })));
};
const $ecb09202e271902c$var$wrapperStyles = null;
var $ecb09202e271902c$export$2e2bcd8739ae039 = $ecb09202e271902c$var$DeploymentsBar;

});
parcelRegister("7BnyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bccc9e284d5b6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2LmzR = parcelRequire("2LmzR");

var $39B6V = parcelRequire("39B6V");

var $fvBwB = parcelRequire("fvBwB");
/**
 * Responsible for drawing all the circles for all deployments for an issue.
 */ const $c4bccc9e284d5b6d$var$Circles = ({ deployments: deploymentsSorted, issueId: issueId, showMultipleDeploymentsIcon: showMultipleDeploymentsIcon, getPositionFromDate: getPositionFromDate, timelineMode: timelineMode })=>{
    const deploymentGroups = (0, $2LmzR.getGroupedDeployments)(deploymentsSorted, getPositionFromDate, timelineMode);
    return deploymentGroups.map((group, groupIndex)=>{
        const groupId = group.deployments[0].id;
        const isFirstGroup = groupIndex === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: groupId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c4bccc9e284d5b6d$var$CircleWrapper, {
            "data-testid": "software-deployments.ui.timeline.deployments-bar.circles.deployment-icon-container",
            leftPosition: group.left,
            rightPosition: group.right
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39B6V.default), {
            issueId: issueId,
            deployments: group.deployments,
            showMultipleDeploymentsIcon: showMultipleDeploymentsIcon,
            groupIndex: groupIndex
        })), isFirstGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c4bccc9e284d5b6d$var$EnvironmentsLabelWrapper, {
            leftPosition: 100 - group.right
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvBwB.default), {
            sortedDeployments: group.deployments
        })));
    });
};
const $c4bccc9e284d5b6d$var$isEqual = ({ deployments: prevDeps, showMultipleDeploymentsIcon: prevShowMultipleDeploymentsIcon, timelineMode: prevTimelineMode }, { deployments: nextDeps, showMultipleDeploymentsIcon: nextShowMultipleDeploymentsIcon, timelineMode: nextTimelineMode })=>prevTimelineMode === nextTimelineMode && prevShowMultipleDeploymentsIcon === nextShowMultipleDeploymentsIcon && (0, $2LmzR.areDeploymentsEqual)(prevDeps, nextDeps);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4bccc9e284d5b6d$var$CircleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { leftPosition: leftPosition, rightPosition: rightPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1debku0": (0, $9t7rW.default)(`${__cmplp.leftPosition}%`),
            "--_103kaaw": (0, $9t7rW.default)(`${__cmplp.rightPosition}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ltv15yb _1xi21s9q _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
$c4bccc9e284d5b6d$var$CircleWrapper.displayName = 'CircleWrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c4bccc9e284d5b6d$var$EnvironmentsLabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { leftPosition: leftPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1debku0": (0, $9t7rW.default)(`${__cmplp.leftPosition}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ltv15yb _kqswstnw",
            __cmplp.className
        ])
    });
});
var $c4bccc9e284d5b6d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c4bccc9e284d5b6d$var$Circles, $c4bccc9e284d5b6d$var$isEqual);

});
parcelRegister("39B6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eada3a324e3fa99$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aBjAC = parcelRequire("aBjAC");

var $f297o = parcelRequire("f297o");

var $lsyEF = parcelRequire("lsyEF");
// we need a parent for the Popup to make the exit transition work
const $8eada3a324e3fa99$var$UnstyledPopupComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ...props,
        ref: ref,
        className: (0, $7JEyt.default)([
            "_nt751r31 _49pcglyw _1hvw1o36"
        ])
    }));
const $8eada3a324e3fa99$var$useFireShowMoreInfoAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'showMoreInfoDeployments'
        }));
};
const $8eada3a324e3fa99$var$useFireDeploymentsClickedAnalytics = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (groupIndex)=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'deployments'
        }), 'deploymentsClicked', {
            groupIndex: groupIndex
        });
};
const $8eada3a324e3fa99$var$DeploymentsDialog = ({ issueId: issueId, deployments: deployments, showMultipleDeploymentsIcon: showMultipleDeploymentsIcon, groupIndex: groupIndex })=>{
    const [showMoreInfo, setShowMoreInfo] = (0, $eUqFw.useState)(false);
    const [placement, setPlacement] = (0, $eUqFw.useState)('bottom');
    const fireShowMoreInfoAnalytics = $8eada3a324e3fa99$var$useFireShowMoreInfoAnalytics();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const openPopup = ()=>{
        setIsOpen(true);
    };
    const closePopup = ()=>{
        setIsOpen(false);
    };
    const fireDeploymentsClickedAnalytics = $8eada3a324e3fa99$var$useFireDeploymentsClickedAnalytics();
    // NOTE: both popup and the DevPanelDetailsDialog modal add a
    // window onclick listener to close themselves. Handle it in Popup onclose prop
    // otherwise changing tabs in the modal sees both modal and popup close.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        shouldFlip: false,
        isOpen: isOpen,
        onClose: showMoreInfo ? undefined : closePopup,
        placement: placement,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lsyEF.default), {
                deployments: deployments,
                onShowMoreInfo: ()=>{
                    setShowMoreInfo(true);
                    fireShowMoreInfoAnalytics();
                },
                onClose: closePopup
            }),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8eada3a324e3fa99$var$DeploymentIconButton, {
                ...triggerProps,
                onClick: (evt)=>{
                    if (!isOpen) {
                        fireDeploymentsClickedAnalytics(groupIndex);
                        openPopup();
                    } else closePopup();
                    // custom logic for placement
                    // mouseY is accurate enough to determine if popup should go above or below
                    // mouseY is more performant to retreive than getBoundingClientRect()
                    const mouseY = evt.clientY;
                    const isBottomHalfOfViewport = window.innerHeight - mouseY < window.innerHeight / 2;
                    setPlacement(isBottomHalfOfViewport ? 'top' : 'bottom');
                },
                ref: ref
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBjAC.default), {
                deployments: deployments,
                showMultipleDeploymentsIcon: showMultipleDeploymentsIcon,
                hasBorder: true
            })),
        popupComponent: $8eada3a324e3fa99$var$UnstyledPopupComponent
    }), showMoreInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f297o.default), {
        issueId: issueId,
        onClose: ()=>{
            setShowMoreInfo(false);
        }
    }));
};
const $8eada3a324e3fa99$var$unstyledPopupContainerStyles = null;
const $8eada3a324e3fa99$var$normalizeButtonStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $8eada3a324e3fa99$var$DeploymentIconButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk18uv _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
var $8eada3a324e3fa99$export$2e2bcd8739ae039 = $8eada3a324e3fa99$var$DeploymentsDialog;

});
parcelRegister("f297o", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffb49e752f936b6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $5RlPW = parcelRequire("5RlPW");

var $huI7r = parcelRequire("huI7r");

var $bNe1g = parcelRequire("bNe1g");

var $gd0Sp = parcelRequire("gd0Sp");

var $OwuLI = parcelRequire("OwuLI");
const $4ffb49e752f936b6$var$DeploymentsDevPanel = ({ issueId: issueId, onClose: onClose })=>{
    const issue = (0, $OwuLI.useIssue)(issueId);
    const projectContext = (0, $bNe1g.useProjectContext)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const projectAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'project',
        cloudId: tenantContext.cloudId,
        resourceId: projectContext.data?.projectId?.toString() ?? ''
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RlPW.default), {
        issueId: issueId,
        issueKey: issue?.key ?? '',
        baseUrl: tenantContext.baseUrl,
        locale: tenantContext.locale,
        selectedTab: (0, $14a090e212ebf7a4$export$90cac6260ae9ced5),
        showRemoteLinks: false,
        onCloseDialog: onClose,
        projectAri: projectAri || '',
        accountId: tenantContext.atlassianAccountId || ''
    });
};
var $4ffb49e752f936b6$export$2e2bcd8739ae039 = $4ffb49e752f936b6$var$DeploymentsDevPanel;

});
const $14a090e212ebf7a4$export$e18d81f044132a0e = 'branch';
const $14a090e212ebf7a4$export$74a388a09f2a004e = 'build';
const $14a090e212ebf7a4$export$2e42513c7764d5f3 = 'repository';
const $14a090e212ebf7a4$export$3f1e2b276d607490 = 'review';
const $14a090e212ebf7a4$export$90cac6260ae9ced5 = 'deployment-environment';
const $14a090e212ebf7a4$export$6f74b53d652f13f3 = 'pullrequest';
const $14a090e212ebf7a4$export$c69477f358d30f7e = 'feature-flags';
const $14a090e212ebf7a4$export$56470bdd9cd798d0 = 'remote-links';
const $14a090e212ebf7a4$export$3da53566eda5eeef = 'jira.fe.issue.dev-details.time-to.load';
const $14a090e212ebf7a4$export$b4bb784d069c9ab = 'development.details.details-header';
const $14a090e212ebf7a4$export$74189cec821240a6 = 'development.details.remote-links';

parcelRegister("5RlPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $99613e48a8e578d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $aFvYX = parcelRequire("aFvYX");

var $kAdq3 = parcelRequire("kAdq3");

var $aR8n6 = parcelRequire("aR8n6");

var $awlW4 = parcelRequire("awlW4");

var $3IjPO = parcelRequire("3IjPO");

var $cZzAE = parcelRequire("cZzAE");

var $lMWOi = parcelRequire("lMWOi");

var $iqgeJ = parcelRequire("iqgeJ");
class $99613e48a8e578d4$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.store = (0, $cZzAE.default)((0, $3IjPO.default));
        this.dispatchProps();
    }
    componentDidUpdate(prevProps) {
        if ((0, $aFvYX.default)(prevProps, this.props)) return;
        this.dispatchProps();
    }
    dispatchProps() {
        const { onCloseDialog: onCloseDialog, ...stateProps } = this.props;
        this.store.dispatch((0, $lMWOi.initializeAppProps)(stateProps));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            id: "developmentDetailsDialog",
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: "developmentDetailsDialog",
            packageName: "jiraDevelopmentDetails"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAdq3.StartMetric), {
            metric: (0, $awlW4.devDetailsTimeToLoad)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqgeJ.default), this.props)));
    }
}

});
parcelRegister("aFvYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24f9d4e9538bf7e$export$2e2bcd8739ae039);

var $5NVi6 = parcelRequire("5NVi6");
var /**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @atlassian/jira-platform-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f24f9d4e9538bf7e$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $5NVi6.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $5NVi6.default)(value, nextValue);
    });
    return areValuesEqual;
};

});
parcelRegister("5NVi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e4109ba822744d4$export$2e2bcd8739ae039);
/**
 * Returns true if the two given arrays are equal one level deep
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $8e4109ba822744d4$export$2e2bcd8739ae039 = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};

});


parcelRegister("kAdq3", function(module, exports) {

$parcel$export(module.exports, "StopMetric", () => $eede24bd3e1ec54a$export$e96ff7553eadd2a8);
$parcel$export(module.exports, "StartMetric", () => $eede24bd3e1ec54a$export$a8cf8910f40934b2);
$parcel$export(module.exports, "CancelMetric", () => $eede24bd3e1ec54a$export$a5e1c0987a3361a0);

var $eUqFw = parcelRequire("eUqFw");
const $eede24bd3e1ec54a$export$e96ff7553eadd2a8 = ({ metric: metric })=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        metric.stop();
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $eede24bd3e1ec54a$export$a8cf8910f40934b2 = ({ metric: metric })=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        metric.start();
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $eede24bd3e1ec54a$export$a5e1c0987a3361a0 = ({ metric: metric })=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        metric.cancel();
    }, [
        metric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};

});

parcelRegister("awlW4", function(module, exports) {

$parcel$export(module.exports, "devDetailsTimeToLoad", () => $d6d4b662ddde1688$export$f880e4362c4a6a42);

var $lNfG4 = parcelRequire("lNfG4");
const $d6d4b662ddde1688$export$f880e4362c4a6a42 = (0, $lNfG4.metrics).interaction({
    key: 'dev-details.time-to.load',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '300_1000_2500_4000_7000_10000'
    }
});

});

parcelRegister("3IjPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $be80d50d783bc7f7$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $dCCTr = parcelRequire("dCCTr");


var $84IqF = parcelRequire("84IqF");

var $fsoeI = parcelRequire("fsoeI");

var $8Xtx3 = parcelRequire("8Xtx3");

var $lBj3r = parcelRequire("lBj3r");

var $7zYZi = parcelRequire("7zYZi");
const $be80d50d783bc7f7$var$epic = (0, $bd1K7.combineEpics)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $7zYZi.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $8Xtx3.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $lBj3r.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $lBj3r.optOutDeploymentDetailDiscovery), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $84IqF.epic), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $fsoeI.epic));
var $be80d50d783bc7f7$export$2e2bcd8739ae039 = (0, $dCCTr.default)((0, $4bd4dbd4f4336a09$export$d76071d5de2774fc), 'root', $be80d50d783bc7f7$var$epic);

});
parcelRegister("dCCTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c77def2ad7ce8cc2$export$2e2bcd8739ae039);
parcelRequire("1Lcr1");

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");
var /*
 * Catches errors within the epic middleware and makes them available to monitoring.
 *
 * Takes an optional handler as a parameter that can be executed when an error is encountered.
 * This handler returns an observable.
 * This could be used to show an error flag, for example, but will replace attempting to continue
 * the current observable stream.
 *
 * Example usage, which could be applied to the root epic:
 * errorHandlerEpicMiddleware('your-app-name', 'root', combineEpics(epicOne, epicTwo));
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$c77def2ad7ce8cc2$export$2e2bcd8739ae039 = (appId, location, epic, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorHandler)=>(action$, store, deps)=>epic(action$, store, deps).catch((error, stream)=>{
            const fullLocation = `common.epic-error.${appId}.${location}`;
            (0, $gUUjF.default).safeErrorWithoutCustomerData(fullLocation, 'Unhandled error in epic', error);
            (0, $8xmdY.captureException)(fullLocation, error);
            return errorHandler && errorHandler(error) || stream;
        });

});

const $4bd4dbd4f4336a09$export$d76071d5de2774fc = 'development.details';
const $4bd4dbd4f4336a09$export$2fda0856fe66a3c9 = 'DECLINED';
const $4bd4dbd4f4336a09$export$bb29a81b503a982c = 'OPEN';
const $4bd4dbd4f4336a09$export$26d1e2e6f089e8e4 = 'MERGED';
const $4bd4dbd4f4336a09$export$45cb93f72f62540e = 'UNKNOWN';
const $4bd4dbd4f4336a09$export$22401eb1dff04df = 'DRAFT';
const $4bd4dbd4f4336a09$export$dc9cab921059a72 = 'ADDED';
const $4bd4dbd4f4336a09$export$ab06cbdc503432af = 'COPIED';
const $4bd4dbd4f4336a09$export$1cc76b53f23597de = 'DELETED';
const $4bd4dbd4f4336a09$export$57804c30bf47412d = 'MODIFIED';
const $4bd4dbd4f4336a09$export$fdd9e4df1aa8958d = 'MOVED';
const $4bd4dbd4f4336a09$export$52b7b29b7e6404f8 = 'DEPLOYED';
const $4bd4dbd4f4336a09$export$d71930f7f5807a72 = 'FAILED';
const $4bd4dbd4f4336a09$export$c14588b7ed719836 = 'NOT_DEPLOYED';
const $4bd4dbd4f4336a09$export$42dd0cdd351a4a9 = 'PRODUCTION';
const $4bd4dbd4f4336a09$export$a739cd5aac835909 = 'STAGING';
const $4bd4dbd4f4336a09$export$5d789bb7ceeee381 = 'TESTING';
const $4bd4dbd4f4336a09$export$23da285852fc57fc = 'DEVELOPMENT';
const $4bd4dbd4f4336a09$export$a404d8a18351cf3e = 'UNMAPPED';
const $4bd4dbd4f4336a09$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $4bd4dbd4f4336a09$export$aebb42912407fb2d = 'PENDING';
const $4bd4dbd4f4336a09$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $4bd4dbd4f4336a09$export$6b4658081fcf1aed = 'CANCELLED';
const $4bd4dbd4f4336a09$export$4de3c8d09c338516 = 'FAILED';
const $4bd4dbd4f4336a09$export$23bb00587dc6c61 = 'ROLLED_BACK';
const $4bd4dbd4f4336a09$export$f7d0ae1e964896fb = 'SUCCESSFUL';
const $4bd4dbd4f4336a09$export$e68cad5334cc5b = 'vyhOd8hgbSa4rzgnTvyaZNSUqUViKIOc';
const $4bd4dbd4f4336a09$export$a42a1a2fb6310bc7 = 'oAPCjkrphiFxmqbTLkv9r2jBFTvfOI8x';

parcelRegister("84IqF", function(module, exports) {

$parcel$export(module.exports, "epic", () => $29d462178049329f$export$8ec5145af6f76965);
parcelRequire("flmol");
parcelRequire("8OtG5");
parcelRequire("l5lul");
parcelRequire("fiQ2m");

var $3DOEL = parcelRequire("3DOEL");

var $jEbZQ = parcelRequire("jEbZQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $29d462178049329f$var$getAnalyticsForAction = (state, action)=>(0, $jEbZQ.default)[action.type] && (0, $jEbZQ.default)[action.type](state, action);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $29d462178049329f$var$triggerAnalyticsForAction = (event)=>{
    (0, $3DOEL.getAnalyticsWebClient)().sendEvent(event);
};
const $29d462178049329f$export$8ec5145af6f76965 = (action$, store)=>action$.map((action)=>$29d462178049329f$var$getAnalyticsForAction(store.getState(), action)).filter((event)=>!!event).do($29d462178049329f$var$triggerAnalyticsForAction).ignoreElements();

});
parcelRegister("jEbZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5f0ddc6e232797$export$2e2bcd8739ae039);


var $1S1da = parcelRequire("1S1da");

var $iZLP1 = parcelRequire("iZLP1");

var $ipoeq = parcelRequire("ipoeq");

var $gNNkQ = parcelRequire("gNNkQ");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$ea5f0ddc6e232797$export$2e2bcd8739ae039 = {
    [(0, $1S1da.FIRE_DETAIL_DATA_FETCHED_EVENT)]: (state)=>({
            payload: {
                action: 'fetched',
                actionSubject: 'devDetails',
                attributes: (0, $iZLP1.getDetailsReceivedEventAttributes)(state),
                source: (0, $gNNkQ.getActiveTab)(state)
            },
            type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
        }),
    [(0, $1S1da.FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT)]: (state)=>({
            payload: {
                action: (0, $ipoeq.hasEmptyDiffstatForBitbucket)(state) ? 'partiallyFetched' : 'fullyFetched',
                actionSubject: 'bitbucketDiffstat',
                source: (0, $gNNkQ.getActiveTab)(state)
            },
            type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
        })
};

});
parcelRegister("1S1da", function(module, exports) {

$parcel$export(module.exports, "FETCH_DETAIL", () => $d22e0b55de1f8420$export$7c81183ccbd666a0);
$parcel$export(module.exports, "fetchDetail", () => $d22e0b55de1f8420$export$47d408f9b5e5593);
$parcel$export(module.exports, "SET_DETAIL_DATA", () => $d22e0b55de1f8420$export$58da932e063231b2);
$parcel$export(module.exports, "FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT", () => $d22e0b55de1f8420$export$af2bad8228f8ff6b);
$parcel$export(module.exports, "FIRE_DETAIL_DATA_FETCHED_EVENT", () => $d22e0b55de1f8420$export$dd96e80386f99333);
$parcel$export(module.exports, "setDetailData", () => $d22e0b55de1f8420$export$18e0d0155f246019);
$parcel$export(module.exports, "fireBitbucketDiffstatAnalyticsEvent", () => $d22e0b55de1f8420$export$5cf89552779ba9cc);
$parcel$export(module.exports, "fireDetailDataFetchedEvent", () => $d22e0b55de1f8420$export$cd584a07ce04110f);
$parcel$export(module.exports, "FETCHING_FAILED", () => $d22e0b55de1f8420$export$ea08e92921a33ed2);
$parcel$export(module.exports, "fetchingFailed", () => $d22e0b55de1f8420$export$89102398fbdad13e);
$parcel$export(module.exports, "OPT_OUT_DEPLOYMENTS_DISCOVERY", () => $d22e0b55de1f8420$export$8626d637eb2f308f);
$parcel$export(module.exports, "optOutDeploymentDetailDiscovery", () => $d22e0b55de1f8420$export$749833718123995b);
const $d22e0b55de1f8420$export$7c81183ccbd666a0 = 'state.actions.details.FETCH_DETAIL';
const $d22e0b55de1f8420$export$47d408f9b5e5593 = ()=>({
        type: $d22e0b55de1f8420$export$7c81183ccbd666a0
    });
const $d22e0b55de1f8420$export$58da932e063231b2 = 'state.actions.details.SET_DETAIL_DATA';
const $d22e0b55de1f8420$export$af2bad8228f8ff6b = 'state.actions.details.FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT';
const $d22e0b55de1f8420$export$dd96e80386f99333 = 'state.actions.details.FIRE_DETAIL_DATA_FETCHED_EVENT';
const $d22e0b55de1f8420$export$18e0d0155f246019 = (payload)=>({
        type: $d22e0b55de1f8420$export$58da932e063231b2,
        payload: payload
    });
const $d22e0b55de1f8420$export$5cf89552779ba9cc = ()=>({
        type: $d22e0b55de1f8420$export$af2bad8228f8ff6b
    });
const $d22e0b55de1f8420$export$cd584a07ce04110f = (payload)=>({
        type: $d22e0b55de1f8420$export$dd96e80386f99333,
        payload: payload
    });
const $d22e0b55de1f8420$export$ea08e92921a33ed2 = 'state.actions.details.FETCHING_FAILED';
const $d22e0b55de1f8420$export$89102398fbdad13e = ()=>({
        type: $d22e0b55de1f8420$export$ea08e92921a33ed2
    });
const $d22e0b55de1f8420$export$8626d637eb2f308f = 'state.actions.OPT_OUT_DEPLOYMENTS_DISCOVERY';
const $d22e0b55de1f8420$export$749833718123995b = ()=>({
        type: $d22e0b55de1f8420$export$8626d637eb2f308f
    });

});

parcelRegister("iZLP1", function(module, exports) {

$parcel$export(module.exports, "getDetailsReceivedEventAttributes", () => $e241b1f691b2a6fd$export$458dd654ee9bc830);

var $df4Sl = parcelRequire("df4Sl");

var $c5bEE = parcelRequire("c5bEE");

var $aBlK3 = parcelRequire("aBlK3");

var $ipoeq = parcelRequire("ipoeq");

var $6BKzB = parcelRequire("6BKzB");

var $3MW6m = parcelRequire("3MW6m");

var $7Jun3 = parcelRequire("7Jun3");

var $bJBxr = parcelRequire("bJBxr");
const $e241b1f691b2a6fd$export$458dd654ee9bc830 = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getAllInstanceTypeDetails),
    (0, $ipoeq.getAllRepositories),
    (0, $ipoeq.getAllCommitsCount),
    (0, $c5bEE.getAllBranches),
    (0, $7Jun3.getAllPullRequests),
    (0, $aBlK3.getBuildProviders),
    (0, $aBlK3.getBuildsCount),
    (0, $6BKzB.getDeploymentsCount),
    (0, $bJBxr.getRemoteLinksTotalCount)
], (instanceTypes, repositories, commitsCount, branches, pullrequests, buildProviders, buildsCount, deploymentsCount, remoteLinksCount)=>({
        instanceTypeCount: instanceTypes.length,
        buildProvidersCount: buildProviders.length,
        reposCount: repositories.length,
        commitsCount: commitsCount,
        branchesCount: branches.length,
        pullrequestsCount: pullrequests.length,
        buildsCount: buildsCount,
        deploymentsCount: deploymentsCount,
        remoteLinksCount: remoteLinksCount
    }));

});
parcelRegister("c5bEE", function(module, exports) {

$parcel$export(module.exports, "getAllBranches", () => $f716c9661e05e2a1$export$fbe7833bb0d7195a);
$parcel$export(module.exports, "getMultiInstanceBranchForId", () => $f716c9661e05e2a1$export$87498f3bd3494113);
$parcel$export(module.exports, "multiInstanceHasBranches", () => $f716c9661e05e2a1$export$784f5a944dddf872);
$parcel$export(module.exports, "getDiscoveryBranchesWithoutPRs", () => $f716c9661e05e2a1$export$e739fc2a0d32424b);

var $df4Sl = parcelRequire("df4Sl");

var $6ZDS2 = parcelRequire("6ZDS2");

var $j6ziw = parcelRequire("j6ziw");

var $BwVhv = parcelRequire("BwVhv");

var $bbUhj = parcelRequire("bbUhj");

var $3aUuh = parcelRequire("3aUuh");

var $3MW6m = parcelRequire("3MW6m");
const $f716c9661e05e2a1$var$mapInstanceTypeDetailsToBranchesList = (instanceTypeDetails)=>instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(instanceTypeDetails.map((instanceTypeDetail)=>(0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(instanceTypeDetail.repositories.map((repo)=>repo.branches)))) : [];
const $f716c9661e05e2a1$export$8e83e642f64b3797 = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getSelectedInstanceTypeDetails)
], $f716c9661e05e2a1$var$mapInstanceTypeDetailsToBranchesList);
const $f716c9661e05e2a1$export$fbe7833bb0d7195a = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getAllInstanceTypeDetails)
], $f716c9661e05e2a1$var$mapInstanceTypeDetailsToBranchesList);
const $f716c9661e05e2a1$var$getBranchById = (0, $df4Sl.createSelector)([
    $f716c9661e05e2a1$export$8e83e642f64b3797
], (branches)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(branches, (branch)=>branch.id));
const $f716c9661e05e2a1$var$getMultiInstanceBranchById = (0, $df4Sl.createSelector)([
    $f716c9661e05e2a1$export$fbe7833bb0d7195a
], (branches)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(branches, (branch)=>branch.id));
const $f716c9661e05e2a1$export$8d582806d4ccfa1 = (state, id)=>$f716c9661e05e2a1$var$getBranchById(state)[id];
const $f716c9661e05e2a1$export$87498f3bd3494113 = (state, id)=>$f716c9661e05e2a1$var$getMultiInstanceBranchById(state)[id];
const $f716c9661e05e2a1$export$7dc8fa28986f6e8a = (state)=>$f716c9661e05e2a1$export$8e83e642f64b3797(state).length > 0;
const $f716c9661e05e2a1$export$784f5a944dddf872 = (state)=>$f716c9661e05e2a1$export$fbe7833bb0d7195a(state).length > 0;
const $f716c9661e05e2a1$var$flattenEligibleBranches = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((0, (/*@__PURE__*/$parcel$interopDefault($j6ziw)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'repositories')), (0, (/*@__PURE__*/$parcel$interopDefault($j6ziw)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'branches')));
const $f716c9661e05e2a1$export$e739fc2a0d32424b = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getInstancesForPRDiscovery)
], $f716c9661e05e2a1$var$flattenEligibleBranches);

});
parcelRegister("j6ziw", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $de89f53debc53e5f$var$func = $jFIrw('flatMapDeep', (parcelRequire("h0sZe")));

$de89f53debc53e5f$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $de89f53debc53e5f$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});



parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});



parcelRegister("h0sZe", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/** Used as references for various `Number` constants. */ var $c618ebe283af6d5e$var$INFINITY = 1 / 0;
/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $c618ebe283af6d5e$var$flatMapDeep(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), $c618ebe283af6d5e$var$INFINITY);
}
module.exports = $c618ebe283af6d5e$var$flatMapDeep;

});


parcelRegister("BwVhv", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $070cfe9de3c6c09a$var$func = $jFIrw('getOr', (parcelRequire("illlw")));

$070cfe9de3c6c09a$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $070cfe9de3c6c09a$var$func;

});

parcelRegister("bbUhj", function(module, exports) {

module.exports = (parcelRequire("3omiX"));

});
parcelRegister("3omiX", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $2784ea3ef613cf7e$var$func = $jFIrw('flow', (parcelRequire("c8Guq")));

$2784ea3ef613cf7e$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $2784ea3ef613cf7e$var$func;

});


parcelRegister("3MW6m", function(module, exports) {

$parcel$export(module.exports, "getDetailsState", () => $fd18d524e5f351f3$export$36374ff7f1c7f085);
$parcel$export(module.exports, "getSelectedInstanceTypeDetails", () => $fd18d524e5f351f3$export$90d81d836943c1f4);
$parcel$export(module.exports, "getSelectedInstanceBaseUrl", () => $fd18d524e5f351f3$export$f25909d41e7c3596);
$parcel$export(module.exports, "getAllInstanceTypeDetails", () => $fd18d524e5f351f3$export$f7d180cb9209dcec);
$parcel$export(module.exports, "getInstanceTypeDetailsByType", () => $fd18d524e5f351f3$export$4bd371ac17f17b0c);
$parcel$export(module.exports, "getEmbeddedMarketplaceDetails", () => $fd18d524e5f351f3$export$e9bd43294bf74a3f);
$parcel$export(module.exports, "getMultiInstanceRepositories", () => $fd18d524e5f351f3$export$1b565ead0501711b);
$parcel$export(module.exports, "getInstancesForPRDiscovery", () => $fd18d524e5f351f3$export$4ae1ca4d8dfd8e92);
$parcel$export(module.exports, "getAllErrorLinks", () => $fd18d524e5f351f3$export$1455390c38defce);
$parcel$export(module.exports, "getErrorLink", () => $fd18d524e5f351f3$export$9929a1adbfb16fc0);
$parcel$export(module.exports, "getUnauthorizedApplink", () => $fd18d524e5f351f3$export$1b44a95dd4eb1159);
$parcel$export(module.exports, "getAllUnauthorizedApplinks", () => $fd18d524e5f351f3$export$e8ae11b2ac9c5de0);
$parcel$export(module.exports, "isApplicationError", () => $fd18d524e5f351f3$export$8bc44987d4666606);
$parcel$export(module.exports, "isLoading", () => $fd18d524e5f351f3$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $fd18d524e5f351f3$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isDiffstatAnalyticsFired", () => $fd18d524e5f351f3$export$60ddc2fc18c04001);
$parcel$export(module.exports, "isOptOutOfDeploymentDiscovery", () => $fd18d524e5f351f3$export$c2756dd1269e3ee2);

var $df4Sl = parcelRequire("df4Sl");

var $6ZDS2 = parcelRequire("6ZDS2");

var $dd96l = parcelRequire("dd96l");

var $5ZN9W = parcelRequire("5ZN9W");

var $bbUhj = parcelRequire("bbUhj");

var $3aUuh = parcelRequire("3aUuh");

var $gNNkQ = parcelRequire("gNNkQ");
const $fd18d524e5f351f3$export$36374ff7f1c7f085 = (state)=>state.details;
const $fd18d524e5f351f3$export$90d81d836943c1f4 = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$36374ff7f1c7f085,
    (0, $gNNkQ.getSelectedApplicationType)
], (detailsState, selectedType)=>detailsState.details.instanceTypeDetails.filter((item)=>item.type === selectedType));
const $fd18d524e5f351f3$export$f25909d41e7c3596 = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$36374ff7f1c7f085,
    (0, $gNNkQ.getSelectedApplicationType)
], (detailsState, selectedType)=>detailsState.details.instanceTypeDetails.filter((item)=>item.type === selectedType)[0]?.baseUrl);
const $fd18d524e5f351f3$export$f7d180cb9209dcec = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$36374ff7f1c7f085
], (detailsState)=>detailsState.details.instanceTypeDetails);
const $fd18d524e5f351f3$export$4bd371ac17f17b0c = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$f7d180cb9209dcec
], (details)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(details, (detail)=>detail.id));
const $fd18d524e5f351f3$export$e9bd43294bf74a3f = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$36374ff7f1c7f085
], (detailsState)=>detailsState.details.embeddedMarketplaceDetails);
const $fd18d524e5f351f3$export$f594c030cdaac8cb = (state)=>{
    const instanceTypeDetails = $fd18d524e5f351f3$export$90d81d836943c1f4(state);
    return instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(instanceTypeDetails.map((instanceType)=>instanceType.repositories)) : [];
};
const $fd18d524e5f351f3$export$1b565ead0501711b = (state)=>{
    const instanceTypeDetails = $fd18d524e5f351f3$export$f7d180cb9209dcec(state);
    return instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(instanceTypeDetails.map((instanceType)=>instanceType.repositories)) : [];
};
const $fd18d524e5f351f3$var$filterBranchesWithoutPRLinks = (0, (/*@__PURE__*/$parcel$interopDefault($dd96l)))((branch)=>!!branch.createPullRequestUrl && branch.pullRequests.length === 0);
const $fd18d524e5f351f3$var$filterRepositoriesWithoutBranchesWithPRLinks = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((0, (/*@__PURE__*/$parcel$interopDefault($5ZN9W)))((repository)=>({
        ...repository,
        branches: $fd18d524e5f351f3$var$filterBranchesWithoutPRLinks(repository.branches)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($dd96l)))((repository)=>repository.branches.length > 0));
const $fd18d524e5f351f3$var$filterInstancesWithoutRepositories = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((0, (/*@__PURE__*/$parcel$interopDefault($5ZN9W)))((instance)=>({
        ...instance,
        repositories: $fd18d524e5f351f3$var$filterRepositoriesWithoutBranchesWithPRLinks(instance.repositories)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($dd96l)))((instance)=>instance.repositories.length > 0));
const $fd18d524e5f351f3$export$4ae1ca4d8dfd8e92 = (0, $df4Sl.createSelector)($fd18d524e5f351f3$export$f7d180cb9209dcec, $fd18d524e5f351f3$var$filterInstancesWithoutRepositories);
const $fd18d524e5f351f3$var$getErrorLinkForTypes = (instanceTypeDetails)=>{
    const results = [];
    if (instanceTypeDetails.length > 0) instanceTypeDetails.forEach((instanceType)=>{
        if (instanceType.errorLink) results.push(instanceType.errorLink);
    });
    return results;
};
const $fd18d524e5f351f3$var$getUnauthoroizedAppLinks = (instanceTypeDetails)=>{
    const results = [];
    if (instanceTypeDetails.length > 0) instanceTypeDetails.forEach((instanceType)=>{
        if (instanceType.unauthorizedLink) results.push(instanceType.unauthorizedLink);
    });
    return results;
};
const $fd18d524e5f351f3$export$1455390c38defce = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$f7d180cb9209dcec
], (instanceTypes)=>$fd18d524e5f351f3$var$getErrorLinkForTypes(instanceTypes));
const $fd18d524e5f351f3$export$9929a1adbfb16fc0 = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$90d81d836943c1f4
], (instanceTypes)=>$fd18d524e5f351f3$var$getErrorLinkForTypes(instanceTypes));
const $fd18d524e5f351f3$export$1b44a95dd4eb1159 = (0, $df4Sl.createSelector)($fd18d524e5f351f3$export$90d81d836943c1f4, (instanceTypes)=>$fd18d524e5f351f3$var$getUnauthoroizedAppLinks(instanceTypes));
const $fd18d524e5f351f3$export$e8ae11b2ac9c5de0 = (0, $df4Sl.createSelector)($fd18d524e5f351f3$export$f7d180cb9209dcec, (instanceTypes)=>$fd18d524e5f351f3$var$getUnauthoroizedAppLinks(instanceTypes));
const $fd18d524e5f351f3$export$8bc44987d4666606 = (0, $df4Sl.createSelector)([
    $fd18d524e5f351f3$export$9929a1adbfb16fc0,
    $fd18d524e5f351f3$export$1b44a95dd4eb1159
], (errors, appErrors)=>errors && errors.length > 0 || appErrors && appErrors.length > 0);
const $fd18d524e5f351f3$export$20bb0d907fbbe433 = (state)=>$fd18d524e5f351f3$export$36374ff7f1c7f085(state).isLoading;
const $fd18d524e5f351f3$export$e6127cc7fe7395c3 = (state)=>$fd18d524e5f351f3$export$36374ff7f1c7f085(state).isError;
const $fd18d524e5f351f3$export$60ddc2fc18c04001 = (state)=>$fd18d524e5f351f3$export$36374ff7f1c7f085(state).isDiffstatAnalyticsFired || false;
const $fd18d524e5f351f3$export$c2756dd1269e3ee2 = (state)=>$fd18d524e5f351f3$export$36374ff7f1c7f085(state).isOptOutOfDeploymentDiscovery;

});
parcelRegister("dd96l", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $99e38c9c15cf1228$var$func = $jFIrw('filter', (parcelRequire("ezsJz")));

$99e38c9c15cf1228$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $99e38c9c15cf1228$var$func;

});
parcelRegister("ezsJz", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $a9ba9f860705508e$var$filter(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $a9ba9f860705508e$var$filter;

});
parcelRegister("9vvKC", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6ebfa35ee06f887f$var$baseFilter(collection, predicate) {
    var result = [];
    $awetI(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $6ebfa35ee06f887f$var$baseFilter;

});



parcelRegister("5ZN9W", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $45d8c845751d4a1f$var$func = $jFIrw('map', (parcelRequire("eo8NR")));

$45d8c845751d4a1f$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $45d8c845751d4a1f$var$func;

});

parcelRegister("gNNkQ", function(module, exports) {

$parcel$export(module.exports, "getActiveTab", () => $d7ed6a18a8f5d181$export$65f5dad1c8b348cd);
$parcel$export(module.exports, "getSelectedApplicationType", () => $d7ed6a18a8f5d181$export$89d32e1908ffbe6f);
$parcel$export(module.exports, "isCreatingPullRequestFromDiscovery", () => $d7ed6a18a8f5d181$export$c1036e3a0400aebe);
const $d7ed6a18a8f5d181$var$getUi = (state)=>state.ui;
const $d7ed6a18a8f5d181$export$65f5dad1c8b348cd = (state)=>$d7ed6a18a8f5d181$var$getUi(state).activeTab;
const $d7ed6a18a8f5d181$export$89d32e1908ffbe6f = (state)=>$d7ed6a18a8f5d181$var$getUi(state).selectedApplicationType;
const $d7ed6a18a8f5d181$export$c1036e3a0400aebe = (state)=>$d7ed6a18a8f5d181$var$getUi(state).isCreatingPullRequestFromDiscovery;

});



parcelRegister("aBlK3", function(module, exports) {

$parcel$export(module.exports, "getBuildProviders", () => $3240ab893c120d04$export$6a063eb90049a9f9);
$parcel$export(module.exports, "getBuildsCount", () => $3240ab893c120d04$export$37fe964fd70bc325);
$parcel$export(module.exports, "hasBuilds", () => $3240ab893c120d04$export$fa819f9835fb7ab9);

var $df4Sl = parcelRequire("df4Sl");

var $dd96l = parcelRequire("dd96l");

var $8aNmm = parcelRequire("8aNmm");

var $BwVhv = parcelRequire("BwVhv");

var $bbUhj = parcelRequire("bbUhj");

var $3MW6m = parcelRequire("3MW6m");
const $3240ab893c120d04$var$filterProvidersWithoutBuilds = (0, (/*@__PURE__*/$parcel$interopDefault($dd96l)))((provider)=>provider.builds.length > 0);
const $3240ab893c120d04$export$6a063eb90049a9f9 = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getAllInstanceTypeDetails)
], (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((0, (/*@__PURE__*/$parcel$interopDefault($8aNmm)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'buildProviders')), $3240ab893c120d04$var$filterProvidersWithoutBuilds));
const $3240ab893c120d04$var$getBuilds = (0, $df4Sl.createSelector)([
    $3240ab893c120d04$export$6a063eb90049a9f9
], (0, (/*@__PURE__*/$parcel$interopDefault($8aNmm)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'builds')));
const $3240ab893c120d04$export$37fe964fd70bc325 = (0, $df4Sl.createSelector)([
    $3240ab893c120d04$var$getBuilds
], (builds)=>builds.length);
const $3240ab893c120d04$export$fa819f9835fb7ab9 = (0, $df4Sl.createSelector)([
    $3240ab893c120d04$export$37fe964fd70bc325
], (count)=>count > 0);

});
parcelRegister("8aNmm", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $5f358baee26b8fc8$var$func = $jFIrw('flatMap', (parcelRequire("9OdO2")));

$5f358baee26b8fc8$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $5f358baee26b8fc8$var$func;

});


parcelRegister("ipoeq", function(module, exports) {

$parcel$export(module.exports, "getAllRepositories", () => $02a444c9229a1e22$export$40d2f6cdde350698);
$parcel$export(module.exports, "getMultiInstanceRepositoryIds", () => $02a444c9229a1e22$export$f67c422415a712f0);
$parcel$export(module.exports, "multiInstanceHasCommits", () => $02a444c9229a1e22$export$5113ae74ec2e3a4d);
$parcel$export(module.exports, "hasBitbucketCommits", () => $02a444c9229a1e22$export$c46d71e82fd3f0d3);
$parcel$export(module.exports, "hasEmptyDiffstatForBitbucket", () => $02a444c9229a1e22$export$3249832cb7ef2c30);
$parcel$export(module.exports, "getAllCommitsCount", () => $02a444c9229a1e22$export$492f2f301fb0fce5);
$parcel$export(module.exports, "hasEmptyDiffstatForAnyRepositories", () => $02a444c9229a1e22$export$6016129de20acc3a);
$parcel$export(module.exports, "getMultiInstanceRepositoriesForId", () => $02a444c9229a1e22$export$73edbe998d3a980c);
$parcel$export(module.exports, "multiInstanceHasDiffstat", () => $02a444c9229a1e22$export$4e94c174ed0b6706);
$parcel$export(module.exports, "getMultiInstanceCommitForRepositoryIdAndCommitId", () => $02a444c9229a1e22$export$14961bb097a30129);

var $df4Sl = parcelRequire("df4Sl");

var $9OdO2 = parcelRequire("9OdO2");

var $6ZDS2 = parcelRequire("6ZDS2");

var $3aUuh = parcelRequire("3aUuh");

var $czx3b = parcelRequire("czx3b");

var $3G3gn = parcelRequire("3G3gn");

var $3MW6m = parcelRequire("3MW6m");
const $02a444c9229a1e22$var$transformToRepositoriesArray = (instanceTypeDetails)=>instanceTypeDetails ? (0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(instanceTypeDetails.map((instanceTypeDetail)=>(0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))(instanceTypeDetail.repositories))) : [];
const $02a444c9229a1e22$export$40d2f6cdde350698 = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getAllInstanceTypeDetails)
], $02a444c9229a1e22$var$transformToRepositoriesArray);
const $02a444c9229a1e22$export$f594c030cdaac8cb = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getSelectedInstanceTypeDetails)
], $02a444c9229a1e22$var$transformToRepositoriesArray);
const $02a444c9229a1e22$export$767ae3b5a7add336 = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getInstanceTypeDetailsByType)
], (detailsByType)=>{
    const bitbucketDetails = detailsByType.bitbucket;
    return bitbucketDetails ? $02a444c9229a1e22$var$transformToRepositoriesArray([
        bitbucketDetails
    ]) : [];
});
const $02a444c9229a1e22$export$1cc6d83b3e47d08b = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$f594c030cdaac8cb
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(repositories, 'name').map((repo)=>repo.id));
const $02a444c9229a1e22$export$f67c422415a712f0 = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$40d2f6cdde350698
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))(repositories, 'name').map((repo)=>repo.id));
const $02a444c9229a1e22$var$hasCommitsInRepos = (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(repositories, (repo)=>repo.commits).length > 0;
const $02a444c9229a1e22$export$1048c611ef735231 = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$f594c030cdaac8cb
], $02a444c9229a1e22$var$hasCommitsInRepos);
const $02a444c9229a1e22$export$5113ae74ec2e3a4d = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$40d2f6cdde350698
], $02a444c9229a1e22$var$hasCommitsInRepos);
const $02a444c9229a1e22$export$c46d71e82fd3f0d3 = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$767ae3b5a7add336
], $02a444c9229a1e22$var$hasCommitsInRepos);
const $02a444c9229a1e22$export$3249832cb7ef2c30 = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$767ae3b5a7add336
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(repositories, (repo)=>repo.commits).map((commit)=>commit.fileCount).filter((fileCount)=>!fileCount).length > 0);
const $02a444c9229a1e22$export$492f2f301fb0fce5 = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$40d2f6cdde350698
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(repositories, (repo)=>repo.commits).length);
const $02a444c9229a1e22$export$6016129de20acc3a = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$40d2f6cdde350698
], (repositories)=>repositories && repositories.length > 0 && repositories.some((repository)=>repository.commits.some((commit)=>!commit.fileCount)));
const $02a444c9229a1e22$var$getRepositoriesById = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$f594c030cdaac8cb
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(repositories, (repository)=>repository.id));
const $02a444c9229a1e22$var$getMultiInstanceRepositoriesById = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$export$40d2f6cdde350698
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(repositories, (repository)=>repository.id));
const $02a444c9229a1e22$export$f1678251e3586c3f = (state, id)=>$02a444c9229a1e22$var$getRepositoriesById(state)[id];
const $02a444c9229a1e22$export$73edbe998d3a980c = (state, id)=>$02a444c9229a1e22$var$getMultiInstanceRepositoriesById(state)[id];
const $02a444c9229a1e22$export$a2bbcbabd13a4854 = (state, id)=>$02a444c9229a1e22$export$f1678251e3586c3f(state, id).commits.some((commit)=>commit.fileCount);
const $02a444c9229a1e22$export$4e94c174ed0b6706 = (state, id)=>$02a444c9229a1e22$export$73edbe998d3a980c(state, id).commits.some((commit)=>commit.fileCount);
const $02a444c9229a1e22$var$getCommitsByRepositoriesById = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$var$getRepositoriesById
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(repositories, ({ commits: commits })=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(commits, (commit)=>commit.id)));
const $02a444c9229a1e22$var$getMultiInstanceCommitsByRepositoriesById = (0, $df4Sl.createSelector)([
    $02a444c9229a1e22$var$getMultiInstanceRepositoriesById
], (repositories)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(repositories, ({ commits: commits })=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(commits, (commit)=>commit.id)));
const $02a444c9229a1e22$export$a155de9a09f1ae7f = (state, repositoryId, id)=>{
    const repository = $02a444c9229a1e22$var$getCommitsByRepositoriesById(state)[repositoryId];
    return (repository || {})[id];
};
const $02a444c9229a1e22$export$14961bb097a30129 = (state, repositoryId, id)=>{
    const repository = $02a444c9229a1e22$var$getMultiInstanceCommitsByRepositoriesById(state)[repositoryId];
    return (repository || {})[id];
};

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});


parcelRegister("6BKzB", function(module, exports) {

$parcel$export(module.exports, "getDeploymentsByEnvironmentTypes", () => $e5fef29ae9075fc4$export$c9e16e5430d50d52);
$parcel$export(module.exports, "getShowDeploymentTypeHeader", () => $e5fef29ae9075fc4$export$cb2ab1c10ada445c);
$parcel$export(module.exports, "getDeploymentsCount", () => $e5fef29ae9075fc4$export$5293cb68c5e86e85);
$parcel$export(module.exports, "hasDeployments", () => $e5fef29ae9075fc4$export$feabb47efebd957);
$parcel$export(module.exports, "getLatestDeployment", () => $e5fef29ae9075fc4$export$8198b9b4efbc776e);

var $df4Sl = parcelRequire("df4Sl");

var $8aNmm = parcelRequire("8aNmm");

var $BwVhv = parcelRequire("BwVhv");

var $fcWBJ = parcelRequire("fcWBJ");

var $eo8NR = parcelRequire("eo8NR");

var $bDIST = parcelRequire("bDIST");

var $3G3gn = parcelRequire("3G3gn");


var $3MW6m = parcelRequire("3MW6m");
const $e5fef29ae9075fc4$var$environmentTypeScore = {
    [(0, $4bd4dbd4f4336a09$export$42dd0cdd351a4a9)]: 1,
    [(0, $4bd4dbd4f4336a09$export$a739cd5aac835909)]: 2,
    [(0, $4bd4dbd4f4336a09$export$5d789bb7ceeee381)]: 3,
    [(0, $4bd4dbd4f4336a09$export$23da285852fc57fc)]: 4,
    [(0, $4bd4dbd4f4336a09$export$a404d8a18351cf3e)]: 5
};
const $e5fef29ae9075fc4$var$getDeploymentProviders = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getDetailsState)
], (detailsState)=>detailsState.details.deploymentProviders);
const $e5fef29ae9075fc4$var$getDeployments = (0, $df4Sl.createSelector)([
    $e5fef29ae9075fc4$var$getDeploymentProviders
], (0, (/*@__PURE__*/$parcel$interopDefault($8aNmm)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'deployments')));
const $e5fef29ae9075fc4$var$getTypeScore = (deploymentsByEnvironment)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<EnvironmentType, number>>'.
    $e5fef29ae9075fc4$var$environmentTypeScore[deploymentsByEnvironment.type];
const $e5fef29ae9075fc4$var$sortDeployments = (deployments)=>(0, (/*@__PURE__*/$parcel$interopDefault($bDIST)))(deployments, 'lastUpdated', 'desc');
const $e5fef29ae9075fc4$var$groupByEnvironment = (allDeployments)=>(0, (/*@__PURE__*/$parcel$interopDefault($eo8NR)))((0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(allDeployments, (deployment)=>deployment.environment.type), (deployments, type)=>({
            type: type,
            deployments: $e5fef29ae9075fc4$var$sortDeployments(deployments)
        }));
const $e5fef29ae9075fc4$export$c9e16e5430d50d52 = (0, $df4Sl.createSelector)([
    $e5fef29ae9075fc4$var$getDeployments
], (allDeployments)=>(0, (/*@__PURE__*/$parcel$interopDefault($3G3gn)))($e5fef29ae9075fc4$var$groupByEnvironment(allDeployments), $e5fef29ae9075fc4$var$getTypeScore));
const $e5fef29ae9075fc4$export$cb2ab1c10ada445c = (0, $df4Sl.createSelector)([
    $e5fef29ae9075fc4$export$c9e16e5430d50d52
], (allDeploymentTypes)=>allDeploymentTypes.length !== 1 || allDeploymentTypes[0].type !== 'UNMAPPED');
const $e5fef29ae9075fc4$export$5293cb68c5e86e85 = (state)=>$e5fef29ae9075fc4$var$getDeployments(state).length;
const $e5fef29ae9075fc4$export$feabb47efebd957 = (state)=>$e5fef29ae9075fc4$export$5293cb68c5e86e85(state) > 0;
const $e5fef29ae9075fc4$export$8198b9b4efbc776e = (0, $df4Sl.createSelector)([
    $e5fef29ae9075fc4$export$c9e16e5430d50d52
], (allDeploymentTypes)=>allDeploymentTypes?.[0]?.deployments?.[0] ?? null);

});
parcelRegister("bDIST", function(module, exports) {

var $943C2 = parcelRequire("943C2");

var $1c8hB = parcelRequire("1c8hB");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $8796275107b9d4d1$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$1c8hB(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$1c8hB(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $943C2(collection, iteratees, orders);
}
module.exports = $8796275107b9d4d1$var$orderBy;

});


parcelRegister("7Jun3", function(module, exports) {

$parcel$export(module.exports, "getAllPullRequests", () => $8cb2107026a5671f$export$ab04ae017c0b8f3c);
$parcel$export(module.exports, "getMultiInstanceTypePullRequestsGroupByRepoName", () => $8cb2107026a5671f$export$beca9e2e23ad385f);
$parcel$export(module.exports, "getMultiInstancePullRequestForId", () => $8cb2107026a5671f$export$6059e4d9b1f501ed);
$parcel$export(module.exports, "multiInstanceHasPullRequests", () => $8cb2107026a5671f$export$5d7f343387e155d9);

var $df4Sl = parcelRequire("df4Sl");

var $j6ziw = parcelRequire("j6ziw");

var $BwVhv = parcelRequire("BwVhv");

var $5ZN9W = parcelRequire("5ZN9W");

var $kko7W = parcelRequire("kko7W");

var $bbUhj = parcelRequire("bbUhj");

var $lvobk = parcelRequire("lvobk");

var $3aUuh = parcelRequire("3aUuh");


var $3MW6m = parcelRequire("3MW6m");
const $8cb2107026a5671f$var$getDanglingPullRequestOrNothing = (0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'danglingPullRequests');
const $8cb2107026a5671f$var$getReposPullRequests = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'repositories'), (0, (/*@__PURE__*/$parcel$interopDefault($5ZN9W)))((0, (/*@__PURE__*/$parcel$interopDefault($BwVhv)))([], 'pullRequests')));
const $8cb2107026a5671f$var$statusScore = {
    [(0, $4bd4dbd4f4336a09$export$bb29a81b503a982c)]: 1,
    [(0, $4bd4dbd4f4336a09$export$26d1e2e6f089e8e4)]: 2,
    [(0, $4bd4dbd4f4336a09$export$2fda0856fe66a3c9)]: 3
};
const $8cb2107026a5671f$var$getStatusScore = (pullRequest)=>$8cb2107026a5671f$var$statusScore[pullRequest.status];
const $8cb2107026a5671f$var$getInstanceTypeDetailsPullRequests = (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((0, (/*@__PURE__*/$parcel$interopDefault($j6ziw)))((0, (/*@__PURE__*/$parcel$interopDefault($kko7W)))([
    $8cb2107026a5671f$var$getReposPullRequests,
    $8cb2107026a5671f$var$getDanglingPullRequestOrNothing
])), (0, (/*@__PURE__*/$parcel$interopDefault($lvobk)))($8cb2107026a5671f$var$getStatusScore));
const $8cb2107026a5671f$export$89579874f56fc99d = (0, $df4Sl.createSelector)((0, $3MW6m.getSelectedInstanceTypeDetails), $8cb2107026a5671f$var$getInstanceTypeDetailsPullRequests);
const $8cb2107026a5671f$export$ab04ae017c0b8f3c = (0, $df4Sl.createSelector)((0, $3MW6m.getAllInstanceTypeDetails), $8cb2107026a5671f$var$getInstanceTypeDetailsPullRequests);
const $8cb2107026a5671f$export$beca9e2e23ad385f = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getAllInstanceTypeDetails)
], (allInstanceTypeDetails)=>allInstanceTypeDetails.reduce((acc, instanceDetail)=>{
        const pullRequests = $8cb2107026a5671f$var$getInstanceTypeDetailsPullRequests([
            instanceDetail
        ]);
        pullRequests.forEach((pullrequest)=>{
            const key = `${pullrequest.repositoryName}-${instanceDetail.typeName}`;
            if (!acc[key]) acc[key] = {
                providerId: instanceDetail.id,
                instanceName: instanceDetail.typeName,
                repositoryId: pullrequest.repositoryId,
                repositoryName: pullrequest.repositoryName,
                repositoryUrl: pullrequest.repositoryUrl,
                repositoryAvatarUrl: pullrequest.repositoryAvatarUrl,
                pullRequests: []
            };
            acc[key].pullRequests.push(pullrequest);
        });
        return acc;
    }, {}));
const $8cb2107026a5671f$var$getPullRequestById = (0, $df4Sl.createSelector)([
    $8cb2107026a5671f$export$89579874f56fc99d
], (pullRequests)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(pullRequests, (pullRequest)=>pullRequest.uid));
const $8cb2107026a5671f$var$getMultiInstancePullRequestById = (0, $df4Sl.createSelector)([
    $8cb2107026a5671f$export$ab04ae017c0b8f3c
], (pullRequests)=>(0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(pullRequests, (pullRequest)=>pullRequest.uid));
const $8cb2107026a5671f$export$2eabaf76224fd65 = (state, id)=>$8cb2107026a5671f$var$getPullRequestById(state)[id];
const $8cb2107026a5671f$export$6059e4d9b1f501ed = (state, id)=>$8cb2107026a5671f$var$getMultiInstancePullRequestById(state)[id];
const $8cb2107026a5671f$export$5637cc948831a9a7 = (state)=>$8cb2107026a5671f$export$89579874f56fc99d(state).length > 0;
const $8cb2107026a5671f$export$5d7f343387e155d9 = (state)=>$8cb2107026a5671f$export$ab04ae017c0b8f3c(state).length > 0;

});
parcelRegister("kko7W", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $ecc8640560b84b9e$var$func = $jFIrw('over', (parcelRequire("i8TjS")));

$ecc8640560b84b9e$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $ecc8640560b84b9e$var$func;

});
parcelRegister("i8TjS", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $j9vt0 = parcelRequire("j9vt0");
/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */ var $d353e2ae6ecb6ad9$var$over = $j9vt0($kJvGp);
module.exports = $d353e2ae6ecb6ad9$var$over;

});
parcelRegister("j9vt0", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $74vSq = parcelRequire("74vSq");

var $224h2 = parcelRequire("224h2");
/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */ function $df174438844ec606$var$createOver(arrayFunc) {
    return $224h2(function(iteratees) {
        iteratees = $kJvGp(iteratees, $74vSq($7qARj));
        return $9eFtX(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee) {
                return $5VdlS(iteratee, thisArg, args);
            });
        });
    });
}
module.exports = $df174438844ec606$var$createOver;

});



parcelRegister("lvobk", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $fa7f40333865d86c$var$func = $jFIrw('sortBy', (parcelRequire("3G3gn")));

$fa7f40333865d86c$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $fa7f40333865d86c$var$func;

});


parcelRegister("bJBxr", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $b8777aed96b998d1$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getRemoteLinksByType", () => $b8777aed96b998d1$export$afc511e2c997e9c);
$parcel$export(module.exports, "getRemoteLinkProvidersCount", () => $b8777aed96b998d1$export$d1b24cd0f6c9b80c);
$parcel$export(module.exports, "getRemoteLinksTotalCount", () => $b8777aed96b998d1$export$93511f509c82200a);
$parcel$export(module.exports, "getRemoteLinksSummary", () => $b8777aed96b998d1$export$edc1195c568f453f);

var $df4Sl = parcelRequire("df4Sl");

var $g4Gw0 = parcelRequire("g4Gw0");

var $5ZN9W = parcelRequire("5ZN9W");

var $bbUhj = parcelRequire("bbUhj");

var $3HqQe = parcelRequire("3HqQe");

var $hz2yR = parcelRequire("hz2yR");

var $3MW6m = parcelRequire("3MW6m");
const $b8777aed96b998d1$export$68132327813bd90 = (0, $df4Sl.createSelector)((0, $3MW6m.getDetailsState), (details)=>details.details.remoteLinkInformation ? details.details.remoteLinkInformation : {
        numProviders: 0,
        remoteLinksByType: {}
    });
const $b8777aed96b998d1$export$dd1bc94b04021eeb = (0, $df4Sl.createSelector)($b8777aed96b998d1$export$68132327813bd90, (remoteLinksInfo)=>Object.keys(remoteLinksInfo.remoteLinksByType).length === 0);
const $b8777aed96b998d1$export$afc511e2c997e9c = (0, $df4Sl.createSelector)($b8777aed96b998d1$export$68132327813bd90, (remoteLinkInfo = {})=>{
    const { remoteLinksByType: remoteLinksByType } = remoteLinkInfo;
    return Object.keys(remoteLinksByType).reduce((remoteLinks, type)=>{
        if (!remoteLinksByType[type]) return remoteLinks;
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"other" | "security" | "alert" | "document" | "test" | "logFile" | "prototype" | "coverage" | "bugReport"'.
        if ((0, $hz2yR.REMOTE_LINK_TYPES).includes(type)) remoteLinks.push({
            remoteLinkType: type,
            // @ts-expect-error - TS2322 - Type 'RemoteLink[]' is not assignable to type 'never[]'.
            remoteLinks: remoteLinksByType[type]
        });
        else // it's unknown - add it to the object with all unknowns
        // @ts-expect-error - TS2345 - Argument of type 'RemoteLink' is not assignable to parameter of type 'never'.
        remoteLinks[0].remoteLinks.push(...remoteLinksByType[type]);
        return remoteLinks;
    }, [
        {
            remoteLinkType: 'unknown',
            remoteLinks: []
        }
    ]).filter((remoteLinks)=>remoteLinks.remoteLinks.length > 0);
});
const $b8777aed96b998d1$export$be64678a6f02e2d2 = (0, $df4Sl.createSelector)($b8777aed96b998d1$export$68132327813bd90, (0, (/*@__PURE__*/$parcel$interopDefault($bbUhj)))((remoteLinkInfo)=>remoteLinkInfo.remoteLinksByType, (0, (/*@__PURE__*/$parcel$interopDefault($5ZN9W)))('remoteLinks'), (0, (/*@__PURE__*/$parcel$interopDefault($g4Gw0))), (0, (/*@__PURE__*/$parcel$interopDefault($5ZN9W)))('provider.id'), (0, (/*@__PURE__*/$parcel$interopDefault($3HqQe)))));
const $b8777aed96b998d1$export$d1b24cd0f6c9b80c = (0, $df4Sl.createSelector)($b8777aed96b998d1$export$68132327813bd90, (remoteLinkInfo)=>remoteLinkInfo.numProviders);
const $b8777aed96b998d1$export$93511f509c82200a = (0, $df4Sl.createSelector)($b8777aed96b998d1$export$68132327813bd90, (remoteLinkInfo)=>Object.keys(remoteLinkInfo.remoteLinksByType).reduce((acc, remoteLinkType)=>acc + remoteLinkInfo.remoteLinksByType[remoteLinkType].length, 0));
const $b8777aed96b998d1$export$edc1195c568f453f = (0, $df4Sl.createSelector)($b8777aed96b998d1$export$68132327813bd90, (remoteLinkInfo)=>{
    const links = [];
    Object.keys(remoteLinkInfo.remoteLinksByType).forEach((type)=>{
        remoteLinkInfo.remoteLinksByType[type].forEach((link)=>{
            links.push({
                RemoteLinkId: link.id,
                RemoteLinkProviderId: link.provider.id,
                RemoteLinkProviderName: link.provider.name,
                RemoteLinkType: link.type,
                RemoteLinkStatus: link.status ? link.status.label : '',
                RemoteLinkDescription: link.description ? link.description : ''
            });
        });
    });
    return links;
});

});
parcelRegister("g4Gw0", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $bb3dffb182c334e8$var$func = $jFIrw('flatten', (parcelRequire("6ZDS2")), (parcelRequire("jKGa6")));

$bb3dffb182c334e8$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $bb3dffb182c334e8$var$func;

});
parcelRegister("jKGa6", function(module, exports) {
module.exports = {
    'cap': false,
    'curry': false,
    'fixed': false,
    'immutable': false,
    'rearg': false
};

});


parcelRegister("3HqQe", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");


var $2b1a356672d01117$var$func = $jFIrw('uniq', (parcelRequire("MdoH4")), (parcelRequire("jKGa6")));

$2b1a356672d01117$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $2b1a356672d01117$var$func;

});

parcelRegister("hz2yR", function(module, exports) {

$parcel$export(module.exports, "REMOTE_LINK_TYPES", () => $2b62fb6df900cd90$export$a544329e8f55f05);
const $2b62fb6df900cd90$export$a544329e8f55f05 = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];

});





parcelRegister("fsoeI", function(module, exports) {

$parcel$export(module.exports, "epic", () => $378dd0008cc03578$export$8ec5145af6f76965);
parcelRequire("iects");
parcelRequire("8OtG5");


var $1S1da = parcelRequire("1S1da");

var $h60TS = parcelRequire("h60TS");

var $3MW6m = parcelRequire("3MW6m");

var $ipoeq = parcelRequire("ipoeq");

var $gNNkQ = parcelRequire("gNNkQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $378dd0008cc03578$var$diffstatAnalyticEventOrNull = (state)=>{
    const shouldFireDiffstatAnalytics = !(0, $3MW6m.isDiffstatAnalyticsFired)(state) && (0, $gNNkQ.getActiveTab)(state) === (0, $14a090e212ebf7a4$export$2e42513c7764d5f3) && (0, $ipoeq.hasBitbucketCommits)(state);
    return shouldFireDiffstatAnalytics ? (0, $1S1da.fireBitbucketDiffstatAnalyticsEvent)() : null;
};
const $378dd0008cc03578$var$eventsMappers = {
    // @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $1S1da.SET_DETAIL_DATA)]: (action, state)=>[
            (0, $1S1da.fireDetailDataFetchedEvent)(action.payload),
            $378dd0008cc03578$var$diffstatAnalyticEventOrNull(state)
        ],
    // @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type. | TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $h60TS.CHANGE_TAB)]: (action, state)=>[
            $378dd0008cc03578$var$diffstatAnalyticEventOrNull(state)
        ]
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $378dd0008cc03578$var$getNewActions = (action, store)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly "state.actions.details.SET_DETAIL_DATA": (action: any, state: any) => (FireDetailDataFetchedEventAction | FireBitbucketDiffstatAnalyticsEventAction | null)[]; readonly "state.actions.ui.CHANGE_TAB": (action: any, state: any) => (FireBitbucketDiffstatAnalyticsEventAction | null)[]; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly "state.actions.details.SET_DETAIL_DATA": (action: any, state: any) => (FireDetailDataFetchedEventAction | FireBitbucketDiffstatAnalyticsEventAction | null)[]; readonly "state.actions.ui.CHANGE_TAB": (action: any, state: any) => (FireBitbucketDiffstatAnalyticsEventAction | null)[]; }'.
    $378dd0008cc03578$var$eventsMappers[action.type] && $378dd0008cc03578$var$eventsMappers[action.type](action, store) || [];
const $378dd0008cc03578$export$8ec5145af6f76965 = (action$, store)=>action$.flatMap((action)=>$378dd0008cc03578$var$getNewActions(action, store.getState())).filter((newAction)=>!!newAction);

});
parcelRegister("h60TS", function(module, exports) {

$parcel$export(module.exports, "CHANGE_TAB", () => $355a1b51fc688f6c$export$a47987c4210b1f64);
$parcel$export(module.exports, "changeTab", () => $355a1b51fc688f6c$export$595e5d7be493cad3);
$parcel$export(module.exports, "SET_SELECTED_APPLICATION_TYPE", () => $355a1b51fc688f6c$export$7efca4d99d61577a);
$parcel$export(module.exports, "setSelectedApplicationType", () => $355a1b51fc688f6c$export$959e9e5b05ba3981);
$parcel$export(module.exports, "OPEN_PULL_REQUEST_CREATION_DISCOVERY", () => $355a1b51fc688f6c$export$8e35f3f909f3560f);
$parcel$export(module.exports, "openPullRequestCreationDiscovery", () => $355a1b51fc688f6c$export$5be9ed3e28a3477c);
$parcel$export(module.exports, "CLOSE_PULL_REQUEST_CREATION_DISCOVERY", () => $355a1b51fc688f6c$export$57d52469ed51b520);
$parcel$export(module.exports, "closePullRequestCreationDiscovery", () => $355a1b51fc688f6c$export$26193fce85ab99e0);
const $355a1b51fc688f6c$export$a47987c4210b1f64 = 'state.actions.ui.CHANGE_TAB';
const $355a1b51fc688f6c$export$595e5d7be493cad3 = (activeTab)=>({
        type: $355a1b51fc688f6c$export$a47987c4210b1f64,
        payload: {
            activeTab: activeTab
        }
    });
const $355a1b51fc688f6c$export$7efca4d99d61577a = 'state.actions.ui.SET_SELECTED_APPLICATION_TYPE';
const $355a1b51fc688f6c$export$959e9e5b05ba3981 = (selectedApplicationType)=>({
        type: $355a1b51fc688f6c$export$7efca4d99d61577a,
        payload: {
            selectedApplicationType: selectedApplicationType
        }
    });
const $355a1b51fc688f6c$export$8e35f3f909f3560f = 'state.actions.ui.OPEN_PULL_REQUEST_CREATION_DISCOVERY';
const $355a1b51fc688f6c$export$5be9ed3e28a3477c = ()=>({
        type: $355a1b51fc688f6c$export$8e35f3f909f3560f
    });
const $355a1b51fc688f6c$export$57d52469ed51b520 = 'state.actions.ui.CLOSE_PULL_REQUEST_CREATION_DISCOVERY';
const $355a1b51fc688f6c$export$26193fce85ab99e0 = ()=>({
        type: $355a1b51fc688f6c$export$57d52469ed51b520
    });

});


parcelRegister("8Xtx3", function(module, exports) {

$parcel$export(module.exports, "epic", () => $0dbca3ec606aaa95$export$8ec5145af6f76965);
parcelRequire("8jBvP");
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");


var $h60TS = parcelRequire("h60TS");

var $flhWr = parcelRequire("flhWr");

var $gNNkQ = parcelRequire("gNNkQ");
const $0dbca3ec606aaa95$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $h60TS.CHANGE_TAB)).mergeMap(()=>{
        const state = store.getState();
        const activeTab = (0, $gNNkQ.getActiveTab)(state);
        switch(activeTab){
            case 0, $14a090e212ebf7a4$export$e18d81f044132a0e:
            case 0, $14a090e212ebf7a4$export$2e42513c7764d5f3:
            case 0, $14a090e212ebf7a4$export$6f74b53d652f13f3:
                {
                    const applicationTypes = (0, $flhWr.getApplicationTypes)(activeTab)(state);
                    return (0, $3JafE.Observable).of((0, $h60TS.setSelectedApplicationType)(applicationTypes[0]));
                }
            case 0, $14a090e212ebf7a4$export$56470bdd9cd798d0:
            case 0, $14a090e212ebf7a4$export$c69477f358d30f7e:
                return (0, $3JafE.Observable).empty();
            case 0, $14a090e212ebf7a4$export$74a388a09f2a004e:
            case 0, $14a090e212ebf7a4$export$90cac6260ae9ced5:
                /* Why hardcode 'bamboo'? This is set to retrieve the error messages within instance types and only
				 * bamboo can have errors from dev status. This is different from commits/branches/pullrequests tab
				 * because we show each instance type and its error message within its own sub tab, but for builds and
				 * deployments, we need to combine Bamboo and Cloud Data into single view and show errors only from Bamboo. */ return (0, $3JafE.Observable).of((0, $h60TS.setSelectedApplicationType)('bamboo'));
            default:
                throw new Error(`Unsupported tab type: ${activeTab}`);
        }
    });

});
parcelRegister("flhWr", function(module, exports) {

$parcel$export(module.exports, "getApplicationTypes", () => $8189176065ada69f$export$1a7ac998ea9f8737);

var $df4Sl = parcelRequire("df4Sl");

var $8i1R8 = parcelRequire("8i1R8");

var $hgFNe = parcelRequire("hgFNe");

var $8blac = parcelRequire("8blac");

var $lyOYo = parcelRequire("lyOYo");


var $3MW6m = parcelRequire("3MW6m");
const $8189176065ada69f$var$panelTypeToDetailsField = {
    [(0, $14a090e212ebf7a4$export$e18d81f044132a0e)]: 'branches',
    [(0, $14a090e212ebf7a4$export$2e42513c7764d5f3)]: 'commits',
    [(0, $14a090e212ebf7a4$export$6f74b53d652f13f3)]: 'pullRequests'
};
const $8189176065ada69f$var$mapInstancesToApplicationSummary = (instances)=>instances.map(({ type: type, name: name })=>({
            type: type,
            name: name
        }));
const $8189176065ada69f$var$filterByPanelTypePredicate = (instance, panelType)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Repository'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly branch: "branches"; readonly repository: "commits"; readonly pullrequest: "pullRequests"; }'.
    !!(0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(instance.repositories, (repo)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(repo[$8189176065ada69f$var$panelTypeToDetailsField[panelType]]));
const $8189176065ada69f$var$filterByDanglingPRsPredicate = (instance, panelType)=>!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(instance.danglingPullRequests) || $8189176065ada69f$var$filterByPanelTypePredicate(instance, panelType);
const $8189176065ada69f$var$getPanelData = (panelType, instances, // eslint-disable-next-line @typescript-eslint/no-explicit-any
filterFunc)=>[
        panelType,
        (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))($8189176065ada69f$var$mapInstancesToApplicationSummary(instances.filter((instance)=>filterFunc(instance, panelType))), 'type')
    ];
const $8189176065ada69f$var$getApplicationsFromDetails = (0, $df4Sl.createSelector)([
    (0, $3MW6m.getAllInstanceTypeDetails)
], (instances)=>(0, (/*@__PURE__*/$parcel$interopDefault($hgFNe)))([
        $8189176065ada69f$var$getPanelData((0, $14a090e212ebf7a4$export$2e42513c7764d5f3), instances, $8189176065ada69f$var$filterByPanelTypePredicate),
        $8189176065ada69f$var$getPanelData((0, $14a090e212ebf7a4$export$e18d81f044132a0e), instances, $8189176065ada69f$var$filterByPanelTypePredicate),
        $8189176065ada69f$var$getPanelData((0, $14a090e212ebf7a4$export$6f74b53d652f13f3), instances, $8189176065ada69f$var$filterByDanglingPRsPredicate)
    ]));
const $8189176065ada69f$export$33bb3fa8585ccba7 = (panelType)=>(state)=>$8189176065ada69f$var$getApplicationsFromDetails(state)[panelType] || [];
const $8189176065ada69f$export$1a7ac998ea9f8737 = (panelType)=>(state)=>$8189176065ada69f$export$33bb3fa8585ccba7(panelType)(state).map((application)=>application.type);

});
parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});




parcelRegister("lBj3r", function(module, exports) {

$parcel$export(module.exports, "epic", () => $062f661a5be343ad$export$8ec5145af6f76965);
$parcel$export(module.exports, "optOutDeploymentDetailDiscovery", () => $062f661a5be343ad$export$749833718123995b);
parcelRequire("dM0Xt");
parcelRequire("jyKN9");
parcelRequire("jAXdN");
parcelRequire("cpH8E");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3jYzf = parcelRequire("3jYzf");

var $fiOXn = parcelRequire("fiOXn");

var $3JafE = parcelRequire("3JafE");

var $gUUjF = parcelRequire("gUUjF");

var $9KkKi = parcelRequire("9KkKi");

var $8EPVv = parcelRequire("8EPVv");

var $1S1da = parcelRequire("1S1da");

var $h60TS = parcelRequire("h60TS");

var $fcvS0 = parcelRequire("fcvS0");
const $062f661a5be343ad$export$2cca46dea398dd67 = ()=>(0, $3jYzf.default)((0, $fiOXn.default)(new Date(), {
        weeks: 6
    })).toISOString();
const $062f661a5be343ad$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $1S1da.FETCH_DETAIL)).mergeMap(()=>{
        const state = store.getState();
        const issueId = (0, $fcvS0.getIssueId)(state);
        const baseUrl = (0, $fcvS0.getBaseUrl)(state);
        const projectAri = (0, $fcvS0.getProjectAri)(state) || '';
        const accountId = (0, $fcvS0.getAccountId)(state) || '';
        const updatedFrom = $062f661a5be343ad$export$2cca46dea398dd67();
        const detailsObservable = (0, $3JafE.Observable).zip((0, $9KkKi.default)(baseUrl, issueId), (0, $9KkKi.getDeploymentDataDetected)(projectAri, updatedFrom), (0, $8EPVv.getOptOutDeploymentsDiscovery)(accountId), (details, deploymentDataDetected, isOptOutOfDeploymentDiscovery)=>(0, $1S1da.setDetailData)({
                details: {
                    ...details,
                    embeddedMarketplaceDetails: {
                        ...details.embeddedMarketplaceDetails || {},
                        shouldDisplayForBuilds: details?.embeddedMarketplaceDetails?.shouldDisplayForBuilds || false,
                        shouldDisplayForDeployments: !deploymentDataDetected || details?.embeddedMarketplaceDetails?.shouldDisplayForDeployments || false,
                        shouldDisplayForFeatureFlags: details?.embeddedMarketplaceDetails?.shouldDisplayForFeatureFlags || false
                    }
                },
                isOptOutOfDeploymentDiscovery: isOptOutOfDeploymentDiscovery
            })).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('packages.development.details.src.main.fetch-details', error);
            return (0, $3JafE.Observable).of((0, $1S1da.fetchingFailed)());
        });
        return (0, $3JafE.Observable).concat(detailsObservable, (0, $3JafE.Observable).of((0, $fcvS0.getSelectedTab)(state)).map((selectedTab)=>(0, $h60TS.changeTab)(selectedTab)));
    });
const $062f661a5be343ad$export$749833718123995b = (action$, store)=>action$.ofType((0, $1S1da.OPT_OUT_DEPLOYMENTS_DISCOVERY)).mergeMap(()=>{
        const state = store.getState();
        const accountId = (0, $fcvS0.getAccountId)(state) || '';
        return (0, $3JafE.Observable).fromPromise((0, $8EPVv.setOptOutDeploymentsDiscovery)(accountId)).catch((error)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData('packages.development.details.src.main.opt-project-out-deployments-ddd-discovery', error);
            return (0, $3JafE.Observable).empty();
        });
    });

});
parcelRegister("9KkKi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6060f8405091f7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getDeploymentDataDetected", () => $d6060f8405091f7e$export$ee660826ba4bb836);

var $nnu67 = parcelRequire("nnu67");

var $iWLL0 = parcelRequire("iWLL0");

var $7oitI = parcelRequire("7oitI");

var $amu7D = parcelRequire("amu7D");

var $hnYQg = parcelRequire("hnYQg");

var $57eov = parcelRequire("57eov");

var $apC7T = parcelRequire("apC7T");
const $d6060f8405091f7e$var$transformBranchPR = (swagBranchPR)=>({
        ...swagBranchPR
    });
const $d6060f8405091f7e$var$transformReview = (swagReview)=>({
        ...swagReview
    });
const $d6060f8405091f7e$var$UNAUTHORIZED_ERROR = 'unauthorized';
const $d6060f8405091f7e$var$hasUnauthorizedError = (errorMessages = [])=>errorMessages.indexOf($d6060f8405091f7e$var$UNAUTHORIZED_ERROR) > -1;
// Make a string for errors
// @ts-expect-error - TS7006 - Parameter 'instanceType' implicitly has an 'any' type.
const $d6060f8405091f7e$var$mapErrors = (instanceType)=>{
    const errorMessages = instanceType.devStatusErrorMessages || [];
    if (errorMessages.length && !$d6060f8405091f7e$var$hasUnauthorizedError(instanceType.devStatusErrorMessages)) return {
        url: instanceType.baseUrl,
        name: instanceType.name
    };
    return null;
};
// @ts-expect-error - TS7006 - Parameter 'instanceType' implicitly has an 'any' type.
const $d6060f8405091f7e$var$mapUnauthorizedLinks = (instanceType)=>{
    if ($d6060f8405091f7e$var$hasUnauthorizedError(instanceType.devStatusErrorMessages)) return {
        applicationLinkId: instanceType.id,
        name: instanceType.name
    };
    return null;
};
const $d6060f8405091f7e$var$transformInstanceType = (// @ts-expect-error - TS7006 - Parameter 'instanceType' implicitly has an 'any' type.
instanceType, repositories, danglingPullRequests, buildProviders)=>({
        id: instanceType.id,
        name: instanceType.name,
        type: instanceType.type,
        typeName: instanceType.typeName,
        baseUrl: (0, $7oitI.toSanitizedUrl)(instanceType.baseUrl),
        repositories: repositories,
        danglingPullRequests: danglingPullRequests,
        buildProviders: buildProviders,
        errorLink: $d6060f8405091f7e$var$mapErrors(instanceType),
        unauthorizedLink: $d6060f8405091f7e$var$mapUnauthorizedLinks(instanceType)
    });
// @ts-expect-error - TS7006 - Parameter 'swagBranch' implicitly has an 'any' type.
const $d6060f8405091f7e$var$transformLastCommit = (swagBranch)=>swagBranch.lastCommit ? {
        ...swagBranch.lastCommit,
        id: swagBranch.lastCommit.displayId
    } : null;
const $d6060f8405091f7e$export$57ace40be4f3f185 = (instanceType, repository, swagBranch, index)=>({
        id: `${instanceType.id}/${repository.name}/${index}`,
        name: swagBranch.name,
        url: swagBranch.url,
        createPullRequestUrl: swagBranch.createPullRequestUrl,
        createReviewUrl: swagBranch.createReviewUrl,
        pullRequests: swagBranch.pullRequests.map($d6060f8405091f7e$var$transformBranchPR),
        reviews: swagBranch.reviews.map($d6060f8405091f7e$var$transformReview),
        lastCommit: $d6060f8405091f7e$var$transformLastCommit(swagBranch)
    });
const $d6060f8405091f7e$export$b613cefff829ae93 = (swagPr, uid)=>({
        ...swagPr,
        uid: uid
    });
const $d6060f8405091f7e$var$mapCommitAuthor = (author)=>({
        name: author.name,
        avatar: author.avatarUrl
    });
// @ts-expect-error - TS2304 - Cannot find name 'FileType'.
const $d6060f8405091f7e$var$mapCommitFiles = (files)=>files.map((file)=>({
            ...file
        }));
const $d6060f8405091f7e$export$91295c968cc19bfb = (swagCommit)=>({
        id: swagCommit.id,
        displayId: swagCommit.displayId,
        url: swagCommit.url,
        createReviewUrl: swagCommit.createReviewUrl,
        message: swagCommit.message,
        authorTimestamp: swagCommit.timestamp,
        author: $d6060f8405091f7e$var$mapCommitAuthor(swagCommit.author),
        merge: swagCommit.isMerge,
        fileCount: swagCommit.files.length,
        files: $d6060f8405091f7e$var$mapCommitFiles(swagCommit.files)
    });
const $d6060f8405091f7e$var$transformPullRequests = (instanceId, pullRequests = [], repositoryName = '__')=>pullRequests.map((pullRequest)=>$d6060f8405091f7e$export$b613cefff829ae93(pullRequest, `${instanceId}/${repositoryName}/${pullRequest.id}`))// @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    .sort((a, b)=>new Date(b.lastUpdate) - new Date(a.lastUpdate));
const $d6060f8405091f7e$export$1559ce45255ec471 = (instanceType, repository, repoIndex)=>({
        id: repository.id ?? `${instanceType.id}/${repoIndex}`,
        name: repository.name,
        url: repository.url != null ? (0, $7oitI.toSanitizedUrl)(repository.url) : null,
        avatar: repository.avatarUrl != null ? (0, $7oitI.toSanitizedUrl)(repository.avatarUrl) : null,
        description: repository.description,
        instanceName: instanceType.typeName,
        instanceId: instanceType.id,
        branches: repository.branches.map((branch, index)=>$d6060f8405091f7e$export$57ace40be4f3f185(instanceType, repository, branch, index)),
        pullRequests: $d6060f8405091f7e$var$transformPullRequests(instanceType.id, repository.pullRequests, repository.name),
        commits: repository.commits.map((commit)=>$d6060f8405091f7e$export$91295c968cc19bfb(commit))// @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        .sort((a, b)=>new Date(b.authorTimestamp) - new Date(a.authorTimestamp))
    });
const $d6060f8405091f7e$var$transformDanglingPullRequests = (instanceType)=>$d6060f8405091f7e$var$transformPullRequests(instanceType.id, instanceType.danglingPullRequests);
const $d6060f8405091f7e$export$600c070530945ad8 = (buildProvider)=>({
        id: buildProvider.id,
        name: buildProvider.name,
        url: (0, $7oitI.toSanitizedUrl)(buildProvider.url),
        description: buildProvider.description,
        avatarUrl: buildProvider.avatarUrl != null ? (0, $7oitI.toSanitizedUrl)(buildProvider.avatarUrl) : null,
        builds: buildProvider.builds.sort((a, b)=>new Date(b.lastUpdated).valueOf() - new Date(a.lastUpdated).valueOf())
    });
const $d6060f8405091f7e$export$1f9e2fed0535e427 = (response)=>{
    const instanceTypes = response.data.developmentInformation.details.instanceTypes.map((instanceType)=>{
        const transformedRepositories = instanceType.repository.map((repository, index)=>$d6060f8405091f7e$export$1559ce45255ec471(instanceType, repository, index));
        const transformedDanglingPullRequests = $d6060f8405091f7e$var$transformDanglingPullRequests(instanceType);
        const transformedBuildProviders = instanceType.buildProviders.map((buildProvider)=>$d6060f8405091f7e$export$600c070530945ad8(buildProvider));
        return $d6060f8405091f7e$var$transformInstanceType(instanceType, transformedRepositories, transformedDanglingPullRequests, transformedBuildProviders);
    });
    return instanceTypes;
};
const $d6060f8405091f7e$var$transformEnvironment = (environment)=>({
        id: environment.id,
        displayName: environment.displayName,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'EnvironmentType'.
        type: environment.type
    });
const $d6060f8405091f7e$var$transformDeployment = (deployment)=>({
        displayName: deployment.displayName,
        url: deployment.url,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'DeploymentState'.
        state: deployment.state,
        lastUpdated: deployment.lastUpdated,
        environment: $d6060f8405091f7e$var$transformEnvironment(deployment.environment),
        pipelineId: deployment.pipelineId,
        pipelineDisplayName: deployment.pipelineDisplayName,
        pipelineUrl: deployment.pipelineUrl
    });
const $d6060f8405091f7e$var$transformDeploymentProvider = (deploymentProvider)=>({
        id: deploymentProvider.id,
        name: deploymentProvider.name,
        homeUrl: (0, $7oitI.toSanitizedUrl)(deploymentProvider.homeUrl),
        logoUrl: deploymentProvider.logoUrl != null ? (0, $7oitI.toSanitizedUrl)(deploymentProvider.logoUrl) : null,
        deployments: deploymentProvider.deployments.map((deployment)=>$d6060f8405091f7e$var$transformDeployment(deployment))
    });
const $d6060f8405091f7e$export$4efd6b08365fb9e7 = (result)=>result.data.developmentInformation.details.deploymentProviders.map((deploymentProvider)=>$d6060f8405091f7e$var$transformDeploymentProvider(deploymentProvider));
const $d6060f8405091f7e$export$7acea2265cf4ac9c = (response)=>response.data.developmentInformation.details.embeddedMarketplace;
const $d6060f8405091f7e$export$f13b29f9ed0c5a03 = (result)=>{
    const { featureFlagProviders: featureFlagProviders, remoteLinksByType: remoteLinksByType } = result.data.developmentInformation.details;
    return {
        instanceTypeDetails: $d6060f8405091f7e$export$1f9e2fed0535e427(result),
        deploymentProviders: $d6060f8405091f7e$export$4efd6b08365fb9e7(result),
        featureFlags: featureFlagProviders ? (0, $57eov.transformFeatureFlags)(featureFlagProviders) : {},
        remoteLinkInformation: remoteLinksByType ? (0, $apC7T.transformRemoteLinks)(remoteLinksByType) : {
            numProviders: 0,
            remoteLinksByType: {}
        },
        embeddedMarketplaceDetails: $d6060f8405091f7e$export$7acea2265cf4ac9c(result)
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6060f8405091f7e$export$2e2bcd8739ae039 = async (baseUrl, issueId)=>{
    const result = await (0, $hnYQg.default)(baseUrl, issueId);
    if (result.errors && result.errors.length) {
        const errorMessages = result.errors.map((error)=>error.message).reduce((acc, current)=>`${acc}\n ${current}`, '');
        throw Error(`Error retrieving details from service: ${errorMessages}`);
    }
    try {
        return $d6060f8405091f7e$export$f13b29f9ed0c5a03(result);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw Error(`Error creating details, error: ${error}`);
    }
};
const $d6060f8405091f7e$export$ee660826ba4bb836 = (projectAri, updatedFrom)=>(0, $iWLL0.fetchQuery)((0, $amu7D.default)(), (0, $nnu67.default), {
        projectAri: projectAri,
        updatedFrom: updatedFrom
    }, {
        fetchPolicy: 'store-or-network'
    }).toPromise().then((result)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const data = result;
        return (data?.devOps?.ariGraph?.deploymentRelationships?.nodes ?? []).length > 0;
    });

});
parcelRegister("nnu67", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a13fb4896a85ac$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<506f45535620e4112729474229b7d58f>>
 * @relayHash 08c252cc5c3789c2ecbcea82e0174f13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ea3a4f7efc5495f47c1aaa78caf8bccb3cd76572d3141b65719532cb23b2e60
const $36a13fb4896a85ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updatedFrom"
        }
    ], v1 = {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
            {
                "concreteType": "AriGraph",
                "kind": "LinkedField",
                "name": "ariGraph",
                "plural": false,
                "selections": [
                    {
                        "alias": "deploymentRelationships",
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "from",
                                        "variableName": "projectAri"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "project-associated-deployment"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "updatedFrom",
                                        "variableName": "updatedFrom"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "AriGraphRelationshipConnection",
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "AriGraphRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "detailsDeploymentDataDetectedQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": v1 /*: any*/ ,
                    "action": "THROW",
                    "path": "devOps"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "detailsDeploymentDataDetectedQuery",
            "selections": [
                v1 /*: any*/ 
            ]
        },
        "params": {
            "id": "0ea3a4f7efc5495f47c1aaa78caf8bccb3cd76572d3141b65719532cb23b2e60",
            "metadata": {},
            "name": "detailsDeploymentDataDetectedQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$36a13fb4896a85ac$var$node.hash = "21211370ddb0d181284a4265fae29842";
var $36a13fb4896a85ac$export$2e2bcd8739ae039 = $36a13fb4896a85ac$var$node;

});

parcelRegister("7oitI", function(module, exports) {

$parcel$export(module.exports, "toSanitizedUrl", () => $7642b361b145bebc$export$36fdccbdcd093523);

var $licsn = parcelRequire("licsn");
const $7642b361b145bebc$export$36fdccbdcd093523 = (url)=>(0, $licsn.sanitizeUrl)(url);

});

parcelRegister("hnYQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $836b0c50a336c21e$export$2e2bcd8739ae039);

var $jy01K = parcelRequire("jy01K");
const $836b0c50a336c21e$var$OPERATION_NAME = 'DevDetailsDialog';
const $836b0c50a336c21e$var$branchesQuery = `branches {
        name
        url
        createReviewUrl
        createPullRequestUrl
        lastCommit {
            url
            displayId
            timestamp
        }
        pullRequests {
            name
            url
            status
            lastUpdate
        }
        reviews {
            state
            url
            id
        }
    }`;
const $836b0c50a336c21e$var$commitsQuery = `commits{
        id
        displayId
        url
        createReviewUrl
        timestamp
        isMerge
        message
        author {
          name
          avatarUrl
        }
        files{
          linesAdded
          linesRemoved
          changeType
          url
          path
        }
        reviews{
          id
          url
          state
        }
    }`;
const $836b0c50a336c21e$var$getPullRequestQuery = (prName)=>`${prName} {
        id
        url
        name
        branchName
        branchUrl
        destinationBranchName
        destinationBranchUrl
        lastUpdate
        status
        author {
          name
          avatarUrl
        }
        reviewers{
          name
          avatarUrl
          isApproved
        }
        repositoryId
        repositoryName
        repositoryUrl
        repositoryAvatarUrl
    }`;
const $836b0c50a336c21e$var$buildProvidersQuery = `buildProviders {
          id
          name
          url
          description
          avatarUrl
          builds {
            id
            buildNumber
            name
            description
            url
            state
            testSummary {
              totalNumber
              numberPassed
              numberFailed
              numberSkipped
            }
            lastUpdated
            references {
              name
              uri
            }
          }
        }`;
const $836b0c50a336c21e$var$deploymentProvidersQuery = `deploymentProviders {
          id
          name
          homeUrl
          logoUrl
          deployments {
            displayName
            url
            state
            lastUpdated
            pipelineId
            pipelineDisplayName
            pipelineUrl
            environment {
                id
                type
                displayName
            }
          }
        }`;
const $836b0c50a336c21e$var$featureFlagsQuery = `featureFlagProviders {
        id
        createFlagTemplateUrl
        linkFlagTemplateUrl
        featureFlags {
            id
            key
            displayName
            providerId
            details{
                url
                lastUpdated
                environment{
                    name
                    type
                }
                status{
                enabled
                defaultValue
                rollout{
                    percentage
                    text
                    rules
                }
            }
        }
    }
}`;
const $836b0c50a336c21e$var$remoteLinksQuery = `remoteLinksByType {
        providers {
            id
            name
            homeUrl
            logoUrl
            documentationUrl
            actions {
                id
                label {
                    value
                }
                templateUrl
            }
        }
        types {
            type
            remoteLinks {
                id
                providerId
                displayName
                url
                type
                description
                status {
                    appearance
                    label
                }
                actionIds
                attributeMap {
                    key
                    value
                }
            }
        }
    }`;
const $836b0c50a336c21e$var$embeddedMarketplaceQuery = `
    embeddedMarketplace {
        shouldDisplayForBuilds,
        shouldDisplayForDeployments,
        shouldDisplayForFeatureFlags
      }
`;
// TYPO FIX: FUSE-8114 repository needs to be repositories
// TODO: FUSE-8114 buildProviders will be moved out of instanceTypes and placed under details
const $836b0c50a336c21e$var$innerQuery = ()=>`
    details {
        instanceTypes {
            id
            name
            type
            typeName
            isSingleInstance
            baseUrl
            devStatusErrorMessages
            repository {
                id
                name
                avatarUrl
                description
                url
                parent {
                    name
                    url
                }
                ${$836b0c50a336c21e$var$branchesQuery}
                ${$836b0c50a336c21e$var$commitsQuery}
                ${$836b0c50a336c21e$var$getPullRequestQuery('pullRequests')}
            }
            ${$836b0c50a336c21e$var$getPullRequestQuery('danglingPullRequests')}
            ${$836b0c50a336c21e$var$buildProvidersQuery}
         }
         ${$836b0c50a336c21e$var$deploymentProvidersQuery}
         ${$836b0c50a336c21e$var$featureFlagsQuery}
         ${$836b0c50a336c21e$var$remoteLinksQuery}
         ${$836b0c50a336c21e$var$embeddedMarketplaceQuery}
    }
`;
const $836b0c50a336c21e$var$swagGraphQLQuery = ()=>`
    query ${$836b0c50a336c21e$var$OPERATION_NAME} ($issueId: ID!) {
        developmentInformation(issueId: $issueId){
            ${$836b0c50a336c21e$var$innerQuery()}
        }
    }`;
const $836b0c50a336c21e$var$query = (baseUrl, issueId)=>// @ts-expect-error - TS2322 - Type 'Promise<ResponseData | { data: unknown; }>' is not assignable to type 'Promise<ResponseData>'.
    (0, $jy01K.query$)(baseUrl, $836b0c50a336c21e$var$OPERATION_NAME, $836b0c50a336c21e$var$swagGraphQLQuery(), {
        issueId: issueId
    }).toPromise().then((result)=>({
            data: result
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$836b0c50a336c21e$export$2e2bcd8739ae039 = (baseUrl, issueId)=>$836b0c50a336c21e$var$query(baseUrl, issueId);

});
parcelRegister("jy01K", function(module, exports) {

$parcel$export(module.exports, "query$", () => $974ed7d64c30acc8$export$a332dd84c3221bf2);

var $f9vw0 = parcelRequire("f9vw0");
const $974ed7d64c30acc8$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $f9vw0.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("f9vw0", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $82c90398c8cfb5df$export$cbc7c612df05bda);
parcelRequire("jyKN9");
parcelRequire("bI4RP");
parcelRequire("kO85v");
parcelRequire("l5lul");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $illlw = parcelRequire("illlw");

var $dbogu = parcelRequire("dbogu");

var $3JafE = parcelRequire("3JafE");

var $hompL = parcelRequire("hompL");

var $lNfG4 = parcelRequire("lNfG4");

var $gUUjF = parcelRequire("gUUjF");

var $iH6c1 = parcelRequire("iH6c1");

var $aiRd8 = parcelRequire("aiRd8");

var $88Osm = parcelRequire("88Osm");

var $5zSUY = parcelRequire("5zSUY");

var $3FyZ4 = parcelRequire("3FyZ4");

var $R1ugb = parcelRequire("R1ugb");

var $eeJ3R = parcelRequire("eeJ3R");
const $82c90398c8cfb5df$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $82c90398c8cfb5df$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $82c90398c8cfb5df$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $5zSUY.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $gUUjF.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $aiRd8.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $82c90398c8cfb5df$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $88Osm.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $lNfG4.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $3JafE.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $82c90398c8cfb5df$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $82c90398c8cfb5df$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $eeJ3R.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(retryError, [
                'statusCode'
            ], null);
            (0, $eeJ3R.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $3JafE.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($dbogu)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
            'name'
        ], null);
        const swagError = new (0, $R1ugb.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $iH6c1.getErrorHash)(swagError);
        (0, $eeJ3R.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $3JafE.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $eeJ3R.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $eeJ3R.logRestError)(path, statusCode, operationName, errorType);
                    $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $3JafE.Observable).throw(new (0, $R1ugb.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($dbogu)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $eeJ3R.logRestParsingError)(e, operationName);
            $82c90398c8cfb5df$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $82c90398c8cfb5df$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $3JafE.Observable).of(response.data);
    });
};

});
parcelRegister("aiRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6464cf3e92eca984$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("1Lcr1");
parcelRequire("8OtG5");
parcelRequire("flmol");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $6iz4v = parcelRequire("6iz4v");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $6464cf3e92eca984$var$noContentStatus = 204;
const $6464cf3e92eca984$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $6464cf3e92eca984$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$6464cf3e92eca984$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6iz4v.setMark)(`BEGIN_${key}`);
    }
    return (0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), opts), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6iz4v.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, str, traceId);
                else throw new (0, $7byHA.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $6464cf3e92eca984$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        return response.json();
    });
}
var $6464cf3e92eca984$export$2e2bcd8739ae039 = $6464cf3e92eca984$var$fetchJson$;

});

parcelRegister("R1ugb", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $265fd8fb70331573$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $265fd8fb70331573$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $265fd8fb70331573$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $265fd8fb70331573$export$7d7253f3a1a7c031);

var $7byHA = parcelRequire("7byHA");
const $265fd8fb70331573$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $265fd8fb70331573$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage);
        this.graphQLErrors = [];
        this.networkError = null;
        // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $265fd8fb70331573$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $265fd8fb70331573$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $265fd8fb70331573$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $7byHA.default);
const $265fd8fb70331573$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $265fd8fb70331573$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});




parcelRegister("57eov", function(module, exports) {

$parcel$export(module.exports, "transformFeatureFlags", () => $7895c4c2f8dd4879$export$713c7344ce0fdc3b);

var $9OdO2 = parcelRequire("9OdO2");

var $fcWBJ = parcelRequire("fcWBJ");

var $b4Uve = parcelRequire("b4Uve");
const $7895c4c2f8dd4879$var$ENVIRONMENT_TYPE_OTHER = 'other';
const $7895c4c2f8dd4879$var$flattenFeatureFlag = (featureFlag)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(featureFlag.details, (ffDetails)=>({
            id: featureFlag.id,
            key: featureFlag.key,
            displayName: featureFlag.displayName,
            providerId: featureFlag.providerId,
            ...ffDetails
        }));
const $7895c4c2f8dd4879$var$flattenFeatureFlags = (provider)=>provider.featureFlags ? (0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(provider.featureFlags, (ff)=>$7895c4c2f8dd4879$var$flattenFeatureFlag(ff)) : [];
const $7895c4c2f8dd4879$var$getEnvironmentType = ({ type: type })=>// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type '"other" | "production" | "staging" | "development" | "testing"'.
    (0, $b4Uve.featureFlagEnvironmentTypes).includes(type) ? type : $7895c4c2f8dd4879$var$ENVIRONMENT_TYPE_OTHER;
const $7895c4c2f8dd4879$var$transformEnvironment = (environment)=>({
        ...environment,
        type: $7895c4c2f8dd4879$var$getEnvironmentType(environment)
    });
const $7895c4c2f8dd4879$var$transformFlag = (flag)=>({
        // @ts-expect-error - TS2783 - 'id' is specified more than once, so this usage will be overwritten.
        id: flag.id,
        // @ts-expect-error - TS2783 - 'providerId' is specified more than once, so this usage will be overwritten.
        providerId: flag.providerId,
        key: flag.key,
        // @ts-expect-error - TS2783 - 'displayName' is specified more than once, so this usage will be overwritten.
        displayName: flag.displayName,
        ...flag,
        environment: $7895c4c2f8dd4879$var$transformEnvironment(flag.environment)
    });
// @ts-expect-error - TS2304 - Cannot find name 'FeatureFlagProvider'.
const $7895c4c2f8dd4879$var$transformProviders = (providers)=>{
    const flatFlags = (0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(providers, (provider)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))($7895c4c2f8dd4879$var$flattenFeatureFlags(provider), (flatFlag)=>({
                // @ts-expect-error - TS2783 - 'providerId' is specified more than once, so this usage will be overwritten.
                providerId: provider.id,
                ...$7895c4c2f8dd4879$var$transformFlag(flatFlag)
            })));
    return (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(flatFlags, ({ environment: environment })=>$7895c4c2f8dd4879$var$getEnvironmentType(environment));
};
const $7895c4c2f8dd4879$export$713c7344ce0fdc3b = (featureFlagProviders)=>$7895c4c2f8dd4879$var$transformProviders(featureFlagProviders);

});
parcelRegister("b4Uve", function(module, exports) {

$parcel$export(module.exports, "featureFlagEnvironmentTypes", () => $be54e1ce8df2fc97$export$8a335de8ae8d5712);
const $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_PRODUCTION = 'production';
const $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_STAGING = 'staging';
const $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_TESTING = 'testing';
const $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_DEVELOPMENT = 'development';
const $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_OTHER = 'other';
const $be54e1ce8df2fc97$export$8a335de8ae8d5712 = [
    $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_PRODUCTION,
    $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_STAGING,
    $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_TESTING,
    $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_DEVELOPMENT,
    $be54e1ce8df2fc97$var$ENVIRONMENT_TYPE_OTHER
];

});


parcelRegister("apC7T", function(module, exports) {

$parcel$export(module.exports, "transformRemoteLinks", () => $2193a39099a1cc1d$export$c070e22f287b7fc7);

var $jJ8qO = parcelRequire("jJ8qO");
const $2193a39099a1cc1d$export$53b6bdd225fa8b4b = (providerId, remoteLinkProvider)=>({
        id: providerId,
        name: remoteLinkProvider.name,
        homeUrl: remoteLinkProvider.homeUrl,
        logoUrl: remoteLinkProvider.logoUrl ? remoteLinkProvider.logoUrl : null,
        documentationUrl: remoteLinkProvider.documentationUrl ? remoteLinkProvider.documentationUrl : null
    });
const $2193a39099a1cc1d$export$a97844e947d8eadf = (remoteLinkProvider, actionIds, attributeMap)=>{
    if (remoteLinkProvider.actions && actionIds) {
        const remoteLinkProviderActions = remoteLinkProvider.actions;
        return actionIds// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: { label: RemoteLinkLabel; templateUrl: string; }; }'.
        .filter((actionId)=>remoteLinkProviderActions[actionId]).map((actionId)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: { label: RemoteLinkLabel; templateUrl: string; }; }'.
            const baseUrl = remoteLinkProviderActions[actionId].templateUrl;
            return {
                id: actionId,
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: { label: RemoteLinkLabel; templateUrl: string; }; }'.
                label: remoteLinkProviderActions[actionId].label.value,
                url: attributeMap ? attributeMap.reduce((resultUrl, substitution)=>resultUrl.replace(`{${substitution.key}}`, substitution.value), baseUrl) : baseUrl
            };
        });
    }
    return [];
};
const $2193a39099a1cc1d$export$323a7fe46ef8c5af = (providers)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers.reduce((result, provider)=>{
        const { id: id, actions: actions, ...restOfProvider } = provider;
        result[id] = {
            ...restOfProvider,
            ...actions && {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                actions: actions.reduce((actionResult, action)=>{
                    const { id: actionId, ...restOfAction } = action;
                    actionResult[actionId] = restOfAction;
                    return actionResult;
                }, {})
            }
        };
        return result;
    }, {});
const $2193a39099a1cc1d$export$c070e22f287b7fc7 = (remoteLinksByType)=>{
    const remoteLinkProviders = remoteLinksByType.providers.filter((provider)=>!(0, $jJ8qO.isVersionRelatedLinksProvider)(provider.id));
    const modifiedProviders = $2193a39099a1cc1d$export$323a7fe46ef8c5af(remoteLinkProviders);
    const remoteLinkTypes = remoteLinksByType.types.filter((type)=>{
        const filteredLinks = type.remoteLinks.filter((link)=>!(0, $jJ8qO.isVersionRelatedLinksProvider)(link.providerId));
        return filteredLinks.length > 0;
    });
    return remoteLinkTypes.reduce((result, element)=>{
        const { type: type, remoteLinks: remoteLinks } = element;
        const links = remoteLinks.filter((link)=>!(0, $jJ8qO.isVersionRelatedLinksProvider)(link.providerId));
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        result.remoteLinksByType[type] = links.map((remoteLink)=>{
            const { providerId: providerId, actionIds: actionIds, attributeMap: attributeMap, description: description, status: status, ...restOfRemoteLink } = remoteLink;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RemoteLinkProviderTransformed'.
            const remoteLinkProvider = modifiedProviders[providerId];
            if (!remoteLinkProvider) return {};
            return {
                provider: $2193a39099a1cc1d$export$53b6bdd225fa8b4b(providerId, remoteLinkProvider),
                description: description || null,
                status: status || null,
                ...restOfRemoteLink,
                actions: $2193a39099a1cc1d$export$a97844e947d8eadf(remoteLinkProvider, actionIds, attributeMap)
            };
        }).filter((remoteLink)=>Object.keys(remoteLink).length !== 0);
        return result;
    }, {
        numProviders: remoteLinkProviders.length,
        remoteLinksByType: {}
    });
};

});
parcelRegister("jJ8qO", function(module, exports) {

$parcel$export(module.exports, "isVersionRelatedLinksProvider", () => $5ceb9b07ddef5944$export$d85eb3fb354ab222);

const $5ceb9b07ddef5944$export$d85eb3fb354ab222 = (id)=>id === (0, $4bd4dbd4f4336a09$export$a42a1a2fb6310bc7) || id === (0, $4bd4dbd4f4336a09$export$e68cad5334cc5b);

});



parcelRegister("8EPVv", function(module, exports) {

$parcel$export(module.exports, "getOptOutDeploymentsDiscovery", () => $2cc0619f04b48553$export$feb9f7f82afe74b1);
$parcel$export(module.exports, "setOptOutDeploymentsDiscovery", () => $2cc0619f04b48553$export$e5e1193be89a6ae4);

var $gvF1u = parcelRequire("gvF1u");
const $2cc0619f04b48553$var$OPT_OUT_DEPLOYMENTS_DISCOVERY = 'open-toolchain-opt-user-out-deployments-ddd-discovery';
const $2cc0619f04b48553$export$feb9f7f82afe74b1 = (accountId)=>(0, $gvF1u.getUserProperty)({
        accountId: accountId,
        propertyKey: $2cc0619f04b48553$var$OPT_OUT_DEPLOYMENTS_DISCOVERY,
        defaultValue: false
    }).then((property)=>property.value);
const $2cc0619f04b48553$export$e5e1193be89a6ae4 = (accountId)=>(0, $gvF1u.setUserProperty)({
        accountId: accountId,
        propertyValue: true,
        propertyKey: $2cc0619f04b48553$var$OPT_OUT_DEPLOYMENTS_DISCOVERY
    });

});
parcelRegister("gvF1u", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $463d6fca308dc83d$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $463d6fca308dc83d$export$b3126db2ef6e34ed);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $463d6fca308dc83d$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $463d6fca308dc83d$var$handleErrorLogging = (operation, error, attributes)=>{
    (0, $guiFP.default)({
        meta: {
            id: operation,
            packageName: 'jiraDevelopmentDetails',
            teamName: 'fusion-isotopes'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: attributes
    });
};
const $463d6fca308dc83d$export$ba821ce5e177c7ef = async ({ propertyValue: propertyValue, propertyKey: propertyKey, accountId: accountId })=>{
    const url = $463d6fca308dc83d$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        $463d6fca308dc83d$var$handleErrorLogging('setUserProperty', error, {
            propertyValue: JSON.stringify(propertyValue)
        });
        throw error;
    }
};
const $463d6fca308dc83d$export$b3126db2ef6e34ed = async ({ propertyKey: propertyKey, defaultValue: defaultValue, accountId: accountId })=>{
    const url = $463d6fca308dc83d$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $lRmyA.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("fcvS0", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $07887482bac3dbf4$export$f654b28f82155665);
$parcel$export(module.exports, "getIssueId", () => $07887482bac3dbf4$export$b4dd560abafd1fae);
$parcel$export(module.exports, "getIssueKey", () => $07887482bac3dbf4$export$4a030f6192bebe03);
$parcel$export(module.exports, "getLocale", () => $07887482bac3dbf4$export$180605366c04f0cd);
$parcel$export(module.exports, "getSelectedTab", () => $07887482bac3dbf4$export$76c530fbe2143c48);
$parcel$export(module.exports, "getProjectAri", () => $07887482bac3dbf4$export$1029c05cae8fb823);
$parcel$export(module.exports, "getAccountId", () => $07887482bac3dbf4$export$c1e0336bde96e2dc);
const $07887482bac3dbf4$var$getApp = (state)=>state.app;
const $07887482bac3dbf4$export$f654b28f82155665 = (state)=>$07887482bac3dbf4$var$getApp(state).baseUrl;
const $07887482bac3dbf4$export$b4dd560abafd1fae = (state)=>$07887482bac3dbf4$var$getApp(state).issueId;
const $07887482bac3dbf4$export$4a030f6192bebe03 = (state)=>$07887482bac3dbf4$var$getApp(state).issueKey;
const $07887482bac3dbf4$export$180605366c04f0cd = (state)=>$07887482bac3dbf4$var$getApp(state).locale;
const $07887482bac3dbf4$export$76c530fbe2143c48 = (state)=>$07887482bac3dbf4$var$getApp(state).selectedTab;
const $07887482bac3dbf4$export$1029c05cae8fb823 = (state)=>$07887482bac3dbf4$var$getApp(state).projectAri;
const $07887482bac3dbf4$export$c1e0336bde96e2dc = (state)=>$07887482bac3dbf4$var$getApp(state).accountId;

});


parcelRegister("7zYZi", function(module, exports) {

$parcel$export(module.exports, "epic", () => $4b678907647e72ef$export$8ec5145af6f76965);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $lMWOi = parcelRequire("lMWOi");

var $1S1da = parcelRequire("1S1da");

var $h60TS = parcelRequire("h60TS");

var $fcvS0 = parcelRequire("fcvS0");
const $4b678907647e72ef$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, $lMWOi.INITIALIZE_APP_PROPS)).mergeMap(()=>{
        const state = store.getState();
        const selectedTab = (0, $fcvS0.getSelectedTab)(state);
        // @ts-expect-error - TS2769 - No overload matches this call.
        return (0, $3JafE.Observable).of((0, $1S1da.fetchDetail)(), (0, $h60TS.changeTab)(selectedTab));
    });

});
parcelRegister("lMWOi", function(module, exports) {

$parcel$export(module.exports, "INITIALIZE_APP_PROPS", () => $8b90fbd3cfdc9171$export$84856e4ae7cd7538);
$parcel$export(module.exports, "initializeAppProps", () => $8b90fbd3cfdc9171$export$5f0e35553cecddfe);
const $8b90fbd3cfdc9171$export$84856e4ae7cd7538 = 'state.actions.app.INITIALIZE_APP_PROPS';
const $8b90fbd3cfdc9171$export$5f0e35553cecddfe = (payload)=>({
        type: $8b90fbd3cfdc9171$export$84856e4ae7cd7538,
        payload: payload
    });

});



parcelRegister("cZzAE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dbb825ea62a2078$export$2e2bcd8739ae039);

var $8FRHo = parcelRequire("8FRHo");

var $hLwwF = parcelRequire("hLwwF");


var $2mhJB = parcelRequire("2mhJB");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9dbb825ea62a2078$export$2e2bcd8739ae039 = (rootEpic)=>(0, $8FRHo.default)({
        appName: 'development/details',
        rootReducer: $2mhJB.default,
        rootEpic: rootEpic,
        middlewares: [
            (0, $hLwwF.default)((0, $4bd4dbd4f4336a09$export$d76071d5de2774fc))
        ]
    });

});
parcelRegister("hLwwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2862a2f270e4342c$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $2862a2f270e4342c$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $gUUjF.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $8xmdY.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $2862a2f270e4342c$export$2e2bcd8739ae039 = $2862a2f270e4342c$var$errorHandling;

});

parcelRegister("2mhJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22fcd71d6f62f05$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $kWQAt = parcelRequire("kWQAt");

var $k0d35 = parcelRequire("k0d35");

var $az3D8 = parcelRequire("az3D8");
var $e22fcd71d6f62f05$export$2e2bcd8739ae039 = (0, $huRi7.combineReducers)({
    app: $kWQAt.default,
    ui: $az3D8.default,
    details: $k0d35.default
});

});
parcelRegister("kWQAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a0dd0e58dc16fa$export$2e2bcd8739ae039);

var $6GvCI = parcelRequire("6GvCI");


var $lMWOi = parcelRequire("lMWOi");
const $d6a0dd0e58dc16fa$export$49d5fc8cba920a0 = {
    baseUrl: '',
    issueId: '',
    issueKey: '',
    locale: (0, $6GvCI.defaultLocale),
    selectedTab: (0, $14a090e212ebf7a4$export$e18d81f044132a0e),
    showRemoteLinks: false,
    projectAri: '',
    accountId: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d6a0dd0e58dc16fa$export$2e2bcd8739ae039 = (state = $d6a0dd0e58dc16fa$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $lMWOi.INITIALIZE_APP_PROPS:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("k0d35", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f034df6ee4d3b1$export$2e2bcd8739ae039);

var $1S1da = parcelRequire("1S1da");
const $23f034df6ee4d3b1$export$49d5fc8cba920a0 = {
    isLoading: false,
    isError: false,
    isDiffstatAnalyticsFired: false,
    details: {
        instanceTypeDetails: [],
        deploymentProviders: [],
        embeddedMarketplaceDetails: {
            shouldDisplayForBuilds: false,
            shouldDisplayForDeployments: false,
            shouldDisplayForFeatureFlags: false
        }
    },
    isOptOutOfDeploymentDiscovery: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23f034df6ee4d3b1$export$2e2bcd8739ae039 = (state = $23f034df6ee4d3b1$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $1S1da.FETCH_DETAIL:
            return {
                ...state,
                isLoading: true,
                isError: false
            };
        case 0, $1S1da.FIRE_BITBUCKET_DIFFSTAT_ANALYTICS_EVENT:
            return {
                ...state,
                isDiffstatAnalyticsFired: true
            };
        case 0, $1S1da.SET_DETAIL_DATA:
            return {
                ...state,
                isLoading: false,
                isError: false,
                details: action.payload.details,
                isOptOutOfDeploymentDiscovery: action.payload.isOptOutOfDeploymentDiscovery
            };
        case 0, $1S1da.FETCHING_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $1S1da.OPT_OUT_DEPLOYMENTS_DISCOVERY:
            return {
                ...state,
                isOptOutOfDeploymentDiscovery: true
            };
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action;
            return state;
    }
};

});

parcelRegister("az3D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $18ba4ad597fd223e$export$2e2bcd8739ae039);


var $h60TS = parcelRequire("h60TS");
const $18ba4ad597fd223e$export$49d5fc8cba920a0 = {
    activeTab: (0, $14a090e212ebf7a4$export$e18d81f044132a0e),
    selectedApplicationType: undefined,
    isCreatingPullRequestFromDiscovery: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$18ba4ad597fd223e$export$2e2bcd8739ae039 = (state = $18ba4ad597fd223e$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $h60TS.CHANGE_TAB:
            return {
                ...state,
                activeTab: action.payload.activeTab,
                isCreatingPullRequestFromDiscovery: false
            };
        case 0, $h60TS.SET_SELECTED_APPLICATION_TYPE:
            return {
                ...state,
                selectedApplicationType: action.payload.selectedApplicationType,
                isCreatingPullRequestFromDiscovery: false
            };
        // @ts-expect-error - TS2678 - Type '"state.actions.ui.OPEN_PULL_REQUEST_CREATION_DISCOVERY"' is not comparable to type '"state.actions.ui.CHANGE_TAB" | "state.actions.ui.SET_SELECTED_APPLICATION_TYPE"'.
        case 0, $h60TS.OPEN_PULL_REQUEST_CREATION_DISCOVERY:
            return {
                ...state,
                isCreatingPullRequestFromDiscovery: true
            };
        // @ts-expect-error - TS2678 - Type '"state.actions.ui.CLOSE_PULL_REQUEST_CREATION_DISCOVERY"' is not comparable to type '"state.actions.ui.CHANGE_TAB" | "state.actions.ui.SET_SELECTED_APPLICATION_TYPE"'.
        case 0, $h60TS.CLOSE_PULL_REQUEST_CREATION_DISCOVERY:
            return {
                ...state,
                isCreatingPullRequestFromDiscovery: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("iqgeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ff9f21de8facf0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");

var $lNNXV = parcelRequire("lNNXV");


var $h60TS = parcelRequire("h60TS");

var $3MW6m = parcelRequire("3MW6m");

var $gNNkQ = parcelRequire("gNNkQ");

var $4Jfz8 = parcelRequire("4Jfz8");

var $8hGyj = parcelRequire("8hGyj");

var $i9Ky6 = parcelRequire("i9Ky6");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $63ff9f21de8facf0$var$tabs = [
    {
        type: (0, $14a090e212ebf7a4$export$e18d81f044132a0e),
        messageDescriptor: (0, $8hGyj.default).branchTabLabel,
        TabContent: (0, $4Jfz8.Branches)
    },
    {
        type: (0, $14a090e212ebf7a4$export$2e42513c7764d5f3),
        messageDescriptor: (0, $8hGyj.default).commitTabLabel,
        TabContent: (0, $4Jfz8.Commits)
    },
    {
        type: (0, $14a090e212ebf7a4$export$6f74b53d652f13f3),
        messageDescriptor: (0, $8hGyj.default).pullRequestsTabLabel,
        TabContent: (0, $4Jfz8.PullRequests)
    }
];
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $63ff9f21de8facf0$var$buildDeploymentFeatureFlagTabs = [
    {
        type: (0, $14a090e212ebf7a4$export$74a388a09f2a004e),
        messageDescriptor: (0, $8hGyj.default).buildTabLabel,
        TabContent: (0, $4Jfz8.Builds)
    },
    {
        type: (0, $14a090e212ebf7a4$export$90cac6260ae9ced5),
        messageDescriptor: (0, $8hGyj.default).deploymentsTabLabel,
        TabContent: (0, $4Jfz8.Deployments)
    },
    {
        type: (0, $14a090e212ebf7a4$export$c69477f358d30f7e),
        messageDescriptor: (0, $8hGyj.default).featureFlagsLabel,
        TabContent: (0, $4Jfz8.FeatureFlags)
    }
];
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $63ff9f21de8facf0$var$remoteLinksTabs = [
    {
        type: (0, $14a090e212ebf7a4$export$56470bdd9cd798d0),
        messageDescriptor: (0, $8hGyj.default).remoteLinksLabel,
        TabContent: (0, $4Jfz8.RemoteLinks)
    }
];
const $63ff9f21de8facf0$var$getAvailableTabs = (showRemoteLinks)=>{
    let availableTabs = $63ff9f21de8facf0$var$tabs;
    if ((0, $1ybV0.ff)('isotopes-dev-details-hide-tabs-fedramp_ew0ag') && (0, $dfBCt.isFedRamp)()) return availableTabs;
    availableTabs = [
        ...availableTabs,
        ...$63ff9f21de8facf0$var$buildDeploymentFeatureFlagTabs
    ];
    if (showRemoteLinks) availableTabs = [
        ...availableTabs,
        ...$63ff9f21de8facf0$var$remoteLinksTabs
    ];
    return availableTabs;
};
const $63ff9f21de8facf0$var$ConnectedDetails = (0, $lNNXV.connect)((state)=>({
        activeTab: (0, $gNNkQ.getActiveTab)(state),
        isLoading: (0, $3MW6m.isLoading)(state),
        isError: (0, $3MW6m.isError)(state)
    }), {
    onChangeTab: (0, $h60TS.changeTab)
})((0, $i9Ky6.default));
const $63ff9f21de8facf0$var$DevelopmentDetails = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63ff9f21de8facf0$var$ConnectedDetails, {
        ...props,
        tabs: $63ff9f21de8facf0$var$getAvailableTabs(props.showRemoteLinks),
        Header: (0, $4Jfz8.DetailsHeader)
    });
const $63ff9f21de8facf0$export$efb2d5db5f0ac000 = $63ff9f21de8facf0$var$getAvailableTabs;
var $63ff9f21de8facf0$export$2e2bcd8739ae039 = $63ff9f21de8facf0$var$DevelopmentDetails;

});
parcelRegister("4Jfz8", function(module, exports) {

$parcel$export(module.exports, "DetailsHeader", () => $2407fdd3e051c798$export$56e2352e63353d99);
$parcel$export(module.exports, "Branches", () => $2407fdd3e051c798$export$bec84148410bc670);
$parcel$export(module.exports, "Builds", () => $2407fdd3e051c798$export$5026e6aa86fecb8d);
$parcel$export(module.exports, "Commits", () => $2407fdd3e051c798$export$42f6c967f424d901);
$parcel$export(module.exports, "Deployments", () => $2407fdd3e051c798$export$1e0d13bd7c83bc57);
$parcel$export(module.exports, "PullRequests", () => $2407fdd3e051c798$export$5c25d45187ab05fe);
$parcel$export(module.exports, "FeatureFlags", () => $2407fdd3e051c798$export$ab28ab2e245553c7);
$parcel$export(module.exports, "RemoteLinks", () => $2407fdd3e051c798$export$cd0ba36797648943);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $3y0aq = parcelRequire("3y0aq");

var $37ENi = parcelRequire("37ENi");

const $2407fdd3e051c798$var$loadAsyncComponent = async ()=>{
    const result = await (parcelRequire("l3iKh"));
    return result;
};
// DetailsHeaders
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyDetailsHeaderComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Header
        })), {});
const $2407fdd3e051c798$export$56e2352e63353d99 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "details-header-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3y0aq.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyDetailsHeaderComponent, props));
// Branches
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyBranchesComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Branches
        })), {});
const $2407fdd3e051c798$export$bec84148410bc670 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "branches-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyBranchesComponent, props));
// Build
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyBuildsComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Builds
        })), {});
const $2407fdd3e051c798$export$5026e6aa86fecb8d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "builds-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyBuildsComponent, props));
// Commits
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyCommitsComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Commits
        })), {});
const $2407fdd3e051c798$export$42f6c967f424d901 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "commits-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyCommitsComponent, props));
// Deployment
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyDeploymentsComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.Deployments
        })), {});
const $2407fdd3e051c798$export$1e0d13bd7c83bc57 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "deployments-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyDeploymentsComponent, props));
// PullRequests
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyPullRequestsComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.PullRequests
        })), {});
const $2407fdd3e051c798$export$5c25d45187ab05fe = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "pull-requests-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyPullRequestsComponent, props));
// FeatureFlags
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyFeatureFlagsComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.FeatureFlags
        })), {});
const $2407fdd3e051c798$export$ab28ab2e245553c7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "feature-flags-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyFeatureFlagsComponent, props));
// RemoteLinks
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2407fdd3e051c798$var$LazyRemoteLinksComponent = (0, $7rh0R.lazy)(()=>$2407fdd3e051c798$var$loadAsyncComponent().then((exportedModule)=>({
            default: exportedModule.RemoteLinks
        })), {});
const $2407fdd3e051c798$export$cd0ba36797648943 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "remote-links-component",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37ENi.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2407fdd3e051c798$var$LazyRemoteLinksComponent, props));

});
parcelRegister("3y0aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $14572f7bf1c6ef61$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kigFe = parcelRequire("kigFe");
function $14572f7bf1c6ef61$export$55e5a03ad60fe281() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14572f7bf1c6ef61$var$DetailsHeaderPlaceholderContent, null));
}
var $14572f7bf1c6ef61$export$2e2bcd8739ae039 = $14572f7bf1c6ef61$export$55e5a03ad60fe281;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14572f7bf1c6ef61$var$DetailsHeaderPlaceholderContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7ynd",
            __cmplp.className
        ])
    });
});

});

parcelRegister("37ENi", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb31ef1c3988f537$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $c4zaL = parcelRequire("c4zaL");

var $5UVMi = parcelRequire("5UVMi");
function $bb31ef1c3988f537$export$c8c82333c05efb99() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UVMi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4zaL.default), null));
}
var $bb31ef1c3988f537$export$2e2bcd8739ae039 = $bb31ef1c3988f537$export$c8c82333c05efb99;

});
parcelRegister("c4zaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $352890746ad5b013$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$352890746ad5b013$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($352890746ad5b013$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($352890746ad5b013$var$SpinnerAligner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $352890746ad5b013$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1tkedgin _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $352890746ad5b013$var$SpinnerAligner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _94n5xy5q",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5UVMi", function(module, exports) {

$parcel$export(module.exports, "TruncateWrapper", () => $f576892504224eda$export$42d4c92a873375eb);
$parcel$export(module.exports, "SimpleTableWrapper", () => $f576892504224eda$export$ade5168a554b7644);
$parcel$export(module.exports, "default", () => $f576892504224eda$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");
const $f576892504224eda$export$42d4c92a873375eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f576892504224eda$var$TruncateContainer, null, children);
const $f576892504224eda$export$ade5168a554b7644 = ({ children: children, rowHeight: rowHeight, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f576892504224eda$var$SimpleTableContainer, {
        rowHeight: rowHeight,
        "data-testid": testId
    }, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f576892504224eda$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _1rjcu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});
const $f576892504224eda$var$TruncateContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f576892504224eda$var$SimpleTableContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { rowHeight: rowHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_2mmgl8": (0, $9t7rW.default)(__cmplp.rowHeight ? (0, $c9TLT.gridSize) * __cmplp.rowHeight : 'auto')
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1jzq1qwm _6l9yjp4b _1hvyidpf _r02pidpf",
            __cmplp.className
        ])
    });
});
var $f576892504224eda$export$2e2bcd8739ae039 = $f576892504224eda$var$Container;

});


parcelRegister("l3iKh", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("6ETkw")
]).then(()=>parcelRequire('eCJHd'));

});


parcelRegister("8hGyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61cf811b1ab3b10$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b61cf811b1ab3b10$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    branchTabLabel: {
        "id": "development.details.main.branch-tab-label",
        "defaultMessage": "Branches"
    },
    pullRequestsTabLabel: {
        "id": "development.details.main.pull-requests-tab-label",
        "defaultMessage": "Pull requests"
    },
    buildTabLabel: {
        "id": "development.details.main.build-tab-label",
        "defaultMessage": "Builds"
    },
    commitTabLabel: {
        "id": "development.details.main.commit-tab-label",
        "defaultMessage": "Commits"
    },
    deploymentsTabLabel: {
        "id": "development.details.main.deployments-tab-label",
        "defaultMessage": "Deployments"
    },
    featureFlagsLabel: {
        "id": "development.details.main.feature-flags-label",
        "defaultMessage": "Feature flags"
    },
    remoteLinksLabel: {
        "id": "development.details.main.remote-links-label",
        "defaultMessage": "Other links"
    }
});

});

parcelRegister("i9Ky6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cba28261ca9ac3e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");

var $5dpJB = parcelRequire("5dpJB");
var $kgCsd = parcelRequire("kgCsd");

var $kGQen = parcelRequire("kGQen");

var $kAdq3 = parcelRequire("kAdq3");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $awlW4 = parcelRequire("awlW4");

var $jL1Mq = parcelRequire("jL1Mq");
const $4cba28261ca9ac3e$export$1615b9091acd4226 = ({ children: children })=>{
    const tabPanelAttributes = (0, $kgCsd.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4cba28261ca9ac3e$var$TabPanel, tabPanelAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, children));
};
class $4cba28261ca9ac3e$export$3e8048d3cf2ba3fd extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        const { activeTab: prevActiveTab } = prevProps;
        const { activeTab: activeTab } = this.props;
        if (this.bodyRef.current && activeTab !== prevActiveTab) this.bodyRef.current.scrollTop = 0;
    }
    renderTabContent() {
        const { issueId: issueId, issueKey: issueKey, baseUrl: baseUrl, locale: locale, tabs: tabs } = this.props;
        return tabs.map(({ TabContent: TabContent, ...tab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4cba28261ca9ac3e$export$1615b9091acd4226, {
                key: tab.type
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TabContent, {
                issueId: issueId,
                issueKey: issueKey,
                baseUrl: baseUrl,
                locale: locale
            })));
    }
    renderMetricsElements() {
        if (this.props.isLoading) return [];
        if (this.props.isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
            eventName: "developmentDetailsDialog failed",
            attributes: {
                errorType: 'serverError'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAdq3.CancelMetric), {
            metric: (0, $awlW4.devDetailsTimeToLoad)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
            eventName: "developmentDetailsDialog rendered"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kAdq3.StopMetric), {
            metric: (0, $awlW4.devDetailsTimeToLoad)
        }));
    }
    render() {
        const { activeTab: activeTab, tabs: tabs } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "devPanelDetailsDialog",
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jL1Mq.RepoPromptForGithubBannerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default // @ts-expect-error - TS2769 - No overload matches this call.
        ), {
            onClose: this.onClose,
            width: "x-large",
            height: "800px",
            testId: "development-details.main.modal-dialog",
            autoFocus: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
            id: "dev-details-dialog-tab",
            selected: tabs.findIndex((tab)=>tab.type === activeTab),
            onChange: this.onChangeTab,
            shouldUnmountTabPanelOnChange: true
        }, this.renderHeader(), this.renderTabContent()), this.renderMetricsElements(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                activeTab: activeTab
            }
        })))));
    }
    constructor(...args){
        super(...args);
        this.bodyRef = /*#__PURE__*/ (0, $eUqFw.createRef)() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.onClose = (event, analyticsEvent)=>{
            const { onCloseDialog: onCloseDialog } = this.props;
            onCloseDialog();
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closeDevPanelDetailsDialog');
            (0, $awlW4.devDetailsTimeToLoad).cancel();
        };
        this.renderHeader = ()=>{
            const { intl: intl, issueKey: issueKey, Header: Header, tabs: tabs, activeTab: activeTab, onChangeTab: onChangeTab, issueId: issueId } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
                intl: intl,
                issueId: issueId,
                issueKey: issueKey,
                tabs: tabs,
                activeTab: activeTab,
                onChangeTab: onChangeTab,
                onClose: this.onClose
            });
        };
        this.onChangeTab = (selectedIndex)=>{
            const { activeTab: activeTab, tabs: tabs } = this.props;
            const currentIndex = tabs.findIndex((tab)=>tab.type === activeTab);
            if (currentIndex !== selectedIndex) {
                const { type: type } = tabs[selectedIndex];
                this.props.onChangeTab(type);
            }
        };
    }
}
var $4cba28261ca9ac3e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($4cba28261ca9ac3e$export$3e8048d3cf2ba3fd);
const $4cba28261ca9ac3e$var$TabPanel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1695idpf _1pnsidpf _vktqidpf _1byqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $f50084288d7b85a1$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $f50084288d7b85a1$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStylesOld,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$442d081208938078 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStylesOld,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});

parcelRegister("jL1Mq", function(module, exports) {

$parcel$export(module.exports, "RepoPromptForGithubBannerContainer", () => $fd749bfeda3a0bbe$export$45dde93000762220);
$parcel$export(module.exports, "useRepoPromptForGitHubBannerStore", () => $fd749bfeda3a0bbe$export$eb324ac18e7a4169);

var $WBLbN = parcelRequire("WBLbN");
const $fd749bfeda3a0bbe$export$d4c72bab9d6cc13a = {};
const $fd749bfeda3a0bbe$export$45dde93000762220 = (0, $WBLbN.createContainer)();
const $fd749bfeda3a0bbe$export$e324594224ef24da = {
    setRepoPromptForGitHubBannerDetails: (repoId, details)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const repoDetail = state[repoId] || {};
            setState({
                ...state,
                [repoId]: {
                    ...repoDetail,
                    ...details
                }
            });
        }
};
const $fd749bfeda3a0bbe$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    initialState: $fd749bfeda3a0bbe$export$d4c72bab9d6cc13a,
    containedBy: $fd749bfeda3a0bbe$export$45dde93000762220,
    actions: $fd749bfeda3a0bbe$export$e324594224ef24da,
    name: 'repo-prompt-for-github-banner-store'
});
const $fd749bfeda3a0bbe$export$eb324ac18e7a4169 = (0, $WBLbN.createHook)($fd749bfeda3a0bbe$export$390f32400eaf98c9);

});





parcelRegister("lsyEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b822500c7f067daa$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $fcWBJ = parcelRequire("fcWBJ");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $dnbhd = parcelRequire("dnbhd");

var $4ksts = parcelRequire("4ksts");

var $aBjAC = parcelRequire("aBjAC");

var $iCcNH = parcelRequire("iCcNH");

var $8Cq5c = parcelRequire("8Cq5c");

var $gyTi1 = parcelRequire("gyTi1");
const $b822500c7f067daa$var$DATE_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $b822500c7f067daa$var$DeploymentsDialogContent = ({ onClose: onClose, deployments: deployments, onShowMoreInfo: onShowMoreInfo })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $4ksts.useIntlV2)();
    const slideOut = (0, $gyTi1.useSlideOut)();
    (0, $eUqFw.useEffect)(()=>{
        let timer;
        if (slideOut !== null) timer = setTimeout(()=>{
            onClose();
        }, $b822500c7f067daa$var$ANIMATION_DURATION);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        onClose,
        slideOut
    ]);
    const isMultiDeployment = deployments.length > 1;
    const isSingleDeployment = deployments.length === 1;
    const isManyDeployments = deployments.length > 3;
    const deploymentsByPipeline = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(deployments, (deployment)=>deployment.pipeline.displayName);
    const deploymentsByPipelineEntries = Object.entries(deploymentsByPipeline);
    return(// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type '"UP" | "LEFT" | "RIGHT" | null'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$ContentContainer, {
        slideOut: slideOut
    }, isMultiDeployment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$Header, {
        manyDeployments: isManyDeployments
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$DeploymentsTitle, null, formatMessage((0, $8Cq5c.default).numDeployments, {
        numDeployments: deployments.length
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$DateText, null, deployments[0].lastUpdated.toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric'
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$DeploymentsContainer, null, deploymentsByPipelineEntries.map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([pipelineName, pipelineDeployments])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: pipelineName
        }, isMultiDeployment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$PipelineLink, {
            href: pipelineDeployments[0].pipeline.url,
            target: "_blank"
        }, pipelineName), pipelineDeployments.map((deployment)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$DeploymentContainer // used for end-to-end pollinator test (https://pollinator.prod.atl-paas.net/checks/a221dc5e-7252-497b-b39a-e6a1169cfe52)
            , {
                "data-test-id": "software-deployments.ui.timeline.deployments-bar.circles.deployments-dialog.dialog-content.deployment",
                "data-testid": "software-deployments.ui.timeline.deployments-bar.circles.deployments-dialog.dialog-content.deployment",
                key: deployment.id
            }, isSingleDeployment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                level: "h200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$Label, null, formatMessage((0, $8Cq5c.default).pipeline))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
                href: deployment.pipeline.url,
                target: "_blank"
            }, deployment.pipeline.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                level: "h200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$Label, null, formatMessage((0, $8Cq5c.default).environment))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$FlexBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBjAC.default), {
                deployments: [
                    deployment
                ],
                showMultipleDeploymentsIcon: false,
                hasBorder: false
            })), deployment.environment.displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                level: "h200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$Label, null, formatMessage((0, $8Cq5c.default).updated))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCcNH.default), {
                date: (0, $gyTi1.formatDeploymentDate)(new Date(), deployment.lastUpdated),
                tooltip: formatDate(deployment.lastUpdated, $b822500c7f067daa$var$DATE_FORMAT),
                label: formatMessage((0, $8Cq5c.default).infoIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
                level: "h200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$Label, null, formatMessage((0, $8Cq5c.default).deployment))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnbhd.default), {
                href: deployment.url,
                target: "_blank"
            }, deployment.displayName))), isMultiDeployment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$SpaceBetween, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$FlexBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBjAC.default), {
                deployments: [
                    deployment
                ],
                showMultipleDeploymentsIcon: false,
                hasBorder: false
            })), deployment.environment.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$LastUpdated, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iCcNH.default), {
                date: (0, $gyTi1.formatDeploymentDate)(new Date(), deployment.lastUpdated),
                tooltip: formatDate(deployment.lastUpdated, $b822500c7f067daa$var$DATE_FORMAT),
                swiftIconPosition: true,
                label: formatMessage((0, $8Cq5c.default).infoIconLabel)
            })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b822500c7f067daa$var$FooterContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-deployments.ui.timeline.deployments-bar.circles.deployments-dialog.dialog-content.show-more-info",
        shouldFitContainer: true,
        onClick: ()=>{
            onShowMoreInfo();
        }
    }, formatMessage((0, $8Cq5c.default).showMoreInfo))))));
};
const $b822500c7f067daa$var$gutter = "var(--ds-space-300, 24px)";
const $b822500c7f067daa$var$smallGutter = "var(--ds-space-200, 16px)";
const $b822500c7f067daa$var$slideLeft = null;
const $b822500c7f067daa$var$slideRight = null;
const $b822500c7f067daa$var$slideUp = null;
const $b822500c7f067daa$var$slideAnimation = {
    LEFT: $b822500c7f067daa$var$slideLeft,
    RIGHT: $b822500c7f067daa$var$slideRight,
    UP: $b822500c7f067daa$var$slideUp
};
const $b822500c7f067daa$var$ANIMATION_DURATION = 350; // milliseconds
const $b822500c7f067daa$var$DIALOG_MAX_HEIGHT = 376; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { slideOut: slideOut, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_13l4wu": (0, $9t7rW.default)($b822500c7f067daa$var$slideAnimation[__cmplp.slideOut])
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1gwv _4t3i1osq _c71l4u42 _1e0c1txw _2lx21bp4 _1pby1nn1 _1reo1wug _18m91wug _bfhk1bhr _2rko1l7b _16qs1mxi",
            __cmplp.slideOut && "_y44v1hha _1o51q7pw _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $b822500c7f067daa$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { manyDeployments: manyDeployments, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1bhr",
            __cmplp.manyDeployments && "_n7zl1l5u",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$DeploymentsTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _1e0c1txw _1bah1yb4 _syaz1aqp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$DeploymentsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41e2i _18m91wug _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$Footer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$FooterContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4pxbi _x3do1l5u",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$FlexBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$SpaceBetween = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$DeploymentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3tdpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$PipelineLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi _1e0c1ule",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$LastUpdated = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syaz1wmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$DateText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b822500c7f067daa$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyridpf",
            __cmplp.className
        ])
    });
});
var $b822500c7f067daa$export$2e2bcd8739ae039 = $b822500c7f067daa$var$DeploymentsDialogContent;

});
parcelRegister("dnbhd", function(module, exports) {

$parcel$export(module.exports, "default", () => $92444a2f8aee76e7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eGI9v = parcelRequire("eGI9v");

var $lB25E = parcelRequire("lB25E");
function $92444a2f8aee76e7$var$Link(props) {
    const { children: children, ...rest } = props;
    delete rest.createAnalyticsEvent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), rest, children);
}
var $92444a2f8aee76e7$export$2e2bcd8739ae039 = (0, $eGI9v.default)('link', {
    onClick: 'clicked'
})($92444a2f8aee76e7$var$Link);

});

parcelRegister("iCcNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d202e6837c7c7259$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $hyntP = parcelRequire("hyntP");
function $d202e6837c7c7259$var$DateTooltip(props) {
    const { date: date, tooltip: tooltip, swiftIconPosition: swiftIconPosition, label: label } = props;
    const [showInfo, setShowInfo] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        xcss: [
            $d202e6837c7c7259$var$dataCellWrapperStyles,
            swiftIconPosition && $d202e6837c7c7259$var$swiftIconPositionStyles
        ],
        onFocus: ()=>setShowInfo(true),
        onBlur: ()=>setShowInfo(false),
        onMouseEnter: ()=>setShowInfo(true),
        onMouseLeave: ()=>setShowInfo(false)
    }, /*#__PURE__*/ $eUqFw.createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $d202e6837c7c7259$var$contentStyles
        ]
    }, date), /*#__PURE__*/ $eUqFw.createElement((0, $2eG9N.default), {
        content: tooltip,
        position: "top",
        tag: "span"
    }, (tooltipProps)=>/*#__PURE__*/ $eUqFw.createElement((0, $7u4fN.default), {
            ...tooltipProps,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ $eUqFw.createElement((0, $hyntP.default), null),
            spacing: "none",
            "aria-label": label,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $7JEyt.default)([
                "_1e0c1txw _v564vnwl _tzy4idpf",
                showInfo ? "_tzy4kb7n" : "_p12fidpf"
            ])
        })));
}
var $d202e6837c7c7259$export$2e2bcd8739ae039 = $d202e6837c7c7259$var$DateTooltip;
const $d202e6837c7c7259$var$dataCellWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.025'
});
const $d202e6837c7c7259$var$swiftIconPositionStyles = (0, $1ZAYh.xcss)({
    flexDirection: 'row-reverse'
});
const $d202e6837c7c7259$var$contentStyles = (0, $1ZAYh.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $d202e6837c7c7259$var$iconButtonStyles = null;
const $d202e6837c7c7259$var$buttonWithoutWidth = null;
const $d202e6837c7c7259$var$buttonWithOpacity = null;

});
parcelRegister("hyntP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2578eaafa2fcfbea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $2578eaafa2fcfbea$var$InfoIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "12",
        "aria-label": "",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM6 10.6667C8.57733 10.6667 10.6667 8.57733 10.6667 6C10.6667 3.42267 8.57733 1.33333 6 1.33333C3.42267 1.33333 1.33333 3.42267 1.33333 6C1.33333 8.57733 3.42267 10.6667 6 10.6667ZM6 9.33333C5.65811 9.33333 5.37633 9.07597 5.33782 8.74441L5.33333 8.66667V6C5.33333 5.63181 5.63181 5.33333 6 5.33333C6.34189 5.33333 6.62367 5.59069 6.66218 5.92225L6.66667 6V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 2.66667C5.53976 2.66667 5.16667 3.03976 5.16667 3.5C5.16667 3.96024 5.53976 4.33333 6 4.33333C6.46024 4.33333 6.83333 3.96024 6.83333 3.5C6.83333 3.03976 6.46024 2.66667 6 2.66667Z",
        fill: "currentColor"
    }));
var $2578eaafa2fcfbea$export$2e2bcd8739ae039 = $2578eaafa2fcfbea$var$InfoIcon;

});


parcelRegister("8Cq5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d0c76fe3d8f094c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0d0c76fe3d8f094c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    numDeployments: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.num-deployments",
        "defaultMessage": "{numDeployments} {numDeployments, plural, one {Deployment} other {Deployments}}"
    },
    seeMoreInfo: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.see-more-info",
        "defaultMessage": "A clickable label that reveals additional, more detailed information about a deployment"
    },
    showMoreInfo: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.show-more-info",
        "defaultMessage": "Show more information"
    },
    deployment: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.deployment",
        "defaultMessage": "Deployment"
    },
    environment: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.environment",
        "defaultMessage": "Environment"
    },
    pipeline: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.pipeline",
        "defaultMessage": "Pipeline"
    },
    updated: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.updated",
        "defaultMessage": "Updated"
    },
    infoIconLabel: {
        "id": "software-deployments.timeline.deployments-bar.circles.deployments-dialog.dialog-content.info-icon-label",
        "defaultMessage": "More info"
    }
});

});

parcelRegister("gyTi1", function(module, exports) {

$parcel$export(module.exports, "useSlideOut", () => $1ba849caa7a13cb8$export$d8a0f1790f70cabb);
$parcel$export(module.exports, "formatDeploymentDate", () => $1ba849caa7a13cb8$export$bdbf647ad704c85a);

var $eUqFw = parcelRequire("eUqFw");

var $gfGP4 = parcelRequire("gfGP4");
var $EN9B6 = parcelRequire("EN9B6");
var $jtnES = parcelRequire("jtnES");

var $9E36O = parcelRequire("9E36O");
const $1ba849caa7a13cb8$var$SECONDS_IN_A_DAY = 86400;
const $1ba849caa7a13cb8$export$d8a0f1790f70cabb = ()=>{
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll, requestViewportScrollBounding: requestViewportScrollBounding } = (0, $eUqFw.useContext)((0, $9E36O.default));
    const [slideOut, setSlideOut] = (0, $eUqFw.useState)(null);
    const initialScrollRef = (0, $eUqFw.useRef)(null);
    const onScroll = (0, $eUqFw.useCallback)(()=>{
        const { scrollLeft: scrollLeft, scrollTop: scrollTop } = requestViewportScrollBounding();
        if (!initialScrollRef.current) initialScrollRef.current = {
            initScrollLeft: scrollLeft,
            initScrollTop: scrollTop
        };
        // @ts-expect-error - TS2339 - Property 'initScrollLeft' does not exist on type 'unknown'. | TS2339 - Property 'initScrollTop' does not exist on type 'unknown'.
        const { initScrollLeft: initScrollLeft, initScrollTop: initScrollTop } = initialScrollRef.current;
        const directionX = initScrollLeft - scrollLeft;
        const directionY = initScrollTop - scrollTop;
        const THRESHOLD = 20;
        if (slideOut === null) {
            if (directionX > THRESHOLD) setSlideOut('RIGHT');
            else if (directionX < -THRESHOLD) setSlideOut('LEFT');
            else if (directionY > THRESHOLD) setSlideOut('UP');
            else if (directionY < -THRESHOLD) setSlideOut('UP');
        }
    }, [
        requestViewportScrollBounding,
        setSlideOut,
        slideOut
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (slideOut !== null) stopListeningToViewportScroll(onScroll);
    }, [
        onScroll,
        slideOut,
        stopListeningToViewportScroll
    ]);
    (0, $eUqFw.useEffect)(()=>{
        listenToViewportScroll(onScroll);
        return ()=>{
            stopListeningToViewportScroll(onScroll);
        };
    }, [
        listenToViewportScroll,
        onScroll,
        stopListeningToViewportScroll
    ]);
    return slideOut;
};
const $1ba849caa7a13cb8$export$bdbf647ad704c85a = (currentDate, lastUpdatedDate)=>{
    const isDateFormatRelative = (0, $gfGP4.default)(currentDate, lastUpdatedDate) <= $1ba849caa7a13cb8$var$SECONDS_IN_A_DAY;
    return isDateFormatRelative ? (0, $jtnES.default)(lastUpdatedDate, currentDate, {
        addSuffix: true,
        roundingMethod: 'floor'
    }) : (0, $EN9B6.default)(lastUpdatedDate, 'd MMM, HH:mm');
};

});



parcelRegister("fvBwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e057ab500e15363d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2LmzR = parcelRequire("2LmzR");

var $f9pKG = parcelRequire("f9pKG");

var $fa7Ff = parcelRequire("fa7Ff");
const $e057ab500e15363d$export$f55111440b613369 = ({ sortedDeployments: sortedDeployments })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const deployment = (0, $2LmzR.getMostMeaningfulDeployment)(sortedDeployments);
    const otherEnvironmentsCount = (0, $fa7Ff.countEnvironments)(sortedDeployments) - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e057ab500e15363d$var$Container, {
        deploymentState: deployment.state
    }, deployment.environment.displayName, otherEnvironmentsCount > 0 && ` ${formatMessage((0, $f9pKG.default).otherEnvironments, {
        otherEnvironmentsCount: otherEnvironmentsCount
    })}`);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e057ab500e15363d$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { deploymentState: deploymentState, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vbc82b": (0, $9t7rW.default)((0, $2LmzR.getColorForDeploymentState)(__cmplp.deploymentState))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazhqgo _11c8qk37 _1bsb1osq _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
var $e057ab500e15363d$export$2e2bcd8739ae039 = $e057ab500e15363d$export$f55111440b613369;

});
parcelRegister("f9pKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a732477d9bfcf14$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a732477d9bfcf14$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    otherEnvironments: {
        "id": "software-deployments.timeline.deployments-bar.circles.environments-label.other-environments",
        "defaultMessage": "+ {otherEnvironmentsCount} {otherEnvironmentsCount, plural, one {other} other {others}} "
    }
});

});

parcelRegister("fa7Ff", function(module, exports) {

$parcel$export(module.exports, "countEnvironments", () => $9700306bf5f3928f$export$d3806240ded0b031);

var $2LmzR = parcelRequire("2LmzR");
const $9700306bf5f3928f$export$d3806240ded0b031 = (deployments)=>{
    const environmentIds = deployments.map(({ environment: environment })=>(0, $2LmzR.getEnvironmentId)(environment));
    return new Set(environmentIds).size;
};

});



parcelRegister("g7ZmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae28a71eaaa892fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2LmzR = parcelRequire("2LmzR");

var $8Z340 = parcelRequire("8Z340");
const $ae28a71eaaa892fa$var$Lines = ({ deployments: deploymentsSorted, getPositionFromDate: getPositionFromDate, timelineMode: timelineMode })=>{
    const deploymentGroups = (0, $2LmzR.getGroupedDeployments)(deploymentsSorted, getPositionFromDate, timelineMode);
    return deploymentGroups.map((group, groupIndex)=>{
        const nextDeploymentsBatch = deploymentGroups[groupIndex + 1] ? deploymentGroups[groupIndex + 1].deployments : undefined;
        const deployment = (0, $2LmzR.getMostMeaningfulDeployment)(group.deployments);
        const nextDeployment = (0, $2LmzR.getMostMeaningfulDeployment)(nextDeploymentsBatch || []);
        if (nextDeploymentsBatch === undefined) return null;
        const linePosition = (0, $8Z340.getLinePositionBetweenDeployments)(nextDeployment, deployment, getPositionFromDate);
        const color = (0, $2LmzR.getColorForDeploymentState)(deployment.state);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae28a71eaaa892fa$var$Line, {
            key: deployment.id,
            leftPosition: linePosition.left,
            rightPosition: linePosition.right,
            color: color
        });
    });
};
const $ae28a71eaaa892fa$var$isEqual = ({ deployments: prevDeployments, timelineMode: prevTimelineMode }, { deployments: nextDeployments, timelineMode: nextTimelineMode })=>prevTimelineMode === nextTimelineMode && (0, $2LmzR.areDeploymentsEqual)(prevDeployments, nextDeployments);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae28a71eaaa892fa$var$Line = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { leftPosition: leftPosition, rightPosition: rightPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color),
            "--_1ockb60": (0, $9t7rW.default)(__cmplp.leftPosition, "%"),
            "--_1p0zf7x": (0, $9t7rW.default)(__cmplp.rightPosition, "%")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iv77o _kqswstnw _bfhk1cj8 _1ltvzpku _1xi21jef",
            __cmplp.className
        ])
    });
});
var $ae28a71eaaa892fa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($ae28a71eaaa892fa$var$Lines, $ae28a71eaaa892fa$var$isEqual);

});
parcelRegister("8Z340", function(module, exports) {

$parcel$export(module.exports, "getLinePositionBetweenDeployments", () => $e2c764f3fbcbf724$export$90b6b0692688281f);
const $e2c764f3fbcbf724$var$roundTwoDecimals = (n)=>Math.round(n * 100) / 100;
const $e2c764f3fbcbf724$export$90b6b0692688281f = (d1, d2, getPositionFromDate)=>{
    const { left: d1Left, right: d1Right } = getPositionFromDate(d1.lastUpdated);
    const { left: d2Left } = getPositionFromDate(d2.lastUpdated);
    // Apply some margin to draw lines closer to each circle due to the visual design
    const marginPercentage = (100 - (d1Left + d1Right)) * 0.5;
    return {
        left: $e2c764f3fbcbf724$var$roundTwoDecimals(100 - (d1Right + marginPercentage)),
        right: $e2c764f3fbcbf724$var$roundTwoDecimals(100 - (d2Left + marginPercentage))
    };
};

});



parcelRegister("9R8v8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7072329c404ad17$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9E36O = parcelRequire("9E36O");

var $36Dty = parcelRequire("36Dty");

var $gEpgE = parcelRequire("gEpgE");

var $kq9yX = parcelRequire("kq9yX");

var $56t7F = parcelRequire("56t7F");

var $OwuLI = parcelRequire("OwuLI");

var $cspQN = parcelRequire("cspQN");
// Preload next deployments 150px before the bottom
const $b7072329c404ad17$var$THRESHOLD = 150;
const $b7072329c404ad17$var$useVerticalPagination = ()=>{
    const { serviceResult: { loadingState: loadingState }, getNextIssuePage: getNextIssuePage } = (0, $OwuLI.useCoreData)();
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $9E36O.useViewport)();
    const lastScrollHeightBeforePaginated = (0, $eUqFw.useRef)(null);
    const lastScrollTop = (0, $eUqFw.useRef)(null);
    // Ensure we keep paginating until there's no more empty space
    // at the bottom of the table after the initial load. This is
    // possible with the AGS-powered backend because we don't
    // know exactly how many issues will be returned for a given page
    // of data.
    (0, $eUqFw.useEffect)(()=>{
        const scrollBounding = requestViewportScrollBounding();
        const isMoreFreeSpace = !scrollBounding.isOverflowY;
        if (loadingState === (0, $gEpgE.LoadingStateOptions).READY && isMoreFreeSpace && getNextIssuePage !== null) getNextIssuePage();
    }, [
        loadingState,
        getNextIssuePage,
        requestViewportScrollBounding
    ]);
    const onScroll = (0, $eUqFw.useCallback)((target)=>{
        const isDownwardVerticallyScrolled = lastScrollTop.current === null ? false : lastScrollTop.current < target.scrollTop;
        lastScrollTop.current = target.scrollTop;
        if (lastScrollHeightBeforePaginated.current !== null) {
            // it appears that you can keep scrolling a container past its max height.
            // In this example if you scroll fast to the bottom and keep scrolling
            // there is a big jump when the new deployments load in.
            // TODO this isn't perfect at all, we need to fix this.
            // Maybe setting overscroll-behavior: none will help?
            // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'number'.
            // eslint-disable-next-line no-param-reassign
            target.scrollTop = lastScrollHeightBeforePaginated.current;
            lastScrollHeightBeforePaginated.current = null;
            return;
        }
        const isVerticalEndReached = target.scrollTop + target.clientHeight + $b7072329c404ad17$var$THRESHOLD >= target.scrollHeight && isDownwardVerticallyScrolled;
        if (isVerticalEndReached && getNextIssuePage !== null && loadingState === (0, $gEpgE.LoadingStateOptions).READY) {
            // load more issues and deployments but remember the scrollHeight so we don't
            // exceed this in the next animation frame.
            lastScrollHeightBeforePaginated.current = target.scrollHeight;
            getNextIssuePage();
        }
    }, [
        getNextIssuePage,
        loadingState
    ]);
    return onScroll;
};
const $b7072329c404ad17$var$useHorizontalPagination = ()=>{
    const { serviceResult: { loadingState: loadingState }, getNextIssuePage: getNextIssuePage } = (0, $OwuLI.useCoreData)();
    const earliestVisibleDeploymentDate = (0, $OwuLI.useEarliestVisibleDeploymentDate)();
    const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, $9E36O.useViewport)();
    const timeWindowFilter = (0, $56t7F.useTimeWindowFilter)();
    const timelineDuration = (0, $kq9yX.getTimelineDurationFromTimeWindowFilter)(timeWindowFilter);
    const earliestVisibleDeploymentPosition = earliestVisibleDeploymentDate == null ? null : (0, $36Dty.getPositionForTimestamp)(earliestVisibleDeploymentDate, timelineDuration);
    const paginateIfNeeded = (0, $eUqFw.useCallback)(()=>{
        const scrollBounding = requestViewportScrollBounding();
        const currentScrollPosition = scrollBounding.scrollLeft / scrollBounding.scrollWidth;
        const hasScrolledPastEarliestDeployment = earliestVisibleDeploymentPosition != null && currentScrollPosition <= earliestVisibleDeploymentPosition;
        if (loadingState === (0, $gEpgE.LoadingStateOptions).READY && hasScrolledPastEarliestDeployment && getNextIssuePage !== null) getNextIssuePage();
    }, [
        earliestVisibleDeploymentPosition,
        requestViewportScrollBounding,
        getNextIssuePage,
        loadingState
    ]);
    // We don't know how far back in time a given page of deployments will push
    // the `earliestVisibleDeploymentPosition`, so we may need to immediately
    // re-trigger pagination (note that `loadingState` is a dependency of `paginateIfNeeded`).
    (0, $eUqFw.useEffect)(paginateIfNeeded, [
        paginateIfNeeded
    ]);
    const onScroll = paginateIfNeeded;
    return onScroll;
};
const $b7072329c404ad17$var$IssuePageFetcher = ()=>{
    const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, $9E36O.useViewport)();
    const onHorizontalScroll = $b7072329c404ad17$var$useHorizontalPagination();
    const onVerticalScroll = $b7072329c404ad17$var$useVerticalPagination();
    (0, $eUqFw.useEffect)(()=>{
        const onScroll = (event)=>{
            if (event.target instanceof Element) {
                // Doesn't actually matter if the scroll was horizontal, vertical, or both.
                // Let each handler determine what to do...
                onHorizontalScroll();
                onVerticalScroll(event.target);
            }
        };
        listenToViewportScroll(onScroll);
        return ()=>{
            stopListeningToViewportScroll(onScroll);
        };
    }, [
        listenToViewportScroll,
        stopListeningToViewportScroll,
        onHorizontalScroll,
        onVerticalScroll
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cspQN.LoadingStatusIndicator), null);
};
var $b7072329c404ad17$export$2e2bcd8739ae039 = $b7072329c404ad17$var$IssuePageFetcher;

});
parcelRegister("cspQN", function(module, exports) {

$parcel$export(module.exports, "LoadingStatusIndicator", () => $6f7d411d49e424bb$export$c5d07ab1048465a3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gEpgE = parcelRequire("gEpgE");

var $OwuLI = parcelRequire("OwuLI");

var $2k28K = parcelRequire("2k28K");
const $6f7d411d49e424bb$export$c5d07ab1048465a3 = ()=>{
    const { serviceResult: { loadingState: loadingState, data: data }, getNextIssuePage: getNextIssuePage, hasReachedMaxIssuesLimit: hasReachedMaxIssuesLimit } = (0, $OwuLI.useCoreData)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issuesCount = data?.issues.length ?? 0;
    const isLoading = loadingState === (0, $gEpgE.LoadingStateOptions).LOADING_NEXT_PAGE;
    const message = hasReachedMaxIssuesLimit ? formatMessage((0, $2k28K.default).maxIssues) : formatMessage((0, $2k28K.default).allIssues, {
        issuesCount: issuesCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6f7d411d49e424bb$var$ContentContainer, null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    }), !isLoading && getNextIssuePage === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, message));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f7d411d49e424bb$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _1yt4utpp _syaz1wmz _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2k28K", function(module, exports) {

$parcel$export(module.exports, "default", () => $112de2c47e5d638b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $112de2c47e5d638b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    allIssues: {
        "id": "software-deployments.timeline.issue-page-fetcher.loading-status-indicator.all-issues",
        "defaultMessage": "Showing {issuesCount} {issuesCount, plural, one {issue} other {issues}} that match your settings or filters."
    },
    maxIssues: {
        "id": "software-deployments.timeline.issue-page-fetcher.loading-status-indicator.max-issues",
        "defaultMessage": "Displaying maximum number of issues. Please add some filters to refine your search."
    }
});

});



parcelRegister("jkcwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $17080b43fefd6df1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $OwuLI = parcelRequire("OwuLI");

var $iZvR4 = parcelRequire("iZvR4");

var $3xFrP = parcelRequire("3xFrP");
const $17080b43fefd6df1$var$IssueTitle = ()=>{
    const isLoadingByFilterChange = (0, $OwuLI.useIsCoreLoadingByFilterChange)(); // TODO: Only display this if we are paginating due to a horizontal scroll.
    // For vertical scrolls, there'll already be a spinner shown at the bottom
    // of the table.
    const isLoadingNextPage = (0, $OwuLI.useIsLoadingNextPage)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($17080b43fefd6df1$var$IssueTitleContainer, null, formatMessage((0, $3xFrP.default).issues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iZvR4.default), null), isLoadingByFilterChange || isLoadingNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $17080b43fefd6df1$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })));
};
var $17080b43fefd6df1$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $17080b43fefd6df1$var$IssueTitle;
const $17080b43fefd6df1$var$IssueTitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq _k48p8n31",
            __cmplp.className
        ])
    });
});
const $17080b43fefd6df1$var$spinnerWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("iZvR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28eace271fba33b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5YsMl = parcelRequire("5YsMl");


var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $OwuLI = parcelRequire("OwuLI");

var $elGYS = parcelRequire("elGYS");
const $c28eace271fba33b$var$MaxPaginationWarning = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hasReachedMaxIssuesLimit: hasReachedMaxIssuesLimit, hasReachedMaxDeploymentsLimit: hasReachedMaxDeploymentsLimit } = (0, $OwuLI.useCoreDataLimits)();
    if (!hasReachedMaxIssuesLimit && !hasReachedMaxDeploymentsLimit) return null;
    const message = hasReachedMaxIssuesLimit ? (0, $elGYS.default).maxIssues : (0, $elGYS.default).maxDeployments;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c28eace271fba33b$var$MaxPaginationWarningWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: formatMessage(message),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$exports).Y400})`,
        label: formatMessage((0, $elGYS.default).warning)
    })), hasReachedMaxIssuesLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "issues limitReached"
    }), hasReachedMaxDeploymentsLimit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: "deployments limitReached"
    }));
};
var $c28eace271fba33b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c28eace271fba33b$var$MaxPaginationWarning;
const $c28eace271fba33b$var$MaxPaginationWarningWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("elGYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3cf899acd29982b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c3cf899acd29982b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    maxIssues: {
        "id": "software-deployments.timeline.issue-title.max-pagination-warning.max-issues",
        "defaultMessage": "Displaying maximum number of issues. Please add some filters to refine your search."
    },
    maxDeployments: {
        "id": "software-deployments.timeline.issue-title.max-pagination-warning.max-deployments",
        "defaultMessage": "Cannot display all deployments for these issues. Please add some filters to refine your search."
    },
    warning: {
        "id": "software-deployments.timeline.issue-title.max-pagination-warning.warning",
        "defaultMessage": "Warning"
    }
});

});


parcelRegister("3xFrP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a1e924d7b64b28$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c0a1e924d7b64b28$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issues: {
        "id": "software-deployments.timeline.issue-title.issues",
        "defaultMessage": "Issues"
    }
});

});


parcelRegister("1Ohdz", function(module, exports) {

$parcel$export(module.exports, "Legend", () => $89d20466c3199b1b$export$ed247974535929c7);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $yevjV = parcelRequire("yevjV");

var $aBjAC = parcelRequire("aBjAC");

var $2LmzR = parcelRequire("2LmzR");

var $h3FVp = parcelRequire("h3FVp");

var $6Yjt9 = parcelRequire("6Yjt9");

var $d5S9v = parcelRequire("d5S9v");
const $89d20466c3199b1b$export$ed247974535929c7 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const iconsConfig = (0, $h3FVp.useIconsConfigurationPreference)();
    const [keyExpanded, setKeyExpanded] = (0, $eUqFw.useState)(false);
    if (iconsConfig === null || !iconsConfig.showIconKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89d20466c3199b1b$var$ContentContainer, {
        "data-testid": "software-deployments.ui.timeline.legend.table-key-legend"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89d20466c3199b1b$var$OptionsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89d20466c3199b1b$var$LabelWrapper, null, formatMessage((0, $d5S9v.default).legendLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "software-deployments.ui.timeline.legend.legend-button",
        appearance: "subtle-link",
        spacing: "none",
        onClick: ()=>setKeyExpanded(!keyExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89d20466c3199b1b$var$ShowMoreWrapper, {
        onClick: ()=>setKeyExpanded(!keyExpanded),
        "data-testid": "software-deployments.ui.timeline.legend.show-more"
    }, keyExpanded ? formatMessage((0, $d5S9v.default).showLess) : formatMessage((0, $d5S9v.default).showMore)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89d20466c3199b1b$var$KeysWrapper, null, keyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).IN_PROGRESS),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).IN_PROGRESS, (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION)
    }, formatMessage((0, $d5S9v.default).inProgress)), keyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).FAILED),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).FAILED, (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION)
    }, formatMessage((0, $d5S9v.default).failed)), keyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).ROLLED_BACK),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).ROLLED_BACK, (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION)
    }, formatMessage((0, $d5S9v.default).rolledBack)), keyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).PENDING),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).PENDING, (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION)
    }, formatMessage((0, $d5S9v.default).pending)), keyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).CANCELLED),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).CANCELLED, (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION)
    }, formatMessage((0, $d5S9v.default).cancelled)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).SUCCESSFUL),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).SUCCESSFUL, (0, $yevjV.DeploymentEnvironmentTypeOptions).STAGING)
    }, formatMessage((0, $d5S9v.default).nonProduction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Yjt9.default), {
        color: (0, $2LmzR.getColorForDeploymentState)((0, $yevjV.DeploymentStateOptions).SUCCESSFUL),
        state: (0, $aBjAC.getDeploymentIconState)((0, $yevjV.DeploymentStateOptions).SUCCESSFUL, (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION)
    }, formatMessage((0, $d5S9v.default).production))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89d20466c3199b1b$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahitcz _2lx21bp4 _4cvr1h6o _2rko1l7b _vchh18uv _1yt41nob _bfhkhp5a _1bsb1yk2 _16qs1e8m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89d20466c3199b1b$var$KeysWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _2mzuglyw _19pk1b66 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1reo1wug _18m91wug _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89d20466c3199b1b$var$OptionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _4cvr1h6o _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89d20466c3199b1b$var$LabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syazloe7 _k48p8n31",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $89d20466c3199b1b$var$ShowMoreWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syazloe7 _k48p8n31",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6Yjt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a835571e494876a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $3oKhY = parcelRequire("3oKhY");
const $a835571e494876a5$var$Key = ({ children: children, color: color, state: state })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a835571e494876a5$var$KeyWrapper, {
        color: color,
        "data-testid": "software-deployments.ui.timeline.legend.key.legend-key"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwx12x7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3oKhY.DeploymentIcons), {
        deploymentState: state,
        size: "small"
    })), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a835571e494876a5$var$KeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _syaz1cj8 _4cvr1h6o _ca0qu2gc _n3tdu2gc _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $a835571e494876a5$var$keyIconWrapperStyles = null;
var $a835571e494876a5$export$2e2bcd8739ae039 = $a835571e494876a5$var$Key;

});

parcelRegister("d5S9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fcbf4269b037915$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4fcbf4269b037915$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    legendLabel: {
        "id": "software-deployments.timeline.legend.legend-label",
        "defaultMessage": "Key"
    },
    nonProduction: {
        "id": "software-deployments.timeline.legend.non-production",
        "defaultMessage": "Non-production deployment"
    },
    production: {
        "id": "software-deployments.timeline.legend.production",
        "defaultMessage": "Production deployment"
    },
    failed: {
        "id": "software-deployments.timeline.legend.failed",
        "defaultMessage": "Failed deployment"
    },
    cancelled: {
        "id": "software-deployments.timeline.legend.cancelled",
        "defaultMessage": "Canceled deployment"
    },
    inProgress: {
        "id": "software-deployments.timeline.legend.in-progress",
        "defaultMessage": "In-progress deployment "
    },
    pending: {
        "id": "software-deployments.timeline.legend.pending",
        "defaultMessage": "Pending deployment"
    },
    rolledBack: {
        "id": "software-deployments.timeline.legend.rolled-back",
        "defaultMessage": "Rolled back deployment"
    },
    showMore: {
        "id": "software-deployments.timeline.legend.show-more",
        "defaultMessage": "Show more"
    },
    showLess: {
        "id": "software-deployments.timeline.legend.show-less",
        "defaultMessage": "Show less"
    }
});

});


parcelRegister("iZi2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d1a6b5b7b08318$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iexdl = parcelRequire("iexdl");

var $lkPGY = parcelRequire("lkPGY");

var $OwuLI = parcelRequire("OwuLI");

var $lnbOK = parcelRequire("lnbOK");
const $f7d1a6b5b7b08318$var$ListItemContent = ({ id: id })=>{
    const issue = (0, $OwuLI.useIssue)(id);
    if (!issue) throw new Error('issue not found but is required for ListItemContent');
    const issueTypes = (0, $lnbOK.useIssueTypesLookup)();
    const { epic: epic } = issue;
    const { iconUrl: iconUrl, name: name } = issueTypes[issue.typeId];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7d1a6b5b7b08318$var$ListItemContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPGY.default), {
        title: issue.summary,
        issue: issue.key,
        iconUrl: iconUrl,
        typeName: name
    }), epic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f7d1a6b5b7b08318$var$ParentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iexdl.default), {
        color: epic.color
    }, epic.summary)));
};
var $f7d1a6b5b7b08318$export$2e2bcd8739ae039 = $f7d1a6b5b7b08318$var$ListItemContent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f7d1a6b5b7b08318$var$ListItemContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1reo15vq _18m915vq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $f7d1a6b5b7b08318$var$ParentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iexdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3d760980009585b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $ffiyv = parcelRequire("ffiyv");

var $c9TLT = parcelRequire("c9TLT");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");

var $opsFH = parcelRequire("opsFH");

var $lPQPn = parcelRequire("lPQPn");
const $d3d760980009585b$var$LOZENGE_THEMES = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $d3d760980009585b$var$getLozengeThemeByColor = (color)=>// This uses schema from src/packages/issue/epic-color/src/common/constants.js
    $d3d760980009585b$var$LOZENGE_THEMES[color] || $d3d760980009585b$var$LOZENGE_THEMES[0, $opsFH.PURPLE];
const $d3d760980009585b$var$CardEpic = (props)=>{
    // This uses schema from src/packages/issue/epic-color/src/common/constants.js
    const { color: color = (0, $opsFH.PURPLE), children: children } = props; /* eslint-disable jira/react/no-style-attribute */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3d760980009585b$var$LozengeWrapper, {
        "data-test-id": "platform-board-kit.ui.swimlane.epic.lozenge",
        "data-testid": "platform-board-kit.ui.swimlane.epic.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        style: $d3d760980009585b$var$getLozengeThemeByColor(color)
    }, children)); /* eslint-enable jira/react/no-style-attribute */ 
};
var $d3d760980009585b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d3d760980009585b$var$CardEpic;
const $d3d760980009585b$var$LozengeWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1qr9bmp-0"
})({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${(0, $c9TLT.gridSize) * 2}px`
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3d760980009585b$var$LozengeWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});
const $d3d760980009585b$var$LozengeWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d3d760980009585b$var$LozengeWrapperExperiment, $d3d760980009585b$var$LozengeWrapperControl);

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});


parcelRegister("lkPGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a4974f6084cc95$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $ljHdG = parcelRequire("ljHdG");

var $2Dq8F = parcelRequire("2Dq8F");
function $e7a4974f6084cc95$var$Summary(props) {
    const { iconUrl: iconUrl, typeName: typeName, title: title, issue: issue, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7a4974f6084cc95$var$SummaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ljHdG.default), {
        src: iconUrl,
        alt: formatMessage((0, $2Dq8F.default).iconAltText, {
            typeName: typeName
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7a4974f6084cc95$var$IssueKey, null, issue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7a4974f6084cc95$var$Title, null, title));
}
$e7a4974f6084cc95$var$Summary.defaultProps = {
    issue: undefined,
    title: undefined
};
var $e7a4974f6084cc95$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($e7a4974f6084cc95$var$Summary);
const $e7a4974f6084cc95$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $e7a4974f6084cc95$var$SummaryWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e7a4974f6084cc95$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ljHdG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cf09772a143e95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
function $e3cf09772a143e95$var$Icon(props) {
    const { src: src, alt: alt, size: size } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3cf09772a143e95$var$IconStyled, {
        src: src,
        alt: alt,
        size: size
    });
}
$e3cf09772a143e95$var$Icon.defaultProps = {
    alt: '',
    size: '16'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e3cf09772a143e95$var$IconStyled = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $9t7rW.default)(__cmplp.size, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _2rko1l7b _1bsb1vpm _4t3i1vpm",
            __cmplp.className
        ])
    });
});
var $e3cf09772a143e95$export$2e2bcd8739ae039 = $e3cf09772a143e95$var$Icon;

});

parcelRegister("2Dq8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $02fd6e771c7685c8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $02fd6e771c7685c8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    iconAltText: {
        "id": "deployments.common.components.summary.icon-alt-text",
        "defaultMessage": "{typeName} issue type"
    }
});

});



parcelRegister("aPkMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eaa3a31bd270774$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2eG9N = parcelRequire("2eG9N");

var $OwuLI = parcelRequire("OwuLI");
const $4eaa3a31bd270774$var$ListItemContentTooltip = ({ id: id, children: children })=>{
    const issue = (0, $OwuLI.useIssue)(id);
    if (!issue) throw new Error('issue not found but is required for ListItemContentTooltip');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        tag: $4eaa3a31bd270774$var$CustomTooltipTag,
        content: `${issue.key}: ${issue.summary}`,
        position: "top"
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4eaa3a31bd270774$var$CustomTooltipTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
var $4eaa3a31bd270774$export$2e2bcd8739ae039 = $4eaa3a31bd270774$var$ListItemContentTooltip;

});

parcelRegister("53ni8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3831579c954deb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $iNMur = parcelRequire("iNMur");

var $aVkzK = parcelRequire("aVkzK");

var $94TFJ = parcelRequire("94TFJ");


var $ePfmq = parcelRequire("ePfmq");
const $1c3831579c954deb$var$LoadingSkeleton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c3831579c954deb$var$LoadingSkeletonWrapper, {
        "data-testId": "deployments.table.loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c3831579c954deb$var$Header, null), (0, (/*@__PURE__*/$parcel$interopDefault($iNMur)))((0, $ePfmq.ISSUE_PAGE_SIZE), (index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c3831579c954deb$var$Row, {
            key: index,
            isOdd: index % 2 === 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVkzK.default), {
            hasIcon: true,
            isShimmering: true,
            width: (0, $d736b332644d7251$export$58590494eb7f9f92)
        }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c3831579c954deb$var$LoadingSkeletonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1reo15vq _18m915vq _2rko1l7b _19it1l7n",
            __cmplp.className
        ])
    });
});
const $1c3831579c954deb$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_544y0l": (0, $9t7rW.default)((0, $94TFJ.TABLE_HEADER_HEIGHT_PX))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ilk1k _bfhk1aqf _n7zl1l7n",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c3831579c954deb$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOdd: isOdd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ady",
            __cmplp.isOdd ? "_bfhkmhsy" : "_bfhk18tl",
            __cmplp.className
        ])
    });
});
var $1c3831579c954deb$export$2e2bcd8739ae039 = $1c3831579c954deb$var$LoadingSkeleton;

});

parcelRegister("hUc9F", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b0c3472419714a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a0b0c3472419714a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadingNextIssuePageFailedFlagTitle: {
        "id": "software-deployments.timeline.loading-next-issue-page-failed-flag-title",
        "defaultMessage": "Unable to load more issues."
    },
    loadingNextIssuePageFailedFlagDescription: {
        "id": "software-deployments.timeline.loading-next-issue-page-failed-flag-description",
        "defaultMessage": "Please try to load the next page again."
    }
});

});

parcelRegister("1YzcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47f30daa8be1b43$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6go3X = parcelRequire("6go3X");

var $3uyue = parcelRequire("3uyue");

var $d3B6Z = parcelRequire("d3B6Z");
const $a47f30daa8be1b43$var$NoMatches = ()=>{
    const [isFilterActive, filterStoreActions] = (0, $6go3X.useHasAppliedFilters)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _1e0c1txw _2lx21bp4 _1bsb1osq _4cvr1h6o _bfhktxrc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3uyue))),
        alt: "",
        width: "110",
        height: "84"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium"
    }, formatMessage((0, $d3B6Z.default).noResults)), isFilterActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_19pkpxbi _y3gn1h6o"
        ])
    }, formatMessage((0, $d3B6Z.default).explanationActiveFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a47f30daa8be1b43$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: ()=>{
            filterStoreActions.resetAllFilters();
        }
    }, formatMessage((0, $d3B6Z.default).clearFilter)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_19pkpxbi _y3gn1h6o"
        ])
    }, formatMessage((0, $d3B6Z.default).explanationNoFilter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        className: (0, $7JEyt.default)([
            "_19pkpxbi _y3gn1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://support.atlassian.com/jira-software-cloud/docs/enable-deployments/"
    }, formatMessage((0, $d3B6Z.default).learnMore)))));
};
const $a47f30daa8be1b43$var$containerStyles = null;
const $a47f30daa8be1b43$var$explanationStyles = null;
const $a47f30daa8be1b43$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200'
});
var $a47f30daa8be1b43$export$2e2bcd8739ae039 = $a47f30daa8be1b43$var$NoMatches;

});
parcelRegister("3uyue", function(module, exports) {
module.exports = new URL("magnifying_glass.8bd2cc78.svg", import.meta.url).toString();

});

parcelRegister("d3B6Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $f437b0a47a0bb942$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f437b0a47a0bb942$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    imageAlt: {
        "id": "software-deployments.timeline.no-matches.image-alt",
        "defaultMessage": "No results found"
    },
    noResults: {
        "id": "software-deployments.timeline.no-matches.no-results",
        "defaultMessage": "No matching issues found"
    },
    explanationActiveFilter: {
        "id": "software-deployments.timeline.no-matches.explanation-active-filter",
        "defaultMessage": "Reset your search criteria by changing your filters"
    },
    explanationNoFilter: {
        "id": "software-deployments.timeline.no-matches.explanation-no-filter",
        "defaultMessage": "Try changing your date range"
    },
    learnMore: {
        "id": "software-deployments.timeline.no-matches.learn-more",
        "defaultMessage": "Learn more"
    },
    clearFilter: {
        "id": "software-deployments.timeline.no-matches.clear-filter",
        "defaultMessage": "Clear filter"
    }
});

});


parcelRegister("iQqTb", function(module, exports) {

$parcel$export(module.exports, "toTableItem", () => $06b8d9b75336671f$export$3902fb2145c726db);
$parcel$export(module.exports, "toTableItemProject", () => $06b8d9b75336671f$export$46c348b9bd7a5cc8);

var $94TFJ = parcelRequire("94TFJ");

var $hA1Fa = parcelRequire("hA1Fa");
const $06b8d9b75336671f$export$3902fb2145c726db = (issue)=>({
        id: issue.id,
        listData: {},
        chartData: {}
    });
const $06b8d9b75336671f$export$46c348b9bd7a5cc8 = (project)=>({
        id: (0, $hA1Fa.toProjectId)(project.id),
        name: project.name,
        key: (0, $hA1Fa.toProjectKey)(project.key),
        itemTypes: {
            [(0, $94TFJ.DEFAULT_LEVEL)]: project.issueTypes
        },
        iconUrl: ''
    });

});
parcelRegister("hA1Fa", function(module, exports) {

$parcel$export(module.exports, "toProjectKey", () => $c24f27df2535fe90$export$cb2a92f44ebd7cbe);
$parcel$export(module.exports, "toProjectId", () => $c24f27df2535fe90$export$859c6c19231e0cae);
const $c24f27df2535fe90$export$cb2a92f44ebd7cbe = (key)=>key;
const $c24f27df2535fe90$export$42f45f53400ddb3 = (id)=>id;
const $c24f27df2535fe90$export$859c6c19231e0cae = (id)=>id;
const $c24f27df2535fe90$export$40f914e9a75ff65a = 'CLASSIC';
const $c24f27df2535fe90$export$296f840b5ae7056e = 'NEXTGEN';

});



parcelRegister("3Pcni", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f236d618de3bd04$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eJPjg = parcelRequire("eJPjg");

var $6TQlY = parcelRequire("6TQlY");

var $74B6r = parcelRequire("74B6r");
const $0f236d618de3bd04$var$END_TIMELINE_SCROLL_WINDOW = 100;
const $0f236d618de3bd04$var$TodayButton = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [dateFilter] = (0, $6TQlY.useDateFilter)();
    if (dateFilter.type === 'CUSTOM') return null;
    const tooltipContent = formatMessage((0, $74B6r.default).tooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        position: "bottom",
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: ()=>{
            (0, $eJPjg.timelineScroller).scrollToPercentages({
                left: $0f236d618de3bd04$var$END_TIMELINE_SCROLL_WINDOW,
                behavior: 'smooth'
            });
        }
    }, formatMessage((0, $74B6r.default).today)));
};
var $0f236d618de3bd04$export$2e2bcd8739ae039 = $0f236d618de3bd04$var$TodayButton;

});
parcelRegister("74B6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1208a853d741170a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1208a853d741170a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    today: {
        "id": "software-deployments.today-button.today",
        "defaultMessage": "Today"
    },
    tooltip: {
        "id": "software-deployments.today-button.tooltip",
        "defaultMessage": "Go to current date"
    }
});

});


parcelRegister("CwpiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c657599f734ffdfe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8NoA2 = parcelRequire("8NoA2");

var $itGQN = parcelRequire("itGQN");

var $7uxUn = parcelRequire("7uxUn");

var $2YZvw = parcelRequire("2YZvw");

var $h1Cog = parcelRequire("h1Cog");

var $6go3X = parcelRequire("6go3X");

var $5Wowz = parcelRequire("5Wowz");

var $lnbOK = parcelRequire("lnbOK");

var $hAqZB = parcelRequire("hAqZB");

var $diC1Y = parcelRequire("diC1Y");

var $9hxzw = parcelRequire("9hxzw");

var $ljKtM = parcelRequire("ljKtM");

var $7CPPy = parcelRequire("7CPPy");

var $4Y3IR = parcelRequire("4Y3IR");

var $i7AwO = parcelRequire("i7AwO");

var $as4Zx = parcelRequire("as4Zx");
const $c657599f734ffdfe$var$TopFilters = ()=>{
    const [hasAppliedFilters, { resetAllFilters: resetAllFilters, setFixVersionFilter: setFixVersionFilter, setEpicIdsFilter: setEpicIdsFilter, setIssueTypeIdsFilter: setIssueTypeIdsFilter }] = (0, $6go3X.useHasAppliedFilters)();
    const projectId = (0, $lnbOK.useProjectId)();
    const { data: issueTypes, error: issueTypesFetchError, loading: isIssueTypesLoading } = (0, $5Wowz.useIssueTypes)({
        excludeEpic: true
    });
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $eUqFw.useState)((0, $2YZvw.DEFAULT_VISIBLE_USERS));
    const filterBarRef = (0, $eUqFw.useRef)(null);
    const [selectedFixVersions] = (0, $6go3X.useFixVersionsFilter)();
    const [selectedEpicIds] = (0, $6go3X.useEpicIdsFilter)();
    const [selectedIssueTypes] = (0, $6go3X.useIssueTypeIdsFilter)();
    const { selectedEntryIds: selectedEnvironmentIds, onChange: onEnvironmentFilterChange, entries: environments } = (0, $ljKtM.useSelectState)((0, $ljKtM.useFormatEnvironmentType)());
    const filters = {
        [(0, $2YZvw.ENVIRONMENT)]: selectedEnvironmentIds,
        [(0, $2YZvw.VERSION)]: selectedFixVersions,
        [(0, $2YZvw.EPIC)]: selectedEpicIds,
        [(0, $2YZvw.ISSUE_TYPE)]: selectedIssueTypes
    };
    const handleResize = (0, $eUqFw.useCallback)(()=>{
        // Handle avatar overflow
        if (!filterBarRef.current) return;
        // Handle avatar overflow
        const width = filterBarRef.current.offsetWidth - (0, $2YZvw.MIN_SEARCH_INPUT_WIDTH);
        if (width < (0, $2YZvw.MIN_FILTER_BAR_WIDTH)) {
            const usersToReduce = Math.ceil(((0, $2YZvw.MIN_FILTER_BAR_WIDTH) - width) / (0, $2YZvw.USER_AVATAR_WIDTH));
            const newMax = Math.max((0, $2YZvw.DEFAULT_VISIBLE_USERS) - usersToReduce, (0, $2YZvw.MIN_VISIBLE_USERS));
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers((0, $2YZvw.DEFAULT_VISIBLE_USERS));
    }, []);
    (0, $7uxUn.useResizeObserver)({
        ref: filterBarRef,
        onResize: handleResize
    });
    const itemsBefore = [
        {
            id: (0, $2YZvw.ENVIRONMENT),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9hxzw.default), {
                    key: "EnvironmentFilter",
                    isNested: isNested,
                    onChange: onEnvironmentFilterChange,
                    options: environments,
                    selectedValues: selectedEnvironmentIds
                })
        },
        {
            id: (0, $2YZvw.VERSION),
            isStatic: false,
            isHidden: !projectId,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
                    fallback: "unmount",
                    eventLocation: "fixVersionFilter"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $as4Zx.default), {
                    projectId: projectId,
                    isNested: isNested,
                    selectedValues: selectedFixVersions,
                    onChange: setFixVersionFilter
                })))
        },
        {
            id: (0, $2YZvw.EPIC),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h1Cog.NonCriticalErrorBoundary), {
                    fallback: "unmount",
                    eventLocation: "epicFilter"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CPPy.default), {
                    key: "EpicFilter",
                    isNested: isNested,
                    selectedValues: selectedEpicIds,
                    onChange: setEpicIdsFilter
                }))
        },
        {
            id: (0, $2YZvw.ISSUE_TYPE),
            isStatic: false,
            isHidden: isIssueTypesLoading,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Y3IR.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    selectedValues: selectedIssueTypes,
                    onChange: setIssueTypeIdsFilter,
                    issueTypes: issueTypes,
                    error: issueTypesFetchError
                })
        }
    ];
    const itemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            isStatic: true,
            isHidden: !hasAppliedFilters,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $itGQN.default), {
                    onClick: resetAllFilters,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diC1Y.default), null)
                })
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c657599f734ffdfe$var$topFiltersWrapperStyles,
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i7AwO.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAqZB.default), {
        maxVisibleUsers: maxVisibleUsers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_16jx1txw _1uf81b66 _1o94h2mm _yj55idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NoA2.default), {
        itemsBefore: itemsBefore,
        itemsAfter: itemsAfter,
        selectedItems: filters
    })));
};
var $c657599f734ffdfe$export$2e2bcd8739ae039 = $c657599f734ffdfe$var$TopFilters;
const $c657599f734ffdfe$var$listFilterContainerStyle = null;
const $c657599f734ffdfe$var$topFiltersWrapperStyles = (0, $1ZAYh.xcss)({
    // enough width to fit expanded search + avatar filter + clear filters button
    minWidth: '405px',
    alignItems: 'center',
    display: 'flex',
    flex: '1 1 0%'
});

});
parcelRegister("8NoA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d87a122a4f8c098d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $2eG9N = parcelRequire("2eG9N");

var $eWeL8 = parcelRequire("eWeL8");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7uxUn = parcelRequire("7uxUn");

var $8rQuz = parcelRequire("8rQuz");

var $iLKfm = parcelRequire("iLKfm");

var $fMKb3 = parcelRequire("fMKb3");

var $b9IeP = parcelRequire("b9IeP");
const $d87a122a4f8c098d$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const overflowContainerRef = (0, $eUqFw.useRef)(null);
    const moreFilterRef = (0, $eUqFw.useRef)(null);
    const elementsRef = (0, $eUqFw.useRef)({});
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    // There is a flickering bug switching to/from the "more" button https://jplat.atlassian.net/browse/BLU-3488
    // Additional information can also be found in https://jbusiness.atlassian.net/browse/JVRQ-426
    // But can't reproduce in Storybook + lot of pending changes, so won't fix for now.
    // I suspect this is related to this out-of-rerender memorization of data.
    // Next person actively working on this file is welcome to check. See also investigation notes in the ticket above.
    const prevOverflowContainerWidthRef = (0, $eUqFw.useRef)(0);
    const elementsWidthRef = (0, $eUqFw.useRef)({});
    const visibleElementsRef = (0, $eUqFw.useRef)({});
    const prevElementsWidthRef = (0, $eUqFw.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $eUqFw.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $eUqFw.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $eUqFw.useMemo)(()=>(0, $b9IeP.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const onResize = (0, $eUqFw.useCallback)(()=>{
        const { current: overflowContainer } = overflowContainerRef;
        const { current: moreFilter } = moreFilterRef;
        const shouldRecomputeOverflow = (0, $b9IeP.getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $b9IeP.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    if ((0, $79xbN.expVal)('blu-3488_fix_jsw_filters_flickering', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7uxUn.useResizeObserver)({
        ref: overflowContainerRef,
        onResize: onResize
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fMKb3.useResizeObserver)(overflowContainerRef, onResize);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $iLKfm.default).more);
    const triggerTooltipText = formatMessage((0, $iLKfm.default).moreFiltersTooltip);
    const buttonToolTip = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$BadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: overflowContainerRef,
        className: (0, $7JEyt.default)([
            (0, $8rQuz.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _18s83l1n" : "_1e0c1txw _1ul9idpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d87a122a4f8c098d$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    primaryColor: "var(--ds-icon, #44546F)",
                    label: triggerLabel
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $d87a122a4f8c098d$export$2e2bcd8739ae039 = $d87a122a4f8c098d$var$OverflowHandler;
const $d87a122a4f8c098d$var$overflowContainerStylesOld = null;
const $d87a122a4f8c098d$var$overflowContainerStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$PopupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4swc3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$TriggerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$TriggerLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$BadgeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $d87a122a4f8c098d$var$ItemWrapperControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d87a122a4f8c098d$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $d87a122a4f8c098d$var$ItemWrapper = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $d87a122a4f8c098d$var$ItemWrapperExperiment, $d87a122a4f8c098d$var$ItemWrapperControl);

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("7uxUn", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $dc839ec384d19a4a$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $dc839ec384d19a4a$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $dc839ec384d19a4a$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $dc839ec384d19a4a$export$e58143dc89297272);

var $eUqFw = parcelRequire("eUqFw");

var $gDQs6 = parcelRequire("gDQs6");
function $dc839ec384d19a4a$export$87a9d3e287304ae4(params) {
    const group = new (0, $gDQs6.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eUqFw.useRef)(onResize);
        (0, $eUqFw.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eUqFw.useCallback)(()=>onResizeRef.current(), []);
        (0, $eUqFw.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $dc839ec384d19a4a$export$683480f191c0e3ea, flushResizeObservers: $dc839ec384d19a4a$export$a181ef2a6d0a1bb6 } = $dc839ec384d19a4a$export$87a9d3e287304ae4();
function $dc839ec384d19a4a$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $dc839ec384d19a4a$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("gDQs6", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $91e461fbc4ab66c0$export$607798bbe2869c0);

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");
class $91e461fbc4ab66c0$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("iLKfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a29a4590d069b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c5a29a4590d069b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("fMKb3", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $21cd25eee961b6ff$export$683480f191c0e3ea);

var $eUqFw = parcelRequire("eUqFw");
let $21cd25eee961b6ff$var$resizeObserver;
const $21cd25eee961b6ff$var$callbacks = new Map();
const $21cd25eee961b6ff$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $21cd25eee961b6ff$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $21cd25eee961b6ff$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$21cd25eee961b6ff$var$resizeObserver) $21cd25eee961b6ff$var$resizeObserver = new ResizeObserver($21cd25eee961b6ff$var$runCallbacks);
    $21cd25eee961b6ff$var$callbacks.set(target, callback);
    $21cd25eee961b6ff$var$resizeObserver.observe(target);
};
const $21cd25eee961b6ff$var$unobserveElement = (target)=>{
    if (!$21cd25eee961b6ff$var$resizeObserver) return;
    $21cd25eee961b6ff$var$callbacks.delete(target);
    $21cd25eee961b6ff$var$resizeObserver.unobserve(target);
};
const $21cd25eee961b6ff$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $eUqFw.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $21cd25eee961b6ff$var$observeElement(element, callback);
        return ()=>{
            element && $21cd25eee961b6ff$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("b9IeP", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $274da3a39e4318f2$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldRecomputeOverflow", () => $274da3a39e4318f2$export$2544af09d06b9c65);
$parcel$export(module.exports, "getSelectedItemsCount", () => $274da3a39e4318f2$export$b0e31612dc0df344);

var $8blac = parcelRequire("8blac");
const $274da3a39e4318f2$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $274da3a39e4318f2$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $274da3a39e4318f2$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $274da3a39e4318f2$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $274da3a39e4318f2$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $274da3a39e4318f2$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $274da3a39e4318f2$var$BADGE_WIDTH_THRESHOLD);
    return hasItemsWidthChange;
};
const $274da3a39e4318f2$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("itGQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $35bc1d42f552afea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $hd6kM = parcelRequire("hd6kM");
const $35bc1d42f552afea$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            !(0, $8rQuz.isVisualRefreshEnabled)() && $35bc1d42f552afea$var$styledClearFilterStyles
        ],
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        testId: "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: props.onClick
    }, props.label || formatMessage((0, $hd6kM.default).label)));
};
$35bc1d42f552afea$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $35bc1d42f552afea$export$2e2bcd8739ae039 = $35bc1d42f552afea$var$ClearFilterButton;
const $35bc1d42f552afea$var$styledClearFilterStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("hd6kM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f91b0cf94f2a1046$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f91b0cf94f2a1046$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("5Wowz", function(module, exports) {

$parcel$export(module.exports, "useIssueTypes", () => $1c385ebce1b7cdd9$export$8bbc5cc35915a21b);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $lnbOK = parcelRequire("lnbOK");
const $1c385ebce1b7cdd9$export$8bbc5cc35915a21b = ({ excludeEpic: excludeEpic } = {
    excludeEpic: false
})=>{
    const baseUrl = '';
    const projectKey = (0, $lnbOK.useProjectKey)();
    const [epicIssueTypeIds, setEpicIssueTypeIds] = (0, $eUqFw.useState)(null);
    const [epicIssueTypeIdsError, setEpicIssueTypeIdsError] = (0, $eUqFw.useState)(null);
    const projectResult = (0, $lnbOK.useProject)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchEpicIssueTypeIds = async ()=>{
            try {
                const epicIssueTypeIdsResult = await (0, $2OdyW.default)(`${baseUrl}/rest/deployments-internal/0.1/deployments/epicIssueTypeIds/${projectKey}`);
                setEpicIssueTypeIds(epicIssueTypeIdsResult);
                setEpicIssueTypeIdsError(null);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setEpicIssueTypeIdsError(error);
                setEpicIssueTypeIds(null);
            }
        };
        fetchEpicIssueTypeIds();
    }, [
        baseUrl,
        projectKey
    ]);
    if (projectResult.error) return {
        error: projectResult.error,
        loading: false
    };
    if (epicIssueTypeIdsError) return {
        // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error | undefined'.
        error: epicIssueTypeIdsError,
        loading: false
    };
    if (projectResult.loading || projectResult.data == null || epicIssueTypeIds === null) return {
        loading: true
    };
    const { issueTypes: issueTypes } = projectResult.data;
    return {
        loading: false,
        data: issueTypes.filter(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        (issueType)=>!excludeEpic || !epicIssueTypeIds.includes(issueType.id))
    };
};

});

parcelRegister("hAqZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f35e9d54fea68b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7xG8t = parcelRequire("7xG8t");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6go3X = parcelRequire("6go3X");

var $d6qlS = parcelRequire("d6qlS");
const $c1f35e9d54fea68b$var$AssigneesFilter = ({ maxVisibleUsers: maxVisibleUsers = 5 })=>{
    const [{ assignees: selectedUsers }, { toggleAssignee: toggleAssignee }] = (0, $6go3X.useTableFilterStore)();
    const assignees = (0, $d6qlS.useAllKnownAssignees)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return assignees.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c1f35e9d54fea68b$var$ListFilterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xG8t.default), {
        users: assignees,
        maxUsers: maxVisibleUsers,
        selectedUsers: selectedUsers,
        onToggle: (assignee)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'deploymentsAssigneePicker'
            }));
            return toggleAssignee(assignee);
        }
    })) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1f35e9d54fea68b$var$ListFilterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jx1txw _y8xaidpf _cl0npxbi _1o94h2mm _1i9sb3bt _jbo4stnw _c94o1ssb _o4887vkz _1gh91i34 _ih5wt94y _4v7iidpf _1sp2lecj",
            __cmplp.className
        ])
    });
});
var $c1f35e9d54fea68b$export$2e2bcd8739ae039 = $c1f35e9d54fea68b$var$AssigneesFilter;

});
parcelRegister("7xG8t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21c7a389f4c6f79$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $i528B = parcelRequire("i528B");

var $anpCp = parcelRequire("anpCp");

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Ua7e = parcelRequire("6Ua7e");


var $eIp1n = parcelRequire("eIp1n");

var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $6UBeg = parcelRequire("6UBeg");

var $1Gl68 = parcelRequire("1Gl68");

var $7NnaN = parcelRequire("7NnaN");

var $kovzS = parcelRequire("kovzS");
const $d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $kovzS.default));
$d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $d21c7a389f4c6f79$export$3ecb2c48b5973cac = ({ AddPeopleModal: AddPeopleModal, showAddPeopleModal: showAddPeopleModal, onAddPeopleModalClose: onAddPeopleModalClose, cloudId: cloudId, projectName: projectName, projectId: projectId, projectKey: projectKey, appEdition: appEdition, isSiteAdmin: isSiteAdmin, modalRef: modalRef })=>{
    if ((0, $anpCp.isCoreInvitesInJiraProjectsEnabled)(isSiteAdmin)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Ua7e.default), {
        inviteRef: modalRef,
        appEdition: appEdition,
        cloudId: cloudId,
        isOpen: (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: isSiteAdmin
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AddPeopleModal, {
        onClose: onAddPeopleModalClose,
        isOpen: (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal
    });
};
const $d21c7a389f4c6f79$export$804bfdea59f89629 = (createAnalyticsEvent, baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, isSiteAdmin, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        (0, $i528B.fireCoreInvitesInJiraProjectFeatureExposed)(createAnalyticsEvent, isSiteAdmin);
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $6WXNs.toEdition)((0, $6WXNs.FREE_EDITION))) (0, $1Gl68.getRemainingSeats)(baseUrl, (0, $2edfd53057852e41$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $d21c7a389f4c6f79$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UBeg.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $d21c7a389f4c6f79$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $eUqFw.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const appEdition = (0, $6WXNs.getEdition)((0, $eIp1n.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $jMP2a.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $d21c7a389f4c6f79$export$804bfdea59f89629(createAnalyticsEvent, tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, tenantContext.isSiteAdmin, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        tenantContext.isSiteAdmin,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $eUqFw.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $eUqFw.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7NnaN.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && ((0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleButton) && ((0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? showAddPeopleModal : true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d21c7a389f4c6f79$export$3ecb2c48b5973cac, {
        modalRef: addButtonRef,
        projectName: projectName,
        projectKey: projectKey,
        projectId: projectId,
        AddPeopleModal: AddPeopleModal,
        showAddPeopleModal: (0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') ? true : showAddPeopleModal,
        onAddPeopleModalClose: onAddPeopleModalClose,
        cloudId: tenantContext.cloudId,
        appEdition: appEdition,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$d21c7a389f4c6f79$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $d21c7a389f4c6f79$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($d21c7a389f4c6f79$export$20e0939737a940df);
$d21c7a389f4c6f79$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$d21c7a389f4c6f79$var$AssigneeFilterComponent.whyDidYouRender = true;
var $d21c7a389f4c6f79$export$2e2bcd8739ae039 = $d21c7a389f4c6f79$var$AssigneeFilterComponent;

});
parcelRegister("i528B", function(module, exports) {

$parcel$export(module.exports, "fireCoreInvitesInJiraProjectFeatureExposed", () => $0dbd3d296d3d0e11$export$2f2d4a4234531655);
$parcel$export(module.exports, "fireCoreInvitesInJsmProjectFeatureExposed", () => $0dbd3d296d3d0e11$export$4ae66d6e56a5cb11);

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");

var $anpCp = parcelRequire("anpCp");
const $0dbd3d296d3d0e11$var$getCoreInvitesInJiraProjects = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('core-invites-in-jira-projects', (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED, [
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).NOT_ENROLLED,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).CONTROL,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_ONLY_NOT_ENROLLED,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA,
        (0, $anpCp.CORE_INVITES_IN_JIRA_PROJECTS).INVITE_RA_NOT_ENROLLED
    ]);
const $0dbd3d296d3d0e11$export$2f2d4a4234531655 = (createAnalyticsEvent, isSiteAdmin)=>{
    const featureFlagValue = $0dbd3d296d3d0e11$var$getCoreInvitesInJiraProjects();
    const cohort = featureFlagValue;
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'core-invites-in-jira-projects',
        value: featureFlagValue,
        cohort: cohort,
        isSiteAdmin: isSiteAdmin,
        ineligibilityReasons: [],
        growthInitiative: 'virality'
    });
};
const $0dbd3d296d3d0e11$export$4ae66d6e56a5cb11 = (createAnalyticsEvent, coreInvitesJsmExpValue)=>{
    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
        flagKey: 'jsm_core_invites_experiment',
        cohort: coreInvitesJsmExpValue
    });
};

});
parcelRegister("anpCp", function(module, exports) {

$parcel$export(module.exports, "CORE_INVITES_IN_JIRA_PROJECTS", () => $2d494c23fdb3d24c$export$3496ae3c3008d7e5);
$parcel$export(module.exports, "isCoreInvitesInJiraProjectsEnabled", () => $2d494c23fdb3d24c$export$78d85fc0e603743c);
$parcel$export(module.exports, "isElligibleProject", () => $2d494c23fdb3d24c$export$b0222359e25e154);
$parcel$export(module.exports, "isServiceProject", () => $2d494c23fdb3d24c$export$f52f6e19ac3c110);

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");
const $2d494c23fdb3d24c$export$3496ae3c3008d7e5 = {
    CONTROL: 'control',
    NOT_ENROLLED: 'not-enrolled',
    INVITE_ONLY: 'invite-only-variation',
    INVITE_ONLY_NOT_ENROLLED: 'invite-only-not-enrolled',
    INVITE_RA: 'invite-ra-variation',
    INVITE_RA_NOT_ENROLLED: 'invite-ra-variation'
};
const $2d494c23fdb3d24c$var$getCoreInvitesInJiraProjects = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('core-invites-in-jira-projects', $2d494c23fdb3d24c$export$3496ae3c3008d7e5.NOT_ENROLLED, [
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.NOT_ENROLLED,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.CONTROL,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY_NOT_ENROLLED,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA,
        $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA_NOT_ENROLLED
    ]);
const $2d494c23fdb3d24c$export$78d85fc0e603743c = (isSiteAdmin)=>{
    const flag = $2d494c23fdb3d24c$var$getCoreInvitesInJiraProjects();
    return isSiteAdmin && flag === $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_ONLY || flag === $2d494c23fdb3d24c$export$3496ae3c3008d7e5.INVITE_RA;
};
const $2d494c23fdb3d24c$export$b0222359e25e154 = (projectType)=>projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
const $2d494c23fdb3d24c$export$f52f6e19ac3c110 = (projectType)=>projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);

});


parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("6Ua7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $586cc92d06f8b9df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $586cc92d06f8b9df$var$LazyComponent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("cTVAu")), {
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $586cc92d06f8b9df$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($586cc92d06f8b9df$var$LazyComponent, props)));
var $586cc92d06f8b9df$export$2e2bcd8739ae039 = $586cc92d06f8b9df$export$6a02a79fa2b0ddab;

});
parcelRegister("cTVAu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e1vXm")
]).then(()=>parcelRequire('bagiu'));

});


const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("6UBeg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d6c2870ae2a9a87$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDzFH = parcelRequire("kDzFH");

var $3svxt = parcelRequire("3svxt");

var $5oIBC = parcelRequire("5oIBC");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");


var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $3uAFr = parcelRequire("3uAFr");

var $9ekFy = parcelRequire("9ekFy");

var $3V6nz = parcelRequire("3V6nz");


var $1Y97h = parcelRequire("1Y97h");
const $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $3V6nz.applicationEditionToUpFlowEdition)((0, $6WXNs.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $3d6c2870ae2a9a87$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $3d6c2870ae2a9a87$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $3d6c2870ae2a9a87$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $eUqFw.useState)(null);
    const currentEdition = (0, $3V6nz.applicationEditionToUpFlowEdition)((0, $kDzFH.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $3uAFr.mapActionIdFromType)[0, $3uAFr.UPGRADE];
        $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $3uAFr.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $3uAFr.mapActionIdFromType)[0, $3uAFr.LEARN_MORE];
        $3d6c2870ae2a9a87$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $3uAFr.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $eUqFw.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, intl.formatMessage((0, $1Y97h.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3d6c2870ae2a9a87$var$MultiLineParagraph, null, intl.formatMessage((0, $1Y97h.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $3d6c2870ae2a9a87$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $3d6c2870ae2a9a87$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $1Y97h.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $584c6c5758c545fa$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $3d6c2870ae2a9a87$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $1Y97h.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $584c6c5758c545fa$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ekFy.UpFlowIFrame), {
            targetEdition: (0, $6WXNs.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $3d6c2870ae2a9a87$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $5oIBC.default)($3d6c2870ae2a9a87$var$UpgradeToAddUsersDialog));
const $3d6c2870ae2a9a87$var$buttonBarStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d6c2870ae2a9a87$var$MultiLineParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kDzFH", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $f3ca75df413b6183$export$53e066a63a960439);

const $f3ca75df413b6183$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $2edfd53057852e41$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});

parcelRegister("3svxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e55bb6ee669ca6d$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e55bb6ee669ca6d$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $2edfd53057852e41$export$db515c8cec1e6f79] && result.push((0, $2edfd53057852e41$export$db515c8cec1e6f79));
    licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61] && result.push((0, $2edfd53057852e41$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $2edfd53057852e41$export$1346c9aa3cbb477d] && result.push((0, $2edfd53057852e41$export$1346c9aa3cbb477d));
    licensedProducts[0, $2edfd53057852e41$export$202f50ee62667e32] && result.push((0, $2edfd53057852e41$export$202f50ee62667e32));
    return result;
};

});

parcelRegister("3uAFr", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $bc6bb1980bacdf08$export$1979295cc80a7ec1);
$parcel$export(module.exports, "READ_ABOUT_CONFIGURING_STATUSES", () => $bc6bb1980bacdf08$export$ec2640a84c44efca);
$parcel$export(module.exports, "UPGRADE", () => $bc6bb1980bacdf08$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $bc6bb1980bacdf08$export$2bf527ee1645dc7d);
const $bc6bb1980bacdf08$export$9ba2bc3b1bdc1519 = 'experiment';
const $bc6bb1980bacdf08$export$5b7423264d48ab04 = 'not-enrolled';
const $bc6bb1980bacdf08$export$43f367b3e957f219 = 'control';
const $bc6bb1980bacdf08$export$1979295cc80a7ec1 = 'learn-more';
const $bc6bb1980bacdf08$export$ec2640a84c44efca = 'read-about-configuring-statuses';
const $bc6bb1980bacdf08$export$fe5b785cab515b6e = 'upgrade';
const $bc6bb1980bacdf08$export$2bf527ee1645dc7d = {
    [$bc6bb1980bacdf08$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$bc6bb1980bacdf08$export$ec2640a84c44efca]: 'readAboutConfiguringStatuses',
    [$bc6bb1980bacdf08$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("9ekFy", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $1bd1da7075fc78d1$export$e9eafd8c579e773d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


var $3V6nz = parcelRequire("3V6nz");

var $lB1hx = parcelRequire("lB1hx");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1bd1da7075fc78d1$var$UpFlowIFrameLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("cRo6H")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $1bd1da7075fc78d1$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
        teamName: "growth-tako",
        fallback: (0, $lB1hx.ChunkLoadErrorFlag),
        attributes: (0, $3V6nz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1bd1da7075fc78d1$var$UpFlowIFrameLazy, props)));

});
const $784e146d081cab2a$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $784e146d081cab2a$export$cb7e587097a78810 = 'upsell-edition';
const $784e146d081cab2a$export$fb320338324d1328 = 'upflowIFrame';
const $784e146d081cab2a$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $784e146d081cab2a$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $784e146d081cab2a$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $784e146d081cab2a$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $784e146d081cab2a$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $784e146d081cab2a$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("3V6nz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $4f19dd0acff36bb5$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $4f19dd0acff36bb5$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $4f19dd0acff36bb5$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $4f19dd0acff36bb5$export$d3da1ecaf1206c58);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $lNfG4 = parcelRequire("lNfG4");

var $guiFP = parcelRequire("guiFP");

var $6WXNs = parcelRequire("6WXNs");



var $fdxQj = parcelRequire("fdxQj");
const $4f19dd0acff36bb5$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $guiFP.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            packageName: (0, $784e146d081cab2a$export$c73007a11ea7e52),
            teamName: 'growth-tako'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $4f19dd0acff36bb5$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $6WXNs.FREE_EDITION)) return 0, $0722a49a19fd82a0$export$e69af2c4378638a2;
    if (applicationEdition === (0, $6WXNs.STANDARD_EDITION)) return 0, $0722a49a19fd82a0$export$7bc7dd5faba7ad6b;
    return 0, $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7;
};
const $4f19dd0acff36bb5$export$7d4045a899f62dfd = (0, $lNfG4.metrics).interaction({
    key: `${(0, $784e146d081cab2a$export$c73007a11ea7e52)}.upgrade.plan`
});
const $4f19dd0acff36bb5$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $7rh0R.isLoaderError)(error)
    });
const $4f19dd0acff36bb5$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $4f19dd0acff36bb5$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $4f19dd0acff36bb5$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fdxQj.CommerceApiErrorFlag), null);
};

});
const $0722a49a19fd82a0$export$e69af2c4378638a2 = 'free';
const $0722a49a19fd82a0$export$7bc7dd5faba7ad6b = 'standard';
const $0722a49a19fd82a0$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("fdxQj", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $f9cddb5329b8bde6$export$7ee77c445dd775b4);

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $7AaMe = parcelRequire("7AaMe");
const $f9cddb5329b8bde6$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $eo17r.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $7AaMe.default).title,
        description: (0, $7AaMe.default).description,
        isAutoDismiss: true
    });
    return null;
};

});
parcelRegister("7AaMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec87d75cc62a60c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec87d75cc62a60c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("lB1hx", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $fbcf8118023ec96d$export$7a9d9407b3a5f50e);

var $7rh0R = parcelRequire("7rh0R");

var $k8Qyf = parcelRequire("k8Qyf");

var $eo17r = parcelRequire("eo17r");

var $d7NSa = parcelRequire("d7NSa");
const $fbcf8118023ec96d$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $eo17r.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    if ((0, $7rh0R.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $d7NSa.default).title,
        description: (0, $d7NSa.default).description,
        isAutoDismiss: true,
        actions: [
            {
                content: (0, $d7NSa.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("d7NSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf70fc34a5a9ee18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cf70fc34a5a9ee18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("cRo6H", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("ipZXA")
]).then(()=>parcelRequire('9t7R1'));

});


const $584c6c5758c545fa$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $584c6c5758c545fa$export$b31b7002b6bdcbe9 = 'https://support.atlassian.com/jira-cloud-administration/docs/configure-statuses-resolutions-and-priorities/';
const $584c6c5758c545fa$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("1Y97h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a007549c91f619$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e5a007549c91f619$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("1Gl68", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $a8e8f70e71e008ee$export$6397e3bbf35b34e3);

var $lRmyA = parcelRequire("lRmyA");
const $a8e8f70e71e008ee$var$toRemainingSeats = (json)=>json.remainingSeat;
const $a8e8f70e71e008ee$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $lRmyA.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$a8e8f70e71e008ee$var$toRemainingSeats(json));

});

parcelRegister("7NnaN", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $92267752c3276ed5$export$2b3af6baec22bd98);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $g1u9S = parcelRequire("g1u9S");

var $2DMQz = parcelRequire("2DMQz");

var $grFrv = parcelRequire("grFrv");
const $92267752c3276ed5$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $2DMQz.getUserProjectRoles)(baseUrl, projectId),
            (0, $g1u9S.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $grFrv.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $grFrv.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("g1u9S", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $cb03e98e1c54da65$export$f5f97c28ee230e06);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $cb03e98e1c54da65$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $cb03e98e1c54da65$var$transform = (data)=>data.value;
const $cb03e98e1c54da65$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $lRmyA.performGetRequest)($cb03e98e1c54da65$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$cb03e98e1c54da65$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $7byHA.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $guiFP.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("2DMQz", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $5485a1e5a52a43c5$export$3b587d1e1fe73b9d);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME = 'Member';
const $5485a1e5a52a43c5$var$VIEWER_ROLE_NAME = 'Viewer';
const $5485a1e5a52a43c5$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $5485a1e5a52a43c5$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME);
const $5485a1e5a52a43c5$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $5485a1e5a52a43c5$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $5485a1e5a52a43c5$var$VIEWER_ROLE_NAME && role.name !== $5485a1e5a52a43c5$var$MEMBER_ROLE_NAME && !role.admin);
const $5485a1e5a52a43c5$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $5485a1e5a52a43c5$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $lRmyA.performGetRequest)($5485a1e5a52a43c5$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $5485a1e5a52a43c5$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $5485a1e5a52a43c5$export$10eeb2d34050404e(data),
            hasCustomRole: $5485a1e5a52a43c5$export$a4d7f3415bee4b75(data),
            projectRoleNames: $5485a1e5a52a43c5$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $7byHA.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $guiFP.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("grFrv", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $c3f54e4ee61be276$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $c3f54e4ee61be276$export$7f2d1c0dab5190f9);

var $jMP2a = parcelRequire("jMP2a");
const $c3f54e4ee61be276$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $c3f54e4ee61be276$export$ecf9824f02c8a125 = 'Custom Role';
const $c3f54e4ee61be276$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $c3f54e4ee61be276$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $c3f54e4ee61be276$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($c3f54e4ee61be276$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("kovzS", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46f6f245d939aef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $giAhk = parcelRequire("giAhk");

var $8rQuz = parcelRequire("8rQuz");

var $9pw6N = parcelRequire("9pw6N");

var $ddnmK = parcelRequire("ddnmK");

var $1Y4Nh = parcelRequire("1Y4Nh");

var $l2Yeb = parcelRequire("l2Yeb");

var $fGrG2 = parcelRequire("fGrG2");
const $a46f6f245d939aef$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef } = props;
    const mainList = (0, $eUqFw.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $eUqFw.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "fieldset",
        xcss: [
            (0, $8rQuz.isVisualRefreshEnabled)() ? $a46f6f245d939aef$var$fieldsetStyles : $a46f6f245d939aef$var$fieldsetStylesOld
        ],
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        testId: "filters.ui.filters.assignee.stateless.assignee-filter" // eslint-disable-next-line jira/react/no-style-attribute
        ,
        style: {
            // Ensure layering of avatars does not conflict with anything else in the DOM tree
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$AvatarFilterLegend, {
        id: (0, $9pw6N.FILTER_PREFIX)
    }, formatMessage((0, $l2Yeb.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a46f6f245d939aef$var$AvatarsList, null, mainList.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Y4Nh.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fGrG2.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: onAssigneeMenuOpen
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ddnmK.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    })));
};
$a46f6f245d939aef$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showAddPeopleButton: false
};
var $a46f6f245d939aef$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($a46f6f245d939aef$var$AssigneeFilter);
const $a46f6f245d939aef$var$fieldsetStyles = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    border: 0
});
const $a46f6f245d939aef$var$fieldsetStylesOld = (0, $1ZAYh.xcss)({
    flexShrink: 0,
    border: 0,
    marginLeft: 'space.150'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a46f6f245d939aef$var$AvatarsList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a46f6f245d939aef$var$AvatarFilterLegend = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3it94y _1bsbt94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _ogto7mnp _1reo15vq _18m915vq _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9pw6N", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $0967a5c8c840826d$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $0967a5c8c840826d$export$42310dd57a41067);
const $0967a5c8c840826d$export$d6acfe0d617669c3 = 'assignee';
const $0967a5c8c840826d$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $0967a5c8c840826d$export$e70f7f4a08e4d8fb = 10;
const $0967a5c8c840826d$export$75297e3804621b0 = 36;

});

parcelRegister("ddnmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ddc227f3bf4696$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $jG2Eu = parcelRequire("jG2Eu");

var $eri7S = parcelRequire("eri7S");

var $iisnK = parcelRequire("iisnK");

var $eI5EY = parcelRequire("eI5EY");

var $2qhQi = parcelRequire("2qhQi");

var $5cLMB = parcelRequire("5cLMB");

var $kS8l2 = parcelRequire("kS8l2");

var $aked2 = parcelRequire("aked2");

var $8k8RR = parcelRequire("8k8RR");

var $9pw6N = parcelRequire("9pw6N");

var $9bwt3 = parcelRequire("9bwt3");

var $c6LJE = parcelRequire("c6LJE");

var $3zepQ = parcelRequire("3zepQ");
const $70ddc227f3bf4696$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $70ddc227f3bf4696$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $9bwt3.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $kS8l2.useGlobalRefStoreActions)();
    const onRef = (0, $eUqFw.useCallback)((ref)=>{
        register($70ddc227f3bf4696$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    const [isDismissed] = (0, $5cLMB.useIsDismissed)();
    const NudgeTooltip = !(0, $eI5EY.fg)('jsw-perf-async-add-people-modal-load') || !isDismissed ? (0, $aked2.AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $eUqFw.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zepQ.AddPeopleTooltip), {
        content: formatMessage((0, $c6LJE.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $9pw6N.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $c6LJE.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $9pw6N.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ddc227f3bf4696$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iisnK))), {
        size: "medium",
        label: formatMessage((0, $c6LJE.default).addPeople)
    }))))));
};
$70ddc227f3bf4696$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $70ddc227f3bf4696$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($70ddc227f3bf4696$var$AddUsersButton);
const $70ddc227f3bf4696$var$AddButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ddc227f3bf4696$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8k8RR.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ddc227f3bf4696$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $8k8RR.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $9t7rW.default)((0, $eri7S.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _1yt4otz2 _vchhusvi _bfhk1s4m _1p9v18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $70ddc227f3bf4696$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $70ddc227f3bf4696$var$ActionAvatarWrapper
};

});
parcelRegister("iisnK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d51fec82b4cf5254$var$_react = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d51fec82b4cf5254$var$_personAdd = $d51fec82b4cf5254$var$_interopRequireDefault((parcelRequire("kdBCz")));
function $d51fec82b4cf5254$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d51fec82b4cf5254$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d51fec82b4cf5254$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d51fec82b4cf5254$var$_personAdd.default
    }));
$d51fec82b4cf5254$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d51fec82b4cf5254$var$_default = module.exports.default = $d51fec82b4cf5254$var$InviteTeamIcon;

});
parcelRegister("kdBCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c71910615fcdf3419bf276c45a2048a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb823455dae27cb1$var$_react = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $eb823455dae27cb1$var$_UNSAFE_baseNew = $eb823455dae27cb1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $eb823455dae27cb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb823455dae27cb1$var$PersonAddIcon = (props)=>/*#__PURE__*/ $eb823455dae27cb1$var$_react.default.createElement($eb823455dae27cb1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 15v-2.25a3 3 0 0 1 3-3h2.5a3 3 0 0 1 3 3V15M13 8V5m0 3v3m0-3h3m-3 0h-3M8.25 4a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$eb823455dae27cb1$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $eb823455dae27cb1$var$_default = module.exports.default = $eb823455dae27cb1$var$PersonAddIcon;

});


parcelRegister("kS8l2", function(module, exports) {

$parcel$export(module.exports, "useGlobalRef", () => $450c796f66462b96$export$361e4f658203e95);
$parcel$export(module.exports, "useGlobalRefStoreActions", () => $450c796f66462b96$export$3c6c6911d09d7d8a);
$parcel$export(module.exports, "withGlobalRef", () => $450c796f66462b96$export$6b4b878b04fd3017);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $450c796f66462b96$var$store = (0, $WBLbN.createStore)({
    initialState: {},
    actions: {
        register: (key, ref)=>({ setState: setState })=>{
                setState({
                    [key]: ref || undefined
                });
            }
    },
    name: 'refs-store'
});
const $450c796f66462b96$export$4beaa3baa53198e4 = (0, $WBLbN.createContainer)($450c796f66462b96$var$store);
const $450c796f66462b96$var$useGlobalRefStateSelector = (0, $WBLbN.createStateHook)($450c796f66462b96$var$store, {
    selector: (state, key)=>state[key]
});
const $450c796f66462b96$export$361e4f658203e95 = (key)=>[
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        $450c796f66462b96$var$useGlobalRefStateSelector(key)
    ];
const $450c796f66462b96$export$3c6c6911d09d7d8a = (0, $WBLbN.createHook)($450c796f66462b96$var$store, {
    selector: null
});
const $450c796f66462b96$export$6b4b878b04fd3017 = (propName, refName)=>(Component)=>(props)=>{
            const [ref] = $450c796f66462b96$export$361e4f658203e95(refName);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...props,
                [propName]: ref
            });
        };

});

parcelRegister("aked2", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $3995bf095383eb37$export$4e4097c2567f79b7);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");


var $ewdMq = parcelRequire("ewdMq");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $3995bf095383eb37$var$AssigneeFilterAddPeopleButtonLazy = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("dgobk")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $3995bf095383eb37$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3995bf095383eb37$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98)
    }, children)));

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $8379f5d78bf6fb5a$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $8379f5d78bf6fb5a$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $8379f5d78bf6fb5a$export$e3884212029f7bef = 'should-show-welcome-modal';
const $8379f5d78bf6fb5a$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $8379f5d78bf6fb5a$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $8379f5d78bf6fb5a$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $8379f5d78bf6fb5a$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $8379f5d78bf6fb5a$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $8379f5d78bf6fb5a$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $8379f5d78bf6fb5a$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $8379f5d78bf6fb5a$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $8379f5d78bf6fb5a$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $8379f5d78bf6fb5a$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $8379f5d78bf6fb5a$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $8379f5d78bf6fb5a$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $8379f5d78bf6fb5a$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $8379f5d78bf6fb5a$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $8379f5d78bf6fb5a$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $8379f5d78bf6fb5a$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $8379f5d78bf6fb5a$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $8379f5d78bf6fb5a$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $8379f5d78bf6fb5a$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $8379f5d78bf6fb5a$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $8379f5d78bf6fb5a$export$468488291ccd988 = 'timelineAddItemNudge';
const $8379f5d78bf6fb5a$export$7a33548109ac931d = 'createFormNudge';
const $8379f5d78bf6fb5a$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $8379f5d78bf6fb5a$export$594d3436316492be = 'summaryViewNudge';
const $8379f5d78bf6fb5a$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $8379f5d78bf6fb5a$export$73278890f736ee6f = 'manageProjectsNudge';

parcelRegister("dgobk", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("l5jGp")
]).then(()=>parcelRequire('htukB'));

});


parcelRegister("8k8RR", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $325bbcd3886753b0$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $325bbcd3886753b0$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $325bbcd3886753b0$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $325bbcd3886753b0$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eri7S = parcelRequire("eri7S");

var $9zysr = parcelRequire("9zysr");

var $8rQuz = parcelRequire("8rQuz");

var $9pw6N = parcelRequire("9pw6N");
const $325bbcd3886753b0$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $325bbcd3886753b0$export$a3e8c7acf36da4c1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $9t7rW.default)(__cmplp.zIndex + (0, $9pw6N.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $9t7rW.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $9t7rW.default)(__cmplp.zIndex + (0, $9pw6N.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _18u014id _bfhk18uv _s7n4jp4b _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$7d5adb020315f211 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $325bbcd3886753b0$export$a3e8c7acf36da4c1, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3in7od",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$f7513421c53ce141 = (0, $9zysr.componentWithCondition)((0, $8rQuz.isVisualRefreshEnabled), $325bbcd3886753b0$export$7d5adb020315f211, $325bbcd3886753b0$export$a3e8c7acf36da4c1);
const $325bbcd3886753b0$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _19it7zi8 _bfhk1s4m _v5644dm8 _80omtlke _7ehi12h7 _nt751r31 _49pcglyw _1hvw1o36 _irr3yucn",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $9t7rW.default)((0, $eri7S.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syaz8a6j _vwz412pq",
            __cmplp.className
        ])
    });
});
const $325bbcd3886753b0$export$398a7826f6fd570e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1ssb _19itj1ic",
            __cmplp.selected ? "_1h6d1c86" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9bwt3", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $9033ffcb430e0776$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $9033ffcb430e0776$export$49f6dd346c7dfb52);

var $eUqFw = parcelRequire("eUqFw");
const $9033ffcb430e0776$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $9033ffcb430e0776$export$49f6dd346c7dfb52 = (callback)=>(0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("c6LJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba036c0ba7538c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ba036c0ba7538c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("3zepQ", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $5da98676a909d737$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2eG9N = parcelRequire("2eG9N");
const $5da98676a909d737$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5da98676a909d737$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5da98676a909d737$var$TooltipWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _kqswh2mm _12ji1r31 _1qu2glyw _12y3idpf _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1Y4Nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09bf05d0581ac1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $2eG9N = parcelRequire("2eG9N");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $2qhQi = parcelRequire("2qhQi");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $l4zCR = parcelRequire("l4zCR");

var $8rQuz = parcelRequire("8rQuz");

var $8k8RR = parcelRequire("8k8RR");

var $9bwt3 = parcelRequire("9bwt3");

var $9lr32 = parcelRequire("9lr32");

var $43XZb = parcelRequire("43XZb");
const $a09bf05d0581ac1d$var$type = 'assignee';
const $a09bf05d0581ac1d$var$AvatarWithAnalytics = ({ isRealtimePresenceEnabled: isRealtimePresenceEnabled, intl: intl, ...user })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = intl;
    const onShow = ()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'tooltip viewed');
    };
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $43XZb.default).presenceOnlineLabel : (0, $43XZb.default).presenceOfflineLabel, {
        name: user.displayName
    });
    if (isRealtimePresenceEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span",
        presence: user.presence
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $8rQuz.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: user.label || user.displayName,
        onShow: onShow,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $8rQuz.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
};
const $a09bf05d0581ac1d$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const userIdentifier = user.id;
    const checkboxId = `${$a09bf05d0581ac1d$var$type}-${userIdentifier}`;
    const onToggle = (0, $eUqFw.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $9bwt3.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $1Iui1.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $43XZb.default).presenceOnlineLabel : (0, $43XZb.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: user.displayName,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: "medium",
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarInputCheckbox, {
        "aria-label": formatMessage((0, $43XZb.default).avatarInputCheckboxLabel),
        type: "checkbox",
        id: checkboxId,
        name: $a09bf05d0581ac1d$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $9bwt3.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarBorder), {
        selected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, (0, $1ybV0.ff)('jsw.enable.avatar.tooltip.label.and.analytic_hikl3') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a09bf05d0581ac1d$var$AvatarWithAnalytics, {
        ...user,
        isRealtimePresenceEnabled: isRealtimePresenceEnabled,
        intl: intl
    }) : avatarWithTooltip)));
};
$a09bf05d0581ac1d$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $a09bf05d0581ac1d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2qhQi.default)($a09bf05d0581ac1d$var$Avatar);
const $a09bf05d0581ac1d$var$AvatarLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $a09bf05d0581ac1d$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _1xp4rg51",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $a09bf05d0581ac1d$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $a09bf05d0581ac1d$var$AvatarInputCheckbox
};

});
parcelRegister("l4zCR", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $fd97030f85875137$export$ba964695877b24);

var $d2wNG = parcelRequire("d2wNG");

var $79xbN = parcelRequire("79xbN");

var $21Sgb = parcelRequire("21Sgb");
const $fd97030f85875137$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $21Sgb.useFirstActivationDateMs)();
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $d2wNG.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});
parcelRegister("21Sgb", function(module, exports) {

$parcel$export(module.exports, "useFirstActivationDateMs", () => $080756a4d87be123$export$9df3a539e50a284b);

var $gd0Sp = parcelRequire("gd0Sp");
const $080756a4d87be123$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});


parcelRegister("9lr32", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4523828920fa75c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2eG9N = parcelRequire("2eG9N");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2MpRo = parcelRequire("2MpRo");
const $c4523828920fa75c$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $2MpRo.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $2MpRo.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $c4523828920fa75c$export$2e2bcd8739ae039 = $c4523828920fa75c$var$PresenceTooltip;

});
parcelRegister("2MpRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e99513c5816bd7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a9e99513c5816bd7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("43XZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $28562c6ddb0b4980$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $28562c6ddb0b4980$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    }
});

});


parcelRegister("l2Yeb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ec85272c96e5b8f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1ec85272c96e5b8f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    }
});

});

parcelRegister("fGrG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f094d1bb53629df3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $iJlfe = parcelRequire("iJlfe");

var $6OfWd = parcelRequire("6OfWd");
var $9mc6u = parcelRequire("9mc6u");

var $2eG9N = parcelRequire("2eG9N");

var $1Iui1 = parcelRequire("1Iui1");

var $l4zCR = parcelRequire("l4zCR");

var $6vrw7 = parcelRequire("6vrw7");

var $8k8RR = parcelRequire("8k8RR");

var $9pw6N = parcelRequire("9pw6N");

var $9bwt3 = parcelRequire("9bwt3");

var $9lr32 = parcelRequire("9lr32");
const $f094d1bb53629df3$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps } = props;
    const [isOpen, setOpenState] = (0, $eUqFw.useState)(false);
    const _onOpenChange = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (attrs)=>{
        setOpenState(attrs.isOpen);
        if (attrs.isOpen) onOpen();
    }, [
        setOpenState,
        onOpen
    ]);
    const isSelected = (0, $eUqFw.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $l4zCR.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $1Iui1.VARIATION);
    const dropdownItems = (0, $eUqFw.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mc6u.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $6vrw7.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9lr32.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
                content: displayName
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownAvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$TextContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarWrapper), {
                ...triggerProps,
                ref: triggerRef,
                zIndex: (0, $9pw6N.Z_INDEX).MENU
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$ActionInputCheckbox, {
                "data-test-id": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more",
                type: "checkbox",
                id: `${(0, $9pw6N.FILTER_PREFIX)}-show-more`,
                name: (0, $9pw6N.FILTER_PREFIX),
                value: `${(0, $9pw6N.FILTER_PREFIX)}-show-more`,
                defaultChecked: isOpen,
                "aria-describedby": (0, $9pw6N.FILTER_PREFIX),
                onClick: (0, $9bwt3.onBlur)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.ActionAvatar), {
                tabIndex: -1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8k8RR.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f094d1bb53629df3$var$DropdownItemsWrapper, null, dropdownItems)));
};
$f094d1bb53629df3$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $f094d1bb53629df3$export$2e2bcd8739ae039 = $f094d1bb53629df3$var$ShowMoreButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f094d1bb53629df3$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _18u014id _1pbyidpf",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1mjv _1yt4swc3",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1t4ug9d8 _k907ze3t",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ItemContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$TextContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _18s816r1 _1yt41w01 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$TextContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $f094d1bb53629df3$var$ActionInputCheckbox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _tzy4idpf _1reo15vq _18m915vq _o5721q9c _80omtlke _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1glwzk5k _5o9f194a",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9mc6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd85e99771c9c60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $caOPr = parcelRequire("caOPr");

var $4lVNM = parcelRequire("4lVNM");

var $h1Q9j = parcelRequire("h1Q9j");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $bdd85e99771c9c60$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $4lVNM.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $caOPr.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...rest
    }, children));
};
var $bdd85e99771c9c60$export$2e2bcd8739ae039 = $bdd85e99771c9c60$var$DropdownItemCheckbox;

});
parcelRegister("caOPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70ae4045f17c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $0f70ae4045f17c28$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $0f70ae4045f17c28$export$2e2bcd8739ae039 = $0f70ae4045f17c28$var$CheckboxIcon;

});

parcelRegister("4lVNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f55dd9044769050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b9WHI = parcelRequire("b9WHI");

var $7mYCs = parcelRequire("7mYCs");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4f55dd9044769050$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const groupId = (0, $eUqFw.useContext)((0, $b9WHI.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4f55dd9044769050$export$2e2bcd8739ae039 = $4f55dd9044769050$var$useCheckboxState;

});
parcelRegister("b9WHI", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $7d37fbf6df8e3733$export$baf37c4be89255b8);

var $eUqFw = parcelRequire("eUqFw");
const $7d37fbf6df8e3733$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eUqFw.createContext)('');

});






parcelRegister("d6qlS", function(module, exports) {

$parcel$export(module.exports, "useAllKnownAssignees", () => $e540d2dd8b0cd766$export$933724ba186f60c6);

var $eUqFw = parcelRequire("eUqFw");

var $OwuLI = parcelRequire("OwuLI");

var $gInUF = parcelRequire("gInUF");
const $e540d2dd8b0cd766$export$933724ba186f60c6 = ()=>{
    const { current: allKnownAssignees } = (0, $eUqFw.useRef)(new Map());
    const { data: issuesResult = [] } = (0, $OwuLI.useIssues)();
    const currentUser = (0, $gInUF.useLoggedInUser)();
    const filteredAssignees = currentUser != null ? issuesResult.filter(({ assignee: assignee })=>assignee != null && assignee.id !== currentUser.id) : issuesResult;
    filteredAssignees.forEach(({ assignee: assignee })=>{
        if (assignee && !allKnownAssignees.has(assignee.id)) allKnownAssignees.set(assignee.id, assignee);
    });
    if (currentUser != null) return [
        currentUser,
        ...allKnownAssignees.values()
    ];
    return [
        ...allKnownAssignees.values()
    ];
};

});
parcelRegister("gInUF", function(module, exports) {

$parcel$export(module.exports, "useLoggedInUser", () => $74a98e51bd75ca5f$export$aae23f3a65fbe750);

var $gNByR = parcelRequire("gNByR");

var $eUqFw = parcelRequire("eUqFw");

var $5UFhP = parcelRequire("5UFhP");

var $6vrw7 = parcelRequire("6vrw7");

var $dxcfv = parcelRequire("dxcfv");
// @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
const $74a98e51bd75ca5f$var$transformUser = (user)=>{
    const { accountId: accountId, picture: picture, name: name } = user;
    if (accountId == null || name == null) return Error('Invalid user returned');
    return {
        id: (0, $6vrw7.toAccountId)(accountId),
        displayName: name,
        avatarUrl: picture
    };
};
const $74a98e51bd75ca5f$export$f13b29f9ed0c5a03 = ({ loading: loading, error: error, data: data })=>{
    if (loading || error) return null;
    if (data == null || data.user == null) return null;
    const transformedResult = $74a98e51bd75ca5f$var$transformUser(data.user);
    return transformedResult instanceof Error ? null : transformedResult;
};
const $74a98e51bd75ca5f$export$aae23f3a65fbe750 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    const queryResult = (0, $5UFhP.useFetchQuery)((0, $gNByR.default), {
        accountId: accountId ?? ''
    }, {
        skip: accountId === null,
        fetchPolicy: 'store-or-network'
    });
    const userQueryResult = (0, $eUqFw.useMemo)(()=>$74a98e51bd75ca5f$export$f13b29f9ed0c5a03(queryResult), [
        queryResult
    ]);
    return userQueryResult;
};

});
parcelRegister("gNByR", function(module, exports) {

$parcel$export(module.exports, "default", () => $591f358c66fa378c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e66c7b3eed506d87bbfd2644fe3ebd5f>>
 * @relayHash 14483244b17ec100310300c91a84f702
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 698302250ad1dfbbfb787bec4d645d7edba86da66a6b49eecee1708827dde5f6
const $591f358c66fa378c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getCurrentUserRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getCurrentUserRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "698302250ad1dfbbfb787bec4d645d7edba86da66a6b49eecee1708827dde5f6",
            "metadata": {},
            "name": "getCurrentUserRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$591f358c66fa378c$var$node.hash = "e1f043319049bb505255b5c6763fa29d";
var $591f358c66fa378c$export$2e2bcd8739ae039 = $591f358c66fa378c$var$node;

});

parcelRegister("5UFhP", function(module, exports) {

$parcel$export(module.exports, "useFetchQuery", () => $43d0ba1f8ff89bcd$export$e0fe68859e28ee42);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $iWLL0 = parcelRequire("iWLL0");
// sounced from https://github.com/apollographql/apollo-client/blob/main/src/react/hooks/utils/useDeepMemo.ts
const $43d0ba1f8ff89bcd$var$useDeepMemo = (memoFn, key)=>{
    const ref = (0, $eUqFw.useRef)();
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return ref.current.value;
};
const $43d0ba1f8ff89bcd$export$e0fe68859e28ee42 = (query, vars, opts)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [result, setResult] = (0, $eUqFw.useState)({
        data: null,
        error: null,
        loading: true
    });
    const { data: data, error: error, loading: loading } = result;
    const prevVariables = (0, $eUqFw.useRef)();
    const fetch = (variables, options)=>{
        const { fetchPolicy: fetchPolicy = 'network-only', skip: skip = false } = options || {};
        if (skip || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevVariables.current, variables)) return;
        prevVariables.current = variables;
        // Don't trigger re-render if it's intial render
        if (!(loading === true && data == null && error === null)) setResult({
            error: null,
            loading: true,
            data: null
        });
        (0, $iWLL0.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy
        }).toPromise().then((d)=>{
            setResult({
                error: null,
                loading: false,
                // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'null'.
                data: d
            });
        }).catch((e)=>{
            setResult({
                data: null,
                loading: false,
                error: e
            });
        });
    };
    const memo = {
        vars: vars,
        opts: opts
    };
    $43d0ba1f8ff89bcd$var$useDeepMemo(()=>{
        fetch(vars, opts);
    }, memo);
    const nullableData = data == null ? null : data;
    return {
        data: nullableData,
        error: error,
        loading: loading
    };
};

});




parcelRegister("diC1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0760da72723457e9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9W2Vz = parcelRequire("9W2Vz");
const $0760da72723457e9$var$ClearFilterLabel = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span"
    }, formatMessage((0, $9W2Vz.default).labelClear)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $0760da72723457e9$var$labelFiltersWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0", formatMessage((0, $9W2Vz.default).labelFilters))));
};
const $0760da72723457e9$var$labelFiltersWrapperStyles = (0, $1ZAYh.xcss)({
    // @ts-expect-error doesn't support media.below yet
    [(0, $4Ywu9.media).below.md]: {
        display: 'none'
    }
});
var $0760da72723457e9$export$2e2bcd8739ae039 = $0760da72723457e9$var$ClearFilterLabel;

});
parcelRegister("9W2Vz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4ccbe4949f058b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b4ccbe4949f058b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labelClear: {
        "id": "software-deployments.top-filters.clear-filter-label.label-clear",
        "defaultMessage": "Clear"
    },
    labelFilters: {
        "id": "software-deployments.top-filters.clear-filter-label.label-filters",
        "defaultMessage": "filters"
    }
});

});


parcelRegister("9hxzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b34e96836d279a5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $azooe = parcelRequire("azooe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kg1NY = parcelRequire("kg1NY");
const $0b34e96836d279a5$var$MAX_ENVIRONMENT_NAMES = 50;
const $0b34e96836d279a5$var$EnvironmentFilter = ({ isNested: isNested, onChange: onChange, options: options, selectedValues: selectedValues })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b34e96836d279a5$var$FilterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $kg1NY.default).environmentLabel),
        values: options,
        selectedValues: selectedValues,
        onChange: (newEntries)=>{
            const filteringEnvNamesByEnvType = newEntries.some((entry)=>entry.value.includes('environment-type'));
            const filteringBySpecificEnvName = newEntries.some((entry)=>entry.value.includes('environment-name'));
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'deploymentsEnvironmentNameFilter'
            }), {
                filteringEnvNamesByEnvType: filteringEnvNamesByEnvType,
                filteringBySpecificEnvName: filteringBySpecificEnvName
            });
            onChange(newEntries);
        },
        maxSelectionAllowed: $0b34e96836d279a5$var$MAX_ENVIRONMENT_NAMES,
        maxSelectionReachedTooltip: formatMessage((0, $kg1NY.default).maxEnvironmentNamesTooltip),
        isNested: isNested
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0b34e96836d279a5$var$FilterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1j9a",
            __cmplp.className
        ])
    });
});
var $0b34e96836d279a5$export$2e2bcd8739ae039 = $0b34e96836d279a5$var$EnvironmentFilter;

});
parcelRegister("azooe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e44aa39502f5b060$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $bVKeg = parcelRequire("bVKeg");
var $jQxSL = parcelRequire("jQxSL");
var $l44HT = parcelRequire("l44HT");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $bBKri = parcelRequire("bBKri");

var $iN7qj = parcelRequire("iN7qj");

var $4q4xB = parcelRequire("4q4xB");

var $o0yPF = parcelRequire("o0yPF");

var $iRoug = parcelRequire("iRoug");

var $kCSUv = parcelRequire("kCSUv");
const $e44aa39502f5b060$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, rest, children));
const $e44aa39502f5b060$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const options = (0, $eUqFw.useMemo)(()=>(0, $kCSUv.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $eUqFw.useMemo)(()=>(0, $kCSUv.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $bBKri.OPEN_CHANGE_PAYLOAD));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $bBKri.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>(0, $eI5EY.fg)('allow_jplat_filter_list_to_be_disabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRoug.default), {
            ...popupProps,
            isDisabled: isTriggerDisabled,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRoug.default), {
            ...popupProps,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iN7qj.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $o0yPF.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $o0yPF.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l44HT.default), {
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $4q4xB.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $bVKeg.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $e44aa39502f5b060$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $kCSUv.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        })
    });
};
$e44aa39502f5b060$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isTriggerDisabled: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $e44aa39502f5b060$export$2e2bcd8739ae039 = $e44aa39502f5b060$export$fa71ab09534e6447;

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hSJ9G = parcelRequire("hSJ9G");

var $c6Z6Z = parcelRequire("c6Z6Z");

function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $02468a1d390d1515$var$_radioChecked = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("a7ob3")));
function $02468a1d390d1515$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $02468a1d390d1515$var$_radioChecked.default
    }));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});
parcelRegister("a7ob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75dd4fef0eed872c$var$_react = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75dd4fef0eed872c$var$_UNSAFE_baseNew = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75dd4fef0eed872c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75dd4fef0eed872c$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $75dd4fef0eed872c$var$_react.default.createElement($75dd4fef0eed872c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$75dd4fef0eed872c$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $75dd4fef0eed872c$var$_default = module.exports.default = $75dd4fef0eed872c$var$RadioCheckedIcon;

});



parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $lbDTY = parcelRequire("lbDTY");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $asNSH = parcelRequire("asNSH");

var $XHGTv = parcelRequire("XHGTv");


var $5wCDk = parcelRequire("5wCDk");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");

var $7ldaw = parcelRequire("7ldaw");
/**
 * Are we rendering on the client or server?
 */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$FocusLock = (0, $XHGTv.fg)('platform_dst_select-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.selectRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            if ((0, $XHGTv.fg)('tab-event-should-close-popupSelect')) {
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            }
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen && (0, $XHGTv.fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose && (0, $XHGTv.fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const menuHandlers = !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver') ? {
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            } : {};
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $lT14u.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $lT14u.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $lT14u.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>// When the feature flag 'platform_design_system_team_select_node_resolver' is enabled,
                // we directly pass the ref to MenuDialog instead of wrapping it with NodeResolver.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper, {
                    hasNodeResolver: !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver'),
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId,
                    ref: !(0, $XHGTv.fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e29cbcff993ea6c5$var$FocusLock, {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                    "aria-label": providedAriaLabel,
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    ...menuHandlers,
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange,
                    ariaLiveMessages: !showSearchControl ? {
                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                        onFocus: onReactSelectFocus,
                        ...props.ariaLiveMessages // priority to use user handlers if provided
                    } : props.ariaLiveMessages
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, otherwise just the children.
 */ const $e29cbcff993ea6c5$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return children;
};

});
parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hcvt0 = parcelRequire("hcvt0");


var $lcnyw = parcelRequire("lcnyw");

var $lkPEe = parcelRequire("lkPEe");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).modal(),
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: ref,
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children));
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "7693z9",
    styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hcvt0))), {
        color: "currentColor",
        spacing: "spacious",
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$var$IndicatorSeparator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).IndicatorSeparator, props);
const $e208c4fdfb4dbbc3$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, props);
const $e208c4fdfb4dbbc3$var$MultiValueRemove = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu,
    IndicatorSeparator: $e208c4fdfb4dbbc3$var$IndicatorSeparator,
    ClearIndicator: $e208c4fdfb4dbbc3$var$ClearIndicator,
    MultiValueRemove: $e208c4fdfb4dbbc3$var$MultiValueRemove
};

});
parcelRegister("hcvt0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::96a381bb462d74e92d39bb265721c443>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c85bf750af932d50$var$_react = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c85bf750af932d50$var$_search = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("9IsWp")));

var $c85bf750af932d50$var$_search2 = $c85bf750af932d50$var$_interopRequireDefault((parcelRequire("bPZtE")));
function $c85bf750af932d50$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c85bf750af932d50$var$SearchIcon = (props)=>/*#__PURE__*/ $c85bf750af932d50$var$_react.default.createElement($c85bf750af932d50$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $c85bf750af932d50$var$_search2.default
    }, props));
$c85bf750af932d50$var$SearchIcon.Name = 'SearchIconMigration';
var $c85bf750af932d50$var$_default = module.exports.default = $c85bf750af932d50$var$SearchIcon;

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});




parcelRegister("bBKri", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $b7c20e9c2dfb0c8d$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $b7c20e9c2dfb0c8d$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $b7c20e9c2dfb0c8d$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $b7c20e9c2dfb0c8d$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $b7c20e9c2dfb0c8d$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $b7c20e9c2dfb0c8d$export$b94e5dc1a8a1409);

var $c9TLT = parcelRequire("c9TLT");
const $b7c20e9c2dfb0c8d$export$84ae3fb9fdba8a12 = (0, $c9TLT.gridSize) * 21;
const $b7c20e9c2dfb0c8d$export$920d89f17cd2fe3d = (0, $c9TLT.gridSize) * 25;
const $b7c20e9c2dfb0c8d$export$6ea791ab71b8fa00 = (0, $c9TLT.gridSize) * 48;
const $b7c20e9c2dfb0c8d$export$1d287c6a8b81eb5b = 9;
const $b7c20e9c2dfb0c8d$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $b7c20e9c2dfb0c8d$export$b94e5dc1a8a1409 = 'filterList';

});

parcelRegister("iN7qj", function(module, exports) {

$parcel$export(module.exports, "default", () => $11194a43908dcca2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $jMP2a = parcelRequire("jMP2a");

var $l61gw = parcelRequire("l61gw");

var $i3CUI = parcelRequire("i3CUI");
const $11194a43908dcca2$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11194a43908dcca2$var$HorizontalSeparator, null), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11194a43908dcca2$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3CUI.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l61gw.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$11194a43908dcca2$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $11194a43908dcca2$export$2e2bcd8739ae039 = $11194a43908dcca2$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $11194a43908dcca2$var$HorizontalSeparator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _4t3iv77o _bfhkyucn _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $11194a43908dcca2$var$PanelToggleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4wux3 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l61gw", function(module, exports) {

$parcel$export(module.exports, "default", () => $63861f575a33e906$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $eGI9v = parcelRequire("eGI9v");

var $jMP2a = parcelRequire("jMP2a");

var $lB25E = parcelRequire("lB25E");
const $63861f575a33e906$var$DropdownItem = (0, $eGI9v.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $hD6GJ.default));
const $63861f575a33e906$var$linkWrapperStyles = null;
const $63861f575a33e906$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const onDropdownClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _1i3qd8e8 _hjpp1osq _c24d81pi"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63861f575a33e906$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($63861f575a33e906$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $63861f575a33e906$export$2e2bcd8739ae039 = $63861f575a33e906$export$532cb6865ebe8946;

});

parcelRegister("i3CUI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb29b4841d4c7f6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c8Guq = parcelRequire("c8Guq");

var $jG2Eu = parcelRequire("jG2Eu");

var $ffiyv = parcelRequire("ffiyv");

var $e270j = parcelRequire("e270j");

var $eGI9v = parcelRequire("eGI9v");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");

var $5oqMG = parcelRequire("5oqMG");

var $2GBsX = parcelRequire("2GBsX");
const $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $cfb29b4841d4c7f6$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $5oqMG.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $2GBsX.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        label: ariaLabel,
        id: $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleLabel, {
        htmlFor: $cfb29b4841d4c7f6$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cfb29b4841d4c7f6$var$PanelToggleHint, {
        id: $cfb29b4841d4c7f6$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $2GBsX.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$cfb29b4841d4c7f6$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};
var $cfb29b4841d4c7f6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $2qhQi.default), (0, $eUqFw.memo), (0, $eGI9v.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($cfb29b4841d4c7f6$var$PanelToggle);
const $cfb29b4841d4c7f6$var$PanelToggleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleControl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfb29b4841d4c7f6$var$PanelToggleHint = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _o5721q9c _11c8qk37 _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



parcelRegister("5oqMG", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $4efb03f3225c562c$export$fa36ece4b5d88abc);

const $4efb03f3225c562c$var$panelShortcuts = {
    Epic: (0, $b9597ab46ec7cd93$export$9b094cdf6fd7589e),
    Version: (0, $b9597ab46ec7cd93$export$6f416a1fb11a53d9)
};
const $4efb03f3225c562c$export$fa36ece4b5d88abc = (panelType)=>$4efb03f3225c562c$var$panelShortcuts[panelType];

});
const $b9597ab46ec7cd93$export$a10c132b86ae798b = 'Epic';
const $b9597ab46ec7cd93$export$41073ac826c57195 = 'Version';
const $b9597ab46ec7cd93$export$9b094cdf6fd7589e = 'E';
const $b9597ab46ec7cd93$export$6f416a1fb11a53d9 = 'V';


parcelRegister("2GBsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d484359a982a7b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $01d484359a982a7b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("4q4xB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b803d9be02c7a9c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b803d9be02c7a9c9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    }
});

});

parcelRegister("o0yPF", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $4e0754c0a543f63b$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $4e0754c0a543f63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $2eG9N = parcelRequire("2eG9N");

var $c9TLT = parcelRequire("c9TLT");
const $4e0754c0a543f63b$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$Icon, {
        src: iconUrl,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionLabel, null, label));
const $4e0754c0a543f63b$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e0754c0a543f63b$var$SelectOptionSubLabel, null, subLabel));
};
$4e0754c0a543f63b$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $4e0754c0a543f63b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($4e0754c0a543f63b$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e0754c0a543f63b$var$SelectOptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$SelectOptionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _syaz1e9r _1wyb1skh",
            __cmplp.className
        ])
    });
});
const $4e0754c0a543f63b$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_zb0g5d": (0, $9t7rW.default)((0, $c9TLT.layout).issueIconSize, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsbwrp2 _4t3iwrp2 _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iRoug", function(module, exports) {

$parcel$export(module.exports, "default", () => $2627b6651f6d491e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $c6CvK = parcelRequire("c6CvK");

var $fCmfi = parcelRequire("fCmfi");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $2eG9N = parcelRequire("2eG9N");

var $eI5EY = parcelRequire("eI5EY");

var $2KzVh = parcelRequire("2KzVh");

var $8WuJm = parcelRequire("8WuJm");

var $8rQuz = parcelRequire("8rQuz");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2627b6651f6d491e$var$FilterListTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const primaryColor = isOpen ? "var(--ds-icon-selected, #0052CC)" : "var(--ds-icon, #44546F)";
    const IconComponent = isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCmfi))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))),
        LEGACY_primaryColor: primaryColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6CvK))), {
        label: "",
        color: primaryColor,
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
        LEGACY_primaryColor: primaryColor
    });
    const inputRef = (0, $eUqFw.useRef)();
    const isMounted = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $2KzVh.mergeRefs)(ref, inputRef) : ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            !isNested && $2627b6651f6d491e$var$containerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$StyledButton, {
        ...popupProps,
        ref: conditionalRef,
        isNested: isNested,
        isSelected: isOpen || (0, $8rQuz.isVisualRefreshEnabled)() && selectedCount > 0,
        shouldFitContainer: isNested,
        appearance: (0, $8rQuz.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onMouseEnter: onMouseEnter,
        iconAfter: (0, $8rQuz.isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
        ...(0, $eI5EY.fg)('allow_jplat_filter_list_to_be_disabled') && {
            isDisabled: isDisabled || false
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$TriggerLabel, null, label), selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2627b6651f6d491e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "primary"
    }, selectedCount)))))));
});
var $2627b6651f6d491e$export$2e2bcd8739ae039 = $2627b6651f6d491e$var$FilterListTrigger;
const $2627b6651f6d491e$var$containerStyles = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $2627b6651f6d491e$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$CountWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$TriggerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2627b6651f6d491e$var$TriggerLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f68cl _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2KzVh", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $0be6a57b715845c4$export$c9058316764c140e);
$parcel$export(module.exports, "default", () => $0be6a57b715845c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0be6a57b715845c4$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref != null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref.current = value; // eslint-disable-line no-param-reassign
        });
    };
}
function $0be6a57b715845c4$export$2e2bcd8739ae039(...refs) {
    return (0, $eUqFw.useMemo)(()=>$0be6a57b715845c4$export$c9058316764c140e(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs);
}

});


parcelRegister("kCSUv", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $d5275d028e90805a$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $d5275d028e90805a$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $d5275d028e90805a$export$62d9d395b3dd2ae8);

var $cEc3i = parcelRequire("cEc3i");

var $bBKri = parcelRequire("bBKri");
const $d5275d028e90805a$var$isValueGroupOption = (value)=>'options' in value;
const $d5275d028e90805a$var$containsOnlyOption = (values)=>values.every((value)=>!$d5275d028e90805a$var$isValueGroupOption(value));
const $d5275d028e90805a$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $d5275d028e90805a$var$containsOnlyOption(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $d5275d028e90805a$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$d5275d028e90805a$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $d5275d028e90805a$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $bBKri.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $bBKri.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $bBKri.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $bBKri.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $cEc3i.c)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};

});


parcelRegister("kg1NY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5879aa2c2945603c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5879aa2c2945603c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    environmentLabel: {
        "id": "software-deployments.top-filters.environment-filter.environment-label",
        "defaultMessage": "Environment"
    },
    production: {
        "id": "software-deployments.top-filters.environment-filter.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "software-deployments.top-filters.environment-filter.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "software-deployments.top-filters.environment-filter.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "software-deployments.top-filters.environment-filter.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "software-deployments.top-filters.environment-filter.unmapped",
        "defaultMessage": "Unmapped"
    },
    maxEnvironmentNamesTooltip: {
        "id": "software-deployments.top-filters.environment-filter.max-environment-names-tooltip",
        "defaultMessage": "Max. number of environments selected"
    }
});

});


parcelRegister("ljKtM", function(module, exports) {

$parcel$export(module.exports, "useFormatEnvironmentType", () => $e2f271b03c843d1f$export$c9a6f0987af1f650);
$parcel$export(module.exports, "useSelectState", () => $e2f271b03c843d1f$export$5159ec8b34d4ec12);

var $iVIEg = parcelRequire("iVIEg");

var $1urNG = parcelRequire("1urNG");

var $5JgJ2 = parcelRequire("5JgJ2");

var $yevjV = parcelRequire("yevjV");

var $6go3X = parcelRequire("6go3X");

var $2crkH = parcelRequire("2crkH");

var $6QrnC = parcelRequire("6QrnC");

var $a0JSi = parcelRequire("a0JSi");
// Determines the order the environment types will be displayed in the menu
const $e2f271b03c843d1f$var$orderedEnvironmentTypes = [
    (0, $yevjV.DeploymentEnvironmentTypeOptions).PRODUCTION,
    (0, $yevjV.DeploymentEnvironmentTypeOptions).STAGING,
    (0, $yevjV.DeploymentEnvironmentTypeOptions).TESTING,
    (0, $yevjV.DeploymentEnvironmentTypeOptions).DEVELOPMENT,
    (0, $yevjV.DeploymentEnvironmentTypeOptions).UNMAPPED
];
const $e2f271b03c843d1f$var$hasType = (type)=>(environment)=>environment.type === type;
const $e2f271b03c843d1f$export$ceb72384e9f84237 = (allEnvironments, formatForDisplay, formatMessage)=>{
    const toEnvironmentTypeCheckboxEntry = (type)=>({
            label: formatMessage((0, $a0JSi.default).allEnvironmentSelectLabel, {
                envType: formatForDisplay(type)
            }),
            value: (0, $6QrnC.entryIdFromEnvironmentType)(type)
        });
    const toEnvironmentNameCheckboxEntry = (environment)=>({
            label: environment.displayName,
            value: (0, $6QrnC.entryIdFromEnvironment)(environment)
        });
    const orderedExistingEnvTypes = $e2f271b03c843d1f$var$orderedEnvironmentTypes.filter((type)=>allEnvironments.some($e2f271b03c843d1f$var$hasType(type)));
    const entries = orderedExistingEnvTypes.map((type)=>toEnvironmentTypeCheckboxEntry(type));
    return entries.concat(orderedExistingEnvTypes.map((type)=>({
            label: formatForDisplay(type),
            options: allEnvironments.filter($e2f271b03c843d1f$var$hasType(type)).map(toEnvironmentNameCheckboxEntry)
        })));
};
const $e2f271b03c843d1f$export$901d275de8107a21 = (environmentTypeConcatNamesFilter, allEnvironments)=>{
    const areAllEnvironmentsWithTypeSelected = (type)=>{
        const environmentsWithType = allEnvironments.filter($e2f271b03c843d1f$var$hasType(type));
        return environmentsWithType.length > 0 && environmentsWithType.every((environment)=>environmentTypeConcatNamesFilter.includes((0, $6QrnC.composeEnvironmentKey)(environment.type, environment.displayName)));
    };
    const environmentTypeEntryIds = $e2f271b03c843d1f$var$orderedEnvironmentTypes.filter(areAllEnvironmentsWithTypeSelected).map((0, $6QrnC.entryIdFromEnvironmentType));
    return [
        ...environmentTypeEntryIds,
        ...environmentTypeConcatNamesFilter.map((0, $6QrnC.entryIdFromEnvironmentTypeConcatName))
    ];
};
const $e2f271b03c843d1f$var$getEnvironmentNames = (entryIds)=>entryIds.flatMap((entryId)=>(0, $6QrnC.matchEntryId)(entryId, {
            environmentName: (name)=>[
                    name
                ],
            environmentType: ()=>[]
        }));
const $e2f271b03c843d1f$var$getEnvironmentTypes = (entryIds)=>entryIds.flatMap((entryId)=>(0, $6QrnC.matchEntryId)(entryId, {
            environmentName: ()=>[],
            environmentType: (type)=>[
                    type
                ]
        }));
const $e2f271b03c843d1f$var$getEnvironmentNamesForType = (type, environments)=>environments.filter($e2f271b03c843d1f$var$hasType(type)).map((environment)=>(0, $6QrnC.composeEnvironmentKey)(environment.type, environment.displayName));
const $e2f271b03c843d1f$export$f25b03955a6688f8 = (prevSelectedEntryIds, nextSelectedEntryIds, allEnvironments)=>{
    const nextSelectedEnvironmentNames = $e2f271b03c843d1f$var$getEnvironmentNames(nextSelectedEntryIds);
    const nextSelectedEnvironmentTypes = $e2f271b03c843d1f$var$getEnvironmentTypes(nextSelectedEntryIds);
    const prevSelectedEnvironmentTypes = $e2f271b03c843d1f$var$getEnvironmentTypes(prevSelectedEntryIds);
    // Determine which environment types the user just *deselected*
    const environmentNamesForNewlyDeselectedEnvironmentTypes = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(prevSelectedEnvironmentTypes, nextSelectedEnvironmentTypes).flatMap((type)=>$e2f271b03c843d1f$var$getEnvironmentNamesForType(type, allEnvironments));
    // Determine which environment types the user just *selected*
    const environmentNamesForNewlySelectedEnvironmentTypes = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(nextSelectedEnvironmentTypes, prevSelectedEnvironmentTypes).flatMap((type)=>$e2f271b03c843d1f$var$getEnvironmentNamesForType(type, allEnvironments));
    // Determine the next environment names filter by:
    // 1. Starting with the next selected names.
    // 2. Removing names that correspond to environment types that were just *deselected*.
    // 3. Adding names that correspond to environment types that were just *selected*.
    return (0, (/*@__PURE__*/$parcel$interopDefault($1urNG)))((0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(nextSelectedEnvironmentNames, environmentNamesForNewlyDeselectedEnvironmentTypes), environmentNamesForNewlySelectedEnvironmentTypes);
};
const $e2f271b03c843d1f$export$c9a6f0987af1f650 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const labels = {
        PRODUCTION: formatMessage((0, $a0JSi.default).production),
        STAGING: formatMessage((0, $a0JSi.default).staging),
        TESTING: formatMessage((0, $a0JSi.default).testing),
        DEVELOPMENT: formatMessage((0, $a0JSi.default).development),
        UNMAPPED: formatMessage((0, $a0JSi.default).unmapped)
    };
    return (type)=>labels[type];
};
const $e2f271b03c843d1f$export$5159ec8b34d4ec12 = (formatForDisplay)=>{
    const allEnvironments = (0, $2crkH.useAllEnvironments)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const entries = $e2f271b03c843d1f$export$ceb72384e9f84237(allEnvironments, formatForDisplay, formatMessage);
    const [environmentTypeConcatNamesFilter, actions] = (0, $6go3X.useEnvironmentTypeConcatNamesFilter)();
    const selectedEntryIds = $e2f271b03c843d1f$export$901d275de8107a21(environmentTypeConcatNamesFilter, allEnvironments);
    const onChange = (nextSelectedEntries)=>{
        const nextSelectedEntryIds = nextSelectedEntries.map((entry)=>(0, $6QrnC.entryIdFromRawString)(entry.value));
        const nextEnvironmentTypeConcatNamesFilter = $e2f271b03c843d1f$export$f25b03955a6688f8(selectedEntryIds, nextSelectedEntryIds, allEnvironments);
        actions.setEnvironmentFilter(nextEnvironmentTypeConcatNamesFilter.map((0, $6QrnC.extractEnvNameFromEnvironmentKey)));
        actions.setEnvironmentTypeConcatNameFilter(nextEnvironmentTypeConcatNamesFilter);
    };
    return {
        entries: entries,
        selectedEntryIds: selectedEntryIds.map((0, $6QrnC.entryIdToRawString)),
        onChange: onChange
    };
};

});
parcelRegister("1urNG", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $42tFs = parcelRequire("42tFs");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $115e28588d963fcd$var$union = $9eFtX(function(arrays) {
    return $42tFs($hKE3p(arrays, 1, $cRpul, true));
});
module.exports = $115e28588d963fcd$var$union;

});

parcelRegister("2crkH", function(module, exports) {

$parcel$export(module.exports, "useAllEnvironments", () => $46c8a1cfdd53361e$export$f7b9544ae9810d91);

var $eUqFw = parcelRequire("eUqFw");

var $OwuLI = parcelRequire("OwuLI");
const $46c8a1cfdd53361e$export$f7b9544ae9810d91 = ()=>{
    const { current: allKnownEnvironments } = (0, $eUqFw.useRef)(new Map());
    const { data: deploymentsForCurrentFilters = [] } = (0, $OwuLI.useAllDeployments)();
    deploymentsForCurrentFilters.forEach(({ environment: environment })=>{
        // Environment name could be same but type could be different. For customer example, https://getsupport.atlassian.com/browse/PCS-178628
        allKnownEnvironments.set(`${environment.type}-${environment.displayName}`, environment);
    });
    return [
        ...allKnownEnvironments.values()
    ];
};

});

parcelRegister("6QrnC", function(module, exports) {

$parcel$export(module.exports, "entryIdFromEnvironmentType", () => $a091f607fc6e85e8$export$48e2c8026a8e652d);
$parcel$export(module.exports, "entryIdFromEnvironmentTypeConcatName", () => $a091f607fc6e85e8$export$b36310211cf7f961);
$parcel$export(module.exports, "composeEnvironmentKey", () => $a091f607fc6e85e8$export$29cf5950ef114e3b);
$parcel$export(module.exports, "entryIdFromEnvironment", () => $a091f607fc6e85e8$export$8b6f70eb1ee2277d);
$parcel$export(module.exports, "entryIdFromRawString", () => $a091f607fc6e85e8$export$c8b5bc737290822d);
$parcel$export(module.exports, "entryIdToRawString", () => $a091f607fc6e85e8$export$26b35851b5c28cc6);
$parcel$export(module.exports, "extractEnvNameFromEnvironmentKey", () => $a091f607fc6e85e8$export$e81646f430fb5ada);
$parcel$export(module.exports, "matchEntryId", () => $a091f607fc6e85e8$export$499263ee168aaa89);

var $yevjV = parcelRequire("yevjV");
const $a091f607fc6e85e8$export$48e2c8026a8e652d = (type)=>`environment-type:${type}`;
const $a091f607fc6e85e8$export$1272cc3a2afd70e6 = (name)=>`environment-name:${name}`;
const $a091f607fc6e85e8$export$b36310211cf7f961 = (name)=>`environment-name:${name}`;
const $a091f607fc6e85e8$export$ab1e5d315f2a6266 = (type, name)=>`environment-name:${$a091f607fc6e85e8$export$29cf5950ef114e3b(type, name)}`;
const $a091f607fc6e85e8$export$8b6f70eb1ee2277d = (environemnt)=>$a091f607fc6e85e8$export$ab1e5d315f2a6266(environemnt.type, environemnt.displayName);
const $a091f607fc6e85e8$export$c8b5bc737290822d = (value)=>{
    if (value.startsWith('environment-type:') || value.startsWith('environment-name:')) return value;
    throw new Error('Invalid entry ID');
};
const $a091f607fc6e85e8$export$26b35851b5c28cc6 = (entryId)=>entryId;
const $a091f607fc6e85e8$export$29cf5950ef114e3b = (type, name)=>`${type}-${name}`;
const $a091f607fc6e85e8$export$e81646f430fb5ada = (key)=>key.slice(key.indexOf('-') + 1);
const $a091f607fc6e85e8$export$499263ee168aaa89 = (entryId, handlers)=>{
    const separatorIndex = entryId.indexOf(':');
    const entryKind = entryId.slice(0, separatorIndex);
    const entryValue = entryId.slice(separatorIndex + 1);
    if (entryKind === 'environment-type') {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly PRODUCTION: "PRODUCTION"; readonly STAGING: "STAGING"; readonly TESTING: "TESTING"; readonly DEVELOPMENT: "DEVELOPMENT"; readonly UNMAPPED: "UNMAPPED"; }'.
        const environmentType = (0, $yevjV.DeploymentEnvironmentTypeOptions)[entryValue];
        return handlers.environmentType(environmentType);
    }
    if (entryKind === 'environment-name') return handlers.environmentName(entryValue);
    throw new Error('Invalid entry ID');
};

});

parcelRegister("a0JSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f973a9b889ccd85a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f973a9b889ccd85a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    allEnvironmentSelectLabel: {
        "id": "software-deployments.top-filters.environment-filter.utils.all-environment-select-label",
        "defaultMessage": "All {envType} environments"
    },
    production: {
        "id": "software-deployments.top-filters.environment-filter.utils.production",
        "defaultMessage": "Production"
    },
    staging: {
        "id": "software-deployments.top-filters.environment-filter.utils.staging",
        "defaultMessage": "Staging"
    },
    testing: {
        "id": "software-deployments.top-filters.environment-filter.utils.testing",
        "defaultMessage": "Testing"
    },
    development: {
        "id": "software-deployments.top-filters.environment-filter.utils.development",
        "defaultMessage": "Development"
    },
    unmapped: {
        "id": "software-deployments.top-filters.environment-filter.utils.unmapped",
        "defaultMessage": "Unmapped"
    }
});

});


parcelRegister("7CPPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $90bccfa4e8fcca40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cNGJr = parcelRequire("cNGJr");

var $37gdQ = parcelRequire("37gdQ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6vrw7 = parcelRequire("6vrw7");

var $2YZvw = parcelRequire("2YZvw");

var $fWtJD = parcelRequire("fWtJD");

var $i0pTQ = parcelRequire("i0pTQ");
// ParentFilter expects IssueId and doesn't support an unassigned type
// so we transform UNASSIGNED_EPIC_ID in and out of IssueId in this component
const $90bccfa4e8fcca40$var$EpicFilter = ({ isNested: isNested, selectedValues: selectedValues, onChange: onChange })=>{
    // real-time input changes
    const [epicInputText, setEpicInputText] = (0, $eUqFw.useState)('');
    // debounced input changes
    const [epicSearchText, setEpicSearchText] = (0, $eUqFw.useState)('');
    const { data: data, error: error, loading: loading } = (0, $fWtJD.useEpics)(epicSearchText);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issueParents = (0, $eUqFw.useMemo)(()=>{
        if (error) throw error;
        if (!data) return [];
        const partialParents = data.map(({ id: id, summary: summary })=>({
                id: (0, $6vrw7.toIssueId)(id),
                name: summary
            }));
        return partialParents && partialParents.length && epicSearchText === '' ? [
            {
                id: (0, $6vrw7.toIssueId)((0, $2YZvw.UNASSIGNED_EPIC_ID)),
                name: formatMessage((0, $i0pTQ.default).unassigned)
            },
            ...partialParents
        ] : partialParents;
    }, [
        data,
        epicSearchText,
        error,
        formatMessage
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [searchEpic] = (0, $cNGJr.default)(setEpicSearchText, (0, $2YZvw.DEBOUNCE_MILLISECONDS));
    (0, $eUqFw.useEffect)(()=>{
        searchEpic(epicInputText);
    }, [
        epicInputText,
        searchEpic
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37gdQ.default), {
        label: "Epic",
        parents: issueParents,
        selectedParents: selectedValues.map((0, $6vrw7.toIssueId)),
        inputValue: epicInputText,
        isLoading: loading,
        isAsyncSearch: true,
        onChange: (selectedParents)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'deploymentsEpicFilter'
            }));
            onChange(selectedParents.map((id)=>id === (0, $6vrw7.toIssueId)((0, $2YZvw.UNASSIGNED_EPIC_ID)) ? (0, $2YZvw.UNASSIGNED_EPIC_ID) : id));
        },
        onInputChange: (input, { action: action })=>{
            if (action === 'input-change') setEpicInputText(input);
        },
        showMenuIfValuesAreEmpty: true,
        isNested: isNested
    });
};
var $90bccfa4e8fcca40$export$2e2bcd8739ae039 = $90bccfa4e8fcca40$var$EpicFilter;

});
parcelRegister("37gdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89b7bf9c6af5f6d4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");

var $6vrw7 = parcelRequire("6vrw7");

var $3kYjh = parcelRequire("3kYjh");

var $8MrYx = parcelRequire("8MrYx");

var $lB25E = parcelRequire("lB25E");

var $azooe = parcelRequire("azooe");

var $9kkzA = parcelRequire("9kkzA");
const $89b7bf9c6af5f6d4$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $lB25E.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $8MrYx.useViewSettingsActions)();
    const values = (0, $eUqFw.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $6vrw7.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $eUqFw.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $3kYjh.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: label,
        toggleLabel: formatMessage((0, $9kkzA.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9kkzA.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton
    }));
};
$89b7bf9c6af5f6d4$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $89b7bf9c6af5f6d4$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($89b7bf9c6af5f6d4$var$ParentFilter);

});
parcelRegister("3kYjh", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $c7ac9f0e85497714$export$b6da678b61e4982c);

var $c3qrZ = parcelRequire("c3qrZ");

var $kqmep = parcelRequire("kqmep");
const $c7ac9f0e85497714$export$b6da678b61e4982c = {
    ...(0, $c3qrZ.Panels),
    ...(0, $kqmep.CardDetails),
    ...(0, $c3qrZ.IncrementPlanningSettings),
    QUICK_FILTERS: $c3qrZ.QUICK_FILTERS,
    COMPACT_MODE: $c3qrZ.COMPACT_MODE
};

});
parcelRegister("c3qrZ", function(module, exports) {

$parcel$export(module.exports, "View", () => $8eb6b75af7e82572$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $8eb6b75af7e82572$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $8eb6b75af7e82572$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $8eb6b75af7e82572$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $8eb6b75af7e82572$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $8eb6b75af7e82572$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $8eb6b75af7e82572$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $8eb6b75af7e82572$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $8eb6b75af7e82572$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $8eb6b75af7e82572$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $8eb6b75af7e82572$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $8eb6b75af7e82572$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $8eb6b75af7e82572$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $8eb6b75af7e82572$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $8eb6b75af7e82572$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_DEVELOPMENT", () => $8eb6b75af7e82572$export$e7b5d3d062c615d5);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $8eb6b75af7e82572$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $8eb6b75af7e82572$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $8eb6b75af7e82572$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $8eb6b75af7e82572$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $8eb6b75af7e82572$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "Panels", () => $8eb6b75af7e82572$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $8eb6b75af7e82572$export$ad46e765f851721f);
const $8eb6b75af7e82572$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $8eb6b75af7e82572$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $8eb6b75af7e82572$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $8eb6b75af7e82572$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $8eb6b75af7e82572$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $8eb6b75af7e82572$export$41073ac826c57195 = 'VERSION_PANEL';
const $8eb6b75af7e82572$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $8eb6b75af7e82572$export$59191afd909777e0 = 'QUICK_FILTERS';
const $8eb6b75af7e82572$export$abd09d2531440e47 = 'COMPACT_MODE';
const $8eb6b75af7e82572$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $8eb6b75af7e82572$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $8eb6b75af7e82572$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $8eb6b75af7e82572$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $8eb6b75af7e82572$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $8eb6b75af7e82572$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $8eb6b75af7e82572$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $8eb6b75af7e82572$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $8eb6b75af7e82572$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $8eb6b75af7e82572$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
const $8eb6b75af7e82572$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $8eb6b75af7e82572$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $8eb6b75af7e82572$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $8eb6b75af7e82572$export$63993996bfd99919 = 'SHOW_LABELS';
const $8eb6b75af7e82572$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $8eb6b75af7e82572$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
const $8eb6b75af7e82572$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $8eb6b75af7e82572$export$b94e9de8950563ef = {
    VERSION_PANEL: $8eb6b75af7e82572$export$41073ac826c57195,
    EPIC_PANEL: $8eb6b75af7e82572$export$86bfe5c9d2cf6b7c
};
const $8eb6b75af7e82572$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $8eb6b75af7e82572$export$c3308fa11d994bc5,
    SHOW_OFFTRACK_DEPENDENCY_LINES: $8eb6b75af7e82572$export$ecec86e489253c13,
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: $8eb6b75af7e82572$export$79b3cada7e291288
};

});

parcelRegister("kqmep", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $17487e014d4eeb0c$export$741386389156bf07);

var $c3qrZ = parcelRequire("c3qrZ");
const $17487e014d4eeb0c$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $c3qrZ.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $c3qrZ.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $c3qrZ.SHOW_EPICS,
    SHOW_STATUSES: $c3qrZ.SHOW_STATUSES,
    SHOW_VERSIONS: $c3qrZ.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $c3qrZ.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $c3qrZ.SHOW_PRIORITY,
    SHOW_DEVELOPMENT: $c3qrZ.SHOW_DEVELOPMENT,
    SHOW_ASSIGNEE: $c3qrZ.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $c3qrZ.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $c3qrZ.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $c3qrZ.SHOW_DUE_DATE,
    SHOW_LABELS: $c3qrZ.SHOW_LABELS,
    SHOW_CARD_COVERS: $c3qrZ.SHOW_CARD_COVERS
};

});


parcelRegister("8MrYx", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $40a687938ce25904$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $40a687938ce25904$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $40a687938ce25904$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $40a687938ce25904$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $40a687938ce25904$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $40a687938ce25904$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $40a687938ce25904$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $40a687938ce25904$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $40a687938ce25904$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $40a687938ce25904$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $40a687938ce25904$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $40a687938ce25904$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $40a687938ce25904$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $40a687938ce25904$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $40a687938ce25904$export$be6bf1e24771efde);
$parcel$export(module.exports, "useShowCardCovers", () => $40a687938ce25904$export$77ff271d002b6f7e);
$parcel$export(module.exports, "useHasCardExtraFields", () => $40a687938ce25904$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $40a687938ce25904$export$e41d531469117029);
$parcel$export(module.exports, "useShowOfftrackDependencyLines", () => $40a687938ce25904$export$e709b26074f3a4a5);
$parcel$export(module.exports, "useIssueIdsToShowDependencies", () => $40a687938ce25904$export$b6fb171038a9e77e);

var $WBLbN = parcelRequire("WBLbN");

var $jyKDT = parcelRequire("jyKDT");

var $cMFHk = parcelRequire("cMFHk");

var $2R2bz = parcelRequire("2R2bz");
const $40a687938ce25904$var$Store = (0, $WBLbN.createStore)({
    name: 'ViewSettings',
    initialState: $jyKDT.initialState,
    actions: $cMFHk.actions
});
const $40a687938ce25904$export$920204d7413f6fe1 = (0, $WBLbN.createContainer)($40a687938ce25904$var$Store, {
    onInit: (0, $cMFHk.actions).initState
});
const $40a687938ce25904$export$704cffd05c51e2b6 = (0, $WBLbN.createHook)($40a687938ce25904$var$Store);
const $40a687938ce25904$export$d6a70239aff099b8 = (0, $WBLbN.createActionsHook)($40a687938ce25904$var$Store);
const $40a687938ce25904$export$d397eccea5f37b0a = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getIsFullscreen)
});
const $40a687938ce25904$export$459b400687bc0f20 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowVersionPanel)
});
const $40a687938ce25904$export$203c9a05aebea04a = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEpicPanel)
});
const $40a687938ce25904$export$714ba21e90859f45 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowQuickFilters)
});
const $40a687938ce25904$export$8a591bb42a805814 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCompactMode)
});
const $40a687938ce25904$export$736bfa164a60e240 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowPanels)
});
const $40a687938ce25904$export$ecaca052f9755b4e = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEpics)
});
const $40a687938ce25904$export$10178a1fc177e27a = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowVersions)
});
const $40a687938ce25904$export$7a14d92e68e42de1 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowStatuses)
});
const $40a687938ce25904$export$afb23457b0007ce7 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowUnscheduledColumn)
});
const $40a687938ce25904$export$1d584d816be8e0fd = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueLinksStats)
});
const $40a687938ce25904$export$c94c02788702c7e4 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueType)
});
const $40a687938ce25904$export$8007ae8b25a75629 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowIssueKey)
});
const $40a687938ce25904$export$75223d65852dc3c0 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowPriority)
});
const $40a687938ce25904$export$eac20fb60c7f35ac = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowDevelopment)
});
const $40a687938ce25904$export$be6bf1e24771efde = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowAssignee)
});
const $40a687938ce25904$export$b5a76590347456cc = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowEstimate)
});
const $40a687938ce25904$export$5e8e69c97a3cd45b = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCardExtraField)
});
const $40a687938ce25904$export$a53839ab3a916ce3 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowDaysInColumn)
});
const $40a687938ce25904$export$77ff271d002b6f7e = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowCardCovers)
});
const $40a687938ce25904$export$9e1ece2ef34a030 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getHasCardExtraFields)
});
const $40a687938ce25904$export$e41d531469117029 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getCardFieldsSettings)
});
const $40a687938ce25904$export$e709b26074f3a4a5 = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getShowOfftrackDependencyLines)
});
const $40a687938ce25904$export$b6fb171038a9e77e = (0, $WBLbN.createStateHook)($40a687938ce25904$var$Store, {
    selector: (0, $2R2bz.getIssueIdsToShowDependencies)
});

});
parcelRegister("jyKDT", function(module, exports) {

$parcel$export(module.exports, "VIEW_SETTINGS", () => $d03619c6ca5a0718$export$f900da9acbf1ac33);
$parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", () => $d03619c6ca5a0718$export$752f3d44db2fbd2d);
$parcel$export(module.exports, "initialState", () => $d03619c6ca5a0718$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "boardViewTestIds", () => $d03619c6ca5a0718$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $d03619c6ca5a0718$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $d03619c6ca5a0718$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $d03619c6ca5a0718$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $d03619c6ca5a0718$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $d03619c6ca5a0718$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $d03619c6ca5a0718$export$c0d46007b8549aca);
const $d03619c6ca5a0718$export$f900da9acbf1ac33 = 'view-settings';
const $d03619c6ca5a0718$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $d03619c6ca5a0718$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: false,
    showOfftrackDependencyLines: false,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $d03619c6ca5a0718$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $d03619c6ca5a0718$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog'
};
const $d03619c6ca5a0718$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $d03619c6ca5a0718$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $d03619c6ca5a0718$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $d03619c6ca5a0718$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $d03619c6ca5a0718$export$c0d46007b8549aca = 'on';
const $d03619c6ca5a0718$export$788a94e8107fb947 = 'off';

});

parcelRegister("cMFHk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $09be8f99c8e5e595$export$e324594224ef24da);

var $4E7nZ = parcelRequire("4E7nZ");
const $09be8f99c8e5e595$export$e324594224ef24da = {
    setViewSettings: $4E7nZ.setViewSettings,
    setIsFullscreen: $4E7nZ.setIsFullscreen,
    setViewSettingsPanels: $4E7nZ.setViewSettingsPanels,
    setViewSettingsQuickFilters: $4E7nZ.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $4E7nZ.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $4E7nZ.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $4E7nZ.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $4E7nZ.setShowUnscheduledColumn,
    setShowOfftrackDependencyLines: $4E7nZ.setShowOfftrackDependencyLines,
    setIssueIdsToShowDependencies: $4E7nZ.setIssueIdsToShowDependencies,
    setViewSettingsShowCardCovers: $4E7nZ.setViewSettingsShowCardCovers,
    toggleViewSetting: $4E7nZ.toggleViewSetting,
    toggleShowEpics: $4E7nZ.toggleShowEpics,
    toggleShowVersions: $4E7nZ.toggleShowVersions,
    toggleShowStatuses: $4E7nZ.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $4E7nZ.toggleShowLinkedIssuesStats,
    toggleExtraField: $4E7nZ.toggleExtraField,
    toggleShowDaysInColumn: $4E7nZ.toggleShowDaysInColumn,
    toggleShowDueDate: $4E7nZ.toggleShowDueDate,
    toggleShowLabels: $4E7nZ.toggleShowLabels,
    initState: $4E7nZ.initState
};

});
parcelRegister("4E7nZ", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b676a0d483ac8166$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b676a0d483ac8166$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b676a0d483ac8166$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b676a0d483ac8166$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b676a0d483ac8166$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b676a0d483ac8166$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b676a0d483ac8166$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b676a0d483ac8166$export$b54537ba70def946);
$parcel$export(module.exports, "setViewSettingsShowCardCovers", () => $b676a0d483ac8166$export$d166622a8f3a93f0);
$parcel$export(module.exports, "toggleViewSetting", () => $b676a0d483ac8166$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b676a0d483ac8166$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b676a0d483ac8166$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b676a0d483ac8166$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b676a0d483ac8166$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b676a0d483ac8166$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b676a0d483ac8166$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b676a0d483ac8166$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b676a0d483ac8166$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b676a0d483ac8166$export$6acb0c83c20a20);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $b676a0d483ac8166$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $b676a0d483ac8166$export$f7b68cb584e33d77);

var $3kYjh = parcelRequire("3kYjh");

var $cNacc = parcelRequire("cNacc");
const $b676a0d483ac8166$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b676a0d483ac8166$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b676a0d483ac8166$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b676a0d483ac8166$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b676a0d483ac8166$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b676a0d483ac8166$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b676a0d483ac8166$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS
        });
    };
const $b676a0d483ac8166$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b676a0d483ac8166$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const newState = {
            ...currentSettings,
            showCardCovers: showCardCovers
        };
        $cNacc.setViewSettings({
            boardId: boardId,
            state: newState,
            view: view || currentSettings.view || undefined
        });
        setState(newState);
    };
const $b676a0d483ac8166$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $cNacc.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $3kYjh.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $3kYjh.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $3kYjh.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $3kYjh.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DEVELOPMENT:
                set({
                    ...currentSettings,
                    showDevelopment: !currentSettings.showDevelopment
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            case (0, $3kYjh.ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                set({
                    ...currentSettings,
                    showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                });
                break;
            default:
                break;
        }
    };
const $b676a0d483ac8166$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b676a0d483ac8166$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b676a0d483ac8166$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b676a0d483ac8166$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b676a0d483ac8166$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b676a0d483ac8166$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b676a0d483ac8166$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b676a0d483ac8166$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b676a0d483ac8166$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $cNacc.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };
const $b676a0d483ac8166$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setShowOfftrackDependencyLines({
            boardId: boardId,
            showOfftrackDependencyLines: isVisible
        });
        setState({
            ...currentSettings,
            showOfftrackDependencyLines: isVisible
        });
    };
const $b676a0d483ac8166$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $cNacc.setIssueIdsToShowDependencies({
            boardId: boardId,
            issueIds: issueIds
        });
        setState({
            ...currentSettings,
            issueIdsToShowDependencies: issueIds
        });
    };

});
parcelRegister("cNacc", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $168332c15e8ca043$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $168332c15e8ca043$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $168332c15e8ca043$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $168332c15e8ca043$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $168332c15e8ca043$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $168332c15e8ca043$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $168332c15e8ca043$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $168332c15e8ca043$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $168332c15e8ca043$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $168332c15e8ca043$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $168332c15e8ca043$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $168332c15e8ca043$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $168332c15e8ca043$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $168332c15e8ca043$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $168332c15e8ca043$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $168332c15e8ca043$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $168332c15e8ca043$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $168332c15e8ca043$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $168332c15e8ca043$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $168332c15e8ca043$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $168332c15e8ca043$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $168332c15e8ca043$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $168332c15e8ca043$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $168332c15e8ca043$export$b24e660e664a6bba);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $168332c15e8ca043$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $168332c15e8ca043$export$32c01395d25dfdcc);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $168332c15e8ca043$export$f7b68cb584e33d77);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $168332c15e8ca043$export$67e6bba1326e537a);

var $aZaPn = parcelRequire("aZaPn");

var $jyKDT = parcelRequire("jyKDT");

var $c3qrZ = parcelRequire("c3qrZ");

var $6eyW6 = parcelRequire("6eyW6");
const $168332c15e8ca043$var$browserLocalStorage = (0, $aZaPn.createLocalStorageProvider)((0, $jyKDT.VIEW_SETTINGS_LOCAL_STORAGE));
const $168332c15e8ca043$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD) return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $6eyW6.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $c3qrZ.View).BACKLOG:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).BACKLOG}`;
        case (0, $c3qrZ.View).BOARD:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).BOARD}`;
        case (0, $c3qrZ.View).JSM_BOARD:
            return `${0, $jyKDT.VIEW_SETTINGS}-${(0, $c3qrZ.View).JSM_BOARD}`;
        default:
            return 0, $jyKDT.VIEW_SETTINGS;
    }
    return 0, $jyKDT.VIEW_SETTINGS;
};
const $168332c15e8ca043$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$168332c15e8ca043$var$browserLocalStorage.get(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`) || $168332c15e8ca043$var$browserLocalStorage.get(`${(0, $jyKDT.VIEW_SETTINGS)}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $168332c15e8ca043$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $168332c15e8ca043$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $jyKDT.initialState).isFullscreen;
};
const $168332c15e8ca043$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $jyKDT.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $jyKDT.initialState).showVersionPanel
    };
};
const $168332c15e8ca043$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, state);
const $168332c15e8ca043$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $168332c15e8ca043$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $c3qrZ.Panels).EPIC_PANEL) $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $c3qrZ.Panels).VERSION_PANEL) $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $168332c15e8ca043$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $jyKDT.initialState).showQuickFilters;
};
const $168332c15e8ca043$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $168332c15e8ca043$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $jyKDT.initialState).showCompactMode;
};
const $168332c15e8ca043$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $168332c15e8ca043$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        SHOW_EPICS: state?.showEpics ?? (0, $jyKDT.initialState).showEpics,
        SHOW_STATUSES: state?.showStatuses ?? (0, $jyKDT.initialState).showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? (0, $jyKDT.initialState).showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? (0, $jyKDT.initialState).showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? (0, $jyKDT.initialState).showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? (0, $jyKDT.initialState).showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? (0, $jyKDT.initialState).showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : (0, $jyKDT.initialState).showPriority) ?? (0, $jyKDT.initialState).showPriority,
        SHOW_DEVELOPMENT: state?.showDevelopment ?? (0, $jyKDT.initialState).showDevelopment,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : (0, $jyKDT.initialState).showEstimate) ?? (0, $jyKDT.initialState).showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : (0, $jyKDT.initialState).showDaysInColumn) ?? (0, $jyKDT.initialState).showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : (0, $jyKDT.initialState).showDueDate) ?? (0, $jyKDT.initialState).showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : (0, $jyKDT.initialState).showLabels) ?? (0, $jyKDT.initialState).showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? (0, $jyKDT.initialState).showCardCovers
    };
};
const $168332c15e8ca043$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS
    });
};
const $168332c15e8ca043$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $168332c15e8ca043$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $168332c15e8ca043$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $168332c15e8ca043$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $168332c15e8ca043$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $168332c15e8ca043$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $168332c15e8ca043$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $168332c15e8ca043$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $jyKDT.initialState).showUnscheduledColumn;
};
const $168332c15e8ca043$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $168332c15e8ca043$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $168332c15e8ca043$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $168332c15e8ca043$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $168332c15e8ca043$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};
const $168332c15e8ca043$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showOfftrackDependencyLines: showOfftrackDependencyLines
    });
};
const $168332c15e8ca043$export$32c01395d25dfdcc = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showOfftrackDependencyLines ?? (0, $jyKDT.initialState).showOfftrackDependencyLines;
};
const $168332c15e8ca043$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    $168332c15e8ca043$var$browserLocalStorage.set(`${$168332c15e8ca043$export$36e24695f02d4503((0, $c3qrZ.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        issueIdsToShowDependencies: issueIds
    });
};
const $168332c15e8ca043$export$67e6bba1326e537a = (boardId)=>{
    const state = $168332c15e8ca043$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $c3qrZ.View).INCREMENT_PLANNING_BOARD
    });
    return state?.issueIdsToShowDependencies ?? (0, $jyKDT.initialState).issueIdsToShowDependencies;
};

});
parcelRegister("6eyW6", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e52899f32986aa87$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e52899f32986aa87$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e52899f32986aa87$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettingsQuery", () => $e52899f32986aa87$export$8bc567645273ba46);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e52899f32986aa87$export$eed360eb853808ee);

var $6HC1D = parcelRequire("6HC1D");

var $53ciZ = parcelRequire("53ciZ");

var $eI5EY = parcelRequire("eI5EY");

const $e52899f32986aa87$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $737beaccda042ec2$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $737beaccda042ec2$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e52899f32986aa87$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $737beaccda042ec2$export$ec3c43b997309252));
    search.unset((0, $737beaccda042ec2$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $737beaccda042ec2$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $737beaccda042ec2$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $e52899f32986aa87$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search);
    if (!(0, $eI5EY.fg)('dependency_visualisation_program_board_fe_and_be')) return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $737beaccda042ec2$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: false,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: []
    };
    const issuesQuery = searchParams[0, $737beaccda042ec2$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $737beaccda042ec2$export$1692762d83d78f09]) : undefined;
    const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
    const issueIdsToShowDependencies = [];
    issuesSplit.forEach((issueId)=>{
        const trimmedIssueId = issueId.trim();
        if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
    });
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $737beaccda042ec2$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $737beaccda042ec2$export$8b0819c4fa234ad] === 'visible' ? true : undefined,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
    };
};
const $e52899f32986aa87$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
    const search = (0, $6HC1D.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(location.search)
    });
    search.unset((0, $737beaccda042ec2$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $737beaccda042ec2$export$bfa26a3d2f080ac5), 'hidden');
    if ((0, $eI5EY.fg)('dependency_visualisation_program_board_fe_and_be')) {
        search.unset((0, $737beaccda042ec2$export$8b0819c4fa234ad));
        search.unset((0, $737beaccda042ec2$export$1692762d83d78f09));
        if (incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $737beaccda042ec2$export$8b0819c4fa234ad), 'visible');
        if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $737beaccda042ec2$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
    }
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(search.value())
    };
};
const $e52899f32986aa87$export$eed360eb853808ee = ()=>(0, $eI5EY.fg)('jira_view_settings_additional_fields');

});
const $737beaccda042ec2$export$ec3c43b997309252 = 'epics';
const $737beaccda042ec2$export$a86c1a6dde9da34f = 'versions';
const $737beaccda042ec2$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $737beaccda042ec2$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $737beaccda042ec2$export$1692762d83d78f09 = 'issueIdsToShowDependencies';





parcelRegister("2R2bz", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $0824ef21329004e5$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $0824ef21329004e5$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $0824ef21329004e5$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $0824ef21329004e5$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $0824ef21329004e5$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $0824ef21329004e5$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $0824ef21329004e5$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $0824ef21329004e5$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $0824ef21329004e5$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $0824ef21329004e5$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $0824ef21329004e5$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $0824ef21329004e5$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $0824ef21329004e5$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $0824ef21329004e5$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowDevelopment", () => $0824ef21329004e5$export$d89a1b3e54af627e);
$parcel$export(module.exports, "getShowAssignee", () => $0824ef21329004e5$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $0824ef21329004e5$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $0824ef21329004e5$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $0824ef21329004e5$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $0824ef21329004e5$export$983376245b8547dc);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $0824ef21329004e5$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $0824ef21329004e5$export$67e6bba1326e537a);
$parcel$export(module.exports, "getCardFieldsSettings", () => $0824ef21329004e5$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $0824ef21329004e5$export$1e24fae4497ff7e0);
const $0824ef21329004e5$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $0824ef21329004e5$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $0824ef21329004e5$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $0824ef21329004e5$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $0824ef21329004e5$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $0824ef21329004e5$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $0824ef21329004e5$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $0824ef21329004e5$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $0824ef21329004e5$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $0824ef21329004e5$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $0824ef21329004e5$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $0824ef21329004e5$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $0824ef21329004e5$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $0824ef21329004e5$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $0824ef21329004e5$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
const $0824ef21329004e5$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $0824ef21329004e5$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $0824ef21329004e5$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $0824ef21329004e5$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $0824ef21329004e5$export$983376245b8547dc = (state)=>state.showCardCovers;
const $0824ef21329004e5$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
const $0824ef21329004e5$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
const $0824ef21329004e5$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showDevelopment: state.showDevelopment,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers
    });
const $0824ef21329004e5$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});


parcelRegister("9kkzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2065d18bd5dbf1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f2065d18bd5dbf1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    }
});

});


parcelRegister("fWtJD", function(module, exports) {

$parcel$export(module.exports, "useEpics", () => $4a1d2e48722b902f$export$5353a98fd988b08c);

var $3mynN = parcelRequire("3mynN");

var $eUqFw = parcelRequire("eUqFw");

var $5UFhP = parcelRequire("5UFhP");

var $6vrw7 = parcelRequire("6vrw7");

var $itCm6 = parcelRequire("itCm6");

var $b4bNf = parcelRequire("b4bNf");
const $4a1d2e48722b902f$var$transformEpic = (epic)=>{
    if (epic == null) throw Error('epic cannot be null');
    return {
        id: (0, $6vrw7.toIssueId)((0, $itCm6.getResourceId)(epic.id)),
        summary: epic.summary ?? ''
    };
};
const $4a1d2e48722b902f$export$f8067c2b38255fb2 = ({ loading: loading, error: error, data: data })=>{
    if (loading) return {
        loading: true
    };
    if (error) return {
        error: error,
        loading: false
    };
    // This is possible due to the `skip` condition on the query
    if (data == null) return {
        loading: false
    };
    if (data.jiraReleases?.epics?.nodes == null) return {
        loading: false,
        error: Error('Epics not found')
    };
    const transformationResult = data.jiraReleases.epics.nodes.map($4a1d2e48722b902f$var$transformEpic);
    return transformationResult instanceof Error ? {
        error: transformationResult,
        loading: false
    } : {
        data: transformationResult,
        loading: false
    };
};
const $4a1d2e48722b902f$export$5353a98fd988b08c = (text)=>{
    const projectAri = (0, $b4bNf.useProjectAri)();
    const queryResult = (0, $5UFhP.useFetchQuery)((0, $3mynN.default), {
        first: 10,
        filter: {
            projectId: projectAri ?? '',
            text: text
        }
    }, {
        skip: projectAri === null,
        fetchPolicy: 'store-or-network'
    });
    return (0, $eUqFw.useMemo)(()=>$4a1d2e48722b902f$export$f8067c2b38255fb2(queryResult), [
        queryResult
    ]);
};

});
parcelRegister("3mynN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2f827fe40501bba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a0619e0618d0f612b7b56f5fd03dac6>>
 * @relayHash 174dfd62fb50a2a7dcdfdfa25c33ef4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 465e18c29b80899568ed74ff08be9f9efe10e3a3efad0f0a92c504f3b8f10895
const $b2f827fe40501bba$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = [
        {
            "concreteType": "JiraReleases",
            "kind": "LinkedField",
            "name": "jiraReleases",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "filter"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "JiraReleasesEpicConnection",
                    "kind": "LinkedField",
                    "name": "epics",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraReleasesEpic",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "summary"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getEpicsRelayQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getEpicsRelayQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "465e18c29b80899568ed74ff08be9f9efe10e3a3efad0f0a92c504f3b8f10895",
            "metadata": {},
            "name": "getEpicsRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b2f827fe40501bba$var$node.hash = "9c0f3b27fa6a0d9bd173b6183209bae4";
var $b2f827fe40501bba$export$2e2bcd8739ae039 = $b2f827fe40501bba$var$node;

});

parcelRegister("b4bNf", function(module, exports) {

$parcel$export(module.exports, "useProjectAri", () => $a6e4afe7eff2a581$export$8688254b761eadc4);

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");

var $lnbOK = parcelRequire("lnbOK");
const $a6e4afe7eff2a581$export$8688254b761eadc4 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const projectId = (0, $lnbOK.useProjectId)();
    if (projectId === null) return null;
    return (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: projectId
    });
};

});


parcelRegister("i0pTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e13fd9d5d995fac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e13fd9d5d995fac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassigned: {
        "id": "software-deployments.top-filters.epic-filter.unassigned",
        "defaultMessage": "Issues without epic"
    }
});

});


parcelRegister("4Y3IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e98be9e3ce67513f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dNCGp = parcelRequire("dNCGp");

var $dWGNJ = parcelRequire("dWGNJ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cBUq0 = parcelRequire("cBUq0");
const $e98be9e3ce67513f$var$IssueTypeFilter = ({ isNested: isNested, selectedValues: selectedValues, onChange: onChange, issueTypes: issueTypes, error: error })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWGNJ.ErrorFlag), {
        error: error,
        title: (0, $cBUq0.default).issueTypeFilterErrorFlagTitle,
        description: (0, $cBUq0.default).issueTypeFilterErrorFlagDescription
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dNCGp.default), {
        // @ts-expect-error - TS2322 - Type 'IssueType[] | undefined' is not assignable to type 'IssueType[]'.
        issueTypes: issueTypes,
        selectedIssueTypes: selectedValues,
        onChange: (ids)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'deploymentsIssueTypeFilter'
            }));
            onChange(ids);
        },
        isNested: isNested
    });
};
var $e98be9e3ce67513f$export$2e2bcd8739ae039 = $e98be9e3ce67513f$var$IssueTypeFilter;

});
parcelRegister("dNCGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb3e818e9802c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6vrw7 = parcelRequire("6vrw7");

var $azooe = parcelRequire("azooe");

var $7Wut4 = parcelRequire("7Wut4");
const $6bb3e818e9802c28$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const values = (0, $eUqFw.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $eUqFw.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $6vrw7.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $7Wut4.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested
    });
};
const $6bb3e818e9802c28$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $eUqFw.memo)($6bb3e818e9802c28$var$IssueTypeFilter);
$6bb3e818e9802c28$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$6bb3e818e9802c28$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $6bb3e818e9802c28$export$2e2bcd8739ae039 = $6bb3e818e9802c28$var$IssueTypeFilterComponent;

});
parcelRegister("7Wut4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba2dd317ef60362$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6ba2dd317ef60362$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    }
});

});


parcelRegister("cBUq0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f919576038d3d3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f3f919576038d3d3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypeFilterErrorFlagTitle: {
        "id": "software-deployments.top-filters.issue-type-filter.issue-type-filter-error-flag-title",
        "defaultMessage": "Unable to load issue type filter."
    },
    issueTypeFilterErrorFlagDescription: {
        "id": "software-deployments.top-filters.issue-type-filter.issue-type-filter-error-flag-description",
        "defaultMessage": "Please try to refresh the page again."
    }
});

});


parcelRegister("i7AwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5af7af15290cca7f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cNGJr = parcelRequire("cNGJr");

var $8CfG4 = parcelRequire("8CfG4");

var $9zALC = parcelRequire("9zALC");

var $jmejm = parcelRequire("jmejm");

var $axKFq = parcelRequire("axKFq");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8Ui86 = parcelRequire("8Ui86");

var $1Ksr6 = parcelRequire("1Ksr6");

var $2YZvw = parcelRequire("2YZvw");

var $6go3X = parcelRequire("6go3X");

var $erEDr = parcelRequire("erEDr");
const $5af7af15290cca7f$export$bf4978b2dd458630 = ()=>{
    const searchInputRef = (0, $eUqFw.useRef)(null);
    const [{ text: debouncedText }, { setTextFilter: setTextFilter }] = (0, $6go3X.useTableFilterStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getCallback = (value)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'searched',
            actionSubject: 'deploymentsTextFilter'
        }));
        setTextFilter(value.trim());
    };
    const [onChangeDebounced] = (0, $cNGJr.default)(getCallback, (0, $2YZvw.DEBOUNCE_MILLISECONDS));
    const fireShortcutAnalytics = (0, $1Ksr6.useShortcutAnalytics)('deployments');
    const focusSearchInput = ()=>{
        if (searchInputRef?.current != null) {
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // We have to pass the `value` prop here because the store state could be modified from
    // elsewhere in the app. `SearchField` maintains its own internal state (which updates as
    // the user types), and it syncs in the `value` prop when it changes.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $axKFq.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'deployments-focus-search-input',
                    name: formatMessage((0, $erEDr.default).searchCurrentPage),
                    priority: (0, $jmejm.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $9zALC.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8CfG4))), {
                                label: formatMessage((0, $erEDr.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "deployments.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
        value: debouncedText,
        // @ts-expect-error - TS2322 - Type '{ value: string; width: string; isAutocompleteDisabled: true; onChange: (value: string) => void; }' is not assignable to type 'IntrinsicAttributes & Props'.
        width: "small",
        isAutocompleteDisabled: true,
        onChange: onChangeDebounced,
        inputRef: searchInputRef
    }));
};
var $5af7af15290cca7f$export$2e2bcd8739ae039 = $5af7af15290cca7f$export$bf4978b2dd458630;

});
parcelRegister("8CfG4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $645e088e86b3f594$var$_react = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $645e088e86b3f594$var$_page = $645e088e86b3f594$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $645e088e86b3f594$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $645e088e86b3f594$var$PageIcon = (props)=>/*#__PURE__*/ $645e088e86b3f594$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="8" height="2" x="8" y="9" rx="1"/><rect width="4" height="2" x="8" y="12" rx="1"/><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/></g></svg>`
    }, props, {
        newIcon: $645e088e86b3f594$var$_page.default
    }));
$645e088e86b3f594$var$PageIcon.displayName = 'PageIcon';
var $645e088e86b3f594$var$_default = module.exports.default = $645e088e86b3f594$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c63ce0083f2e9a73a4c7c0a839641a58>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});


parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});

parcelRegister("jmejm", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $008cf4f8cce3a652$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $008cf4f8cce3a652$export$5ea2dca0a260365d;
(function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 0] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 1] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 2] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 3] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 4] = "checkNotifications";
})($008cf4f8cce3a652$export$5ea2dca0a260365d || ($008cf4f8cce3a652$export$5ea2dca0a260365d = {}));

});

parcelRegister("axKFq", function(module, exports) {

$parcel$export(module.exports, "CommandShortcuts", () => $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a);

var $eUqFw = parcelRequire("eUqFw");

var $fmmnJ = parcelRequire("fmmnJ");

var $awzwr = parcelRequire("awzwr");

var $6jiFZ = parcelRequire("6jiFZ");

var $9aFSa = parcelRequire("9aFSa");
const $cc0f6b42d78d14cf$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eUqFw.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $6jiFZ.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $6jiFZ.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eUqFw.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzwr.RegisterCommands), {
        registrationId: (0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("awzwr", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $42c02b036374b0c2$export$cd555833c78729f1);

var $eUqFw = parcelRequire("eUqFw");

var $7ElYg = parcelRequire("7ElYg");
const $42c02b036374b0c2$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ElYg.RegisterCommandsWithRegistry), props);

});
parcelRegister("7ElYg", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $f8fb4bce96babd2d$export$b8955a01360d2876);

var $fqCN8 = parcelRequire("fqCN8");
function $f8fb4bce96babd2d$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $fqCN8.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("fqCN8", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $f1b669646bbb8295$export$8a824ae164ff968d);

var $eUqFw = parcelRequire("eUqFw");

var $7Xm2s = parcelRequire("7Xm2s");
function $f1b669646bbb8295$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $7Xm2s.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $eUqFw.useRef)(commands);
    (0, $eUqFw.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});
parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $9139bfe8dcd2ea64$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $WBLbN.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $WBLbN.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$a18633b655403b12 = (0, $WBLbN.createStateHook)($9139bfe8dcd2ea64$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $WBLbN.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $WBLbN.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $48b165edb54974f4$export$894e19fc96687503);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));
const $48b165edb54974f4$export$894e19fc96687503 = 250;

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $8PVSz = parcelRequire("8PVSz");

var $75e8i = parcelRequire("75e8i");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $476b965ceb7c28b6$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $75e8i.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $8PVSz.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $75e8i.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $75e8i.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $8PVSz.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride,
    setHasPopupOverlay: $476b965ceb7c28b6$var$setHasPopupOverlay,
    forceSearchValue: $476b965ceb7c28b6$var$forceSearchValue,
    resetShouldForceSearchValue: $476b965ceb7c28b6$var$resetShouldForceSearchValue
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});








parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8rQuz = parcelRequire("8rQuz");

var $babBw = parcelRequire("babBw");

var $kq9HD = parcelRequire("kq9HD");

var $dAreR = parcelRequire("dAreR");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $babBw.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $8rQuz.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kq9HD.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $babBw.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("kq9HD", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $c70659cfee4e098d$export$84038b503874befa);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $02Sz7 = parcelRequire("02Sz7");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $c70659cfee4e098d$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c70659cfee4e098d$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($02Sz7)))
    }));
const $c70659cfee4e098d$var$wrapperStylesCloseIcon = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $81537fc79b34b1c4$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8xkEh = parcelRequire("8xkEh");

var $aB51E = parcelRequire("aB51E");

var $9IsWp = parcelRequire("9IsWp");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aB51E))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStylesBefore,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $81537fc79b34b1c4$var$wrapperStylesBefore = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $81537fc79b34b1c4$var$spacingStylesBefore = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});


parcelRegister("1Ksr6", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $6f08a6f9a81f758c$export$cd482f0b72849b2c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $jMP2a = parcelRequire("jMP2a");
const $6f08a6f9a81f758c$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $6f08a6f9a81f758c$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAnalytics = (0, $eUqFw.useCallback)((payload)=>{
        $6f08a6f9a81f758c$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

parcelRegister("erEDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d3fa9c3ad02528$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $05d3fa9c3ad02528$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchCurrentPage: {
        "id": "software-deployments.top-filters.text-filter.search-current-page",
        "defaultMessage": "Search on current page"
    }
});

});


parcelRegister("as4Zx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf4260767958138$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $azooe = parcelRequire("azooe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $km6oo = parcelRequire("km6oo");

var $a9sHF = parcelRequire("a9sHF");
const $3bf4260767958138$var$VersionFilter = ({ projectId: projectId, isNested: isNested, selectedValues: selectedValues, onChange: onChange })=>{
    const { data: data, error: error, loading: loading } = (0, $km6oo.useFixVersions)(projectId);
    if (error) throw error;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fixVersions = data ? data.map((version)=>({
            value: version.name,
            label: version.name
        })) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $azooe.default), {
        label: formatMessage((0, $a9sHF.default).versions),
        values: fixVersions,
        selectedValues: selectedValues,
        onChange: (newSelectedFixVersions)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'deploymentsFixVersionsFilter'
            }));
            onChange(newSelectedFixVersions.map((v)=>v.value));
        },
        isLoading: loading,
        showMenuIfValuesAreEmpty: false,
        isNested: isNested
    });
};
var $3bf4260767958138$export$2e2bcd8739ae039 = $3bf4260767958138$var$VersionFilter;

});
parcelRegister("km6oo", function(module, exports) {

$parcel$export(module.exports, "useFixVersions", () => $b3dc5b9435941a70$export$4b48edd89678fd0c);

var $kgVgA = parcelRequire("kgVgA");

var $eUqFw = parcelRequire("eUqFw");

var $huI7r = parcelRequire("huI7r");

var $5UFhP = parcelRequire("5UFhP");

var $dWLk9 = parcelRequire("dWLk9");
const $b3dc5b9435941a70$var$transformQueryResult = ({ loading: loading, error: error, data: data })=>{
    if (loading) return {
        loading: true
    };
    if (error) return {
        error: error,
        loading: false
    };
    if (!data) return {
        loading: false,
        error: Error('Versions not found')
    };
    const transformationResult = data.jira.versionsForProject.edges.filter(Boolean).map((edge)=>edge.node).map(({ name: name })=>({
            id: name,
            name: name
        }));
    return {
        data: transformationResult,
        loading: false
    };
};
const $b3dc5b9435941a70$export$4b48edd89678fd0c = (projectId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const queryResult = (0, $5UFhP.useFetchQuery)((0, $kgVgA.default), {
        projectId: (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: projectId
        }),
        first: 500
    }, {
        fetchPolicy: 'store-or-network'
    });
    // @ts-expect-error - TS2345 - Argument of type '{ data: unknown; error: Error | null; loading: boolean; }' is not assignable to parameter of type '{ loading: boolean; error: Error | null; data: getVersions_jira_deployments_versionsForProject_Query$data | null; }'.
    return (0, $eUqFw.useMemo)(()=>$b3dc5b9435941a70$var$transformQueryResult(queryResult), [
        queryResult
    ]);
};

});
parcelRegister("kgVgA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6781aaf0ce0c8b7c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6fc0a1947967f0ca1b62c653bdc9eecb>>
 * @relayHash dec4c3eeae49019329cdb4f44c721cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8a0902d7c7442fe6c6ecf8cedd6c2c0a0dda1653fdd59736a83c517cd15ed8e2
const $6781aaf0ce0c8b7c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectId"
    }, v2 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": [
                "UNRELEASED",
                "RELEASED"
            ]
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "jiraProjectId",
            "variableName": "projectId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getVersions_jira_deployments_versionsForProject_Query",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraVersionConnection",
                                    "kind": "LinkedField",
                                    "name": "versionsForProject",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.versionsForProject.edges.node.name"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.versionsForProject.edges.node"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.versionsForProject.edges"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.versionsForProject"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getVersions_jira_deployments_versionsForProject_Query",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraVersionConnection",
                            "kind": "LinkedField",
                            "name": "versionsForProject",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraVersionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8a0902d7c7442fe6c6ecf8cedd6c2c0a0dda1653fdd59736a83c517cd15ed8e2",
            "metadata": {},
            "name": "getVersions_jira_deployments_versionsForProject_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6781aaf0ce0c8b7c$var$node.hash = "aca7bd224bde536f6132e78cabac2822";
var $6781aaf0ce0c8b7c$export$2e2bcd8739ae039 = $6781aaf0ce0c8b7c$var$node;

});


parcelRegister("a9sHF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3f63a4977a4d68c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b3f63a4977a4d68c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    versions: {
        "id": "software-deployments.top-filters.versions-filter.versions",
        "defaultMessage": "Versions"
    }
});

});



parcelRegister("foURZ", function(module, exports) {

$parcel$export(module.exports, "usePreventSwipeBack", () => $3ec491daa92aa4f3$export$9fad0c892831bb27);

var $eUqFw = parcelRequire("eUqFw");
const $3ec491daa92aa4f3$export$9fad0c892831bb27 = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        let initOverscrollBehaviorX = '';
        if (document.body) {
            initOverscrollBehaviorX = document.body.style.overscrollBehaviorX ?? '';
            if (document.body) document.body.style.overscrollBehaviorX = 'contain';
        }
        return ()=>{
            if (document.body) document.body.style.overscrollBehaviorX = initOverscrollBehaviorX;
        };
    }, []);
};

});


parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("5p2pw", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $de0deb0ce0efa641$export$52d8964299339cae);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $de0deb0ce0efa641$var$LazyNoSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4qojl")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $de0deb0ce0efa641$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de0deb0ce0efa641$var$LazyNoSoftwareLicense, null));

});
parcelRegister("4qojl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gd5QC").then(()=>parcelRequire('4kT9n'));

});


parcelRegister("7BhMl", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $623739831bab1cba$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $623739831bab1cba$export$944be0b3bf2a6feb);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");
const $623739831bab1cba$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $623739831bab1cba$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$623739831bab1cba$var$appPermissionMapper[type]]);
const $623739831bab1cba$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $623739831bab1cba$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("3iYii", function(module, exports) {

$parcel$export(module.exports, "useProjectDetails", () => $8e24978b1f8cd3f7$export$43446549442decd6);

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $8e24978b1f8cd3f7$var$useProjectKey = ()=>{
    const [projectKey] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey == null) throw new Error('Project key missing');
    return (0, $6vrw7.toProjectKey)(projectKey);
};
const $8e24978b1f8cd3f7$var$useProjectContext = ()=>{
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    if (containerContext == null || containerContext.contextType !== 'project') return null;
    return containerContext;
};
const $8e24978b1f8cd3f7$var$useProjectId = ()=>{
    const projectContext = $8e24978b1f8cd3f7$var$useProjectContext();
    return projectContext === null ? null : (0, $6vrw7.toProjectId)(`${projectContext.project.id}`);
};
const $8e24978b1f8cd3f7$var$useProjectName = ()=>{
    const projectContext = $8e24978b1f8cd3f7$var$useProjectContext();
    return projectContext === null ? null : projectContext.project.name;
};
const $8e24978b1f8cd3f7$var$useIsSimplified = ()=>{
    const projectContext = $8e24978b1f8cd3f7$var$useProjectContext();
    return projectContext === null ? null : projectContext.project.isSimplified;
};
const $8e24978b1f8cd3f7$export$43446549442decd6 = ()=>{
    const id = $8e24978b1f8cd3f7$var$useProjectId();
    const key = $8e24978b1f8cd3f7$var$useProjectKey();
    const name = $8e24978b1f8cd3f7$var$useProjectName();
    const isSimplified = $8e24978b1f8cd3f7$var$useIsSimplified();
    return {
        id: id,
        key: key,
        name: name,
        isSimplified: isSimplified
    };
};

});

parcelRegister("onPBs", function(module, exports) {

$parcel$export(module.exports, "PreconditionCheck", () => $6b4690bd186337e6$export$ef543003424a5eae);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $gGtKh = parcelRequire("gGtKh");

var $buJlM = parcelRequire("buJlM");

var $ezjOd = parcelRequire("ezjOd");

var $8N2W1 = parcelRequire("8N2W1");
const $6b4690bd186337e6$export$669f6ea7d267feaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b4690bd186337e6$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
const $6b4690bd186337e6$export$ef543003424a5eae = ({ children: children })=>{
    const { queryReference: queryReference } = (0, $buJlM.useRelayResource)((0, $ezjOd.deploymentPreconditionRelayResource));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "precondition-check-entry-point",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b4690bd186337e6$export$669f6ea7d267feaf, null)
    }, queryReference != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8N2W1.PreconditionCheck), {
        queryReference: queryReference
    }, children) : null);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b4690bd186337e6$var$LoadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9BQAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6197ac6572a87766$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6197ac6572a87766$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "spa-apps-software-deployments.title",
        "defaultMessage": "Deployments"
    }
});

});

parcelRegister("VFdsG", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $0782400e4a48a1cb$export$476aa014e2fd89d5);
const $0782400e4a48a1cb$var$ERROR_MESSAGE_CHROME = 'Failed to fetch';
const $0782400e4a48a1cb$var$ERROR_MESSAGE_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $0782400e4a48a1cb$var$ERROR_MESSAGE_OTHER = 'Network request failed';
const $0782400e4a48a1cb$var$NetworkErrorMessages = new Set([
    $0782400e4a48a1cb$var$ERROR_MESSAGE_CHROME,
    $0782400e4a48a1cb$var$ERROR_MESSAGE_FIREFOX,
    $0782400e4a48a1cb$var$ERROR_MESSAGE_OTHER
]);
const $0782400e4a48a1cb$export$476aa014e2fd89d5 = (error)=>typeof error === 'object' && $0782400e4a48a1cb$var$NetworkErrorMessages.has(error.message.replace(/^Network error: (.*)/, '$1'));

});




//# sourceMappingURL=async-deployments.1a70cd17.js.map
